/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Type, typeCast, markType, delegateCombine, delegateRemove, PropertyChangedEventArgs, String_$type, Number_$type, enumGetBox, Boolean_$type, EnumUtil, Delegate_$type, typeGetValue, runOn, INotifyPropertyChanged_$type, EventArgs, IList$1_$type, NotSupportedException, Point_$type, fromEnum, fromEn, getInstanceType, Date_$type } from "igniteui-react-core";
import { IDataSource_$type } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { ICellActionManager_$type } from "./ICellActionManager";
import { DataSourceSchemaPropertyType_$type } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { GridViewportChangedEventArgs } from "./GridViewportChangedEventArgs";
import { DateTimeFormats_$type } from "./DateTimeFormats";
import { dateMinValue, dateNow } from "igniteui-react-core";
import { ModelStates_$type } from "./ModelStates";
import { CellPath } from "./CellPath";
import { ModelTypes_$type } from "./ModelTypes";
import { CellContentHorizontalAlignment_$type } from "./CellContentHorizontalAlignment";
import { CellContentVerticalAlignment_$type } from "./CellContentVerticalAlignment";
import { FontInfo } from "igniteui-react-core";
import { TextCellLineBreakMode_$type } from "./TextCellLineBreakMode";
import { ColumnSortDirection_$type } from "./ColumnSortDirection";
import { PinnedPositions_$type } from "./PinnedPositions";
import { Dictionary$2 } from "igniteui-react-core";
import { GridStyleRepository } from "./GridStyleRepository";
import { BrushUtil } from "igniteui-react-core";
import { CellModelExport } from "./CellModelExport";
import { AppearanceHelper } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { DataSourceRowType_$type } from "igniteui-react-core";
import { truncate, isNaN_, intDivide, tryParseNumber } from "igniteui-react-core";
import { GroupSummaryDisplayMode_$type } from "./GroupSummaryDisplayMode";
import { DateTimeCellModelExport } from "./DateTimeCellModelExport";
import { EditorType_$type } from "./EditorType";
import { EditorCellModelExport } from "./EditorCellModelExport";
import { RowPath } from "./RowPath";
import { SummaryCellModelExport } from "./SummaryCellModelExport";
import { ImageStretchOptions_$type } from "./ImageStretchOptions";
import { ImageResourceType_$type } from "./ImageResourceType";
import { ImageCellModelExport } from "./ImageCellModelExport";
import { NumericCellModelExport } from "./NumericCellModelExport";
import { RowSeparatorModelExport } from "./RowSeparatorModelExport";
import { GroupData } from "./GroupData";
import { SummaryData } from "./SummaryData";
import { SectionHeaderCellModelExport } from "./SectionHeaderCellModelExport";
import { TemplateCellModelExport } from "./TemplateCellModelExport";
import { TextCellModelExport } from "./TextCellModelExport";
import { SortIndicatorStyle_$type } from "./SortIndicatorStyle";
import { ColumnOptionsIconAlignment_$type } from "./ColumnOptionsIconAlignment";
import { ColumnOptionsIconBehavior_$type } from "./ColumnOptionsIconBehavior";
import { TextHeaderCellModelExport } from "./TextHeaderCellModelExport";
import { IDataSourceUpdateNotifier_$type } from "igniteui-react-core";
import { HashSet$1 } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { createGuid, stringStartsWith, stringEmpty, stringIsNullOrWhiteSpace } from "igniteui-react-core";
import { FastIterationDictionary$2 } from "igniteui-react-core";
import { ColumnResizingMode_$type } from "./ColumnResizingMode";
import { ColumnMovingMode_$type } from "./ColumnMovingMode";
import { ColumnWidth } from "./ColumnWidth";
import { HeaderClickAction_$type } from "./HeaderClickAction";
import { EditModeType_$type } from "./EditModeType";
import { EditModeClickAction_$type } from "./EditModeClickAction";
import { ColumnShowingAnimationMode_$type } from "./ColumnShowingAnimationMode";
import { ColumnPropertyUpdatingAnimationMode_$type } from "./ColumnPropertyUpdatingAnimationMode";
import { CellDataLoadedAnimationMode_$type } from "./CellDataLoadedAnimationMode";
import { RowSelectionAnimationMode_$type } from "./RowSelectionAnimationMode";
import { CellSelectionAnimationMode_$type } from "./CellSelectionAnimationMode";
import { GridColumnAnimationSettings } from "./GridColumnAnimationSettings";
import { GridAnimationSettings } from "./GridAnimationSettings";
import { ColumnResizingAnimationMode_$type } from "./ColumnResizingAnimationMode";
import { ColumnMovingAnimationMode_$type } from "./ColumnMovingAnimationMode";
import { ColumnHidingAnimationMode_$type } from "./ColumnHidingAnimationMode";
import { ColumnExchangingAnimationMode_$type } from "./ColumnExchangingAnimationMode";
import { Thickness } from "igniteui-react-core";
import { GridSelectionMode_$type } from "./GridSelectionMode";
import { GridActivationMode_$type } from "./GridActivationMode";
import { GridSelectionBehavior_$type } from "./GridSelectionBehavior";
import { GridSelectedItemsCollection } from "./GridSelectedItemsCollection";
import { GridSelectedKeysCollection } from "./GridSelectedKeysCollection";
import { GridSelectedCellRangesCollection } from "./GridSelectedCellRangesCollection";
import { GridCellPosition } from "./GridCellPosition";
import { CornerRadius } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { ColumnSortDescriptionCollection } from "./ColumnSortDescriptionCollection";
import { ColumnGroupDescriptionCollection } from "./ColumnGroupDescriptionCollection";
import { FilterExpressionCollection } from "igniteui-react-core";
import { ColumnSummaryDescriptionCollection } from "./ColumnSummaryDescriptionCollection";
import { DataSourceSummaryScope_$type } from "igniteui-react-core";
import { DataSourceSectionHeaderDisplayMode_$type } from "igniteui-react-core";
import { IEditableDataSource_$type } from "igniteui-react-core";
import { GridFilterExpressionsEventArgs } from "./GridFilterExpressionsEventArgs";
import { CellRange } from "./CellRange";
import { DeviceUtils } from "igniteui-react-core";
import { DefaultPlatformPixelConverter } from "./DefaultPlatformPixelConverter";
import { ObservableCollection$1 } from "igniteui-react-core";
import { ColumnSortDescription } from "./ColumnSortDescription";
import { GridGroupDescriptionsChangedEventArgs } from "./GridGroupDescriptionsChangedEventArgs";
import { GridSortDescriptionsChangedEventArgs } from "./GridSortDescriptionsChangedEventArgs";
import { PrimaryKeyValue } from "./PrimaryKeyValue";
import { GridSelectedItemsChangedEventArgs } from "./GridSelectedItemsChangedEventArgs";
import { GridSelectedKeysChangedEventArgs } from "./GridSelectedKeysChangedEventArgs";
import { GridSelectedCellRangesChangedEventArgs } from "./GridSelectedCellRangesChangedEventArgs";
import { GridDataCommittedEventArgs } from "./GridDataCommittedEventArgs";
import { GridDataCommittingEventArgs } from "./GridDataCommittingEventArgs";
import { DefinitionPropertyUpdatedEventArgs } from "./DefinitionPropertyUpdatedEventArgs";
import { CellPropertyAnimationType_$type } from "./CellPropertyAnimationType";
import { GridSizeChangedEventArgs } from "./GridSizeChangedEventArgs";
import { ColumnStates_$type } from "./ColumnStates";
import { InvalidOperationException } from "igniteui-react-core";
import { VisualModelExport } from "./VisualModelExport";
import { GridActiveCellChangedEventArgs } from "./GridActiveCellChangedEventArgs";
import { FilterFactory } from "igniteui-react-core";
import { Convert } from "igniteui-react-core";
import { timeSpanTotalSeconds, timeSpanFromMilliseconds, timeSpanTotalMilliseconds } from "igniteui-react-core";
import { GridAnimationPhaseSettings } from "./GridAnimationPhaseSettings";
import { GridAnimationManagerAnimationCreatedEventArgs } from "./GridAnimationManagerAnimationCreatedEventArgs";
import { GridAnimationManagerAnimationCompletedEventArgs } from "./GridAnimationManagerAnimationCompletedEventArgs";
import { GridAnimationManagerAnimationCanceledEventArgs } from "./GridAnimationManagerAnimationCanceledEventArgs";
import { GridColumnSpacer } from "./GridColumnSpacer";
import { GridColumnSpacerCollection } from "./GridColumnSpacerCollection";
import { CellStyleRequestedEventArgs } from "./CellStyleRequestedEventArgs";
import { Stack$1 } from "igniteui-react-core";
import { DataSourceSpecialRow } from "igniteui-react-core";
import { DefaultSectionInformation } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { EasingFunctions } from "igniteui-react-core";
import { CalculationParameters } from "./CalculationParameters";
import { ColumnPropertySettersCollection } from "./ColumnPropertySettersCollection";
import { ColumnPropertySetter } from "./ColumnPropertySetter";
import { ResponsiveStateEnteringEventArgs } from "./ResponsiveStateEnteringEventArgs";
import { ResponsiveStateEnteredEventArgs } from "./ResponsiveStateEnteredEventArgs";
import { ResponsiveStateExitedEventArgs } from "./ResponsiveStateExitedEventArgs";
import { RectData } from "igniteui-react-core";
import { GridLayerExport } from "./GridLayerExport";
/**
 * @hidden
 */
export var IExternalGrid_$type = /*@__PURE__*/ new Type(null, 'IExternalGrid');
/**
 * @hidden
 */
var DefaultCellActionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefaultCellActionManager, _super);
    function DefaultCellActionManager(a, b) {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.a = null;
        _this.c = false;
        _this.d = false;
        _this._isLeaveActionDesired = false;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    DefaultCellActionManager.prototype.clickExpansionIndicator = function () {
        if (this.b != null && this.a != null) {
            this.b.q0(this.a);
        }
    };
    DefaultCellActionManager.prototype.clickCell = function (a) {
        if (this.b != null && this.a != null) {
            this.b.p1(this.a, this.c, this.d, a);
        }
    };
    DefaultCellActionManager.prototype.dragStarted = function () {
        if (this.b != null && this.b.aq != null) {
            this.b.qy(this.b.aq, this.mousePosition.x, this.mousePosition.y, this.c);
            this.mouseUpCell(this.mousePosition.x, this.mousePosition.y);
        }
    };
    DefaultCellActionManager.prototype.previewPointerDownCell = function () {
        if (this.b != null && this.a != null) {
            this.b.p9(this.a);
        }
    };
    DefaultCellActionManager.prototype.previewPointerUpCell = function () {
        if (this.b != null && this.a != null) {
            this.b.qa(this.a);
        }
    };
    DefaultCellActionManager.prototype.pointerDownCell = function () {
        if (this.b != null && this.a != null) {
            this.b.p7(this.a);
        }
    };
    DefaultCellActionManager.prototype.pointerUpCell = function () {
        if (this.b != null && this.a != null) {
            this.b.p8(this.a);
        }
    };
    DefaultCellActionManager.prototype.mouseDownCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.p5(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseUpCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.p6(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseLeaveCell = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.p4(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.mouseIsOver = function (a, b) {
        if (this.b != null && this.a != null) {
            this.b.q4(this.a, a, b);
        }
    };
    DefaultCellActionManager.prototype.doubleClicked = function () {
        if (this.b != null && this.a != null) {
            this.b.p3(this.a);
        }
    };
    DefaultCellActionManager.prototype.getColumnFilterCondition = function () {
        if (this.b == null) {
            return null;
        }
        return this.b.o(this.a);
    };
    DefaultCellActionManager.prototype.getColumnPropertyType = function () {
        if (this.b == null) {
            return 11;
        }
        return this.b.p(this.a);
    };
    DefaultCellActionManager.prototype.columnFilterChanging = function (a) {
        if (this.b == null) {
            return;
        }
        this.b.o8(this.a, a);
    };
    DefaultCellActionManager.prototype.columnFilterChanged = function (a) {
        if (this.b == null) {
            return;
        }
        this.b.o7(this.a, a);
    };
    DefaultCellActionManager.prototype.isCellDown = function () {
        if (this.b != null && this.b.aq != null && this.a != null) {
            return this.b.aq.equals(this.a.k);
        }
        return false;
    };
    Object.defineProperty(DefaultCellActionManager.prototype, "isLeaveActionDesired", {
        get: function () {
            return this._isLeaveActionDesired;
        },
        set: function (a) {
            this._isLeaveActionDesired = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isClickActionDesired", {
        get: function () {
            return this.b.g5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isHoverActionDesired", {
        get: function () {
            return this.b.hk;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPreviewPointerDownActionDesired", {
        get: function () {
            return this.b.hp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPreviewPointerUpActionDesired", {
        get: function () {
            return this.b.hq;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPointerDownActionDesired", {
        get: function () {
            return this.b.hn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isPointerUpActionDesired", {
        get: function () {
            return this.b.ho;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isControlPressed", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isShiftPressed", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            this.d = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isDrag", {
        get: function () {
            return this.b.dragger.isDragActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isMouseDown", {
        get: function () {
            return this.b.aq != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "mousePosition", {
        get: function () {
            return this.b.uo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultCellActionManager.prototype, "isGridDragging", {
        get: function () {
            if (this.b != null) {
                return this.b.dragger.isDragActive;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    DefaultCellActionManager.prototype.updateCellEditValue = function (a) {
        var b = typeCast(EditorCellModel.$, this.a);
        if (b != null) {
            b.k3 = a;
        }
    };
    DefaultCellActionManager.prototype.editorCellLostFocus = function () {
        if (this.b != null) {
            this.b.qz(typeCast(EditorCellModel.$, this.a));
        }
    };
    DefaultCellActionManager.prototype.cancelEditMode = function (a) {
        if (this.b != null) {
            this.b.gz(a);
        }
    };
    DefaultCellActionManager.$t = markType(DefaultCellActionManager, 'DefaultCellActionManager', Base.$, [ICellActionManager_$type]);
    return DefaultCellActionManager;
}(Base));
export { DefaultCellActionManager };
/**
 * @hidden
 */
export var IGridInfoRequestor_$type = /*@__PURE__*/ new Type(null, 'IGridInfoRequestor');
/**
 * @hidden
 */
var DefaultGridInfoRequestor = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefaultGridInfoRequestor, _super);
    function DefaultGridInfoRequestor(a, b) {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.a = null;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    DefaultGridInfoRequestor.prototype.getColumn = function () {
        if (this.b == null) {
            return null;
        }
        return this.b.a0(this.a.k);
    };
    DefaultGridInfoRequestor.prototype.getDensity = function () {
        if (this.b == null) {
            return 3;
        }
        return this.b.e8;
    };
    DefaultGridInfoRequestor.prototype.getTheme = function () {
        if (this.b == null) {
            return 0;
        }
        return 1;
    };
    DefaultGridInfoRequestor.prototype.setViewportChangedHandler = function (a) {
        if (this.b != null && a != null) {
            var b = this.b;
            b.viewportChanged = delegateCombine(b.viewportChanged, a);
        }
    };
    DefaultGridInfoRequestor.prototype.removeViewportChangedHandler = function (a) {
        if (this.b != null && a != null) {
            var b = this.b;
            b.viewportChanged = delegateRemove(b.viewportChanged, a);
        }
    };
    DefaultGridInfoRequestor.$t = markType(DefaultGridInfoRequestor, 'DefaultGridInfoRequestor', Base.$, [IGridInfoRequestor_$type]);
    return DefaultGridInfoRequestor;
}(Base));
export { DefaultGridInfoRequestor };
/**
 * @hidden
 */
var DateTimeColumnValueFormatter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeColumnValueFormatter, _super);
    function DateTimeColumnValueFormatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = 0;
        _this.b = false;
        _this.f = null;
        _this.e = null;
        _this.c = null;
        _this.d = null;
        _this.g = null;
        _this.h = null;
        return _this;
    }
    DateTimeColumnValueFormatter.prototype.k = function () {
        this.b = true;
    };
    DateTimeColumnValueFormatter.prototype.j = function (a) {
        this.a = a.ki;
        this.b = false;
    };
    DateTimeColumnValueFormatter.prototype.i = function (a) {
        if (+a == +(dateMinValue())) {
            return "";
        }
        var b = (Intl && Intl.DateTimeFormat);
        if (b) {
            var format_ = null;
            switch (this.a) {
                case 4:
                    if (this.f == null) {
                        this.f = (new Intl.DateTimeFormat([], { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }));
                    }
                    format_ = this.f;
                    break;
                case 5:
                    if (this.e == null) {
                        this.e = (new Intl.DateTimeFormat([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }));
                    }
                    format_ = this.e;
                    break;
                case 1:
                    if (this.c == null) {
                        this.c = (new Intl.DateTimeFormat([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }));
                    }
                    format_ = this.c;
                    break;
                case 0:
                    if (this.d == null) {
                        this.d = (new Intl.DateTimeFormat([], { month: 'numeric', day: 'numeric', year: 'numeric' }));
                    }
                    format_ = this.d;
                    break;
                case 3:
                    if (this.g == null) {
                        this.g = (new Intl.DateTimeFormat([], { hour: 'numeric', minute: 'numeric', second: 'numeric' }));
                    }
                    format_ = this.g;
                    break;
                case 2:
                    if (this.h == null) {
                        this.h = (new Intl.DateTimeFormat([], { hour: 'numeric', minute: 'numeric' }));
                    }
                    format_ = this.h;
                    break;
            }
            var date_ = a;
            return (format_.format(date_));
        }
        else {
            var date_ = a;
            switch (this.a) {
                case 4: return (date_.toLocaleString());
                case 5: return (date_.toLocaleString());
                case 1: return (date_.toLocaleDateString());
                case 0: return (date_.toLocaleDateString());
                case 3: return (date_.toLocaleTimeString());
                case 2: return (date_.toLocaleTimeString());
            }
            return a.toString();
        }
    };
    DateTimeColumnValueFormatter.$t = markType(DateTimeColumnValueFormatter, 'DateTimeColumnValueFormatter');
    return DateTimeColumnValueFormatter;
}(Base));
export { DateTimeColumnValueFormatter };
/**
 * @hidden
 */
var CellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellModel, _super);
    function CellModel() {
        var _this = _super.call(this) || this;
        _this.n = null;
        _this.r = null;
        _this.s = 0;
        _this.ir = null;
        _this.j = null;
        _this.ee = 0;
        _this.a2 = false;
        _this.a7 = false;
        _this.ar = false;
        _this.ap = false;
        _this.a0 = false;
        _this.a8 = false;
        _this.at = false;
        _this.a1 = false;
        _this.c = null;
        _this.d = null;
        _this.al = false;
        _this.am = false;
        _this.ak = false;
        _this.cw = 0;
        _this.a9 = new Dictionary$2(String_$type, Boolean_$type, 0);
        _this.cp = -1;
        _this.a = null;
        _this.bb = null;
        _this.p = null;
        _this.ge = null;
        _this.bs = 0;
        _this.bt = 0;
        _this.c3 = 0;
        _this.c4 = 0;
        _this.bj = 1;
        _this.bi = 1;
        _this.bg = 1;
        _this.bm = 1;
        _this.bh = 1;
        _this.bk = 0;
        _this.bp = 0;
        _this.bl = 0;
        _this.bq = 0;
        _this.cv = 0;
        _this.c5 = 0;
        _this.an = false;
        _this.u = 0;
        _this.bo = 0;
        _this.bf = 0;
        _this.e = 0;
        _this.g = 1;
        _this.jq = null;
        _this.jr = null;
        _this.jn = null;
        _this.jo = null;
        _this.jm = null;
        _this.jt = null;
        _this.jw = null;
        _this.jx = null;
        _this.jy = null;
        _this.jv = null;
        _this.ju = null;
        _this.bn = 0.3;
        _this.gd = null;
        _this.gk = "";
        _this.jz = null;
        _this.jp = null;
        _this.js = null;
        _this.ac = null;
        _this.aa = null;
        _this.y = 0;
        _this.br = 0;
        _this.c0 = 0;
        _this.c2 = 0;
        _this.c1 = 0;
        _this.cz = 0;
        _this.ci = 0;
        _this.ck = 0;
        _this.cj = 0;
        _this.ch = 0;
        _this.cm = 0;
        _this.co = 0;
        _this.cn = 0;
        _this.cl = 0;
        _this.ca = 1;
        _this.cc = 1;
        _this.cb = 1;
        _this.b9 = 1;
        _this.cs = 2;
        _this.cu = 2;
        _this.ct = 2;
        _this.cr = 2;
        _this.ce = 0;
        _this.cg = 0;
        _this.cf = 0;
        _this.cd = 0;
        _this.l = 0;
        _this.aj = false;
        _this.ag = false;
        _this.w = 0;
        _this.ab = null;
        _this.ai = false;
        _this.ah = false;
        _this.gj = null;
        _this.cq = -1;
        _this.gc = 0;
        _this.propertyChanged = null;
        _this.cellReconciling = null;
        _this.t = 0;
        _this.ee = -1;
        _this.ji();
        _this.j4 = GridStyleRepository.au;
        return _this;
    }
    Object.defineProperty(CellModel.prototype, "o", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            this.n = a;
        },
        enumerable: true,
        configurable: true
    });
    CellModel.eu = function (a) {
        if (CellModel.bc == null || CellModel.bc == undefined) {
            CellModel.bc = new Dictionary$2(String_$type, Number_$type, 0);
        }
        if (CellModel.bc.containsKey(a)) {
            return CellModel.bc.item(a);
        }
        var b = CellModel.cy;
        CellModel.cy++;
        CellModel.cx = b;
        CellModel.bc.item(a, b);
        return b;
    };
    Object.defineProperty(CellModel.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            if (this.s != b) {
                this.jd("State", CellModel.f1, enumGetBox(ModelStates_$type, b), enumGetBox(ModelStates_$type, this.s));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            var b = this.j;
            this.j = a;
            if (this.j != b) {
                this.jd("Path", CellModel.fn, b, this.j);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a3", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (this.al != b) {
                this.jd("IsRowPinned", CellModel.e5, b, this.al);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a4", {
        get: function () {
            return this.am;
        },
        set: function (a) {
            var b = this.am;
            this.am = a;
            if (this.am != b) {
                this.jd("IsRowSticky", CellModel.e6, b, this.am);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "az", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (this.ak != b) {
                this.jd("IsLastStickyRow", CellModel.e4, b, this.ak);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ey", {
        get: function () {
            return this.cw;
        },
        set: function (a) {
            var b = this.cw;
            this.cw = a;
            if (this.cw != b) {
                this.jd("Indent", CellModel.ez, b, this.cw);
            }
        },
        enumerable: true,
        configurable: true
    });
    CellModel.prototype.as = function (a) {
        if (this.a9.containsKey(a)) {
            return this.a9.item(a);
        }
        return false;
    };
    CellModel.prototype.aw = function (propertyId_) {
        if (this.cp == -1) {
            return false;
        }
        var a = ((propertyId_ / 32) | 0);
        var b = propertyId_ % 32;
        return ((this.a[a] >> b) & 1) != 0;
    };
    CellModel.prototype.av = function (a) {
        var b = CellModel.bc.f(a);
        if (b != undefined) {
            return this.aw(b);
        }
        if (this.as(a)) {
            return true;
        }
        return false;
    };
    CellModel.prototype.i5 = function (propertyId_) {
        if (this.cp == -1) {
            this.cp = truncate(Math.ceil(CellModel.cx / 32));
            this.a = new Array(propertyId_);
        }
        var a = ((propertyId_ / 32) | 0);
        var b = propertyId_ % 32;
        this.a[a] = this.a[a] | (1 << b);
    };
    CellModel.prototype.i2 = function () {
        for (var a = 0; a < this.cp; a++) {
            this.a[a] = 0;
        }
    };
    CellModel.prototype.i6 = function (a) {
        var b = CellModel.bc.f(a);
        if (b != undefined) {
            this.i5(b);
            return;
        }
        this.a9.item(a, true);
    };
    CellModel.prototype.jd = function (a, b, c, d) {
        this.i5(b);
        this.jg(a, c, d);
        if (this.o != null) {
            this.o.ro();
        }
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
    };
    CellModel.prototype.jg = function (a, b, c) {
        switch (a) {
            case "State":
                this.a2 = true;
                this.a7 = true;
                this.ar = true;
                this.a8 = true;
                break;
            case "LeftOffset":
            case "TopOffset":
            case "LeftPercentOffset":
            case "TopPercentOffset":
            case "X":
            case "Y":
                this.a2 = true;
                break;
            case "Width":
            case "Height":
                this.a7 = true;
                break;
            case "RowItem":
                this.je();
                break;
            case "Background":
            case "SelectedBackground":
            case "SelectedStatus":
            case "IsLastStickyRow":
            case "StickyRowBackground":
            case "PinnedRowBackground":
            case "LastStickyRowBackground":
                this.i8();
                break;
            case "IsRowSticky":
            case "IsRowPinned":
            case "PinnedRowOpacity":
                this.i8();
                this.jb();
                break;
            case "Border":
            case "ActivationBorder":
            case "ErrorBorder":
            case "BorderLeftWidth":
            case "BorderTopWidth":
            case "BorderBottomWidth":
            case "BorderRightWidth":
            case "ActivationBorderLeftWidth":
            case "ActivationBorderTopWidth":
            case "ActivationBorderBottomWidth":
            case "ActivationBorderRightWidth":
            case "ActivationStatus":
            case "EditError":
            case "ErrorBorderLeftWidth":
            case "ErrorBorderTopWidth":
            case "ErrorBorderBottomWidth":
            case "ErrorBorderRightWidth":
                this.ap = true;
                this.i9();
                break;
            case "PaddingLeft":
            case "PaddingTop":
            case "PaddingBottom":
            case "PaddingRight":
                this.i9();
                break;
            case "Opacity":
                this.ja();
                break;
            case "ContentOpacity":
            case "EditOpacity":
                this.jb();
                break;
            case "IsEdited":
            case "IsDeleted":
                this.jf();
                this.jb();
                this.jc();
                this.ar = true;
                break;
            case "TextColor":
            case "DeletedTextColor":
                this.jf();
                break;
            case "FontInfo":
            case "EditFontInfo":
                this.jc();
                break;
            case "Path": break;
            default:
                this.ar = true;
                break;
        }
    };
    CellModel.prototype.je = function () {
    };
    CellModel.prototype.i8 = function () {
        var a = this.j4;
        if (this.az && this.j9 != null) {
            a = this.j9;
        }
        else if (this.a4 && this.kd != null) {
            a = this.kd;
        }
        else if (this.a3 && this.ka != null) {
            a = this.ka;
        }
        this.j1 = this.j8(a, this.kb, this.b3);
    };
    CellModel.prototype.i9 = function () {
        var a = false;
        if (this.bu != 0 && this.j0 != null) {
            a = true;
        }
        if (this.he != null) {
            var b = this.em - this.d6;
            var c = this.er - this.eb;
            var d = this.ep - this.d9;
            var e = this.ek - this.d4;
            this.dw = Math.max(0, this.fh - b);
            this.d0 = Math.max(0, this.fl - c);
            this.dy = Math.max(0, this.fj - d);
            this.du = Math.max(0, this.ff - e);
            this.dj = Math.max(0, this.d6 + b);
            this.dp = Math.max(0, this.eb + c);
            this.dm = Math.max(0, this.d9 + d);
            this.dh = Math.max(0, this.d4 + e);
            this.j2 = this.j7;
        }
        else {
            if (a && (this.d6 == 0 || this.eb == 0 || this.d9 == 0 || this.d4 == 0)) {
                var f = this.c8 - this.d6;
                var g = this.dd - this.eb;
                var h = this.db - this.d9;
                var i = this.c6 - this.d4;
                this.dw = Math.max(0, this.fh - f);
                this.d0 = Math.max(0, this.fl - g);
                this.dy = Math.max(0, this.fj - h);
                this.du = Math.max(0, this.ff - i);
                this.dj = Math.max(0, this.d6 + f);
                this.dp = Math.max(0, this.eb + g);
                this.dm = Math.max(0, this.d9 + h);
                this.dh = Math.max(0, this.d4 + i);
            }
            else {
                this.dw = this.fh;
                this.d0 = this.fl;
                this.dy = this.fj;
                this.du = this.ff;
                this.dj = this.d6;
                this.dp = this.eb;
                this.dm = this.d9;
                this.dh = this.d4;
            }
            var j = this.j5;
            this.j2 = this.j8(j, this.j0, this.bu);
        }
    };
    CellModel.prototype.ja = function () {
        this.bw = this.b1;
    };
    CellModel.prototype.jb = function () {
        if (this.ax && !this.au) {
            this.bv = this.by;
        }
        else if (this.a3 && !this.a4) {
            this.bv = this.b2;
        }
        else {
            this.bv = this.bx;
        }
    };
    CellModel.prototype.jf = function () {
        if (this.au) {
            this.j3 = this.j6;
        }
        else {
            this.j3 = this.ke;
        }
    };
    CellModel.prototype.jc = function () {
        if (this.ax || this.au) {
            this.ad = this.ae;
        }
        else {
            this.ad = this.af;
        }
    };
    CellModel.prototype.j8 = function (a, b, c) {
        if (c == 0) {
            return a;
        }
        if (c == 1) {
            return b;
        }
        return BrushUtil.k(a, c, b, 0);
    };
    CellModel.prototype.ji = function () {
        this.jj();
    };
    CellModel.prototype.jj = function () {
        this.i2();
        if (this.bb != null) {
            this.bb.clear();
        }
        this.b3 = 0;
        this.ar = true;
        this.a2 = true;
        this.a7 = true;
        this.a0 = false;
    };
    CellModel.prototype.jk = function (a, b) {
        if (this.bb == null) {
            this.bb = new Dictionary$2(String_$type, Base.$, 0);
        }
        var c = null;
        if (this.bb.containsKey(a)) {
            c = this.bb.item(a);
        }
        this.bb.item(a, b);
        var d = false;
        if (c == null && b != null) {
            d = true;
        }
        if (c != null) {
            if (!Base.equalsStatic(c, b)) {
                d = true;
            }
        }
        if (d) {
            this.i6(a);
            this.ar = true;
            if (this.o != null) {
                this.o.ro();
            }
        }
    };
    CellModel.prototype.ao = function (a) {
        if (this.bb == null) {
            return false;
        }
        return this.bb.containsKey(a);
    };
    CellModel.prototype.jh = function (a) {
        if (this.bb == null) {
            return;
        }
        if (this.bb.containsKey(a)) {
            this.bb.removeItem(a);
        }
    };
    CellModel.prototype.gf = function (a) {
        if (this.bb == null) {
            return null;
        }
        if (this.bb.containsKey(a)) {
            return this.bb.item(a);
        }
        return null;
    };
    Object.defineProperty(CellModel.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            if (this.p != b) {
                this.a0 = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "gi", {
        get: function () {
            return this.ge;
        },
        set: function (a) {
            var b = this.ge;
            this.ge = a;
            if (this.ge != b) {
                this.jd("RowItem", CellModel.fs, b, this.ge);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b7", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            var b = this.bs;
            this.bs = a;
            if (this.bs != b) {
                this.jd("X", CellModel.ga, b, this.bs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b8", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (this.bt != b) {
                this.jd("Y", CellModel.gb, b, this.bt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fv", {
        get: function () {
            return this.c3;
        },
        set: function (a) {
            var b = this.c3;
            this.c3 = a;
            if (this.c3 != b) {
                this.jd("SnappedX", CellModel.fw, b, this.c3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fx", {
        get: function () {
            return this.c4;
        },
        set: function (a) {
            var b = this.c4;
            this.c4 = a;
            if (this.c4 != b) {
                this.jd("SnappedY", CellModel.fy, b, this.c4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "by", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (this.bj != b) {
                this.jd("EditOpacity", CellModel.ej, b, this.bj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "bx", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (this.bi != b) {
                this.jd("ContentOpacity", CellModel.ed, b, this.bi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "bv", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (this.bg != b) {
                this.jd("ActualContentOpacity", CellModel.dr, b, this.bg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b1", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (this.bm != b) {
                this.jd("Opacity", CellModel.fd, b, this.bm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "bw", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (this.bh != b) {
                this.jd("ActualOpacity", CellModel.dt, b, this.bh);
            }
        },
        enumerable: true,
        configurable: true
    });
    CellModel.prototype.i7 = function () {
        if (this.cellReconciling != null) {
            this.cellReconciling(this);
        }
    };
    Object.defineProperty(CellModel.prototype, "bz", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (this.bk != b) {
                this.jd("LeftOffset", CellModel.e9, b, this.bk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b4", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bp;
            this.bp = a;
            if (this.bp != b) {
                this.jd("TopOffset", CellModel.f4, b, this.bp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b0", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (this.bl != b) {
                this.jd("LeftPercentOffset", CellModel.fa, b, this.bl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b5", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            if (this.bq != b) {
                this.jd("TopPercentOffset", CellModel.f5, b, this.bq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ev", {
        get: function () {
            return this.cv;
        },
        set: function (a) {
            var b = this.cv;
            this.cv = a;
            if (this.cv != b) {
                this.jd("Height", CellModel.ew, b, this.cv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "f8", {
        get: function () {
            return this.c5;
        },
        set: function (a) {
            var b = this.c5;
            this.c5 = a;
            if (this.c5 != b) {
                this.jd("Width", CellModel.f9, b, this.c5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "a6", {
        get: function () {
            return this.an;
        },
        set: function (a) {
            var b = this.an;
            this.an = a;
            if (this.an != b) {
                this.jd("IsSelected", CellModel.e7, b, this.an);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "v", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (this.u != b) {
                this.jd("ModelType", CellModel.fc, enumGetBox(ModelTypes_$type, b), enumGetBox(ModelTypes_$type, this.u));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b3", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (this.bo != b) {
                this.jd("SelectedStatus", CellModel.fu, b, this.bo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "bu", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (this.bf != b) {
                this.jd("ActivationStatus", CellModel.df, b, this.bf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "f", {
        get: function () {
            return this.e;
        },
        set: function (a) {
            var b = this.e;
            this.e = a;
            if (this.e != b) {
                this.jd("HorizontalAlignment", CellModel.ex, enumGetBox(CellContentHorizontalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.e));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "h", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            var b = this.g;
            this.g = a;
            if (this.g != b) {
                this.jd("VerticalAlignment", CellModel.f6, enumGetBox(CellContentVerticalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.e));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j4", {
        get: function () {
            return this.jq;
        },
        set: function (a) {
            var b = this.jq;
            this.jq = a;
            if (this.jq != b) {
                this.jd("Background", CellModel.d3, b, this.jq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j5", {
        get: function () {
            return this.jr;
        },
        set: function (a) {
            var b = this.jr;
            this.jr = a;
            if (this.jr != b) {
                this.jd("Border", CellModel.d8, b, this.jr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j1", {
        get: function () {
            return this.jn;
        },
        set: function (a) {
            var b = this.jn;
            this.jn = a;
            if (this.jn != b) {
                this.jd("ActualBackground", CellModel.dg, b, this.jn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j2", {
        get: function () {
            return this.jo;
        },
        set: function (a) {
            var b = this.jo;
            this.jo = a;
            if (this.jo != b) {
                this.jd("ActualBorder", CellModel.dl, b, this.jo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j0", {
        get: function () {
            return this.jm;
        },
        set: function (a) {
            var b = this.jm;
            this.jm = a;
            if (this.jm != b) {
                this.jd("ActivationBorder", CellModel.da, b, this.jm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j7", {
        get: function () {
            return this.jt;
        },
        set: function (a) {
            var b = this.jt;
            this.jt = a;
            if (this.jt != b) {
                this.jd("ErrorBorder", CellModel.eo, b, this.jt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kb", {
        get: function () {
            return this.jw;
        },
        set: function (a) {
            var b = this.jw;
            this.jw = a;
            if (this.jw != b) {
                this.jd("SelectedBackground", CellModel.ft, b, this.jw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kc", {
        get: function () {
            return this.jx;
        },
        set: function (a) {
            var b = this.jx;
            this.jx = a;
            if (this.jx != b) {
                this.jd("SortIndicatorColor", CellModel.f0, b, this.jx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "kd", {
        get: function () {
            return this.jy;
        },
        set: function (a) {
            var b = this.jy;
            this.jy = a;
            if (this.jy != b) {
                this.jd("StickyRowBackground", CellModel.f2, b, this.jy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ka", {
        get: function () {
            return this.jv;
        },
        set: function (a) {
            var b = this.jv;
            this.jv = a;
            if (this.jv != b) {
                this.jd("PinnedRowBackground", CellModel.fp, b, this.jv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j9", {
        get: function () {
            return this.ju;
        },
        set: function (a) {
            var b = this.ju;
            this.ju = a;
            if (this.ju != b) {
                this.jd("LastStickyRowBackground", CellModel.e8, b, this.ju);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b2", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (this.bn != b) {
                this.jd("PinnedRowOpacity", CellModel.fq, b, this.bn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "gh", {
        get: function () {
            return this.gd;
        },
        set: function (a) {
            var b = this.gd;
            this.gd = a;
            if (this.gd != b) {
                this.jd("OriginalValue", CellModel.fe, b, this.gd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ie", {
        get: function () {
            return this.gk;
        },
        set: function (a) {
            var b = this.gk;
            this.gk = a;
            if (this.gk != b) {
                this.jd("RenderValue", CellModel.fr, b, this.gk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ke", {
        get: function () {
            return this.jz;
        },
        set: function (a) {
            var b = this.jz;
            this.jz = a;
            if (this.jz != b) {
                this.jd("TextColor", CellModel.f3, b, this.jz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j3", {
        get: function () {
            return this.jp;
        },
        set: function (a) {
            var b = this.jp;
            this.jp = a;
            if (this.jp != b) {
                this.jd("ActualTextColor", CellModel.d2, b, this.jp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "j6", {
        get: function () {
            return this.js;
        },
        set: function (a) {
            var b = this.js;
            this.js = a;
            if (this.js != b) {
                this.jd("DeletedTextColor", CellModel.ef, b, this.js);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "af", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (this.ac != b) {
                this.jd("FontInfo", CellModel.et, b, this.ac);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ad", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            var b = this.aa;
            this.aa = a;
            if (this.aa != b) {
                this.jd("ActualFontInfo", CellModel.ds, b, this.aa);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "z", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (this.y != b) {
                this.jd("LineBreakMode", CellModel.fb, enumGetBox(TextCellLineBreakMode_$type, b), enumGetBox(TextCellLineBreakMode_$type, this.y));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "b6", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            var b = this.br;
            this.br = a;
            if (this.br != b) {
                this.jd("VirtualizationPercentage", CellModel.f7, b, this.br);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fh", {
        get: function () {
            return this.c0;
        },
        set: function (a) {
            var b = this.c0;
            this.c0 = a;
            if (this.c0 != b) {
                this.jd("PaddingLeft", CellModel.fi, b, this.c0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fl", {
        get: function () {
            return this.c2;
        },
        set: function (a) {
            var b = this.c2;
            this.c2 = a;
            if (this.c2 != b) {
                this.jd("PaddingTop", CellModel.fm, b, this.c2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "fj", {
        get: function () {
            return this.c1;
        },
        set: function (a) {
            var b = this.c1;
            this.c1 = a;
            if (this.c1 != b) {
                this.jd("PaddingRight", CellModel.fk, b, this.c1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ff", {
        get: function () {
            return this.cz;
        },
        set: function (a) {
            var b = this.cz;
            this.cz = a;
            if (this.cz != b) {
                this.jd("PaddingBottom", CellModel.fg, b, this.cz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dw", {
        get: function () {
            return this.ci;
        },
        set: function (a) {
            var b = this.ci;
            this.ci = a;
            if (this.ci != b) {
                this.jd("ActualPaddingLeft", CellModel.dx, b, this.ci);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d0", {
        get: function () {
            return this.ck;
        },
        set: function (a) {
            var b = this.ck;
            this.ck = a;
            if (this.ck != b) {
                this.jd("ActualPaddingTop", CellModel.d1, b, this.ck);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dy", {
        get: function () {
            return this.cj;
        },
        set: function (a) {
            var b = this.cj;
            this.cj = a;
            if (this.cj != b) {
                this.jd("ActualPaddingRight", CellModel.dz, b, this.cj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "du", {
        get: function () {
            return this.ch;
        },
        set: function (a) {
            var b = this.ch;
            this.ch = a;
            if (this.ch != b) {
                this.jd("ActualPaddingBottom", CellModel.dv, b, this.ch);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d6", {
        get: function () {
            return this.cm;
        },
        set: function (a) {
            var b = this.cm;
            this.cm = a;
            if (this.cm != b) {
                this.jd("BorderLeftWidth", CellModel.d7, b, this.cm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "eb", {
        get: function () {
            return this.co;
        },
        set: function (a) {
            var b = this.co;
            this.co = a;
            if (this.co != b) {
                this.jd("BorderTopWidth", CellModel.ec, b, this.co);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d9", {
        get: function () {
            return this.cn;
        },
        set: function (a) {
            var b = this.cn;
            this.cn = a;
            if (this.cn != b) {
                this.jd("BorderRightWidth", CellModel.ea, b, this.cn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "d4", {
        get: function () {
            return this.cl;
        },
        set: function (a) {
            var b = this.cl;
            this.cl = a;
            if (this.cl != b) {
                this.jd("BorderBottomWidth", CellModel.d5, b, this.cl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "c8", {
        get: function () {
            return this.ca;
        },
        set: function (a) {
            var b = this.ca;
            this.ca = a;
            if (this.ca != b) {
                this.jd("ActivationBorderLeftWidth", CellModel.c9, b, this.ca);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dd", {
        get: function () {
            return this.cc;
        },
        set: function (a) {
            var b = this.cc;
            this.cc = a;
            if (this.cc != b) {
                this.jd("ActivationBorderTopWidth", CellModel.de, b, this.cc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "db", {
        get: function () {
            return this.cb;
        },
        set: function (a) {
            var b = this.cb;
            this.cb = a;
            if (this.cb != b) {
                this.jd("ActivationBorderRightWidth", CellModel.dc, b, this.cb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "c6", {
        get: function () {
            return this.b9;
        },
        set: function (a) {
            var b = this.b9;
            this.b9 = a;
            if (this.b9 != b) {
                this.jd("ActivationBorderBottomWidth", CellModel.c7, b, this.b9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "em", {
        get: function () {
            return this.cs;
        },
        set: function (a) {
            var b = this.cs;
            this.cs = a;
            if (this.cs != b) {
                this.jd("ErrorBorderLeftWidth", CellModel.en, b, this.cs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "er", {
        get: function () {
            return this.cu;
        },
        set: function (a) {
            var b = this.cu;
            this.cu = a;
            if (this.cu != b) {
                this.jd("ErrorBorderTopWidth", CellModel.es, b, this.cu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ep", {
        get: function () {
            return this.ct;
        },
        set: function (a) {
            var b = this.ct;
            this.ct = a;
            if (this.ct != b) {
                this.jd("ErrorBorderRightWidth", CellModel.eq, b, this.ct);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ek", {
        get: function () {
            return this.cr;
        },
        set: function (a) {
            var b = this.cr;
            this.cr = a;
            if (this.cr != b) {
                this.jd("ErrorBorderBottomWidth", CellModel.el, b, this.cr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dj", {
        get: function () {
            return this.ce;
        },
        set: function (a) {
            var b = this.ce;
            this.ce = a;
            if (this.ce != b) {
                this.jd("ActualBorderLeftWidth", CellModel.dk, b, this.ce);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dp", {
        get: function () {
            return this.cg;
        },
        set: function (a) {
            var b = this.cg;
            this.cg = a;
            if (this.cg != b) {
                this.jd("ActualBorderTopWidth", CellModel.dq, b, this.cg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dm", {
        get: function () {
            return this.cf;
        },
        set: function (a) {
            var b = this.cf;
            this.cf = a;
            if (this.cf != b) {
                this.jd("ActualBorderRightWidth", CellModel.dn, b, this.cf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "dh", {
        get: function () {
            return this.cd;
        },
        set: function (a) {
            var b = this.cd;
            this.cd = a;
            if (this.cd != b) {
                this.jd("ActualBorderBottomWidth", CellModel.di, b, this.cd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "m", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            var b = this.l;
            this.l = a;
            if (this.l != b) {
                this.jd("SortDirection", CellModel.fz, enumGetBox(ColumnSortDirection_$type, b), enumGetBox(ColumnSortDirection_$type, this.l));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ay", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (this.aj != b) {
                this.jd("IsExpanded", CellModel.e3, b, this.aj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "aq", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (this.ag != b) {
                this.jd("IsCollapsable", CellModel.e0, b, this.ag);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "x", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (this.w != b) {
                this.jd("Pinned", CellModel.fo, enumGetBox(PinnedPositions_$type, b), enumGetBox(PinnedPositions_$type, this.w));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ae", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (this.ab != b) {
                this.jd("EditFontInfo", CellModel.eh, b, this.ab);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ax", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (this.ai != b) {
                this.jd("IsEdited", CellModel.e2, b, this.ai);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "au", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (this.ah != b) {
                this.jd("IsDeleted", CellModel.e1, b, this.ah);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "he", {
        get: function () {
            return this.gj;
        },
        set: function (a) {
            var b = this.gj;
            this.gj = a;
            if (this.gj != b) {
                this.jd("EditError", CellModel.eg, b, this.gj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellModel.prototype, "ei", {
        get: function () {
            return this.cq;
        },
        set: function (a) {
            this.cq = a;
        },
        enumerable: true,
        configurable: true
    });
    CellModel.prototype.i0 = function () {
        this.i1();
    };
    CellModel.prototype.i1 = function () {
        this.a2 = false;
        this.a7 = false;
        this.ar = false;
        this.ap = false;
        this.a0 = false;
        this.a8 = false;
        this.at = false;
        this.i2();
    };
    CellModel.prototype.b = function (a) {
        if (a == null) {
            a = new CellModelExport();
        }
        a.r = this.b7;
        a.s = this.b8;
        a.n = this.fv;
        a.o = this.fx;
        a.k = this.ev;
        a.q = this.f8;
        a.m = this.b3;
        a.h = this.bu;
        a.z = EnumUtil.getName(TextCellLineBreakMode_$type, this.z);
        a.a = AppearanceHelper.a(this.j1);
        a.b = AppearanceHelper.a(this.j2);
        a.l = this.bw;
        a.i = this.bv;
        a.t = this.ey;
        a.g = this.aq;
        a.d = this.f;
        a.e = this.h;
        a.aa = this.ie;
        a.p = this.b6;
        a.f = this.m;
        a.c = AppearanceHelper.a(this.j3);
        if (this.ad != null) {
            var b = this.ad;
            if (this.o != null && b.n == null) {
                var c = this.o.externalGrid.renderer;
                var d = FontUtil.getFontInfoFromString(c, b.fontString);
                b.n = d.n;
                b.d = d.d;
                b.o = d.o;
                b.q = d.q;
                b.r = d.r;
                b.s = d.s;
            }
            if (b.n != null) {
                a.u = b.n;
            }
            if (!isNaN_(b.d)) {
                a.j = b.d;
            }
            if (b.s != null) {
                a.y = b.s;
            }
            if (b.q != null) {
                a.w = b.q;
            }
            if (b.o != null) {
                a.v = b.q;
            }
        }
        return a;
    };
    CellModel.prototype.i4 = function () {
        if (CellModel.bd == null) {
            CellModel.bd = new Dictionary$2(String_$type, Delegate_$type, 0);
            CellModel.bd.addItem("X", function (a, b) { return a.b7 = typeGetValue(b); });
            CellModel.bd.addItem("Y", function (a, b) { return a.b8 = typeGetValue(b); });
            CellModel.bd.addItem("SnappedX", function (a, b) { return a.fv = typeGetValue(b); });
            CellModel.bd.addItem("SnappedY", function (a, b) { return a.fx = typeGetValue(b); });
            CellModel.bd.addItem("ContentOpacity", function (a, b) { return a.bx = b; });
            CellModel.bd.addItem("Opacity", function (a, b) { return a.b1 = b; });
            CellModel.bd.addItem("LeftOffset", function (a, b) { return a.bz = b; });
            CellModel.bd.addItem("LeftPercentOffset", function (a, b) { return a.b0 = b; });
            CellModel.bd.addItem("TopOffset", function (a, b) { return a.b4 = b; });
            CellModel.bd.addItem("TopPercentOffset", function (a, b) { return a.b5 = b; });
            CellModel.bd.addItem("Height", function (a, b) { return a.ev = typeGetValue(b); });
            CellModel.bd.addItem("Width", function (a, b) { return a.f8 = typeGetValue(b); });
            CellModel.bd.addItem("IsSelected", function (a, b) { return a.a6 = b; });
            CellModel.bd.addItem("ModelType", function (a, b) { return a.v = EnumUtil.getEnumValue(ModelTypes_$type, b); });
            CellModel.bd.addItem("SelectedStatus", function (a, b) { return a.b3 = b; });
            CellModel.bd.addItem("ActivationStatus", function (a, b) { return a.bu = b; });
            CellModel.bd.addItem("HorizontalAlignment", function (a, b) { return a.f = EnumUtil.getEnumValue(CellContentHorizontalAlignment_$type, b); });
            CellModel.bd.addItem("VerticalAlignment", function (a, b) { return a.h = EnumUtil.getEnumValue(CellContentVerticalAlignment_$type, b); });
            CellModel.bd.addItem("Background", function (a, b) { return a.j4 = b; });
            CellModel.bd.addItem("Border", function (a, b) { return a.j5 = b; });
            CellModel.bd.addItem("ActivationBorder", function (a, b) { return a.j0 = b; });
            CellModel.bd.addItem("SelectedBackground", function (a, b) { return a.kb = b; });
            CellModel.bd.addItem("RenderValue", function (a, b) { return a.ie = b; });
            CellModel.bd.addItem("OriginalValue", function (a, b) { return a.gh = b; });
            CellModel.bd.addItem("TextColor", function (a, b) { return a.ke = b; });
            CellModel.bd.addItem("SortIndicatorColor", function (a, b) { return a.kc = b; });
            CellModel.bd.addItem("FontInfo", function (a, b) { return a.af = b; });
            CellModel.bd.addItem("LineBreakMode", function (a, b) { return a.z = EnumUtil.getEnumValue(TextCellLineBreakMode_$type, b); });
            CellModel.bd.addItem("VirtualizationPercentage", function (a, b) { return a.b6 = b; });
            CellModel.bd.addItem("PaddingLeft", function (a, b) { return a.fh = typeGetValue(b); });
            CellModel.bd.addItem("PaddingTop", function (a, b) { return a.fl = typeGetValue(b); });
            CellModel.bd.addItem("PaddingRight", function (a, b) { return a.fj = typeGetValue(b); });
            CellModel.bd.addItem("PaddingBottom", function (a, b) { return a.ff = typeGetValue(b); });
            CellModel.bd.addItem("BorderLeftWidth", function (a, b) { return a.d6 = typeGetValue(b); });
            CellModel.bd.addItem("BorderTopWidth", function (a, b) { return a.eb = typeGetValue(b); });
            CellModel.bd.addItem("BorderRightWidth", function (a, b) { return a.d9 = typeGetValue(b); });
            CellModel.bd.addItem("BorderBottomWidth", function (a, b) { return a.d4 = typeGetValue(b); });
            CellModel.bd.addItem("ActivationBorderLeftWidth", function (a, b) { return a.c8 = typeGetValue(b); });
            CellModel.bd.addItem("ActivationBorderTopWidth", function (a, b) { return a.dd = typeGetValue(b); });
            CellModel.bd.addItem("ActivationBorderRightWidth", function (a, b) { return a.db = typeGetValue(b); });
            CellModel.bd.addItem("ActivationBorderBottomWidth", function (a, b) { return a.c6 = typeGetValue(b); });
            CellModel.bd.addItem("SortDirection", function (a, b) { return a.m = EnumUtil.getEnumValue(ColumnSortDirection_$type, b); });
            CellModel.bd.addItem("PinnedRowBackground", function (a, b) { return a.ka = b; });
            CellModel.bd.addItem("StickyRowBackground", function (a, b) { return a.kd = b; });
            CellModel.bd.addItem("LastStickyRowBackground", function (a, b) { return a.j9 = b; });
            CellModel.bd.addItem("PinnedRowOpacity", function (a, b) { return a.b2 = b; });
            CellModel.bd.addItem("Pinned", function (a, b) { return a.x = EnumUtil.getEnumValue(PinnedPositions_$type, b); });
            CellModel.bd.addItem("IsEdited", function (a, b) { return a.ax = b; });
            CellModel.bd.addItem("IsDeleted", function (a, b) { return a.au = b; });
            CellModel.bd.addItem("DeletedTextColor", function (a, b) { return a.j6 = b; });
            CellModel.bd.addItem("EditOpacity", function (a, b) { return a.by = b; });
            CellModel.bd.addItem("EditFontInfo", function (a, b) { return a.ae = b; });
            CellModel.bd.addItem("ErrorBorder", function (a, b) { return a.j7 = b; });
            CellModel.bd.addItem("ErrorBorderLeftWidth", function (a, b) { return a.em = typeGetValue(b); });
            CellModel.bd.addItem("ErrorBorderTopWidth", function (a, b) { return a.er = typeGetValue(b); });
            CellModel.bd.addItem("ErrorBorderBottomWidth", function (a, b) { return a.ek = typeGetValue(b); });
            CellModel.bd.addItem("ErrorBorderRightWidth", function (a, b) { return a.ep = typeGetValue(b); });
            CellModel.bd.addItem("EditError", function (a, b) { return a.he = b; });
        }
    };
    CellModel.prototype.i3 = function () {
        if (CellModel.ba == null) {
            CellModel.ba = new Dictionary$2(String_$type, Delegate_$type, 0);
            CellModel.ba.addItem("X", function (a) { return a.b7; });
            CellModel.ba.addItem("Y", function (a) { return a.b8; });
            CellModel.ba.addItem("SnappedX", function (a) { return a.fv; });
            CellModel.ba.addItem("SnappedY", function (a) { return a.fx; });
            CellModel.ba.addItem("ContentOpacity", function (a) { return a.bx; });
            CellModel.ba.addItem("Opacity", function (a) { return a.b1; });
            CellModel.ba.addItem("LeftOffset", function (a) { return a.bz; });
            CellModel.ba.addItem("LeftPercentOffset", function (a) { return a.b0; });
            CellModel.ba.addItem("TopOffset", function (a) { return a.b4; });
            CellModel.ba.addItem("TopPercentOffset", function (a) { return a.b5; });
            CellModel.ba.addItem("Height", function (a) { return a.ev; });
            CellModel.ba.addItem("Width", function (a) { return a.f8; });
            CellModel.ba.addItem("IsSelected", function (a) { return a.a6; });
            CellModel.ba.addItem("ModelType", function (a) { return enumGetBox(ModelTypes_$type, a.v); });
            CellModel.ba.addItem("SelectedStatus", function (a) { return a.b3; });
            CellModel.ba.addItem("ActivationStatus", function (a) { return a.bu; });
            CellModel.ba.addItem("HorizontalAlignment", function (a) { return enumGetBox(CellContentHorizontalAlignment_$type, a.f); });
            CellModel.ba.addItem("VerticalAlignment", function (a) { return enumGetBox(CellContentVerticalAlignment_$type, a.h); });
            CellModel.ba.addItem("Background", function (a) { return a.j4; });
            CellModel.ba.addItem("Border", function (a) { return a.j5; });
            CellModel.ba.addItem("ActivationBorder", function (a) { return a.j0; });
            CellModel.ba.addItem("SelectedBackground", function (a) { return a.kb; });
            CellModel.ba.addItem("RenderValue", function (a) { return a.ie; });
            CellModel.ba.addItem("OriginalValue", function (a) { return a.gh; });
            CellModel.ba.addItem("TextColor", function (a) { return a.ke; });
            CellModel.ba.addItem("SortIndicatorColor", function (a) { return a.kc; });
            CellModel.ba.addItem("FontInfo", function (a) { return a.af; });
            CellModel.ba.addItem("LineBreakMode", function (a) { return enumGetBox(TextCellLineBreakMode_$type, a.z); });
            CellModel.ba.addItem("VirtualizationPercentage", function (a) { return a.b6; });
            CellModel.ba.addItem("PaddingLeft", function (a) { return a.fh; });
            CellModel.ba.addItem("PaddingTop", function (a) { return a.fl; });
            CellModel.ba.addItem("PaddingRight", function (a) { return a.fj; });
            CellModel.ba.addItem("PaddingBottom", function (a) { return a.ff; });
            CellModel.ba.addItem("BorderLeftWidth", function (a) { return a.d6; });
            CellModel.ba.addItem("BorderTopWidth", function (a) { return a.eb; });
            CellModel.ba.addItem("BorderRightWidth", function (a) { return a.d9; });
            CellModel.ba.addItem("BorderBottomWidth", function (a) { return a.d4; });
            CellModel.ba.addItem("ActivationBorderLeftWidth", function (a) { return a.c8; });
            CellModel.ba.addItem("ActivationBorderTopWidth", function (a) { return a.dd; });
            CellModel.ba.addItem("ActivationBorderRightWidth", function (a) { return a.db; });
            CellModel.ba.addItem("ActivationBorderBottomWidth", function (a) { return a.c6; });
            CellModel.ba.addItem("SortDirection", function (a) { return enumGetBox(ColumnSortDirection_$type, a.m); });
            CellModel.ba.addItem("PinnedRowBackground", function (a) { return a.ka; });
            CellModel.ba.addItem("StickyRowBackground", function (a) { return a.kd; });
            CellModel.ba.addItem("LastStickyRowBackground", function (a) { return a.j9; });
            CellModel.ba.addItem("PinnedRowOpacity", function (a) { return a.b2; });
            CellModel.ba.addItem("Pinned", function (a) { return enumGetBox(PinnedPositions_$type, a.x); });
            CellModel.ba.addItem("IsEdited", function (a) { return a.ax; });
            CellModel.ba.addItem("IsDeleted", function (a) { return a.au; });
            CellModel.ba.addItem("DeletedTextColor", function (a) { return a.j6; });
            CellModel.ba.addItem("EditOpacity", function (a) { return a.by; });
            CellModel.ba.addItem("EditFontInfo", function (a) { return a.ae; });
            CellModel.ba.addItem("ErrorBorder", function (a) { return a.j7; });
            CellModel.ba.addItem("ErrorBorderLeftWidth", function (a) { return a.em; });
            CellModel.ba.addItem("ErrorBorderTopWidth", function (a) { return a.er; });
            CellModel.ba.addItem("ErrorBorderBottomWidth", function (a) { return a.ek; });
            CellModel.ba.addItem("ErrorBorderRightWidth", function (a) { return a.ep; });
            CellModel.ba.addItem("EditError", function (a) { return a.he; });
        }
    };
    CellModel.prototype.jl = function (a, b) {
        this.i4();
        if (CellModel.bd.containsKey(a)) {
            CellModel.bd.item(a)(this, b);
        }
        else {
            this.jk(a, b);
        }
    };
    CellModel.prototype.gg = function (a) {
        this.i3();
        if (CellModel.ba.containsKey(a)) {
            return CellModel.ba.item(a)(this);
        }
        if (this.ao(a)) {
            return this.gf(a);
        }
        return null;
    };
    CellModel.prototype.a5 = function (a) {
        return (a != 1 || (a == 1 && this.n.dt == 1)) && a != 2 && a != 4 && a != 5;
    };
    CellModel.$t = markType(CellModel, 'CellModel');
    CellModel.cy = 0;
    CellModel.cx = 0;
    CellModel.bc = null;
    CellModel.f1 = CellModel.eu("State");
    CellModel.fn = CellModel.eu("Path");
    CellModel.e5 = CellModel.eu("IsRowPinned");
    CellModel.e6 = CellModel.eu("IsRowSticky");
    CellModel.e4 = CellModel.eu("IsLastStickyRow");
    CellModel.ez = CellModel.eu("Indent");
    CellModel.fs = CellModel.eu("RowItem");
    CellModel.ga = CellModel.eu("X");
    CellModel.gb = CellModel.eu("Y");
    CellModel.fw = CellModel.eu("SnappedX");
    CellModel.fy = CellModel.eu("SnappedY");
    CellModel.ej = CellModel.eu("EditOpacity");
    CellModel.ed = CellModel.eu("ContentOpacity");
    CellModel.dr = CellModel.eu("ActualContentOpacity");
    CellModel.fd = CellModel.eu("Opacity");
    CellModel.dt = CellModel.eu("ActualOpacity");
    CellModel.e9 = CellModel.eu("LeftOffset");
    CellModel.f4 = CellModel.eu("TopOffset");
    CellModel.fa = CellModel.eu("LeftPercentOffset");
    CellModel.f5 = CellModel.eu("TopPercentOffset");
    CellModel.ew = CellModel.eu("Height");
    CellModel.f9 = CellModel.eu("Width");
    CellModel.e7 = CellModel.eu("IsSelected");
    CellModel.fc = CellModel.eu("ModelType");
    CellModel.fu = CellModel.eu("SelectedStatus");
    CellModel.df = CellModel.eu("ActivationStatus");
    CellModel.ex = CellModel.eu("HorizontalAlignment");
    CellModel.f6 = CellModel.eu("VerticalAlignment");
    CellModel.d3 = CellModel.eu("Background");
    CellModel.d8 = CellModel.eu("Border");
    CellModel.dg = CellModel.eu("ActualBackground");
    CellModel.dl = CellModel.eu("ActualBorder");
    CellModel.da = CellModel.eu("ActivationBorder");
    CellModel.eo = CellModel.eu("ErrorBorder");
    CellModel.ft = CellModel.eu("SelectedBackground");
    CellModel.f0 = CellModel.eu("SortIndicatorColor");
    CellModel.f2 = CellModel.eu("StickyRowBackground");
    CellModel.fp = CellModel.eu("PinnedRowBackground");
    CellModel.e8 = CellModel.eu("LastStickyRowBackground");
    CellModel.fq = CellModel.eu("PinnedRowOpacity");
    CellModel.fe = CellModel.eu("OriginalValue");
    CellModel.fr = CellModel.eu("RenderValue");
    CellModel.f3 = CellModel.eu("TextColor");
    CellModel.d2 = CellModel.eu("ActualTextColor");
    CellModel.ef = CellModel.eu("DeletedTextColor");
    CellModel.et = CellModel.eu("FontInfo");
    CellModel.ds = CellModel.eu("ActualFontInfo");
    CellModel.fb = CellModel.eu("LineBreakMode");
    CellModel.f7 = CellModel.eu("VirtualizationPercentage");
    CellModel.fi = CellModel.eu("PaddingLeft");
    CellModel.fm = CellModel.eu("PaddingTop");
    CellModel.fk = CellModel.eu("PaddingRight");
    CellModel.fg = CellModel.eu("PaddingBottom");
    CellModel.dx = CellModel.eu("ActualPaddingLeft");
    CellModel.d1 = CellModel.eu("ActualPaddingTop");
    CellModel.dz = CellModel.eu("ActualPaddingRight");
    CellModel.dv = CellModel.eu("ActualPaddingBottom");
    CellModel.d7 = CellModel.eu("BorderLeftWidth");
    CellModel.ec = CellModel.eu("BorderTopWidth");
    CellModel.ea = CellModel.eu("BorderRightWidth");
    CellModel.d5 = CellModel.eu("BorderBottomWidth");
    CellModel.c9 = CellModel.eu("ActivationBorderLeftWidth");
    CellModel.de = CellModel.eu("ActivationBorderTopWidth");
    CellModel.dc = CellModel.eu("ActivationBorderRightWidth");
    CellModel.c7 = CellModel.eu("ActivationBorderBottomWidth");
    CellModel.en = CellModel.eu("ErrorBorderLeftWidth");
    CellModel.es = CellModel.eu("ErrorBorderTopWidth");
    CellModel.eq = CellModel.eu("ErrorBorderRightWidth");
    CellModel.el = CellModel.eu("ErrorBorderBottomWidth");
    CellModel.dk = CellModel.eu("ActualBorderLeftWidth");
    CellModel.dq = CellModel.eu("ActualBorderTopWidth");
    CellModel.dn = CellModel.eu("ActualBorderRightWidth");
    CellModel.di = CellModel.eu("ActualBorderBottomWidth");
    CellModel.fz = CellModel.eu("SortDirection");
    CellModel.e3 = CellModel.eu("IsExpanded");
    CellModel.e0 = CellModel.eu("IsCollapsable");
    CellModel.fo = CellModel.eu("Pinned");
    CellModel.eh = CellModel.eu("EditFontInfo");
    CellModel.e2 = CellModel.eu("IsEdited");
    CellModel.e1 = CellModel.eu("IsDeleted");
    CellModel.eg = CellModel.eu("EditError");
    CellModel.bd = null;
    CellModel.ba = null;
    return CellModel;
}(Base));
export { CellModel };
/**
 * @hidden
 */
var DateTimeCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeCellModel, _super);
    function DateTimeCellModel() {
        var _this = _super.call(this) || this;
        _this.kl = new Date();
        _this.kt = null;
        _this._formatOverride = null;
        _this.kh = 0;
        _this.kf = null;
        _this.kj = false;
        _this.km = dateMinValue();
        _this.i5(DateTimeCellModel.ko);
        return _this;
    }
    Object.defineProperty(DateTimeCellModel.prototype, "km", {
        get: function () {
            return this.kl;
        },
        set: function (a) {
            var b = this.kl;
            this.kl = a;
            if (+(this.kl) != +b) {
                this.jd("DateTimeValue", DateTimeCellModel.ko, b, this.kl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "ku", {
        get: function () {
            return this._formatOverride;
        },
        set: function (a) {
            var b = this._formatOverride;
            this._formatOverride = a;
            if (this._formatOverride != b) {
                this.jd("FormatOverride", DateTimeCellModel.kp, b, this._formatOverride);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "ki", {
        get: function () {
            return this.kh;
        },
        set: function (a) {
            var b = this.kh;
            this.kh = a;
            if (this.kh != b) {
                this.jd("DateTimeFormat", DateTimeCellModel.kn, enumGetBox(DateTimeFormats_$type, b), enumGetBox(DateTimeFormats_$type, this.kh));
            }
        },
        enumerable: true,
        configurable: true
    });
    DateTimeCellModel.prototype.kx = function (a) {
        if (this._formatOverride != null) {
            var date_ = a;
            return (this._formatOverride.format(date_));
        }
        this.kf.j(this);
        return this.kf.i(a);
    };
    Object.defineProperty(DateTimeCellModel.prototype, "kg", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (this.kf != b) {
                this.jd("Formatter", DateTimeCellModel.kq, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeCellModel.prototype, "kk", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (this.kj != b) {
                this.jd("IsOffsetValue", DateTimeCellModel.kr, b, this.kj);
            }
        },
        enumerable: true,
        configurable: true
    });
    DateTimeCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "DateTimeFormat") {
            this.ki = EnumUtil.getEnumValue(DateTimeFormats_$type, b);
        }
        if (a == "DateTimeValue") {
            this.km = b;
        }
        if (a == "IsOffsetValue") {
            this.kk = b;
        }
        if (a == "FormatOverride") {
            this.ku = b;
        }
    };
    DateTimeCellModel.prototype.gg = function (a) {
        if (a == "DateTimeFormat") {
            return enumGetBox(DateTimeFormats_$type, this.ki);
        }
        if (a == "DateTimeValue") {
            return this.km;
        }
        if (a == "IsOffsetValue") {
            return this.kk;
        }
        if (a == "FormatOverride") {
            return this.ku;
        }
        return _super.prototype.gg.call(this, a);
    };
    DateTimeCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new DateTimeCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.af = this.km;
        b.ag = this.ki;
        b.ae = this.kk;
        return b;
    };
    DateTimeCellModel.$t = markType(DateTimeCellModel, 'DateTimeCellModel', CellModel.$);
    DateTimeCellModel.ko = CellModel.eu("DateTimeValue");
    DateTimeCellModel.kp = CellModel.eu("FormatOverride");
    DateTimeCellModel.kn = CellModel.eu("DateTimeFormat");
    DateTimeCellModel.kq = CellModel.eu("Formatter");
    DateTimeCellModel.kr = CellModel.eu("IsOffsetValue");
    return DateTimeCellModel;
}(CellModel));
export { DateTimeCellModel };
/**
 * @hidden
 */
var EditorCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorCellModel, _super);
    function EditorCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kq = 0;
        _this.kp = 0;
        _this.kn = true;
        _this.kj = null;
        _this.kh = 0;
        _this.k5 = null;
        _this.k1 = null;
        _this.kl = 0;
        _this.k0 = null;
        _this.k4 = null;
        _this.kf = null;
        return _this;
    }
    Object.defineProperty(EditorCellModel.prototype, "ko", {
        get: function () {
            return this.kn;
        },
        set: function (a) {
            var b = this.kn;
            this.kn = a;
            if (b != this.kn) {
                this.jd("IsHidden", EditorCellModel.kz, b, this.kn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "kk", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (b != this.kj) {
                this.jd("EditTarget", EditorCellModel.kw, b, this.kj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "ki", {
        get: function () {
            return this.kh;
        },
        set: function (a) {
            var b = this.kh;
            this.kh = a;
            if (b != this.kh) {
                this.jd("DataType", EditorCellModel.kr, enumGetBox(DataSourceSchemaPropertyType_$type, b), enumGetBox(DataSourceSchemaPropertyType_$type, this.kh));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "le", {
        get: function () {
            return this.k5;
        },
        set: function (a) {
            var b = this.k5;
            this.k5 = a;
            if (b != this.k5) {
                this.jd("ErrorMessage", EditorCellModel.ky, b, this.k5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "k3", {
        get: function () {
            return this.k1;
        },
        set: function (a) {
            var b = this.k1;
            this.k1 = a;
            if (b != this.k1) {
                this.jd("EditValue", EditorCellModel.kx, b, this.k1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "km", {
        get: function () {
            return this.kl;
        },
        set: function (a) {
            var b = this.kl;
            this.kl = a;
            if (b != this.kl) {
                this.jd("EditorType", EditorCellModel.ku, enumGetBox(EditorType_$type, b), enumGetBox(EditorType_$type, this.kl));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "k2", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (b != this.k0) {
                this.jd("EditorItemsSource", EditorCellModel.ks, b, this.k0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "k8", {
        get: function () {
            return this.k4;
        },
        set: function (a) {
            var b = this.k4;
            this.k4 = a;
            if (b != this.k4) {
                this.jd("EditorTextField", EditorCellModel.kt, b, this.k4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorCellModel.prototype, "kg", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (b != this.kf) {
                this.jd("EditorValueField", EditorCellModel.kv, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    EditorCellModel.prototype.jg = function (a, b, c) {
        _super.prototype.jg.call(this, a, b, c);
        switch (a) {
            case "IsHidden":
                this.a2 = true;
                break;
            case "EditTarget":
                this.lh(b);
                this.lj();
                this.ar = true;
                break;
            case "OriginalValue":
            case "DataType":
                this.ar = true;
                break;
            case "ErrorMessage":
                this.lj();
                this.ar = true;
                break;
        }
    };
    EditorCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "IsHidden") {
            this.ko = b;
        }
        else if (a == "DataType") {
            this.ki = EnumUtil.getEnumValue(DataSourceSchemaPropertyType_$type, b);
        }
        else if (a == "ErrorMessage") {
            this.le = b;
        }
        else if (a == "EditValue") {
            this.k3 = b;
        }
    };
    EditorCellModel.prototype.gg = function (a) {
        switch (a) {
            case "IsHidden": return this.ko;
            case "DataType": return enumGetBox(DataSourceSchemaPropertyType_$type, this.ki);
            case "ErrorMessage": return this.le;
            case "EditValue": return this.k3;
        }
        return _super.prototype.gg.call(this, a);
    };
    EditorCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new EditorCellModelExport();
        }
        var b = _super.prototype.b.call(this, a);
        b.af = this.ko;
        b.ae = this.ki;
        b.ag = this.k3 != null ? this.k3.toString() : null;
        b.ah = this.le;
        return b;
    };
    EditorCellModel.prototype.lh = function (a) {
        if (a != null) {
            var b = a;
            b.propertyChanged = delegateRemove(b.propertyChanged, runOn(this, this.li));
        }
        if (this.kk != null) {
            this.b7 = this.kk.b7;
            this.b8 = this.kk.b8;
            this.f8 = this.kk.f8;
            this.ev = this.kk.ev;
            this.kp = this.kk.k.ax;
            this.kq = this.kk.k.w;
            this.gh = this.kk.gh;
            this.le = this.kk.he;
            this.fh = this.kk.dw;
            this.fl = this.kk.d0;
            this.fj = this.kk.dy;
            this.ff = this.kk.du;
            this.j0 = this.kk.j0;
            this.c8 = this.kk.c8 + 1;
            this.dd = this.kk.dd + 1;
            this.db = this.kk.db + 1;
            this.c6 = this.kk.c6 + 1;
            this.bu = 1;
            this.af = this.kk.af;
            var c = this.kk;
            c.propertyChanged = delegateCombine(c.propertyChanged, runOn(this, this.li));
        }
        else {
            this.le = null;
        }
    };
    EditorCellModel.prototype.lj = function () {
        if (this.kk != null) {
            if (this.le != null) {
                this.j0 = GridStyleRepository.bc;
            }
            else {
                this.j0 = this.kk.j0;
            }
        }
    };
    EditorCellModel.prototype.li = function (a, b) {
        switch (b.propertyName) {
            case "X":
                this.b7 = this.kk.b7;
                break;
            case "Y":
                this.b8 = this.kk.b8;
                break;
            case "Width":
                this.f8 = this.kk.f8;
                break;
            case "Height":
                this.ev = this.kk.ev;
                break;
            case "Path":
                if (this.kq != this.kk.k.w || this.kp != this.kk.k.ax) {
                    this.kk = null;
                }
                break;
        }
    };
    EditorCellModel.$t = markType(EditorCellModel, 'EditorCellModel', CellModel.$);
    EditorCellModel.kz = CellModel.eu("IsHidden");
    EditorCellModel.kw = CellModel.eu("EditTarget");
    EditorCellModel.kr = CellModel.eu("DataType");
    EditorCellModel.ky = CellModel.eu("ErrorMessage");
    EditorCellModel.kx = CellModel.eu("EditValue");
    EditorCellModel.ku = CellModel.eu("EditorType");
    EditorCellModel.ks = CellModel.eu("EditorItemsSource");
    EditorCellModel.kt = CellModel.eu("EditorTextField");
    EditorCellModel.kv = CellModel.eu("EditorValueField");
    return EditorCellModel;
}(CellModel));
export { EditorCellModel };
/**
 * @hidden
 */
var SummaryCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryCellModel, _super);
    function SummaryCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kl = null;
        _this.km = null;
        _this.kt = null;
        _this.kf = null;
        return _this;
    }
    Object.defineProperty(SummaryCellModel.prototype, "kn", {
        get: function () {
            return this.kl;
        },
        set: function (a) {
            var b = this.kl;
            this.kl = a;
            if (this.kl != b) {
                this.jd("ResolvedSummaryLabel", SummaryCellModel.kh, b, this.kl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCellModel.prototype, "kp", {
        get: function () {
            return this.km;
        },
        set: function (a) {
            var b = this.km;
            this.km = a;
            if (this.km != b) {
                this.jd("ResolvedSummaryValue", SummaryCellModel.ki, b, this.km);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCellModel.prototype, "ku", {
        get: function () {
            return this.kt;
        },
        set: function (a) {
            var b = this.kt;
            this.kt = a;
            if (this.kt != b) {
                this.jd("SummaryLabelTextColor", SummaryCellModel.kk, b, this.kt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCellModel.prototype, "kg", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (this.kf != b) {
                this.jd("SummaryLabelFontInfo", SummaryCellModel.kj, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    SummaryCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new SummaryCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ai = this.kn;
        b.ao = this.kp;
        b.ae = AppearanceHelper.a(this.ku);
        b.af = AppearanceHelper.a(this.ke);
        if (this.kg != null) {
            var c = this.kg;
            if (this.o != null && c.n == null) {
                var d = this.o.externalGrid.renderer;
                var e = FontUtil.getFontInfoFromString(d, c.fontString);
                c.n = e.n;
                c.d = e.d;
                c.o = e.o;
                c.q = e.q;
                c.r = e.r;
                c.s = e.s;
            }
            if (c.n != null) {
                b.aj = c.n;
            }
            if (!isNaN_(c.d)) {
                b.ag = c.d;
            }
            if (c.s != null) {
                b.an = c.s;
            }
            if (c.q != null) {
                b.al = c.q;
            }
            if (c.o != null) {
                b.ak = c.q;
            }
        }
        if (this.af != null) {
            var f = this.af;
            if (this.o != null && f.n == null) {
                var g = this.o.externalGrid.renderer;
                var h = FontUtil.getFontInfoFromString(g, f.fontString);
                f.n = h.n;
                f.d = h.d;
                f.o = h.o;
                f.q = h.q;
                f.r = h.r;
                f.s = h.s;
            }
            if (f.n != null) {
                b.ap = f.n;
            }
            if (!isNaN_(f.d)) {
                b.ah = f.d;
            }
            if (f.s != null) {
                b.at = f.s;
            }
            if (f.q != null) {
                b.ar = f.q;
            }
            if (f.o != null) {
                b.aq = f.q;
            }
        }
        return b;
    };
    SummaryCellModel.prototype.a5 = function (a) {
        return a == 4 || a == 5;
    };
    SummaryCellModel.$t = markType(SummaryCellModel, 'SummaryCellModel', CellModel.$);
    SummaryCellModel.kh = CellModel.eu("ResolvedSummaryLabel");
    SummaryCellModel.ki = CellModel.eu("ResolvedSummaryValue");
    SummaryCellModel.kk = CellModel.eu("SummaryLabelTextColor");
    SummaryCellModel.kj = CellModel.eu("SummaryLabelFontInfo");
    return SummaryCellModel;
}(CellModel));
export { SummaryCellModel };
/**
 * @hidden
 */
var VerticalSeparatorCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VerticalSeparatorCellModel, _super);
    function VerticalSeparatorCellModel() {
        var _this = _super.call(this) || this;
        _this.kf = true;
        return _this;
    }
    Object.defineProperty(VerticalSeparatorCellModel.prototype, "kg", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (b != this.kf) {
                this.jd("IsHitTestVisible", VerticalSeparatorCellModel.kh, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    VerticalSeparatorCellModel.$t = markType(VerticalSeparatorCellModel, 'VerticalSeparatorCellModel', CellModel.$);
    VerticalSeparatorCellModel.kh = CellModel.eu("IsHitTestVisible");
    return VerticalSeparatorCellModel;
}(CellModel));
export { VerticalSeparatorCellModel };
/**
 * @hidden
 */
var ImageCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ImageCellModel, _super);
    function ImageCellModel() {
        var _this = _super.call(this) || this;
        _this.km = "";
        _this.kh = 0;
        _this.kf = 0;
        _this.f = 3;
        return _this;
    }
    Object.defineProperty(ImageCellModel.prototype, "kn", {
        get: function () {
            return this.km;
        },
        set: function (a) {
            var b = this.km;
            this.km = a;
            if (this.km != b) {
                this.jd("ImagePath", ImageCellModel.kj, b, this.km);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageCellModel.prototype, "ki", {
        get: function () {
            return this.kh;
        },
        set: function (a) {
            var b = this.kh;
            this.kh = a;
            if (this.kh != b) {
                this.jd("ImageStretchOption", ImageCellModel.kl, enumGetBox(ImageStretchOptions_$type, b), enumGetBox(ImageStretchOptions_$type, this.kh));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageCellModel.prototype, "kg", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (this.kf != b) {
                this.jd("ImageResourceType", ImageCellModel.kk, enumGetBox(ImageResourceType_$type, b), enumGetBox(ImageResourceType_$type, this.kf));
            }
        },
        enumerable: true,
        configurable: true
    });
    ImageCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new ImageCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.kn;
        return b;
    };
    ImageCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "ImageStretchOption") {
            this.ki = EnumUtil.getEnumValue(ImageStretchOptions_$type, b);
        }
        if (a == "ImageResourceType") {
            this.kg = EnumUtil.getEnumValue(ImageResourceType_$type, b);
        }
        if (a == "ImagePath") {
            this.kn = b;
        }
    };
    ImageCellModel.prototype.gg = function (a) {
        if (a == "ImageStretchOption") {
            return enumGetBox(ImageStretchOptions_$type, this.ki);
        }
        if (a == "ImageResourceType") {
            return enumGetBox(ImageResourceType_$type, this.kg);
        }
        if (a == "ImagePath") {
            return this.kn;
        }
        return _super.prototype.gg.call(this, a);
    };
    ImageCellModel.$t = markType(ImageCellModel, 'ImageCellModel', CellModel.$);
    ImageCellModel.kj = CellModel.eu("ImagePath");
    ImageCellModel.kl = CellModel.eu("ImageStretchOption");
    ImageCellModel.kk = CellModel.eu("ImageResourceType");
    return ImageCellModel;
}(CellModel));
export { ImageCellModel };
/**
 * @hidden
 */
var NumericCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericCellModel, _super);
    function NumericCellModel() {
        var _this = _super.call(this) || this;
        _this.kk = NaN;
        _this.kf = false;
        _this.k4 = null;
        _this._formatOverride = null;
        _this.k6 = null;
        _this.k8 = null;
        _this.k7 = null;
        _this.k9 = "";
        _this.km = 5;
        _this.kn = 0;
        _this.ko = -1;
        _this.kg = false;
        _this.f = 2;
        return _this;
    }
    Object.defineProperty(NumericCellModel.prototype, "kl", {
        get: function () {
            return this.kk;
        },
        set: function (a) {
            var b = this.kk;
            this.kk = a;
            if (this.kk != b) {
                this.jd("NumericValue", NumericCellModel.kz, b, this.kk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "kh", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (this.kf != b) {
                this.jd("HasDecimalValue", NumericCellModel.kq, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "k5", {
        get: function () {
            return this._formatOverride;
        },
        set: function (a) {
            var b = this._formatOverride;
            this._formatOverride = a;
            if (this._formatOverride != b) {
                this.jd("FormatOverride", NumericCellModel.kp, b, this._formatOverride);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lf", {
        get: function () {
            return this.k6;
        },
        set: function (a) {
            var b = this.k6;
            this.k6 = a;
            if (this.k6 != b) {
                this.jd("NegativePrefix", NumericCellModel.kx, b, this.k6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lk", {
        get: function () {
            return this.k8;
        },
        set: function (a) {
            var b = this.k8;
            this.k8 = a;
            if (this.k8 != b) {
                this.jd("PositivePrefix", NumericCellModel.k0, b, this.k8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lh", {
        get: function () {
            return this.k7;
        },
        set: function (a) {
            var b = this.k7;
            this.k7 = a;
            if (this.k7 != b) {
                this.jd("NegativeSuffix", NumericCellModel.ky, b, this.k7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "lm", {
        get: function () {
            return this.k9;
        },
        set: function (a) {
            var b = this.k9;
            this.k9 = a;
            if (this.k9 != b) {
                this.jd("PositiveSuffix", NumericCellModel.k1, b, this.k9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "kr", {
        get: function () {
            return this.km;
        },
        set: function (a) {
            var b = this.km;
            this.km = a;
            if (this.km != b) {
                this.jd("MaxFractionDigits", NumericCellModel.ks, b, this.km);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "kt", {
        get: function () {
            return this.kn;
        },
        set: function (a) {
            var b = this.kn;
            this.kn = a;
            if (this.kn != b) {
                this.jd("MinFractionDigits", NumericCellModel.ku, b, this.kn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "kv", {
        get: function () {
            return this.ko;
        },
        set: function (a) {
            var b = this.ko;
            this.ko = a;
            if (this.ko != b) {
                this.jd("MinIntegerDigits", NumericCellModel.kw, b, this.ko);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericCellModel.prototype, "kj", {
        get: function () {
            return this.kg;
        },
        set: function (a) {
            var b = this.kg;
            this.kg = a;
            if (this.kg != b) {
                this.jd("ShowGroupingSeparator", NumericCellModel.k2, b, this.kg);
            }
        },
        enumerable: true,
        configurable: true
    });
    NumericCellModel.prototype.ki = function () {
        if (this.aw(NumericCellModel.ku) || this.aw(NumericCellModel.ks) || this.aw(NumericCellModel.kw) || this.aw(NumericCellModel.k1) || this.aw(NumericCellModel.ky) || this.aw(NumericCellModel.k0) || this.aw(NumericCellModel.kx) || this.aw(NumericCellModel.kp) || this.aw(NumericCellModel.k2)) {
            return true;
        }
        return false;
    };
    NumericCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "NumericValue") {
            this.kl = b;
        }
        if (a == "NegativePrefix") {
            this.lf = b;
        }
        if (a == "PositivePrefix") {
            this.lk = b;
        }
        if (a == "NegativeSuffix") {
            this.lh = b;
        }
        if (a == "PositiveSuffix") {
            this.lm = b;
        }
        if (a == "MinFractionDigits") {
            this.kt = typeGetValue(b);
        }
        if (a == "MaxFractionDigits") {
            this.kr = typeGetValue(b);
        }
        if (a == "MinIntegerDigits") {
            this.kv = typeGetValue(b);
        }
        if (a == "ShowGroupingSeparator") {
            this.kj = b;
        }
        if (a == "FormatOverride") {
            this.k5 = b;
        }
    };
    NumericCellModel.prototype.gg = function (a) {
        if (a == "NumericValue") {
            return this.kl;
        }
        if (a == "NegativePrefix") {
            return this.lf;
        }
        if (a == "PositivePrefix") {
            return this.lk;
        }
        if (a == "NegativeSuffix") {
            return this.lf;
        }
        if (a == "PositiveSuffix") {
            return this.lm;
        }
        if (a == "MinFractionDigits") {
            return this.kt;
        }
        if (a == "MaxFractionDigits") {
            return this.kr;
        }
        if (a == "MinIntegerDigits") {
            return this.kv;
        }
        if (a == "ShowGroupingSeparator") {
            return this.kj;
        }
        if (a == "FormatOverride") {
            return this.k5;
        }
        return _super.prototype.gg.call(this, a);
    };
    NumericCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new NumericCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.kl;
        return b;
    };
    NumericCellModel.$t = markType(NumericCellModel, 'NumericCellModel', CellModel.$);
    NumericCellModel.kz = CellModel.eu("NumericValue");
    NumericCellModel.kq = CellModel.eu("HasDecimalValue");
    NumericCellModel.kp = CellModel.eu("FormatOverride");
    NumericCellModel.kx = CellModel.eu("NegativePrefix");
    NumericCellModel.k0 = CellModel.eu("PositivePrefix");
    NumericCellModel.ky = CellModel.eu("NegativeSuffix");
    NumericCellModel.k1 = CellModel.eu("PositiveSuffix");
    NumericCellModel.ks = CellModel.eu("MaxFractionDigits");
    NumericCellModel.ku = CellModel.eu("MinFractionDigits");
    NumericCellModel.kw = CellModel.eu("MinIntegerDigits");
    NumericCellModel.k2 = CellModel.eu("ShowGroupingSeparator");
    return NumericCellModel;
}(CellModel));
export { NumericCellModel };
/**
 * @hidden
 */
var RowSeparatorModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowSeparatorModel, _super);
    function RowSeparatorModel() {
        return _super.call(this) || this;
    }
    RowSeparatorModel.prototype.b = function (a) {
        if (a == null) {
            a = new RowSeparatorModelExport();
        }
        a = _super.prototype.b.call(this, a);
        return a;
    };
    RowSeparatorModel.$t = markType(RowSeparatorModel, 'RowSeparatorModel', CellModel.$);
    return RowSeparatorModel;
}(CellModel));
export { RowSeparatorModel };
/**
 * @hidden
 */
var SectionHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionHeaderCellModel, _super);
    function SectionHeaderCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kf = null;
        _this.kg = null;
        _this.kr = null;
        _this.kq = null;
        _this.kj = 4;
        return _this;
    }
    Object.defineProperty(SectionHeaderCellModel.prototype, "kh", {
        get: function () {
            return this.kf;
        },
        set: function (a) {
            var b = this.kf;
            this.kf = a;
            if (this.kf != b) {
                this.jd("Groups", SectionHeaderCellModel.kl, b, this.kf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "ki", {
        get: function () {
            return this.kg;
        },
        set: function (a) {
            var b = this.kg;
            this.kg = a;
            if (this.kg != b) {
                this.jd("Summaries", SectionHeaderCellModel.ko, b, this.kg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "kv", {
        get: function () {
            return this.kr;
        },
        set: function (a) {
            var b = this.kr;
            this.kr = a;
            if (this.kr != b) {
                this.jd("ResolvedText", SectionHeaderCellModel.kn, b, this.kr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "kt", {
        get: function () {
            return this.kq;
        },
        set: function (a) {
            var b = this.kq;
            this.kq = a;
            if (this.kq != b) {
                this.jd("ResolvedSummaryText", SectionHeaderCellModel.km, b, this.kq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeaderCellModel.prototype, "kk", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (this.kj != b) {
                this.jd("SummaryDisplayMode", SectionHeaderCellModel.kp, enumGetBox(GroupSummaryDisplayMode_$type, b), enumGetBox(GroupSummaryDisplayMode_$type, this.kj));
            }
        },
        enumerable: true,
        configurable: true
    });
    SectionHeaderCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "Groups") {
            this.kh = b;
        }
        else if (a == "SummaryDisplayMode") {
            this.kk = EnumUtil.getEnumValue(GroupSummaryDisplayMode_$type, b);
        }
    };
    SectionHeaderCellModel.prototype.gg = function (a) {
        if (a == "Groups") {
            return this.kh;
        }
        else if (a == "IsCollapsable") {
            return this.aq;
        }
        else if (a == "SummaryDisplayMode") {
            return enumGetBox(GroupSummaryDisplayMode_$type, this.kk);
        }
        return _super.prototype.gg.call(this, a);
    };
    SectionHeaderCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new SectionHeaderCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.af = new Array(this.kh.length);
        b.ag = new Array(this.kh.length);
        b.ae = new Array(this.kh.length);
        b.al = this.kv;
        b.ai = new Array(this.ki.length);
        b.ak = new Array(this.ki.length);
        b.aj = new Array(this.ki.length);
        b.ah = new Array(this.ki.length);
        b.am = this.kt;
        for (var c = 0; c < this.kh.length; c++) {
            b.af[c] = this.kh[c].c;
            b.ag[c] = this.kh[c].a;
            b.ae[c] = this.kh[c].b;
        }
        for (var d = 0; d < this.ki.length; d++) {
            b.ai[d] = this.ki[d].e;
            b.ak[d] = this.ki[d].b;
            b.aj[d] = this.ki[d].a;
            b.ah[d] = this.ki[d].c;
        }
        return b;
    };
    SectionHeaderCellModel.prototype.a5 = function (a) {
        return a == 1;
    };
    SectionHeaderCellModel.$t = markType(SectionHeaderCellModel, 'SectionHeaderCellModel', CellModel.$);
    SectionHeaderCellModel.kl = CellModel.eu("Groups");
    SectionHeaderCellModel.ko = CellModel.eu("Summaries");
    SectionHeaderCellModel.kn = CellModel.eu("ResolvedText");
    SectionHeaderCellModel.km = CellModel.eu("ResolvedSummaryText");
    SectionHeaderCellModel.kp = CellModel.eu("SummaryDisplayMode");
    return SectionHeaderCellModel;
}(CellModel));
export { SectionHeaderCellModel };
/**
 * @hidden
 */
var TemplateCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellModel, _super);
    function TemplateCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kg = null;
        return _this;
    }
    Object.defineProperty(TemplateCellModel.prototype, "kh", {
        get: function () {
            return this.kg;
        },
        set: function (a) {
            var b = this.kg;
            this.kg = a;
            if (this.kg != b) {
                this.jd("Value", TemplateCellModel.kf, b, this.kg);
            }
        },
        enumerable: true,
        configurable: true
    });
    TemplateCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "Value") {
            this.kh = b;
        }
    };
    TemplateCellModel.prototype.gg = function (a) {
        if (a == "Value") {
            return this.kh;
        }
        return _super.prototype.gg.call(this, a);
    };
    TemplateCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TemplateCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.kh;
        return b;
    };
    TemplateCellModel.$t = markType(TemplateCellModel, 'TemplateCellModel', CellModel.$);
    TemplateCellModel.kf = CellModel.eu("Value");
    return TemplateCellModel;
}(CellModel));
export { TemplateCellModel };
/**
 * @hidden
 */
var TextCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextCellModel, _super);
    function TextCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kg = "";
        return _this;
    }
    Object.defineProperty(TextCellModel.prototype, "kh", {
        get: function () {
            return this.kg;
        },
        set: function (a) {
            var b = this.kg;
            this.kg = a;
            if (this.kg != b) {
                this.jd("TextValue", TextCellModel.kf, b, this.kg);
            }
        },
        enumerable: true,
        configurable: true
    });
    TextCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "TextValue") {
            this.kh = b;
        }
    };
    TextCellModel.prototype.gg = function (a) {
        if (a == "TextValue") {
            return this.kh;
        }
        return _super.prototype.gg.call(this, a);
    };
    TextCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TextCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.af = this.kh;
        return b;
    };
    TextCellModel.$t = markType(TextCellModel, 'TextCellModel', CellModel.$);
    TextCellModel.kf = CellModel.eu("TextValue");
    return TextCellModel;
}(CellModel));
export { TextCellModel };
/**
 * @hidden
 */
var TextHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeaderCellModel, _super);
    function TextHeaderCellModel() {
        var _this = _super.call(this) || this;
        _this.kp = false;
        _this.kn = 0;
        _this.kj = 0;
        _this.k1 = null;
        _this.kl = 0;
        return _this;
    }
    Object.defineProperty(TextHeaderCellModel.prototype, "kq", {
        get: function () {
            return this.kp;
        },
        set: function (a) {
            var b = this.kp;
            this.kp = a;
            if (this.kp != b) {
                this.jd("IsColumnOptionsEnabled", TextHeaderCellModel.ku, b, this.kp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "ko", {
        get: function () {
            return this.kn;
        },
        set: function (a) {
            var b = this.kn;
            this.kn = a;
            if (this.kn != b) {
                this.jd("SortIndicatorStyle", TextHeaderCellModel.kv, enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.kn));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "kk", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            var b = this.kj;
            this.kj = a;
            if (this.kj != b) {
                this.jd("ColumnOptionsIconAlignment", TextHeaderCellModel.kr, enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.kj));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "k2", {
        get: function () {
            return this.k1;
        },
        set: function (a) {
            var b = this.k1;
            this.k1 = a;
            if (this.k1 != b) {
                this.jd("ColumnOptionsIconColor", TextHeaderCellModel.kt, b, this.k1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextHeaderCellModel.prototype, "km", {
        get: function () {
            return this.kl;
        },
        set: function (a) {
            var b = this.kl;
            this.kl = a;
            if (this.kl != b) {
                this.jd("ColumnOptionsIconBehavior", TextHeaderCellModel.ks, enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.kl));
            }
        },
        enumerable: true,
        configurable: true
    });
    TextHeaderCellModel.prototype.jl = function (a, b) {
        _super.prototype.jl.call(this, a, b);
        if (a == "IsColumnOptionsEnabled") {
            this.kq = b;
        }
        else if (a == "SortIndicatorStyle") {
            this.ko = EnumUtil.getEnumValue(SortIndicatorStyle_$type, b);
        }
        else if (a == "ColumnOptionsIconAlignment") {
            this.kk = EnumUtil.getEnumValue(ColumnOptionsIconAlignment_$type, b);
        }
        else if (a == "ColumnOptionsIconColor") {
            this.k2 = b;
        }
        else if (a == "ColumnOptionsIconBehavior") {
            this.km = EnumUtil.getEnumValue(ColumnOptionsIconBehavior_$type, b);
        }
    };
    TextHeaderCellModel.prototype.gg = function (a) {
        if (a == "IsColumnOptionsEnabled") {
            return this.kq;
        }
        if (a == "SortIndicatorStyle") {
            return enumGetBox(SortIndicatorStyle_$type, this.ko);
        }
        if (a == "ColumnOptionsIconAlignment") {
            return enumGetBox(ColumnOptionsIconAlignment_$type, this.kk);
        }
        if (a == "ColumnOptionsIconColor") {
            return this.k2;
        }
        if (a == "ColumnOptionsIconBehavior") {
            return enumGetBox(ColumnOptionsIconBehavior_$type, this.km);
        }
        return _super.prototype.gg.call(this, a);
    };
    TextHeaderCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TextHeaderCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        return b;
    };
    TextHeaderCellModel.$t = markType(TextHeaderCellModel, 'TextHeaderCellModel', TextCellModel.$);
    TextHeaderCellModel.ku = CellModel.eu("IsColumnOptionsEnabled");
    TextHeaderCellModel.kv = CellModel.eu("SortIndicatorStyle");
    TextHeaderCellModel.kr = CellModel.eu("ColumnOptionsIconAlignment");
    TextHeaderCellModel.kt = CellModel.eu("ColumnOptionsIconColor");
    TextHeaderCellModel.ks = CellModel.eu("ColumnOptionsIconBehavior");
    return TextHeaderCellModel;
}(TextCellModel));
export { TextHeaderCellModel };
/**
 * @hidden
 */
export var ICellPresenter_$type = /*@__PURE__*/ new Type(null, 'ICellPresenter');
/**
 * @hidden
 */
var DataSourceNotificationBridge = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataSourceNotificationBridge, _super);
    function DataSourceNotificationBridge(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    DataSourceNotificationBridge.prototype.rangeActualized = function (a, b) {
        this.a.qq(a, b);
    };
    DataSourceNotificationBridge.prototype.notifySetItem = function (a, b, c) {
        this.a.rd(a, b, c);
    };
    DataSourceNotificationBridge.prototype.notifyClearItems = function () {
        this.a.qd();
    };
    DataSourceNotificationBridge.prototype.notifyInsertItem = function (a, b) {
        this.a.q1(a, b);
    };
    DataSourceNotificationBridge.prototype.notifyRemoveItem = function (a, b) {
        this.a.q6(a, b);
    };
    DataSourceNotificationBridge.$t = markType(DataSourceNotificationBridge, 'DataSourceNotificationBridge', Base.$, [IDataSourceUpdateNotifier_$type]);
    return DataSourceNotificationBridge;
}(Base));
export { DataSourceNotificationBridge };
/**
 * @hidden
 */
var ColumnController = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnController, _super);
    function ColumnController(a, b, c) {
        var _this = _super.call(this) || this;
        _this.i = null;
        _this.n = false;
        _this.c = null;
        _this.a = null;
        _this.u = new HashSet$1(String_$type, 0);
        _this.m = false;
        _this.k = null;
        _this.l = null;
        _this.n = b;
        _this.i = a;
        _this.l = c;
        return _this;
    }
    Object.defineProperty(ColumnController.prototype, "p", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            if (b != this.n) {
                this.m = false;
            }
            this.t();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.m = false;
            }
            this.t();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.m = false;
                this.u.clear();
                for (var c = 0; c < this.a.length; c++) {
                    this.u.add_1(this.a[c]);
                }
            }
            this.t();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "j", {
        get: function () {
            return this.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnController.prototype, "o", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            this.m = a;
        },
        enumerable: true,
        configurable: true
    });
    ColumnController.prototype.t = function () {
        if (this.m) {
            return false;
        }
        if (this.c == null) {
            return false;
        }
        var a = new Dictionary$2(String_$type, Boolean_$type, 0);
        for (var b = 0; b < this.i.count; b++) {
            var c = this.i._inner[b];
            if (!c.f8) {
                a.item(c.hx, true);
            }
        }
        var d = false;
        for (var e = this.i.count - 1; e >= 0; e--) {
            if (this.i._inner[e].f8) {
                this.k.removeExternalColumn(this.i._inner[e].externalObject);
            }
        }
        if (this.n && this.c != null) {
            d = this.q(a, this.c);
        }
        this.m = true;
        if (d) {
            this.l();
        }
        return d;
    };
    ColumnController.prototype.q = function (a, b) {
        var c = new GridColumnCollection();
        for (var d = 0; d < b.propertyNames.length; d++) {
            var e = b.propertyNames[d];
            if (!a.containsKey(e)) {
                if (this.b != null && !this.u.contains(e)) {
                    continue;
                }
                var f = this.e(e, b.propertyTypes[d]);
                c.add(f);
                a.item(e, true);
            }
        }
        var g = new Dictionary$2(String_$type, Boolean_$type, 0);
        for (var h = 0; h < c.count; h++) {
            g.item(c._inner[h].hx, true);
        }
        var i = false;
        var j = this.i.count;
        for (var k = 0; k < c.count; k++) {
            i = true;
            this.k.insertExternalColumnAtIndex(j + k, c._inner[k].externalObject);
        }
        return i;
    };
    ColumnController.prototype.e = function (a, b) {
        var c = null;
        switch (b) {
            case 8:
            case 9:
                c = this.k.createDateTimeColumn(a);
                break;
            case 5:
            case 6:
            case 7:
            case 1:
            case 3:
            case 4:
            case 10:
                c = this.k.createNumericColumn(a);
                break;
            case 11:
                c = this.k.createTextColumn(a);
                break;
            case 0:
            case 2:
                c = this.k.createTextColumn(a);
                break;
        }
        c.hx = a;
        c.f8 = true;
        c.ic = (createGuid());
        return c;
    };
    ColumnController.prototype.h = function (a) {
        if (a.ax < 0 || this.i.count == 0 || this.i.count <= a.ax) {
            return null;
        }
        return this.i._inner[a.ax];
    };
    ColumnController.prototype.f = function (a) {
        for (var b = 0; b < this.i.count; b++) {
            if (this.i._inner[b].g2 == a) {
                return this.i._inner[b];
            }
        }
        return null;
    };
    ColumnController.prototype.g = function (a) {
        for (var b = 0; b < this.i.count; b++) {
            if (this.i._inner[b].hz() == a) {
                return this.i._inner[b];
            }
        }
        return null;
    };
    ColumnController.prototype.r = function (a) {
        return false;
    };
    ColumnController.prototype.s = function (a) {
        return false;
    };
    ColumnController.$t = markType(ColumnController, 'ColumnController');
    return ColumnController;
}(Base));
export { ColumnController };
/**
 * @hidden
 */
var EditingManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditingManager, _super);
    function EditingManager(a) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.b = null;
        _this.j = 0;
        _this.i = 0;
        _this.g = false;
        _this.d = a;
        return _this;
    }
    Object.defineProperty(EditingManager.prototype, "c", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditingManager.prototype, "a", {
        get: function () {
            return this.c != null ? this.c.kk : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditingManager.prototype, "h", {
        get: function () {
            return this.a != null ? this.a.ei : -1;
        },
        enumerable: true,
        configurable: true
    });
    EditingManager.prototype.n = function (a) {
        if (a == null || a.k.ax < 0 || a.k.w < 0) {
            return;
        }
        if (this.b == null) {
            this.b = new EditorCellModel();
            this.b.c = new DefaultCellActionManager(this.d, this.b);
            this.b.d = new DefaultGridInfoRequestor(this.d, this.b);
            this.b.k = new CellPath(1, -1000, 0, -1000);
        }
        if (this.g && this.b.le != null) {
            return;
        }
        this.g = true;
        var b = this.d.actualColumns._inner[a.k.ax];
        var c = this.e(b, a.k.w);
        if (this.b.q != c) {
            if (this.b.q != null) {
                this.b.q.f(this.b.k);
            }
            c.s(this.b.k, this.b);
        }
        this.b.q = c;
        this.b.kk = a;
        this.b.k3 = a.gh;
        this.b.le = a.he;
        this.b.km = b.fc;
        this.b.k2 = b.g4;
        this.b.k8 = b.ht;
        this.b.kg = b.em;
        this.b.ko = false;
        this.b.ki = this.d.actualDataSource.resolveSchemaPropertyType(b.hx);
        this.j = a.k.w;
        this.i = a.k.ax;
        this.k();
    };
    EditingManager.prototype.f = function (a) {
        if (this.b != null && this.b.kk != null && this.g) {
            var b = true;
            if (a) {
                b = this.d.im(this.b.kk, this.b.k3);
            }
            else {
                if (this.h != -1) {
                    this.d.rs(this.h);
                }
                this.b.le = null;
            }
            if (b && this.b.le == null) {
                this.g = false;
                this.b.kk = null;
                this.b.gh = null;
                this.b.k3 = null;
                this.b.ko = true;
                this.b.b7 = -1000;
                this.b.b8 = -1000;
                this.k();
            }
        }
        return !this.g;
    };
    EditingManager.prototype.l = function (a) {
        if (this.b != null) {
            this.b.le = a;
            this.k();
        }
    };
    EditingManager.prototype.m = function (a) {
        if (this.b != null) {
            this.b.kk = a;
        }
    };
    EditingManager.prototype.k = function () {
        this.d.renderingEngine.refresh(this.d.model, false);
    };
    EditingManager.prototype.e = function (a, b) {
        if (a.fk != 0) {
            if (this.d.d3.isRowPinned(b)) {
                return this.d.model.ar;
            }
            else {
                return this.d.model.av;
            }
        }
        else {
            if (this.d.d3.isRowPinned(b)) {
                return this.d.model.a2;
            }
            else {
                return this.d.model.ba;
            }
        }
    };
    EditingManager.$t = markType(EditingManager, 'EditingManager');
    return EditingManager;
}(Base));
export { EditingManager };
/**
 * @hidden
 */
var Grid = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Grid, _super);
    function Grid() {
        var _this = _super.call(this) || this;
        _this.k4 = null;
        _this._propertySetter = null;
        _this.d7 = null;
        _this.d5 = null;
        _this.columnExchangingAnimationCompleted = null;
        _this.columnExchangingAnimationCanceled = null;
        _this.columnShowingAnimationCompleted = null;
        _this.columnShowingAnimationCanceled = null;
        _this.filterExpressionsChanging = null;
        _this.filterExpressionsChanged = null;
        _this.columnMovingAnimationCompleted = null;
        _this.columnMovingAnimationCanceled = null;
        _this.columnHidingAnimationCompleted = null;
        _this.columnHidingAnimationCanceled = null;
        _this.cellPreviewPointerDown = null;
        _this.cellPreviewPointerUp = null;
        _this.cellPointerDown = null;
        _this.cellPointerUp = null;
        _this.cellClicked = null;
        _this.bt = 0;
        _this.bf = 0;
        _this.uo = null;
        _this.aq = null;
        _this.f3 = false;
        _this.jx = -1;
        _this.gc = false;
        _this.gb = false;
        _this.iy = 0;
        _this.i5 = 0;
        _this.i3 = 0;
        _this.i4 = 0;
        _this.io = new Date();
        _this.it = 0;
        _this.iu = 0;
        _this.iv = 0;
        _this.iw = 0;
        _this.as = null;
        _this.j1 = 0;
        _this.j0 = 0;
        _this.gl = false;
        _this.jt = -1;
        _this.j2 = -1;
        _this.ed = 0;
        _this.an = null;
        _this.ir = -1;
        _this.i2 = 0;
        _this.iz = 0;
        _this.i0 = 0;
        _this.am = null;
        _this.hl = false;
        _this.go = false;
        _this.gq = false;
        _this.gn = false;
        _this.cj = new GridAnimationManager();
        _this._delayedExecutionManager = null;
        _this.ee = null;
        _this.d2 = null;
        _this.a1 = null;
        _this.da = new GridLayerController();
        _this.ex = new SpatialEngine();
        _this.c5 = null;
        _this.er = null;
        _this.ai = null;
        _this.ev = null;
        _this.cb = null;
        _this.fr = null;
        _this.ep = null;
        _this.en = new SectionFooter();
        _this.ez = null;
        _this.e1 = null;
        _this.el = null;
        _this.dw = null;
        _this.dy = null;
        _this.bv = null;
        _this.bh = null;
        _this.eb = null;
        _this.b = null;
        _this.c = null;
        _this.e3 = new VisibilityEngine();
        _this._viewportManager = null;
        _this.iq = 0;
        _this.ip = 0;
        _this.e7 = 2;
        _this.jk = truncate(DeviceUtils.g(36));
        _this.ju = -1;
        _this.b8 = ColumnWidth.a;
        _this.is = 0;
        _this.jj = truncate(DeviceUtils.g(36));
        _this.jo = -1;
        _this.jz = truncate(DeviceUtils.g(0));
        _this.k5 = null;
        _this.jy = truncate(DeviceUtils.g(0));
        _this.jw = truncate(DeviceUtils.g(0));
        _this.jn = truncate(DeviceUtils.g(0));
        _this.du = 0;
        _this.ce = 1;
        _this.cc = 2;
        _this.fv = true;
        _this.jv = truncate(DeviceUtils.g(1));
        _this.ga = true;
        _this.bx = 1;
        _this.bo = 0;
        _this.ak = 0;
        _this.ej = 1;
        _this.av = 1;
        _this.cw = new GridColumnAnimationSettings();
        _this.cl = new GridAnimationSettings();
        _this.bq = 1;
        _this.by = 1;
        _this.bc = 1;
        _this.a9 = 1;
        _this.a3 = 1;
        _this.uu = new Thickness(1, 0, 0, 0, 0);
        _this.dm = 5;
        _this.cg = 1;
        _this.dk = 1;
        _this.fz = false;
        _this.ab = new GridSelectedItemsCollection();
        _this.af = new GridSelectedKeysCollection();
        _this.dg = new GridSelectedCellsCollection();
        _this.dd = new GridSelectedCellRangesCollection();
        _this.fy = false;
        _this.aa = new GridSelectedItemsCollection();
        _this.ae = new GridSelectedKeysCollection();
        _this.f2 = true;
        _this.f8 = true;
        _this.f9 = true;
        _this.s0 = null;
        _this.ti = null;
        _this.tl = null;
        _this.tp = null;
        _this.i1 = NaN;
        _this.fa = null;
        _this.ix = NaN;
        _this.s5 = null;
        _this.tk = null;
        _this.tc = null;
        _this.tb = null;
        _this.ct = null;
        _this.cs = null;
        _this.sz = null;
        _this.s1 = null;
        _this.s9 = null;
        _this.et = 0;
        _this.e9 = null;
        _this.th = null;
        _this.tj = null;
        _this.fc = null;
        _this.fd = null;
        _this.ff = null;
        _this.to = null;
        _this.fe = null;
        _this.fg = null;
        _this.ts = null;
        _this.tm = null;
        _this.tq = null;
        _this.tn = null;
        _this.tr = null;
        _this.js = truncate(DeviceUtils.g(1));
        _this.jp = truncate(DeviceUtils.g(1));
        _this.s8 = null;
        _this.s6 = null;
        _this.ta = null;
        _this.fb = null;
        _this.td = null;
        _this.s7 = null;
        _this.tg = null;
        _this.te = null;
        _this.tf = null;
        _this.jm = truncate(DeviceUtils.g(4));
        _this.jl = truncate(DeviceUtils.g(2));
        _this.s4 = null;
        _this.s2 = null;
        _this.gk = false;
        _this.bj = 0;
        _this.s3 = null;
        _this.bl = 0;
        _this.sy = null;
        _this.ut = GridStyleRepository.bl;
        _this.ur = GridStyleRepository.bl;
        _this.us = new Thickness(0, NaN);
        _this.ge = false;
        _this.st = GridStyleRepository.r;
        _this.ss = new CornerRadius(0, NaN);
        _this.sr = GridStyleRepository.r;
        _this.f1 = true;
        _this.fp = new DefaultPlatformPixelConverter();
        _this.d0 = null;
        _this.eg = null;
        _this.e5 = new VisualModel();
        _this.b3 = null;
        _this.a6 = null;
        _this.u = null;
        _this.b6 = null;
        _this.sortDescriptionsChanged = null;
        _this.groupDescriptionsChanged = null;
        _this.columnHiddenChanged = null;
        _this.columnPinnedChanged = null;
        _this.cellValueChanging = null;
        _this.dataCommitted = null;
        _this.dataCommitting = null;
        _this.gm = false;
        _this.s = 0;
        _this.f5 = false;
        _this.f4 = false;
        _this.fw = false;
        _this.q = 0;
        _this.f7 = false;
        _this.f6 = true;
        _this.fx = false;
        _this.ds = 4;
        _this.fu = true;
        _this.propertyChanged = null;
        _this.gj = false;
        _this.y = null;
        _this.w = null;
        _this.d = null;
        _this.a = null;
        _this.sizeChanged = null;
        _this.viewportChanged = null;
        _this.jq = -1;
        _this.jr = -1;
        _this.actualColumnsChanged = null;
        _this.cy = new GridColumnCollection();
        _this.gd = false;
        _this.ij = false;
        _this.ik = false;
        _this.ft = false;
        _this.g5 = false;
        _this.hk = false;
        _this.gp = false;
        _this.ar = null;
        _this.columnsAutoGenerated = null;
        _this.selectedItemsChanged = null;
        _this.selectedKeysChanged = null;
        _this.selectedCellsChanged = null;
        _this.activeCellChanged = null;
        _this.selectedCellRangesChanged = null;
        _this.at = null;
        _this.f0 = false;
        _this.gi = true;
        _this.gh = true;
        _this.gg = true;
        _this.gf = false;
        _this.eq = new SectionHeader();
        _this.em = new RowSeparator();
        _this.dx = new HeaderRowSeparator();
        _this.dz = new HeaderSeparator();
        _this.bw = new ColumnResizingSeparator();
        _this.bi = new ColumnMovingSeparator();
        _this.ec = new PinnedAreaSeparator();
        _this.e0 = new SummaryRowRoot();
        _this.e2 = new SummaryRowSection();
        _this.us = _this.ut;
        _this.ss = _this.st;
        _this.sy = GridStyleRepository.av;
        _this.a1 = new ColumnController(_this.cy, _this.gs, runOn(_this, _this.pw));
        var a = _this.a1.j;
        a.collectionChanged = delegateCombine(a.collectionChanged, runOn(_this, _this.ox));
        _this.d2 = new DataAdapter(_this.a1);
        _this.eg = new ResponsiveStatesCollection();
        _this.ee = new ResponsiveEngine(_this);
        _this.ee.g = _this.eg;
        _this.g5 = _this.ia();
        _this.hk = _this.ib();
        _this.es = new SelectionManager(_this, _this.ck);
        _this.aj = new ActivationManager(_this, _this.ck);
        _this.ab.af(runOn(_this, _this.r9));
        _this.af.af(runOn(_this, _this.sa));
        _this.dg.an(runOn(_this, _this.r8));
        var b = _this.dd;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.r7));
        _this.aa.af(runOn(_this, _this.ri));
        _this.ae.af(runOn(_this, _this.rj));
        _this.b3 = new ColumnSortDescriptionCollection();
        _this.a6 = new ColumnGroupDescriptionCollection();
        _this.b6 = new ColumnSummaryDescriptionCollection();
        _this.b3.l(runOn(_this, _this.sf));
        _this.a6.l(runOn(_this, _this.pi));
        _this.b6.l(runOn(_this, _this.sg));
        _this.u = new FilterExpressionCollection();
        _this.u.m(runOn(_this, _this.pf));
        _this.ew = new SortManager(_this);
        _this.cb = new EditingManager(_this);
        return _this;
    }
    Object.defineProperty(Grid.prototype, "k8", {
        get: function () {
            return this.k4;
        },
        set: function (a) {
            this.k4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "propertySetter", {
        get: function () {
            return this._propertySetter;
        },
        set: function (a) {
            this._propertySetter = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "externalGrid", {
        get: function () {
            return this.d7;
        },
        set: function (a) {
            this.d7 = a;
            if (this.a2 != null) {
                this.a2.k = this.d7;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dragger", {
        get: function () {
            return this.d5;
        },
        set: function (a) {
            if (this.d5 != null) {
                var b = this.d5;
                b.onDrag = delegateRemove(b.onDrag, runOn(this, this.qt));
                var c = this.d5;
                c.onDragEnd = delegateCombine(c.onDragEnd, runOn(this, this.qv));
            }
            this.d5 = a;
            var d = this.d5;
            d.onDrag = delegateCombine(d.onDrag, runOn(this, this.qt));
            var e = this.d5;
            e.onDragEnd = delegateCombine(e.onDragEnd, runOn(this, this.qv));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.qf = function (a) {
        if (this.columnExchangingAnimationCompleted != null) {
            this.columnExchangingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.qe = function (a) {
        if (this.columnExchangingAnimationCanceled != null) {
            this.columnExchangingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.o = function (a) {
        var b = this.a0(a.k);
        if (b == null) {
            return null;
        }
        return b.eo;
    };
    Grid.prototype.p = function (a) {
        var b = this.a0(a.k);
        if (b == null) {
            return 11;
        }
        if (this.actualDataSource == null) {
            return 11;
        }
        return this.actualDataSource.resolveSchemaPropertyType(b.hx);
    };
    Grid.prototype.qo = function (a) {
        if (this.columnShowingAnimationCompleted != null) {
            this.columnShowingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.o8 = function (a, b) {
        var _this = this;
        var c = this.a0(a.k);
        if (c == null) {
            return;
        }
        if (!Base.equalsStatic(c.eo, b)) {
            c.eo = b;
            if (this.filterExpressionsChanging != null) {
                this.filterExpressionsChanging(this, ((function () {
                    var $ret = new GridFilterExpressionsEventArgs();
                    $ret.a = _this.v;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.o7 = function (a, b) {
        var c = this.a0(a.k);
        if (c == null) {
            return;
        }
        if (!Base.equalsStatic(c.eo, b)) {
            c.eo = b;
        }
    };
    Grid.prototype.qn = function (a) {
        if (this.columnShowingAnimationCanceled != null) {
            this.columnShowingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.ql = function (a) {
        if (this.columnMovingAnimationCompleted != null) {
            this.columnMovingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.qk = function (a) {
        if (this.columnMovingAnimationCanceled != null) {
            this.columnMovingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.qh = function (a) {
        if (this.columnHidingAnimationCompleted != null) {
            this.columnHidingAnimationCompleted(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.qg = function (a) {
        if (this.columnHidingAnimationCanceled != null) {
            this.columnHidingAnimationCanceled(a.externalObject, new EventArgs());
        }
    };
    Grid.prototype.p9 = function (a) {
        var _this = this;
        if (this.cellPreviewPointerDown != null) {
            this.cellPreviewPointerDown(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.qa = function (a) {
        var _this = this;
        if (this.cellPreviewPointerUp != null) {
            this.cellPreviewPointerUp(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.p7 = function (a) {
        var _this = this;
        if (this.cellPointerDown != null) {
            this.cellPointerDown(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.p8 = function (a) {
        var _this = this;
        if (this.cellPointerUp != null) {
            this.cellPointerUp(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.q8 = function (a, b) {
        this.pn(a);
    };
    Grid.prototype.q0 = function (a) {
        if (a.v == 2) {
            this.sn(a.k.w);
        }
    };
    Grid.prototype.sn = function (a) {
        if (this.cb.g && !this.gz(true)) {
            return;
        }
        var b = !this.actualDataSource.getIsRowExpandedAtIndex(a);
        this.actualDataSource.setIsRowExpandedAtIndex(a, b);
        var c = this.actualDataSource.getRowLevel(a);
        if (a < this.model.bf.w) {
            this.r6(a - c);
        }
    };
    Grid.prototype.qz = function (a) {
        if (a != null) {
            this.gz(true);
        }
    };
    Grid.prototype.p3 = function (a) {
        if (a.v == 1) {
            if (this.hf()) {
                if (this.cd == 2) {
                    this.ii(a);
                }
            }
        }
    };
    Grid.prototype.p1 = function (a, b, c, d) {
        var _this = this;
        this.externalGrid.focusScroller();
        if (a.v == 1) {
            if (this.cb.g && a != this.cb.a) {
                if (!this.gz(true)) {
                    return;
                }
            }
            if (d && this.hf()) {
                if (this.cd == 1) {
                    this.ii(a);
                }
            }
        }
        if (a.v == 0 && this.dv != 4) {
            this.ew.d(this.a0(a.k));
        }
        if (this.dn == 5) {
            if (a.k.ag && !a.k.as) {
                var e = this.model.br._inner[a.k.ax].n;
                if (this.dl == 1) {
                    if (b) {
                        this.rm(a.k.w, e);
                    }
                    else {
                        if (c && this.at != null) {
                            var f = e;
                            var g = a.k.w;
                            this.de.remove(this.at);
                            this.oz(Math.min(this.at.k, f), Math.max(this.at.k, f), Math.min(this.at.l, g), Math.max(this.at.l, g));
                        }
                        else {
                            this.rt();
                            this.oz(e, e, a.k.w, a.k.w);
                        }
                    }
                }
                else if (this.dl == 0) {
                    this.rm(a.k.w, e);
                }
            }
        }
        else {
            if (this.dl == 0) {
                this.es.an(a);
            }
            else if (this.dl == 1) {
                if (b) {
                    this.es.an(a);
                }
                else {
                    this.es.am(a);
                }
            }
        }
        if (this.ch == 1) {
            this.aj.x(a);
        }
        if (this.cellClicked != null) {
            this.cellClicked(a, ((function () {
                var $ret = new GridCellEventArgs();
                $ret.cellInfo = a;
                $ret.grid = _this;
                return $ret;
            })()));
        }
    };
    Grid.prototype.rm = function (a, b) {
        var c = false;
        for (var d = 0; d < this.de.count; d++) {
            var e = this.de._inner[d];
            if (e.k == b && e.i == b && e.l == a && e.j == a) {
                this.ru(this.de._inner[d]);
                c = true;
                break;
            }
        }
        if (!c) {
            this.oz(b, b, a, a);
        }
    };
    Object.defineProperty(Grid.prototype, "bu", {
        get: function () {
            return this.bt;
        },
        set: function (a) {
            var b = this.bt;
            this.bt = a;
            if (b != this.bt) {
                this.q5("ColumnResizingMode", enumGetBox(ColumnResizingMode_$type, b), enumGetBox(ColumnResizingMode_$type, this.bt));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bg", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.q5("ColumnMovingMode", enumGetBox(ColumnMovingMode_$type, b), enumGetBox(ColumnMovingMode_$type, this.bf));
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.p5 = function (a, b, c) {
        this.aq = a.k.aa();
        this.uo = { $type: Point_$type, x: b, y: c };
        this.f3 = a.a3 && a.a4;
        if (this.bu != 2 && this.aq.h) {
            var d = this.a2.j._inner[a.k.ax];
            if (d.ge) {
                var e = this.model.br._inner[this.aq.ax];
                this.i2 = e.k;
                this.iz = this.model.cf;
                this.i0 = this.model.cg;
                this.i3 = this.model.actualVisibleRegion.left;
                this.i4 = this.model.actualVisibleRegion.top;
                var f = this.dragger.view.transformPoint(b, c);
                this.kv = truncate((f.x + this.i3)) - (intDivide(this.j8, 2));
                this.ir = -1;
                this.externalGrid.setResizeCursor();
                this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 1, this.aq, false);
                if (this.bu == 0) {
                    this.ro();
                }
            }
        }
    };
    Grid.prototype.p6 = function (a, b, c) {
        this.aq = null;
    };
    Grid.prototype.p4 = function (a, b, c) {
        var d = 0;
        for (var e = 0; e < this.model.br.count; e++) {
            var f = this.model.br._inner[e];
            d += f.k;
        }
        var g = this.dragger.view.transformPoint(b, c);
        if (!this.dragger.isDragActive && g.x >= d) {
            this.externalGrid.setDefaultCursor();
        }
    };
    Grid.prototype.q4 = function (a, b, c) {
        if (!this.dragger.isDragActive) {
            if (a.k.h && this.bu != 2) {
                var d = this.a2.j._inner[a.k.ax];
                if (d.ge) {
                    this.externalGrid.setResizeCursor();
                }
            }
            else {
                this.externalGrid.setDefaultCursor();
            }
        }
        else if (this.dragger.dragType != 1 && this.dragger.dragType != 2) {
            this.externalGrid.setDefaultCursor();
        }
    };
    Grid.prototype.o3 = function () {
        if (this.jx != -1) {
            this.fr.teardownTicking(this.jx);
            this.jx = -1;
        }
    };
    Grid.prototype.qy = function (a, b, c, d) {
        this.i3 = this.model.actualVisibleRegion.left;
        this.i4 = this.model.actualVisibleRegion.top;
        if (!this.dragger.isDragActive && a.g && !a.h && this.bg != 1) {
            var e = this.a0(a);
            if (e != null && e.gc) {
                this.externalGrid.ensureColumnsAreManual();
            }
            this.externalGrid.setHandCursor();
            this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 2, a, d);
        }
        else if (this.dn == 5 && a.ag && !a.as) {
            if (!d) {
                this.rt();
            }
            this.j1 = a.w;
            this.j0 = this.model.br._inner[a.ax].n;
            this.gl = this.f3;
            if (this.ch == 1) {
                this.aj.w(a);
            }
            this.dragger.dragStart(b, c, this.model.actualVisibleRegion.x, this.model.actualVisibleRegion.y, 0, a, d);
        }
    };
    Grid.prototype.qv = function (a, b) {
        this.o3();
        this.as = null;
        this.an = null;
        this.jt = -1;
        this.aq = null;
        if (this.dragger.dragType == 1) {
            this.externalGrid.setDefaultCursor();
            if (this.bu == 0) {
                if (this.ir != -1) {
                    var c = this.model.br._inner[this.dragger.cellPath.ax];
                    this.ck.ag(this, this.cx, c, this.ir);
                }
                else {
                    this.renderingEngine.refresh(this.model, false);
                }
            }
        }
        else if (this.dragger.dragType == 2) {
            this.externalGrid.setDefaultCursor();
            if (this.bg == 0) {
                var d = true;
                if ((this.j2 != -1 && this.j2 != this.dragger.cellPath.ax) || this.ed != this.columns._inner[this.dragger.cellPath.ax].fk) {
                    var e = this.columns._inner[this.dragger.cellPath.ax].fk;
                    if (e != this.ed) {
                        this.ik = true;
                        this.pr(this.dragger.cellPath.ax, this.j2);
                        this.ik = false;
                        this.rh(this.columns._inner[this.j2], this.ed);
                    }
                    else {
                        this.pr(this.dragger.cellPath.ax, this.j2);
                    }
                    d = false;
                }
                if (d) {
                    this.ro();
                }
                this.j2 = -1;
            }
        }
    };
    Grid.prototype.qt = function (a, b) {
        this.it = b.startX;
        this.iu = b.startY;
        this.iv = b.currentX;
        this.iw = b.currentY;
        switch (this.dragger.dragType) {
            case 0:
                this.qx(false);
                break;
            case 1:
                this.qw();
                break;
            case 2:
                this.qu(false);
                break;
        }
    };
    Object.defineProperty(Grid.prototype, "kv", {
        get: function () {
            return this.jt;
        },
        set: function (a) {
            if (this.jt != a) {
                this.jt = a;
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.qu = function (a) {
        var _this = this;
        var b = this.iv + this.model.actualVisibleRegion.x;
        if (a || !this.gt(b, NaN)) {
            var c = this.dragger.cellPath.ax;
            var d = this.kv;
            this.ed = 0;
            for (var e = 0; e < this.model.br.count; e++) {
                var f = this.model.br._inner[e];
                if (f.a == 3) {
                    continue;
                }
                var g = f.l;
                if (f.d == 1) {
                    g = f.l + this.model.actualVisibleRegion.x;
                }
                var h = g + f.k;
                var i = g + (intDivide(f.k, 2));
                if ((f.n == 0 && b < g) || (b > g && b <= i)) {
                    d = g;
                    if (e != c) {
                        c = e < this.dragger.cellPath.ax ? e : e - 1;
                    }
                    if (f.d != 1 && d < this.model.actualVisibleRegion.x + this.model.cf) {
                        d = this.model.actualVisibleRegion.x + this.model.cf;
                    }
                    this.ed = f.d;
                    break;
                }
                else if ((b > i && b < h) || (e == this.model.br.count - 1 && b > h)) {
                    d = h - this.j6;
                    if (e != c) {
                        c = e < this.dragger.cellPath.ax ? e + 1 : e;
                    }
                    this.ed = f.d;
                    break;
                }
            }
            if (d != this.kv) {
                var j = this.kv;
                this.kv = truncate(d);
                if (j == -1) {
                    this.renderingEngine.invalidateVisibility(function () { return _this.e4.l(_this); });
                    this.renderingEngine.refresh(this.model, true);
                }
                else {
                    if (this.an == null) {
                        this.an = this.db.c(new CellPath(1, -400, 0, -102), this.model);
                    }
                    this.an.b7 = this.kv;
                    this.renderingEngine.refresh(this.model, false);
                }
                this.j2 = c;
            }
        }
    };
    Grid.prototype.qw = function () {
        var _this = this;
        var a = this.a2.h(this.dragger.cellPath);
        if (this.an == null) {
            this.an = this.db.c(new CellPath(1, -400, 0, -102), this.model);
        }
        var b = (this.iv + this.model.actualVisibleRegion.x) - this.it;
        var c = isNaN_(a.gm) ? isNaN_(this.i8) ? 0 : this.i8 : a.gm;
        this.ir = Math.max(this.i2 + b, Math.max(c, 10));
        var d = 20;
        if (a.fk == 1) {
            d = Math.min(20, this.up.width - this.model.cf);
            var e = this.up.width - d - this.model.cg;
            var f = this.iz + (this.ir - this.i2);
            if (f > e) {
                this.ir = this.ir - (f - e);
            }
        }
        else if (a.fk == 2) {
            d = Math.min(20, this.up.width - this.model.cg);
            var g = this.up.width - d - this.model.cf;
            var h = this.i0 + (this.ir - this.i2);
            if (h > g) {
                this.ir = this.ir - (h - g);
            }
        }
        if (this.bu == 0) {
            this.kv = truncate((this.it - this.i2 + this.ir)) - (intDivide(this.j8, 2));
            if (this.an != null) {
                this.an.b7 = this.kv;
                this.renderingEngine.refresh(this.model, false);
            }
        }
        else {
            var i = ((function () {
                var $ret = new ColumnWidth();
                $ret.f = _this.ir;
                $ret.c = false;
                return $ret;
            })());
            if (!isNaN_(a.gm)) {
                i.e = a.gm;
            }
            a.width = i;
        }
    };
    Grid.prototype.qx = function (a) {
        if (a || !this.gt(this.iv + this.model.actualVisibleRegion.x, this.iw + this.model.actualVisibleRegion.y)) {
            var b = this.iv + this.model.actualVisibleRegion.x;
            var c = this.uq(b, this.iu, this.iv, this.iw);
            var d = this.au(c, this.j1, this.j0, this.gl);
            if (this.as == null) {
                this.as = d;
                this.oy(this.as);
            }
            else {
                this.sq(d);
            }
        }
    };
    Grid.prototype.uq = function (a, b, c, d) {
        c += this.model.actualVisibleRegion.x;
        d += this.model.actualVisibleRegion.y;
        return new Rect(0, Math.min(a, c), Math.min(b, d), Math.abs(c - a), Math.abs(d - b));
    };
    Grid.prototype.ap = function (a, b) {
        if (this.e5 == null) {
            return null;
        }
        return this.e5.e(a, b);
    };
    Grid.prototype.au = function (a, b, c, d) {
        var e = this.model.al.q;
        var f = this.model.a0.q;
        var g = this.model.a3.q;
        var h = this.model.an.q;
        var i = new List$1(CellModel.$, 1, f);
        i.o(e);
        i.o(g);
        i.o(h);
        var j = b;
        var k = c;
        var l = this.iv + this.model.actualVisibleRegion.x;
        for (var m = 0; m < i.count; m++) {
            var n = i._inner[m];
            if (!n.k.ag || n.k.as) {
                continue;
            }
            if (l < this.model.actualVisibleRegion.x + this.model.cf && n.k.d != 1) {
                continue;
            }
            if (l > this.model.actualVisibleRegion.right - this.model.cg && n.k.d != 2) {
                continue;
            }
            if (this.dn == 5) {
                if (d) {
                    if (!n.a3 || (n.a3 && !n.a4)) {
                        continue;
                    }
                }
                else {
                    if (n.a3 && n.a4) {
                        continue;
                    }
                }
                var o = new Rect(0, n.b7, n.b8, n.f8, n.ev);
                if (a.intersectsWith(o)) {
                    var p = this.model.br._inner[n.k.ax].n;
                    var q = Math.abs(n.k.w - b);
                    var r = Math.abs(Math.max(0, p) - c);
                    var s = Math.abs(j - b);
                    var t = Math.abs(k - c);
                    if (q > s) {
                        j = n.k.w;
                    }
                    if (r > t && !n.k.as) {
                        k = p;
                    }
                }
            }
        }
        var u = new CellRange();
        u.k = Math.min(c, k);
        u.i = Math.max(c, k);
        u.l = Math.min(b, j);
        u.j = Math.max(b, j);
        return u;
    };
    Grid.prototype.gt = function (a, b) {
        var c = 20;
        var d = 20;
        var e = new Rect(0, this.model.actualVisibleRegion.x + d, this.model.actualVisibleRegion.y + c, this.model.actualVisibleRegion.width - d * 2, this.model.actualVisibleRegion.height - c * 2);
        var f = 5;
        var g = 1000;
        var h = 5;
        var i = 1000;
        if (!this.gl && !isNaN_(b)) {
            if (b > e.bottom) {
                var j = b - e.bottom;
                this.i5 = Math.min(j * f, g);
                this.gc = true;
            }
            else if (b < e.top) {
                var k = e.top - b;
                this.i5 = -Math.min(k * f, g);
                this.gc = true;
            }
            else {
                this.i5 = 0;
                this.gc = false;
            }
        }
        if (a > e.right) {
            var l = a - e.right;
            this.iy = Math.min(l * h, i);
            this.gb = true;
        }
        else if (a < e.left) {
            var m = e.left - a;
            this.iy = -Math.min(m * h, i);
            this.gb = true;
        }
        else {
            this.iy = 0;
            this.gb = false;
        }
        if ((this.gc || this.gb) && this.jx == -1) {
            this.io = dateNow();
            this.jx = this.fr.setupTicking(runOn(this, this.pd));
            this.fr.requestFrame(this.jx);
        }
        if (!this.gc && !this.gb) {
            this.o3();
        }
        return this.gb || this.gc;
    };
    Grid.prototype.pd = function () {
        var a = dateNow();
        var b = timeSpanTotalSeconds((+a - +(this.io)));
        this.io = a;
        this.i3 = Math.max(this.i3 + this.iy * b, 0);
        this.i4 = Math.max(this.i4 + this.i5 * b, 0);
        if (this.model.absoluteWidth > 0 && this.model.actualVisibleRegion.width > 0 && this.i3 + this.model.actualVisibleRegion.width > this.model.absoluteWidth) {
            this.i3 = Math.round(this.model.absoluteWidth - this.model.actualVisibleRegion.width);
        }
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0 && this.i4 + this.model.actualVisibleRegion.height > this.model.absoluteHeight) {
            this.i4 = Math.round(this.model.absoluteHeight - this.model.actualVisibleRegion.height);
        }
        this.viewportManager.moveViewportTo(truncate(this.i3), truncate(this.i4));
        switch (this.dragger.dragType) {
            case 0:
                this.qx(true);
                break;
            case 1:
                this.qw();
                break;
            case 2:
                this.qu(true);
                break;
        }
        this.fr.requestFrame(this.jx);
    };
    Grid.prototype.sq = function (a) {
        if (a.k != this.as.k || a.i != this.as.i || a.l != this.as.l || a.j != this.as.j) {
            this.as.k = a.k;
            this.as.i = a.i;
            this.as.l = a.l;
            this.as.j = a.j;
            this.gq = true;
            this.es.at();
            this.gq = false;
            this.pu(this.as);
        }
    };
    Grid.prototype.rz = function (a) {
        if (this.actualDataSource != null && this.actualDataSource.actualSchema != null) {
            a.g = this.actualDataSource.resolveSchemaPropertyType(a.f);
            a.i = true;
        }
    };
    Grid.prototype.r0 = function (a) {
        if (this.actualDataSource != null && this.actualDataSource.actualSchema != null) {
            a.a = this.actualDataSource.resolveSchemaPropertyType(a.w);
            a.l = true;
        }
    };
    Grid.prototype.sg = function (a, b) {
        switch (b.action) {
            case 0:
                if (b.newItems != null) {
                    for (var c = 0; c < b.newItems.count; c++) {
                        var d = b.newItems.item(c);
                        if (!d.l) {
                            this.r0(d);
                        }
                    }
                }
                break;
        }
    };
    Grid.prototype.pi = function (a, b) {
        var _this = this;
        switch (b.action) {
            case 0:
                if (b.newItems != null) {
                    for (var c = 0; c < b.newItems.count; c++) {
                        var d = b.newItems.item(c);
                        if (!d.i) {
                            this.rz(d);
                        }
                    }
                }
                break;
        }
        if (this.groupDescriptionsChanged != null) {
            this.groupDescriptionsChanged(this, ((function () {
                var $ret = new GridGroupDescriptionsChangedEventArgs();
                $ret.groupDescriptions = _this.a7;
                return $ret;
            })()));
        }
    };
    Grid.prototype.pf = function (a, b) {
        var _this = this;
        if (this.filterExpressionsChanged != null) {
            this.filterExpressionsChanged(this, ((function () {
                var $ret = new GridFilterExpressionsEventArgs();
                $ret.a = _this.v;
                return $ret;
            })()));
        }
    };
    Grid.prototype.sf = function (a, b) {
        var e_1, _a;
        var _this = this;
        this.hl = true;
        try {
            switch (b.action) {
                case 0:
                    if (b.newItems != null) {
                        for (var c = 0; c < b.newItems.count; c++) {
                            var d = b.newItems.item(c);
                            this.sm(d.f, this.b5(d.c));
                        }
                    }
                    break;
                case 1:
                    if (b.oldItems != null) {
                        for (var e = 0; e < b.oldItems.count; e++) {
                            var f = b.oldItems.item(e);
                            this.sm(f.f, 0);
                        }
                    }
                    break;
                case 2:
                    if (b.oldItems != null) {
                        for (var g = 0; g < b.oldItems.count; g++) {
                            var h = b.oldItems.item(g);
                            this.sm(h.f, 0);
                        }
                    }
                    if (b.newItems != null) {
                        for (var i = 0; i < b.newItems.count; i++) {
                            var j = b.newItems.item(i);
                            this.sm(j.f, this.b5(j.c));
                        }
                    }
                    break;
                case 4:
                    try {
                        for (var _b = tslib_1.__values(fromEnum(this.columns)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var k = _c.value;
                            k.e6 = 0;
                        }
                    }
                    catch (e_1_1) {
                        e_1 = { error: e_1_1 };
                    }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return))
                                _a.call(_b);
                        }
                        finally {
                            if (e_1)
                                throw e_1.error;
                        }
                    }
                    break;
            }
            if (this.sortDescriptionsChanged != null) {
                this.sortDescriptionsChanged(this, ((function () {
                    var $ret = new GridSortDescriptionsChangedEventArgs();
                    $ret.sortDescriptions = _this.b4;
                    return $ret;
                })()));
            }
        }
        finally {
            this.hl = false;
        }
    };
    Grid.prototype.sm = function (a, b) {
        for (var c = 0; c < this.columns.count; c++) {
            if (this.columns._inner[c].hx == a) {
                this.columns._inner[c].e6 = b;
            }
        }
    };
    Grid.prototype.b5 = function (a) {
        switch (a) {
            case 0: return 1;
            case 1: return 2;
        }
        return 0;
    };
    Grid.prototype.r9 = function (a, b) {
        var e_2, _a, e_3, _b, e_4, _c;
        var _this = this;
        if (!this.g1 && this.actualDataSource != null) {
            if (!this.go) {
                this.go = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.d3.getItemKey(this.i(), b.newItems.item(c));
                                this.ah.ae.insert(c + b.newStartingIndex, d);
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.ah.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.ah.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.d3.getItemKey(this.i(), b.newItems.item(g));
                                this.ah.ae.insert(g + b.newStartingIndex, h);
                            }
                        }
                        break;
                    case 4:
                        this.ah.clear();
                        try {
                            for (var _d = tslib_1.__values(fromEnum(this.ad.ae)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var i = _e.value;
                                var j = this.d3.getItemKey(this.i(), i);
                                this.ah.add(j);
                            }
                        }
                        catch (e_2_1) {
                            e_2 = { error: e_2_1 };
                        }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return))
                                    _a.call(_d);
                            }
                            finally {
                                if (e_2)
                                    throw e_2.error;
                            }
                        }
                        break;
                }
                this.es.av();
                this.go = false;
            }
        }
        if (this.ht) {
            if (this.selectedItemsChanged != null) {
                var k_1 = null;
                if (b.newItems != null && b.newItems.count > 0) {
                    k_1 = new GridSelectedItemsCollection();
                    try {
                        for (var _f = tslib_1.__values(fromEn(b.newItems)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var l = _g.value;
                            k_1.add1(l);
                        }
                    }
                    catch (e_3_1) {
                        e_3 = { error: e_3_1 };
                    }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return))
                                _b.call(_f);
                        }
                        finally {
                            if (e_3)
                                throw e_3.error;
                        }
                    }
                }
                var m_1 = null;
                if (b.oldItems != null && b.oldItems.count > 0) {
                    m_1 = new GridSelectedItemsCollection();
                    try {
                        for (var _h = tslib_1.__values(fromEn(b.oldItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var n = _j.value;
                            m_1.add1(n);
                        }
                    }
                    catch (e_4_1) {
                        e_4 = { error: e_4_1 };
                    }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return))
                                _c.call(_h);
                        }
                        finally {
                            if (e_4)
                                throw e_4.error;
                        }
                    }
                }
                this.selectedItemsChanged(this, ((function () {
                    var $ret = new GridSelectedItemsChangedEventArgs();
                    $ret.addedItems = k_1;
                    $ret.removedItems = m_1;
                    $ret.currentItems = _this.ad;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.sa = function (a, b) {
        var e_5, _a, e_6, _b, e_7, _c;
        var _this = this;
        if (!this.g1 && this.actualDataSource != null) {
            if (!this.go) {
                this.go = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.d3.getItemForKey(b.newItems.item(c));
                                this.ad.ae.insert1(c + b.newStartingIndex, d);
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.ad.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.ad.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.d3.getItemForKey(b.newItems.item(g));
                                this.ad.ae.insert1(g + b.newStartingIndex, h);
                            }
                        }
                        break;
                    case 4:
                        this.ad.clear();
                        try {
                            for (var _d = tslib_1.__values(fromEnum(this.ah.ae)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var i = _e.value;
                                var j = this.d3.getItemForKey(i);
                                this.ad.add1(j);
                            }
                        }
                        catch (e_5_1) {
                            e_5 = { error: e_5_1 };
                        }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return))
                                    _a.call(_d);
                            }
                            finally {
                                if (e_5)
                                    throw e_5.error;
                            }
                        }
                        break;
                }
                this.es.av();
                this.go = false;
            }
        }
        if (this.ht) {
            if (this.selectedKeysChanged != null) {
                var k_2 = null;
                if (b.newItems != null && b.newItems.count > 0) {
                    k_2 = new GridSelectedKeysCollection();
                    try {
                        for (var _f = tslib_1.__values(fromEn(b.newItems)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var l = _g.value;
                            k_2.add(l);
                        }
                    }
                    catch (e_6_1) {
                        e_6 = { error: e_6_1 };
                    }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return))
                                _b.call(_f);
                        }
                        finally {
                            if (e_6)
                                throw e_6.error;
                        }
                    }
                }
                var m_2 = null;
                if (b.oldItems != null && b.oldItems.count > 0) {
                    m_2 = new GridSelectedKeysCollection();
                    try {
                        for (var _h = tslib_1.__values(fromEn(b.oldItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var n = _j.value;
                            m_2.add(n);
                        }
                    }
                    catch (e_7_1) {
                        e_7 = { error: e_7_1 };
                    }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return))
                                _c.call(_h);
                        }
                        finally {
                            if (e_7)
                                throw e_7.error;
                        }
                    }
                }
                this.selectedKeysChanged(this, ((function () {
                    var $ret = new GridSelectedKeysChangedEventArgs();
                    $ret.addedKeys = k_2;
                    $ret.removedKeys = m_2;
                    $ret.currentKeys = _this.ah;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.r8 = function (a, b) {
        var e_8, _a, e_9, _b;
        var _this = this;
        switch (b.action) {
            case 0:
            case 2:
                for (var c = 0; c < b.newItems.count; c++) {
                    (typeCast(CellKey.$, b.newItems.item(c))).d = this;
                }
                break;
        }
        if (!this.g1) {
            this.gq = true;
            this.es.au();
            this.gq = false;
        }
        if (this.ht) {
            var d_1 = null;
            if (b.newItems != null && b.newItems.count > 0) {
                d_1 = new GridSelectedCellsCollection();
                try {
                    for (var _c = tslib_1.__values(fromEn(b.newItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var e = _d.value;
                        d_1.add(e);
                    }
                }
                catch (e_8_1) {
                    e_8 = { error: e_8_1 };
                }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return))
                            _a.call(_c);
                    }
                    finally {
                        if (e_8)
                            throw e_8.error;
                    }
                }
            }
            var f_1 = null;
            if (b.oldItems != null && b.oldItems.count > 0) {
                f_1 = new GridSelectedCellsCollection();
                try {
                    for (var _e = tslib_1.__values(fromEn(b.oldItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var g = _f.value;
                        f_1.add(g);
                    }
                }
                catch (e_9_1) {
                    e_9 = { error: e_9_1 };
                }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return))
                            _b.call(_e);
                    }
                    finally {
                        if (e_9)
                            throw e_9.error;
                    }
                }
            }
            if (this.selectedCellsChanged != null) {
                this.selectedCellsChanged(this, ((function () {
                    var $ret = new GridSelectedCellsChangedEventArgs();
                    $ret.addedCells = d_1;
                    $ret.removedCells = f_1;
                    $ret.currentCells = _this.dh;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.r7 = function (a, b) {
        var _this = this;
        this.gq = true;
        this.es.at();
        this.gq = false;
        if (this.ht) {
            if (this.selectedCellRangesChanged != null) {
                this.selectedCellRangesChanged(this, ((function () {
                    var $ret = new GridSelectedCellRangesChangedEventArgs();
                    $ret.currentRanges = _this.de;
                    return $ret;
                })()));
            }
        }
    };
    Grid.prototype.ri = function (a, b) {
        var e_10, _a;
        if (!this.g0 && this.actualDataSource != null) {
            if (!this.gn) {
                this.gn = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.d3.getItemKey(this.i(), b.newItems.item(c));
                                this.ag.ae.insert(c + b.newStartingIndex, d);
                                this.d3.pinRow(d);
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.d3.unpinRow(this.ag.ae._inner[b.oldStartingIndex]);
                                this.ag.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.d3.unpinRow(this.ag.ae._inner[b.oldStartingIndex]);
                                this.ag.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.d3.getItemKey(this.i(), b.newItems.item(g));
                                this.ag.ae.insert(g + b.newStartingIndex, h);
                                this.d3.pinRow(h);
                            }
                        }
                        break;
                    case 4:
                        this.ag.clear();
                        this.d3.clearPinnedRows();
                        try {
                            for (var _b = tslib_1.__values(fromEnum(this.ac.ae)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var i = _c.value;
                                var j = this.d3.getItemKey(this.i(), i);
                                this.ag.add(j);
                                this.d3.pinRow(j);
                            }
                        }
                        catch (e_10_1) {
                            e_10 = { error: e_10_1 };
                        }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return))
                                    _a.call(_b);
                            }
                            finally {
                                if (e_10)
                                    throw e_10.error;
                            }
                        }
                        break;
                }
                this.gn = false;
            }
        }
    };
    Grid.prototype.rj = function (a, b) {
        var e_11, _a;
        if (!this.g0 && this.actualDataSource != null) {
            if (!this.gn) {
                this.gn = true;
                switch (b.action) {
                    case 0:
                        if (b.newItems != null) {
                            for (var c = 0; c < b.newItems.count; c++) {
                                var d = this.d3.getItemForKey(b.newItems.item(c));
                                this.ac.ae.insert1(c + b.newStartingIndex, d);
                                this.d3.pinRow(b.newItems.item(c));
                            }
                        }
                        break;
                    case 1:
                        if (b.oldItems != null) {
                            for (var e = 0; e < b.oldItems.count; e++) {
                                this.d3.unpinRow(b.oldItems.item(e));
                                this.ac.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        break;
                    case 2:
                        if (b.oldItems != null) {
                            for (var f = 0; f < b.oldItems.count; f++) {
                                this.d3.unpinRow(b.oldItems.item(f));
                                this.ac.ae.removeAt(b.oldStartingIndex);
                            }
                        }
                        if (b.newItems != null) {
                            for (var g = 0; g < b.newItems.count; g++) {
                                var h = this.d3.getItemForKey(b.newItems.item(g));
                                var i = this.d3.indexOfKey(b.newItems.item(g));
                                this.ac.ae.insert1(g + b.newStartingIndex, h);
                                this.d3.pinRow(b.newItems.item(g));
                            }
                        }
                        break;
                    case 4:
                        this.ac.clear();
                        this.d3.clearPinnedRows();
                        try {
                            for (var _b = tslib_1.__values(fromEnum(this.ag.ae)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var j = _c.value;
                                var k = this.d3.getItemForKey(j);
                                this.ac.add1(k);
                                this.d3.pinRow(j);
                            }
                        }
                        catch (e_11_1) {
                            e_11 = { error: e_11_1 };
                        }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return))
                                    _a.call(_b);
                            }
                            finally {
                                if (e_11)
                                    throw e_11.error;
                            }
                        }
                        break;
                }
                this.gn = false;
            }
        }
    };
    Object.defineProperty(Grid.prototype, "ck", {
        get: function () {
            return this.cj;
        },
        set: function (a) {
            this.cj = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "delayedExecutionManager", {
        get: function () {
            return this._delayedExecutionManager;
        },
        set: function (a) {
            this._delayedExecutionManager = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ef", {
        get: function () {
            return this.ee;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "d3", {
        get: function () {
            return this.d2;
        },
        set: function (a) {
            this.d2 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "a2", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            this.a1 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "db", {
        get: function () {
            return this.da;
        },
        set: function (a) {
            this.da = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ey", {
        get: function () {
            return this.ex;
        },
        set: function (a) {
            this.ex = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "c6", {
        get: function () {
            return this.c5;
        },
        set: function (a) {
            this.c5 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "es", {
        get: function () {
            return this.er;
        },
        set: function (a) {
            this.er = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "aj", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            this.ai = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ew", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            this.ev = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tickProvider", {
        get: function () {
            return this.fr;
        },
        set: function (a) {
            this.fr = a;
            this.c5 = new GridEffectManager(this.fr, this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "eq", {
        get: function () {
            return this.ep;
        },
        set: function (a) {
            var b = this.ep;
            this.ep = a;
            if (this.ep == null) {
                this.ep = new SectionHeader();
            }
            this.ep.grid = this;
            if (b != this.ep) {
                this.q5("SectionHeader", b, this.ep);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "eo", {
        get: function () {
            return this.en;
        },
        set: function (a) {
            this.en = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e0", {
        get: function () {
            return this.ez;
        },
        set: function (a) {
            var b = this.ez;
            this.ez = a;
            if (this.ez == null) {
                this.ez = new SummaryRowRoot();
            }
            this.ez.grid = this;
            if (b != this.ez) {
                this.q5("SummaryRowRoot", b, this.ez);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e2", {
        get: function () {
            return this.e1;
        },
        set: function (a) {
            var b = this.e1;
            this.e1 = a;
            if (this.e1 == null) {
                this.e1 = new SummaryRowSection();
            }
            this.e1.grid = this;
            if (b != this.e1) {
                this.q5("SummaryRowSection", b, this.e1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "em", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (b != this.el) {
                this.q5("RowSeparator", b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dx", {
        get: function () {
            return this.dw;
        },
        set: function (a) {
            var b = this.dw;
            this.dw = a;
            if (b != this.dw) {
                this.q5("HeaderRowSeparator", b, this.dw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dz", {
        get: function () {
            return this.dy;
        },
        set: function (a) {
            var b = this.dy;
            this.dy = a;
            if (b != this.dy) {
                this.q5("HeaderSeparator", b, this.dy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bw", {
        get: function () {
            return this.bv;
        },
        set: function (a) {
            var b = this.bv;
            this.bv = a;
            if (b != this.bv) {
                this.q5("ColumnResizingSeparator", b, this.bv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bi", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.q5("ColumnMovingSeparator", b, this.bh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ec", {
        get: function () {
            return this.eb;
        },
        set: function (a) {
            var b = this.eb;
            this.eb = a;
            if (b != this.eb) {
                this.q5("PinnedAreaSeparator", b, this.eb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "f", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.q5("AutoGenerateDesiredColumns", b, this.b);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.q5("DataSourceDesiredProperties", b, this.c);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e4", {
        get: function () {
            return this.e3;
        },
        set: function (a) {
            this.e3 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "viewportManager", {
        get: function () {
            return this._viewportManager;
        },
        set: function (a) {
            this._viewportManager = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "i7", {
        get: function () {
            return this.iq;
        },
        set: function (a) {
            this.iq = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "i6", {
        get: function () {
            return this.ip;
        },
        set: function (a) {
            this.ip = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e8", {
        get: function () {
            return this.e7;
        },
        set: function (a) {
            var b = this.e7;
            this.e7 = a;
            if (b != this.e7) {
                this.q5("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.e7));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j4", {
        get: function () {
            return this.jk;
        },
        set: function (a) {
            var b = this.jk;
            this.jk = a;
            if (b != this.jk) {
                this.q5("ActualRowHeight", b, this.jk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "kw", {
        get: function () {
            return this.ju;
        },
        set: function (a) {
            var b = this.ju;
            this.ju = a;
            if (b != this.ju) {
                this.q5("RowHeight", b, this.ju);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "defaultColumnWidth", {
        get: function () {
            return this.b8;
        },
        set: function (a) {
            var b = this.b8;
            this.b8 = a;
            if (b != this.b8) {
                this.q5("DefaultColumnWidth", b, this.b8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "i8", {
        get: function () {
            return this.is;
        },
        set: function (a) {
            var b = this.is;
            this.is = a;
            if (b != this.is) {
                this.q5("DefaultColumnMinWidth", b, this.is);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j3", {
        get: function () {
            return this.jj;
        },
        set: function (a) {
            var b = this.jj;
            this.jj = a;
            if (b != this.jj) {
                this.q5("ActualHeaderHeight", b, this.jj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "kp", {
        get: function () {
            return this.jo;
        },
        set: function (a) {
            var b = this.jo;
            this.jo = a;
            if (b != this.jo) {
                this.q5("HeaderHeight", b, this.jo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "k2", {
        get: function () {
            return this.jz;
        },
        set: function (a) {
            var b = this.jz;
            this.jz = a;
            if (b != this.jz) {
                this.q5("SectionHeaderHeight", b, this.jz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "itemsSource", {
        get: function () {
            return this.k5;
        },
        set: function (a) {
            var b = this.k5;
            this.k5 = a;
            if (b != this.k5) {
                this.q5("ItemsSource", b, this.k5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "k0", {
        get: function () {
            return this.jy;
        },
        set: function (a) {
            var b = this.jy;
            this.jy = a;
            if (b != this.jy) {
                this.q5("SectionFooterHeight", b, this.jy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "kz", {
        get: function () {
            return this.jw;
        },
        set: function (a) {
            var b = this.jw;
            this.jw = a;
            if (b != this.jw) {
                this.q5("RowSpacingHeight", b, this.jw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j9", {
        get: function () {
            return this.jn;
        },
        set: function (a) {
            var b = this.jn;
            this.jn = a;
            if (b != this.jn) {
                this.q5("ColumnSpacingWidth", b, this.jn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dv", {
        get: function () {
            return this.du;
        },
        set: function (a) {
            var b = this.du;
            this.du = a;
            if (b != this.du) {
                this.q5("HeaderClickAction", enumGetBox(HeaderClickAction_$type, b), enumGetBox(HeaderClickAction_$type, this.du));
                if ((this.du == 0 || this.du == 2) && (b == 1 || b == 3)) {
                    this.ew.h();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cf", {
        get: function () {
            return this.ce;
        },
        set: function (a) {
            var b = this.ce;
            this.ce = a;
            if (b != this.ce) {
                this.q5("EditMode", enumGetBox(EditModeType_$type, b), enumGetBox(EditModeType_$type, this.ce));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cd", {
        get: function () {
            return this.cc;
        },
        set: function (a) {
            var b = this.cc;
            this.cc = a;
            if (b != this.cc) {
                this.q5("EditModeClickAction", enumGetBox(EditModeClickAction_$type, b), enumGetBox(EditModeClickAction_$type, this.cc));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "gs", {
        get: function () {
            return this.fv;
        },
        set: function (a) {
            var b = this.fv;
            this.fv = a;
            if (b != this.fv) {
                this.q5("AutoGenerateColumns", b, this.fv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ky", {
        get: function () {
            return this.jv;
        },
        set: function (a) {
            var b = this.jv;
            this.jv = a;
            if (b != this.jv) {
                this.q5("RowSeparatorHeight", b, this.jv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hm", {
        get: function () {
            return this.ga;
        },
        set: function (a) {
            var b = this.ga;
            this.ga = a;
            if (b != this.ga) {
                this.q5("IsPlaceholderRenderingEnabled", b, this.ga);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.g6 = function (a) {
        return this.b1(a) != 1 && this.g7;
    };
    Grid.prototype.b1 = function (a) {
        if (this.bx == 0) {
            return a.e4();
        }
        return this.bx;
    };
    Object.defineProperty(Grid.prototype, "bz", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            var b = this.bx;
            this.bx = a;
            this.q5("ColumnAddingAnimationMode", enumGetBox(ColumnShowingAnimationMode_$type, b), enumGetBox(ColumnShowingAnimationMode_$type, this.bx));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hc", {
        get: function () {
            return this.bo != 1 && this.g7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "columnPropertyUpdatingAnimationMode", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            this.q5("ColumnPropertyUpdatingAnimationMode", enumGetBox(ColumnPropertyUpdatingAnimationMode_$type, b), enumGetBox(ColumnPropertyUpdatingAnimationMode_$type, this.bo));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g7", {
        get: function () {
            return this.renderingEngine.initialRefreshFinished;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g3", {
        get: function () {
            return this.ak != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "al", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            this.q5("CellDataLoadedAnimationMode", enumGetBox(CellDataLoadedAnimationMode_$type, b), enumGetBox(CellDataLoadedAnimationMode_$type, this.ak));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hr", {
        get: function () {
            return this.ej != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ek", {
        get: function () {
            return this.ej;
        },
        set: function (a) {
            var b = this.ej;
            this.ej = a;
            this.q5("RowSelectionAnimationMode", enumGetBox(RowSelectionAnimationMode_$type, b), enumGetBox(RowSelectionAnimationMode_$type, this.ej));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g4", {
        get: function () {
            return this.av != 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "aw", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            this.q5("CellSelectionAnimationMode", enumGetBox(CellSelectionAnimationMode_$type, b), enumGetBox(CellSelectionAnimationMode_$type, this.av));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cx", {
        get: function () {
            return this.cw;
        },
        set: function (a) {
            var b = this.cw;
            this.cw = a;
            if (b != this.cw) {
                this.q5("ColumnAnimationSettings", b, this.cw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cm", {
        get: function () {
            return this.cl;
        },
        set: function (a) {
            var b = this.cl;
            this.cl = a;
            if (b != this.cl) {
                this.q5("AnimationSettings", b, this.cl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.hd = function (a) {
        return this.bs(a) != 1 && this.g7;
    };
    Grid.prototype.bs = function (a) {
        if (this.bq == 0) {
            return a.e3();
        }
        return this.bq;
    };
    Object.defineProperty(Grid.prototype, "br", {
        get: function () {
            return this.bq;
        },
        set: function (a) {
            var b = this.bq;
            this.bq = a;
            this.q5("ColumnResizingAnimationMode", enumGetBox(ColumnResizingAnimationMode_$type, b), enumGetBox(ColumnResizingAnimationMode_$type, this.bq));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.he = function (a) {
        return this.b2(a) != 1 && this.g7;
    };
    Grid.prototype.b2 = function (a) {
        if (this.by == 0) {
            return a.e4();
        }
        return this.by;
    };
    Object.defineProperty(Grid.prototype, "b0", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            this.q5("ColumnShowingAnimationMode", enumGetBox(ColumnShowingAnimationMode_$type, b), enumGetBox(ColumnShowingAnimationMode_$type, this.by));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.ha = function (a) {
        return this.be(a) != 1 && this.g7 && !this.ik;
    };
    Grid.prototype.be = function (a) {
        if (this.bc == 0) {
            return 2;
        }
        return this.bc;
    };
    Object.defineProperty(Grid.prototype, "bd", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            this.q5("ColumnMovingAnimationMode", enumGetBox(ColumnMovingAnimationMode_$type, b), enumGetBox(ColumnMovingAnimationMode_$type, this.bc));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.g9 = function (a) {
        return this.bb(a) != 1 && this.g7;
    };
    Grid.prototype.bb = function (a) {
        if (this.a9 == 0) {
            return a.eu();
        }
        return this.a9;
    };
    Object.defineProperty(Grid.prototype, "ba", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            this.q5("ColumnHidingAnimationMode", enumGetBox(ColumnHidingAnimationMode_$type, b), enumGetBox(ColumnHidingAnimationMode_$type, this.a9));
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.g8 = function (a) {
        return this.a5(a) != 1 && this.g7;
    };
    Grid.prototype.a5 = function (a) {
        if (this.a3 == 0) {
            return a.et();
        }
        return this.a3;
    };
    Object.defineProperty(Grid.prototype, "a4", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            this.q5("ColumnExchangingAnimationMode", enumGetBox(ColumnExchangingAnimationMode_$type, b), enumGetBox(ColumnExchangingAnimationMode_$type, this.a3));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "inset", {
        get: function () {
            return this.uu;
        },
        set: function (a) {
            var b = this.uu;
            this.uu = a;
            if (b != this.uu) {
                this.q5("Inset", b, this.uu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dn", {
        get: function () {
            return this.dm;
        },
        set: function (a) {
            var b = this.dm;
            this.dm = a;
            if (b != this.dm) {
                this.q5("SelectionMode", enumGetBox(GridSelectionMode_$type, b), enumGetBox(GridSelectionMode_$type, this.dm));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ch", {
        get: function () {
            return this.cg;
        },
        set: function (a) {
            var b = this.cg;
            this.cg = a;
            if (b != this.cg) {
                this.q5("ActivationMode", enumGetBox(GridActivationMode_$type, b), enumGetBox(GridActivationMode_$type, this.cg));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dl", {
        get: function () {
            return this.dk;
        },
        set: function (a) {
            var b = this.dk;
            this.dk = a;
            if (b != this.dk) {
                this.q5("SelectionBehavior", enumGetBox(GridSelectionBehavior_$type, b), enumGetBox(GridSelectionBehavior_$type, this.dk));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g1", {
        get: function () {
            return this.fz;
        },
        set: function (a) {
            this.fz = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ad", {
        get: function () {
            return this.ab;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ah", {
        get: function () {
            return this.af;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dh", {
        get: function () {
            return this.dg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "de", {
        get: function () {
            return this.dd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g0", {
        get: function () {
            return this.fy;
        },
        set: function (a) {
            this.fy = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ac", {
        get: function () {
            return this.aa;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ag", {
        get: function () {
            return this.ae;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.si = function (a, b) {
        var e_12, _a, e_13, _b, e_14, _c;
        if (this.actualDataSource == null) {
            return;
        }
        if (a.ae.count > 0 && b.ae.count == 0) {
            var c = this.i();
            try {
                for (var _d = tslib_1.__values(fromEnum(a.ae)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var d = _e.value;
                    var e = this.d3.getItemKey(c, d);
                    b.ae.add(e);
                }
            }
            catch (e_12_1) {
                e_12 = { error: e_12_1 };
            }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return))
                        _a.call(_d);
                }
                finally {
                    if (e_12)
                        throw e_12.error;
                }
            }
        }
        else if (a.ae.count == 0 && b.ae.count > 0) {
            try {
                for (var _f = tslib_1.__values(fromEnum(b.ae)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var f = _g.value;
                    var g = this.d3.getItemForKey(f);
                    a.ae.add1(g);
                }
            }
            catch (e_13_1) {
                e_13 = { error: e_13_1 };
            }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return))
                        _b.call(_f);
                }
                finally {
                    if (e_13)
                        throw e_13.error;
                }
            }
        }
        else {
            a.ae.clear();
            try {
                for (var _h = tslib_1.__values(fromEnum(b.ae)), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var h = _j.value;
                    var i = this.d3.getItemForKey(h);
                    a.ae.add1(i);
                }
            }
            catch (e_14_1) {
                e_14 = { error: e_14_1 };
            }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return))
                        _c.call(_h);
                }
                finally {
                    if (e_14)
                        throw e_14.error;
                }
            }
        }
    };
    Object.defineProperty(Grid.prototype, "hb", {
        get: function () {
            return this.f2;
        },
        set: function (a) {
            var b = this.f2;
            this.f2 = a;
            if (b != this.f2) {
                this.q5("IsColumnOptionsEnabled", b, this.f2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hi", {
        get: function () {
            return this.f8;
        },
        set: function (a) {
            var b = this.f8;
            this.f8 = a;
            if (b != this.f8) {
                this.q5("IsGroupRowSticky", b, this.f8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hj", {
        get: function () {
            return this.f9;
        },
        set: function (a) {
            var b = this.f9;
            this.f9 = a;
            if (b != this.f9) {
                this.q5("IsHeaderSeparatorVisible", b, this.f9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tv", {
        get: function () {
            return this.s0;
        },
        set: function (a) {
            var b = this.s0;
            this.s0 = a;
            if (b != this.s0) {
                this.q5("CellSelectedBackground", b, this.s0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ud", {
        get: function () {
            return this.ti;
        },
        set: function (a) {
            var b = this.ti;
            this.ti = a;
            if (b != this.ti) {
                this.q5("SectionHeaderSelectedBackground", b, this.ti);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ug", {
        get: function () {
            return this.tl;
        },
        set: function (a) {
            var b = this.tl;
            this.tl = a;
            if (b != this.tl) {
                this.q5("SummaryRootBackground", b, this.tl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uk", {
        get: function () {
            return this.tp;
        },
        set: function (a) {
            var b = this.tp;
            this.tp = a;
            if (b != this.tp) {
                this.q5("SummarySectionBackground", b, this.tp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ja", {
        get: function () {
            return this.i1;
        },
        set: function (a) {
            var b = this.i1;
            this.i1 = a;
            if (b != this.i1) {
                this.q5("PinnedRowOpacity", b, this.i1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fi", {
        get: function () {
            return this.fa;
        },
        set: function (a) {
            var b = this.fa;
            this.fa = a;
            if (b != this.fa) {
                this.q5("EditTextStyle", b, this.fa);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "i9", {
        get: function () {
            return this.ix;
        },
        set: function (a) {
            var b = this.ix;
            this.ix = a;
            if (b != this.ix) {
                this.q5("EditOpacity", b, this.ix);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t0", {
        get: function () {
            return this.s5;
        },
        set: function (a) {
            var b = this.s5;
            this.s5 = a;
            if (b != this.s5) {
                this.q5("DeletedTextColor", b, this.s5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uf", {
        get: function () {
            return this.tk;
        },
        set: function (a) {
            var b = this.tk;
            this.tk = a;
            if (b != this.tk) {
                this.q5("StickyRowBackground", b, this.tk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t7", {
        get: function () {
            return this.tc;
        },
        set: function (a) {
            var b = this.tc;
            this.tc = a;
            if (b != this.tc) {
                this.q5("PinnedRowBackground", b, this.tc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t6", {
        get: function () {
            return this.tb;
        },
        set: function (a) {
            var b = this.tb;
            this.tb = a;
            if (b != this.tb) {
                this.q5("LastStickyRowBackground", b, this.tb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "cu", {
        get: function () {
            return this.cs;
        },
        set: function (a) {
            var b = this.cs;
            this.cs = a;
            if (b != this.cs) {
                this.q5("ActiveCell", b, this.cs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tu", {
        get: function () {
            return this.sz;
        },
        set: function (a) {
            var b = this.sz;
            this.sz = a;
            if (b != this.sz) {
                this.q5("CellBackground", b, this.sz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tw", {
        get: function () {
            return this.s1;
        },
        set: function (a) {
            var b = this.s1;
            this.s1 = a;
            if (b != this.s1) {
                this.q5("CellTextColor", b, this.s1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t4", {
        get: function () {
            return this.s9;
        },
        set: function (a) {
            var b = this.s9;
            this.s9 = a;
            if (b != this.s9) {
                this.q5("HeaderSortIndicatorColor", b, this.s9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "eu", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (b != this.et) {
                this.q5("HeaderSortIndicatorStyle", enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.et));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fh", {
        get: function () {
            return this.e9;
        },
        set: function (a) {
            var b = this.e9;
            this.e9 = a;
            if (b != this.e9) {
                this.q5("CellTextStyle", b, this.e9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uc", {
        get: function () {
            return this.th;
        },
        set: function (a) {
            var b = this.th;
            this.th = a;
            if (b != this.th) {
                this.q5("SectionHeaderBackground", b, this.th);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ue", {
        get: function () {
            return this.tj;
        },
        set: function (a) {
            var b = this.tj;
            this.tj = a;
            if (b != this.tj) {
                this.q5("SectionHeaderTextColor", b, this.tj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fk", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            var b = this.fc;
            this.fc = a;
            if (b != this.fc) {
                this.q5("SectionHeaderTextStyle", b, this.fc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fl", {
        get: function () {
            return this.fd;
        },
        set: function (a) {
            var b = this.fd;
            this.fd = a;
            if (b != this.fd) {
                this.q5("SummaryRootLabelTextStyle", b, this.fd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fn", {
        get: function () {
            return this.ff;
        },
        set: function (a) {
            var b = this.ff;
            this.ff = a;
            if (b != this.ff) {
                this.q5("SummarySectionLabelTextStyle", b, this.ff);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uj", {
        get: function () {
            return this.to;
        },
        set: function (a) {
            var b = this.to;
            this.to = a;
            if (b != this.to) {
                this.q5("SummaryRootValueTextColor", b, this.to);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fm", {
        get: function () {
            return this.fe;
        },
        set: function (a) {
            var b = this.fe;
            this.fe = a;
            if (b != this.fe) {
                this.q5("SummaryRootValueTextStyle", b, this.fe);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fo", {
        get: function () {
            return this.fg;
        },
        set: function (a) {
            var b = this.fg;
            this.fg = a;
            if (b != this.fg) {
                this.q5("SummarySectionValueTextStyle", b, this.fg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "un", {
        get: function () {
            return this.ts;
        },
        set: function (a) {
            var b = this.ts;
            this.ts = a;
            if (b != this.ts) {
                this.q5("SummarySectionValueTextColor", b, this.ts);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uh", {
        get: function () {
            return this.tm;
        },
        set: function (a) {
            var b = this.tm;
            this.tm = a;
            if (b != this.tm) {
                this.q5("SummaryRootLabelTextColor", b, this.tm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ul", {
        get: function () {
            return this.tq;
        },
        set: function (a) {
            var b = this.tq;
            this.tq = a;
            if (b != this.tq) {
                this.q5("SummarySectionLabelTextColor", b, this.tq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ui", {
        get: function () {
            return this.tn;
        },
        set: function (a) {
            var b = this.tn;
            this.tn = a;
            if (b != this.tn) {
                this.q5("SummaryRootSelectedBackground", b, this.tn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "um", {
        get: function () {
            return this.tr;
        },
        set: function (a) {
            var b = this.tr;
            this.tr = a;
            if (b != this.tr) {
                this.q5("SummarySectionSelectedBackground", b, this.tr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ku", {
        get: function () {
            return this.js;
        },
        set: function (a) {
            var b = this.js;
            this.js = a;
            if (b != this.js) {
                this.q5("PinnedAreaSeparatorWidth", b, this.js);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "kt", {
        get: function () {
            return this.jp;
        },
        set: function (a) {
            var b = this.jp;
            this.jp = a;
            if (b != this.jp) {
                this.q5("HeaderSeparatorWidth", b, this.jp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.j5 = function (a) {
        var b = 3;
        var c = Math.max(b - a, 0);
        if (c % 2 == 1) {
            c += 1;
        }
        return intDivide(c, 2);
    };
    Object.defineProperty(Grid.prototype, "t3", {
        get: function () {
            return this.s8;
        },
        set: function (a) {
            var b = this.s8;
            this.s8 = a;
            if (b != this.s8) {
                this.q5("HeaderSeparatorBackground", b, this.s8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t1", {
        get: function () {
            return this.s6;
        },
        set: function (a) {
            var b = this.s6;
            this.s6 = a;
            if (b != this.s6) {
                this.q5("HeaderBackground", b, this.s6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t5", {
        get: function () {
            return this.ta;
        },
        set: function (a) {
            var b = this.ta;
            this.ta = a;
            if (b != this.ta) {
                this.q5("HeaderTextColor", b, this.ta);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "fj", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (b != this.fb) {
                this.q5("HeaderTextStyle", b, this.fb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t8", {
        get: function () {
            return this.td;
        },
        set: function (a) {
            var b = this.td;
            this.td = a;
            if (b != this.td) {
                this.q5("RowSeparatorBackground", b, this.td);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t2", {
        get: function () {
            return this.s7;
        },
        set: function (a) {
            var b = this.s7;
            this.s7 = a;
            if (b != this.s7) {
                this.q5("HeaderRowSeparatorBackground", b, this.s7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ub", {
        get: function () {
            return this.tg;
        },
        set: function (a) {
            var b = this.tg;
            this.tg = a;
            if (b != this.tg) {
                this.q5("RowSeparatorStickyRowBackground", b, this.tg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t9", {
        get: function () {
            return this.te;
        },
        set: function (a) {
            var b = this.te;
            this.te = a;
            if (b != this.te) {
                this.q5("RowSeparatorLastStickyRowBackground", b, this.te);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ua", {
        get: function () {
            return this.tf;
        },
        set: function (a) {
            var b = this.tf;
            this.tf = a;
            if (b != this.tf) {
                this.q5("RowSeparatorPinnedRowBackground", b, this.tf);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j8", {
        get: function () {
            return this.jm;
        },
        set: function (a) {
            var b = this.jm;
            this.jm = a;
            if (b != this.jm) {
                this.q5("ColumnResizingSeparatorWidth", b, this.jm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "j6", {
        get: function () {
            return this.jl;
        },
        set: function (a) {
            var b = this.jl;
            this.jl = a;
            if (b != this.jl) {
                this.q5("ColumnMovingSeparatorWidth", b, this.jl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tz", {
        get: function () {
            return this.s4;
        },
        set: function (a) {
            var b = this.s4;
            this.s4 = a;
            if (b != this.s4) {
                this.q5("ColumnResizingSeparatorBackground", b, this.s4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "tx", {
        get: function () {
            return this.s2;
        },
        set: function (a) {
            var b = this.s2;
            this.s2 = a;
            if (b != this.s2) {
                this.q5("ColumnMovingSeparatorBackground", b, this.s2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ig", {
        get: function () {
            return this.gk;
        },
        set: function (a) {
            var b = this.gk;
            this.gk = a;
            if (b != this.gk) {
                this.q5("ShiftSectionContent", b, this.gk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bk", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.q5("ColumnOptionsIconAlignment", enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.bj));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ty", {
        get: function () {
            return this.s3;
        },
        set: function (a) {
            var b = this.s3;
            this.s3 = a;
            if (b != this.s3) {
                this.q5("ColumnOptionsIconColor", b, this.s3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "bm", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.q5("ColumnOptionsIconBehavior", enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.bl));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "border", {
        get: function () {
            return this.sy;
        },
        set: function (a) {
            var b = this.sy;
            this.sy = a;
            if (b != this.sy) {
                this.q5("Border", b, this.sy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uy", {
        get: function () {
            return this.ut;
        },
        set: function (a) {
            var b = this.ut;
            this.ut = a;
            if (b != this.ut) {
                this.q5("DefaultBorderWidth", b, this.ut);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uv", {
        get: function () {
            return this.ur;
        },
        set: function (a) {
            var b = this.ur;
            this.ur = a;
            if (b != this.ur) {
                this.q5("ActualBorderWidth", b, this.ur);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "uw", {
        get: function () {
            return this.us;
        },
        set: function (a) {
            var b = this.us;
            this.us = a;
            if (b != this.us) {
                this.q5("BorderWidth", b, this.us);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ht", {
        get: function () {
            return this.ge;
        },
        set: function (a) {
            var b = this.ge;
            this.ge = a;
            if (b != this.ge) {
                this.q5("NotifyOnAllSelectionChanges", b, this.ge);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "sx", {
        get: function () {
            return this.st;
        },
        set: function (a) {
            var b = this.st;
            this.st = a;
            if (b != this.st) {
                this.q5("DefaultCornerRadius", b, this.st);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "sw", {
        get: function () {
            return this.ss;
        },
        set: function (a) {
            var b = this.ss;
            this.ss = a;
            if (b != this.ss) {
                this.q5("CornerRadius", b, this.ss);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "su", {
        get: function () {
            return this.sr;
        },
        set: function (a) {
            var b = this.sr;
            this.sr = a;
            if (b != this.sr) {
                this.q5("ActualCornerRadius", b, this.sr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "g2", {
        get: function () {
            return this.f1;
        },
        set: function (a) {
            var b = this.f1;
            this.f1 = a;
            if (this.f1 != b) {
                this.q5("IsActiveCellStyleEnabled", b, this.f1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "platformPixelConverter", {
        get: function () {
            return this.fp;
        },
        set: function (a) {
            this.fp = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "renderingEngine", {
        get: function () {
            return this.d0;
        },
        set: function (a) {
            this.d0 = a;
            this.q7(this.d0);
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.q7 = function (a) {
        if (a != null) {
            a.refresh(this.model, false);
        }
    };
    Object.defineProperty(Grid.prototype, "eh", {
        get: function () {
            return this.eg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "model", {
        get: function () {
            return this.e5;
        },
        set: function (a) {
            this.e5 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "up", {
        get: function () {
            return new Rect(0, this.e5.b3, this.e5.b8, this.e5.b9, this.e5.by);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "b4", {
        get: function () {
            return this.b3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "a7", {
        get: function () {
            return this.a6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "v", {
        get: function () {
            return this.u;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "b7", {
        get: function () {
            return this.b6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            this.gm = true;
            if (b != this.s) {
                this.q5("SummaryScope", enumGetBox(DataSourceSummaryScope_$type, b), enumGetBox(DataSourceSummaryScope_$type, this.s));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hg", {
        get: function () {
            return this.f4;
        },
        set: function (a) {
            var b = this.f4;
            this.f4 = a;
            this.f5 = true;
            if (b != this.f4) {
                this.q5("IsGroupCollapsable", b, this.f4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "r", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            this.fw = true;
            if (b != this.q) {
                this.q5("GroupHeaderDisplayMode", enumGetBox(DataSourceSectionHeaderDisplayMode_$type, b), enumGetBox(DataSourceSectionHeaderDisplayMode_$type, this.q));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hh", {
        get: function () {
            return this.f6;
        },
        set: function (a) {
            var b = this.f6;
            this.f6 = a;
            this.f7 = true;
            if (b != this.f6) {
                this.q5("IsGroupExpandedDefault", b, this.f6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "dt", {
        get: function () {
            return this.ds;
        },
        set: function (a) {
            var b = this.ds;
            this.ds = a;
            this.fx = true;
            if (b != this.ds) {
                this.q5("GroupSummaryDisplayMode", enumGetBox(GroupSummaryDisplayMode_$type, b), enumGetBox(GroupSummaryDisplayMode_$type, this.ds));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "gr", {
        get: function () {
            return this.fu;
        },
        set: function (a) {
            this.fu = a;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.q5 = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.rk(a, b, c);
    };
    Grid.prototype.ry = function () {
    };
    Grid.prototype.rp = function () {
        var _this = this;
        if (this.iq == 0) {
            return;
        }
        var a = this.model.absoluteWidth;
        var b = this.model.absoluteHeight;
        this.h9 = true;
        this.ey.r(this, this.model, truncate(this.i7));
        if (a != this.model.absoluteWidth || b != this.model.absoluteHeight) {
            this.externalGrid.onContentSizeChanged();
        }
        this.h9 = false;
        this.e4.v();
        this.renderingEngine.invalidateVisibility(function () { return _this.e4.l(_this); });
        this.renderingEngine.refresh(this.model, false);
    };
    Grid.prototype.rq = function () {
        var _this = this;
        if (this.f0) {
            this.ph();
        }
        else {
            this.renderingEngine.invalidateVisibility(function () { return _this.e4.l(_this); });
            this.renderingEngine.refresh(this.model, true);
        }
    };
    Grid.prototype.ph = function () {
        if (this.f0) {
            this.f0 = false;
            this.rp();
            this.pq();
        }
    };
    Object.defineProperty(Grid.prototype, "h9", {
        get: function () {
            return this.gj;
        },
        set: function (a) {
            this.gj = a;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.ro = function () {
        var _this = this;
        if (this.gj) {
            return;
        }
        this.renderingEngine.invalidateVisibility(function () { return _this.e4.l(_this); });
        this.renderingEngine.refresh(this.model, false);
    };
    Grid.prototype.pg = function () {
        if (this.actualDataSource != null) {
            this.actualDataSource.flushAutoRefresh();
        }
        this.c6.an(true);
        this.renderingEngine.refresh(this.model, true);
    };
    Object.defineProperty(Grid.prototype, "actualDataSource", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (this.w != b) {
                this.q5("ActualDataSource", b, this.w);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "l", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            var b = this.d;
            this.d = a;
            if (this.d != b) {
                this.q5("PrimaryKey", b, this.d);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "e", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (this.a != b) {
                this.q5("ActualPrimaryKey", b, this.a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.rk = function (a, b, c) {
        if (a == "ItemsSource") {
            if (this.w != null) {
                var d = this.w;
                d.schemaChanged = delegateRemove(d.schemaChanged, runOn(this, this.pc));
                if (this.y != null) {
                    var e = this.y;
                    e.dataCommitted = delegateRemove(e.dataCommitted, runOn(this, this.pb));
                }
                this.w.updateNotifier = null;
                this.b4.b = null;
                this.a7.b = null;
                this.v.syncTarget = null;
                this.b7.b = null;
                this.e = this.m();
            }
            if (typeCast(IDataSource_$type, this.itemsSource) !== null) {
                this.actualDataSource = this.itemsSource;
            }
            else {
                var f = this.externalGrid.createLocalDataSource(this.itemsSource);
                this.actualDataSource = f;
            }
            if (this.w != null) {
                this.y = typeCast(IEditableDataSource_$type, this.actualDataSource);
                var g = this.w;
                g.schemaChanged = delegateCombine(g.schemaChanged, runOn(this, this.pc));
                if (this.y != null) {
                    var h = this.y;
                    h.dataCommitted = delegateCombine(h.dataCommitted, runOn(this, this.pb));
                }
                this.w.updateNotifier = new DataSourceNotificationBridge(this);
                if (this.w.isVirtual) {
                    this.model.bl = this.hm;
                }
                if (this.h8) {
                    this.b4.b = this.w.sortDescriptions;
                }
                if (this.h7) {
                    this.a7.b = this.w.groupDescriptions;
                }
                if (this.h6) {
                    this.v.syncTarget = this.w.filterExpressions;
                }
                this.b7.b = this.w.summaryDescriptions;
                this.w.propertiesRequested = this.n();
                if (this.l != null) {
                    this.actualDataSource.primaryKey = this.l;
                }
                this.e = this.m();
                if (this.w.actualSchema != null) {
                    this.qr();
                }
                this.g1 = true;
                this.g0 = true;
                this.go = true;
                this.gn = true;
                this.si(this.ad, this.ah);
                this.si(this.ac, this.ag);
                this.es.av();
                this.g1 = false;
                this.g0 = false;
                this.go = false;
                this.gn = false;
                for (var i = 0; i < this.ag.ae.count; ++i) {
                    this.d3.pinRow(this.ag.ae._inner[i]);
                }
                if (this.f5) {
                    this.actualDataSource.isSectionCollapsable = this.hg;
                }
                if (this.fw) {
                    this.actualDataSource.sectionHeaderDisplayMode = this.r;
                }
                if (this.gm) {
                    this.actualDataSource.summaryScope = this.t;
                }
                if (this.f7) {
                    this.actualDataSource.isSectionExpandedDefault = this.hh;
                }
                if (this.fx) {
                    switch (this.dt) {
                        case 1:
                        case 0:
                        case 4:
                            this.actualDataSource.includeSummaryRowsInSection = false;
                            break;
                        case 2:
                            this.actualDataSource.includeSummaryRowsInSection = true;
                            this.actualDataSource.isSectionSummaryRowsAtBottom = false;
                            break;
                        case 3:
                            this.actualDataSource.includeSummaryRowsInSection = true;
                            this.actualDataSource.isSectionSummaryRowsAtBottom = true;
                            break;
                    }
                }
                this.sk();
            }
        }
        if (a == "AutoGenerateColumns") {
            this.a2.p = this.gs;
        }
        if (a == "AutoGenerateDesiredColumns") {
            this.a2.b = this.f;
        }
        if (a == "IsPlaceholderRenderingEnabled") {
            if (this.w != null && this.w.isVirtual) {
                this.model.bl = this.hm;
            }
        }
        if (a == "ColumnResizingMode") {
            this.hk = this.ib();
        }
        if (a == "ActivationMode") {
            this.g5 = this.ia();
        }
        if (a == "SelectionMode") {
            this.g5 = this.ia();
            switch (this.dn) {
                case 1:
                    if (this.de.count > 0) {
                        this.de.clear();
                    }
                    if (this.dh.count > 0) {
                        this.dh.clear();
                    }
                    if (this.ah.count > 1) {
                        var j = this.ah._inner[this.ah.count - 1];
                        this.ah.clear();
                        this.ah.add(j);
                    }
                    break;
                case 2:
                    if (this.de.count > 0) {
                        this.de.clear();
                    }
                    if (this.dh.count > 0) {
                        this.dh.clear();
                    }
                    break;
                case 3:
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    if (this.de.count > 0) {
                        this.de.clear();
                    }
                    if (this.dh.count > 1) {
                        var k = this.dh._inner[this.dh.count - 1];
                        this.dh.clear();
                        this.dh.add(k);
                    }
                    break;
                case 4:
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    if (this.de.count > 0) {
                        this.de.clear();
                    }
                    break;
                case 5:
                    if (this.dh.count > 0) {
                        this.dh.clear();
                    }
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    break;
                case 0:
                    if (this.ah.count > 0) {
                        this.ah.clear();
                    }
                    if (this.dh.count > 0) {
                        this.dh.clear();
                    }
                    if (this.de.count > 0) {
                        this.de.clear();
                    }
                    break;
            }
        }
        if (a == "RowSeparator") {
            var l = b;
            var m = c;
            if (l != null) {
                l.definitionPropertyUpdated = delegateRemove(l.definitionPropertyUpdated, runOn(this, this.r1));
                l.grid = null;
            }
            if (m != null) {
                m.definitionPropertyUpdated = delegateCombine(m.definitionPropertyUpdated, runOn(this, this.r1));
                m.grid = this;
            }
        }
        if (a == "HeaderRowSeparator") {
            var n = b;
            var o = c;
            if (n != null) {
                n.definitionPropertyUpdated = delegateRemove(n.definitionPropertyUpdated, runOn(this, this.pj));
                n.grid = null;
            }
            if (o != null) {
                o.definitionPropertyUpdated = delegateCombine(o.definitionPropertyUpdated, runOn(this, this.pj));
                o.grid = this;
            }
        }
        if (a == "HeaderSeparator") {
            var p = b;
            var q = c;
            if (p != null) {
                p.definitionPropertyUpdated = delegateRemove(p.definitionPropertyUpdated, runOn(this, this.pk));
                p.grid = null;
            }
            if (q != null) {
                q.definitionPropertyUpdated = delegateCombine(q.definitionPropertyUpdated, runOn(this, this.pk));
                q.grid = this;
            }
        }
        if (a == "ColumnResizingSeparator") {
            var r = b;
            var s = c;
            if (r != null) {
                r.grid = null;
            }
            if (s != null) {
                s.grid = this;
            }
        }
        if (a == "ColumnMovingSeparator") {
            var t = b;
            var u = c;
            if (t != null) {
                t.grid = null;
            }
            if (u != null) {
                u.grid = this;
            }
        }
        if (a == "DataSourceDesiredProperties") {
            if (this.w != null) {
                this.w.propertiesRequested = this.g;
            }
        }
        if (a == "PrimaryKey") {
            if (this.actualDataSource != null && this.l != null) {
                this.actualDataSource.primaryKey = c;
            }
            this.e = this.m();
        }
        if (a == "ActualRowHeight" || a == "ActualHeaderHeight" || a == "RowSeparatorHeight" || a == "IsGroupRowSticky" || a == "IsHeaderSeparatorVisible" || a == "ShiftSectionContent" || a == "PinnedAreaSeparatorWidth") {
            this.hk = this.ib();
            if (this.ic()) {
                this.rp();
            }
        }
        if (a == "DefaultColumnWidth" || a == "DefaultColumnMinWidth" || a == "Inset" || a == "HeaderSeparatorWidth") {
            if (this.model != null && this.model.br != null && this.model.br.count > 0) {
                this.rp();
            }
        }
        if (a == "SectionHeader") {
            if (b != null) {
                var v = typeCast(SectionHeader.$, b);
                v.sectionHeaderPropertyUpdating = delegateRemove(v.sectionHeaderPropertyUpdating, runOn(this, this.rb));
                v.grid = null;
            }
            if (this.eq != null) {
                var w = this.eq;
                w.sectionHeaderPropertyUpdating = delegateCombine(w.sectionHeaderPropertyUpdating, runOn(this, this.rb));
                this.eq.grid = this;
            }
            this.model.bn = true;
            this.rp();
        }
        if (a == "PinnedAreaSeparator") {
            if (b != null) {
                var x = typeCast(PinnedAreaSeparator.$, b);
                x.grid = null;
            }
            if (this.ec != null) {
                this.ec.grid = this;
            }
            this.rp();
        }
        if (a == "ActiveCell") {
            this.ct = typeCast(GridCellPosition.$, b);
            this.gp = true;
            if (this.cu != null && this.cu.b >= 0) {
                this.aj.y(this.cu.b, this.cu.d);
            }
            else {
                this.aj.aa();
            }
            this.gp = false;
        }
        if (a == "ReactsToSortChanges") {
            var y = c;
            if (!y) {
                this.b4.b = null;
            }
            else {
                if (this.w != null) {
                    this.b4.b = this.w.sortDescriptions;
                }
            }
        }
        if (a == "ReactsToGroupChanges") {
            var z = c;
            if (!z) {
                this.a7.b = null;
            }
            else {
                if (this.w != null) {
                    this.a7.b = this.w.groupDescriptions;
                }
            }
        }
        if (a == "ReactsToFilterChanges") {
            var aa = c;
            if (!aa) {
                this.v.syncTarget = null;
            }
            else {
                if (this.w != null) {
                    this.v.syncTarget = this.w.filterExpressions;
                }
            }
        }
        if (a == "IsGroupCollapsable") {
            if (this.actualDataSource != null) {
                this.actualDataSource.isSectionCollapsable = c;
            }
        }
        if (a == "GroupHeaderDisplayMode") {
            if (this.actualDataSource != null) {
                this.actualDataSource.sectionHeaderDisplayMode = EnumUtil.getEnumValue(DataSourceSectionHeaderDisplayMode_$type, c);
            }
        }
        if (a == "SummaryScope") {
            if (this.actualDataSource != null) {
                this.actualDataSource.summaryScope = EnumUtil.getEnumValue(DataSourceSummaryScope_$type, c);
            }
        }
        if (a == "IsGroupExpandedDefault") {
            if (this.actualDataSource != null) {
                this.actualDataSource.isSectionExpandedDefault = c;
            }
        }
        if (a == "GroupSummaryDisplayMode") {
            this.eq.en = this.dt;
            this.model.bn = true;
            if (this.actualDataSource != null) {
                switch (this.dt) {
                    case 1:
                    case 0:
                    case 4:
                        this.actualDataSource.includeSummaryRowsInSection = false;
                        break;
                    case 2:
                        this.actualDataSource.includeSummaryRowsInSection = true;
                        this.actualDataSource.isSectionSummaryRowsAtBottom = false;
                        break;
                    case 3:
                        this.actualDataSource.includeSummaryRowsInSection = true;
                        this.actualDataSource.isSectionSummaryRowsAtBottom = true;
                        break;
                }
            }
            this.rp();
        }
        if (a == "Density") {
            this.qs();
        }
        if (a == "RowHeight") {
            this.j4 = this.kw;
        }
        if (a == "HeaderHeight") {
            this.j3 = this.kp;
            this.externalGrid.setScrollerVerticalTrackInset(this.kp);
        }
        if (a == "DefaultBorderWidth" || a == "BorderWidth") {
            this.uv = this.ux(this.uw, this.uy);
        }
        if (a == "DefaultCornerRadius" || a == "CornerRadius") {
            this.su = this.sv(this.sw, this.sx);
        }
        if (a == "Border" || a == "ActualCornerRadius" || a == "ActualBorderWidth") {
            this.externalGrid.setBorder(this.border, this.uv.c, this.uv.e, this.uv.d, this.uv.b, this.su.c, this.su.d, this.su.a, this.su.b);
        }
        if (a == "EditMode") {
            this.sk();
        }
    };
    Grid.prototype.sk = function () {
        if (this.y != null) {
            if (this.cf == 2) {
                this.y.isBatchingEnabled = true;
            }
            else {
                this.y.isBatchingEnabled = false;
            }
        }
    };
    Grid.prototype.sv = function (a, b) {
        return new CornerRadius(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b, !isNaN_(a.a) ? a.a : b.a);
    };
    Grid.prototype.ux = function (a, b) {
        return new Thickness(1, !isNaN_(a.c) ? a.c : b.c, !isNaN_(a.e) ? a.e : b.e, !isNaN_(a.d) ? a.d : b.d, !isNaN_(a.b) ? a.b : b.b);
    };
    Grid.prototype.syncBorder = function () {
        if (this.externalGrid != null) {
            this.externalGrid.setBorder(this.border, this.uv.c, this.uv.e, this.uv.d, this.uv.b, this.su.c, this.su.d, this.su.a, this.su.b);
        }
    };
    Grid.prototype.qs = function () {
        if (this.kw == -1) {
            switch (this.e8) {
                case 0:
                case 2:
                    this.j4 = GridStyleRepository.p;
                    break;
                case 3:
                    this.j4 = GridStyleRepository.o;
                    break;
                case 1:
                    this.j4 = GridStyleRepository.n;
                    break;
            }
        }
        if (this.kp == -1) {
            switch (this.e8) {
                case 0:
                case 2:
                    this.j3 = GridStyleRepository.p;
                    break;
                case 3:
                    this.j3 = GridStyleRepository.o;
                    break;
                case 1:
                    this.j3 = GridStyleRepository.n;
                    break;
            }
        }
    };
    Grid.prototype.m = function () {
        if (this.l != null) {
            return this.l;
        }
        if (this.actualDataSource != null) {
            return this.actualDataSource.actualPrimaryKey;
        }
        return null;
    };
    Grid.prototype.n = function () {
        if (!this.gs && this.g == null && this.w.propertiesRequested == null && this.columns.count > 0) {
            return this.h();
        }
        if (this.g != null) {
            return this.g;
        }
        return this.w.propertiesRequested;
    };
    Grid.prototype.h = function () {
        var a = new Array(this.columns.count);
        for (var b = 0; b < this.columns.count; b++) {
            a[b] = this.columns._inner[b].hx;
        }
        return a;
    };
    Grid.prototype.r1 = function (a, b) {
        this.r2(b.propertyName, b.animationType, b.oldValue, b.newValue, false);
    };
    Grid.prototype.pj = function (a, b) {
        this.r2(b.propertyName, b.animationType, b.oldValue, b.newValue, true);
    };
    Grid.prototype.pk = function (a, b) {
        this.pl(b.propertyName, b.animationType, b.oldValue, b.newValue);
    };
    Grid.prototype.r2 = function (a, b, c, d, e) {
        if (b == 10) {
            return;
        }
        if (a != null && stringStartsWith(a, "Actual")) {
            a = a.substr(6);
        }
        this.ck.r(this, null, a, b, c, d, e, true, false, false);
    };
    Grid.prototype.pl = function (a, b, c, d) {
        if (b == 10) {
            return;
        }
        if (a != null && stringStartsWith(a, "Actual")) {
            a = a.substr(6);
        }
        for (var e = 0; e < this.model.br.count; e++) {
            var f = this.model.br._inner[e];
            this.ck.r(this, f, a, b, c, d, true, false, false, true);
        }
    };
    Grid.prototype.pc = function (a, b) {
        this.qr();
    };
    Grid.prototype.pb = function (a, b) {
        if (this.dataCommitted != null) {
            this.dataCommitted(this, new GridDataCommittedEventArgs(b.commitID, b.changes));
        }
    };
    Grid.prototype.qr = function () {
        this.d2.setDataSource(this.w);
        this.a2.d = this.w.actualSchema;
        this.sl();
        for (var a = 0; a < this.a7.i.count; a++) {
            this.rz(this.a7.i.item(a));
        }
        for (var b = 0; b < this.b7.i.count; b++) {
            this.r0(this.b7.i.item(b));
        }
        this.rp();
        this.pq();
    };
    Grid.prototype.pw = function () {
        var e_15, _a;
        if (this.columnsAutoGenerated != null) {
            var a = new GridColumnsAutoGeneratedEventArgs();
            a.columns = this.actualColumns;
            this.columnsAutoGenerated(this, a);
        }
        try {
            for (var _b = tslib_1.__values(fromEnum(this.actualColumns)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                b.gf = false;
            }
        }
        catch (e_15_1) {
            e_15 = { error: e_15_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_15)
                    throw e_15.error;
            }
        }
    };
    Grid.prototype.onSizeChanged = function (a, b) {
        this.i7 = a;
        this.i6 = b;
        this.ee.y(a, b);
        this.rp();
        if (this.sizeChanged != null) {
            this.sizeChanged(this, ((function () {
                var $ret = new GridSizeChangedEventArgs();
                $ret.b = a;
                $ret.a = b;
                return $ret;
            })()));
        }
    };
    Grid.prototype.setViewport = function (a, b, c, d) {
        this.jq = -1;
        this.jr = -1;
        var e = c - a;
        var f = new Rect(0, a, b, c - a, d - b);
        if (f.x != this.model.actualVisibleRegion.x || f.y != this.model.actualVisibleRegion.y || f.width != this.model.actualVisibleRegion.width || f.height != this.model.actualVisibleRegion.height) {
            var g_1 = this.model.actualVisibleRegion;
            this.model.actualVisibleRegion = f;
            this.rq();
            if (this.viewportChanged != null) {
                this.viewportChanged(this, ((function () {
                    var $ret = new GridViewportChangedEventArgs();
                    $ret.g = f.x;
                    $ret.d = g_1.x;
                    $ret.h = f.y;
                    $ret.e = g_1.y;
                    $ret.f = f.width;
                    $ret.c = g_1.width;
                    $ret.a = f.height;
                    $ret.b = g_1.height;
                    return $ret;
                })()));
            }
        }
    };
    Object.defineProperty(Grid.prototype, "actualColumns", {
        get: function () {
            return this.a1.j;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "columns", {
        get: function () {
            return this.cy;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.q3 = function (a, b, c) {
        var d = this.ca(a.k);
        d.cw(a, this, b, c);
        d.cx(a, this, b, c);
    };
    Grid.prototype.q2 = function (a, b, c, d) {
        a.ir = d;
        var e = this.ca(a.k);
        e.cx(a, this, b, c);
    };
    Grid.prototype.a0 = function (a) {
        return this.a2.h(a);
    };
    Grid.prototype.pm = function (a) {
        a.f7 = true;
        a.gd = true;
    };
    Grid.prototype.pe = function (a, b) {
        var c = this.columns.indexOf(b);
        if (c == -1) {
            return;
        }
        if ((a != null && a.gc) || (b != null && b.gc)) {
            throw new InvalidOperationException(1, "Cannot exchange a column created from markup");
        }
        if (this.columns.contains(a)) {
            if (a.gd) {
                this.externalGrid.removeExternalColumn(a.externalObject);
            }
            else {
                return;
            }
        }
        var d = this.a4;
        if (d == 0) {
            d = a.et();
        }
        var e = false;
        if (d == 2 || d == 7) {
            e = true;
        }
        a.e8 = 3;
        if (e) {
            this.externalGrid.insertExternalColumnAtIndex(c + 1, a.externalObject);
        }
        else {
            this.externalGrid.insertExternalColumnAtIndex(c, a.externalObject);
        }
        b.fk = a.fk;
        if (!this.g8(a)) {
            a.gd = false;
            a.e8 = 5;
            this.externalGrid.removeExternalColumn(b.externalObject);
            this.qf(a);
        }
        this.rp();
        if (this.g8(a)) {
            var f = this.model.g(b.g2).a;
            b.e8 = 2;
            a.e8 = 1;
            this.ck.ai(this, this.cx, this.model.g(b.g2), this.model.g(a.g2), f);
        }
    };
    Grid.prototype.ox = function (a, b) {
        var _this = this;
        this.es.w();
        this.aj.ad();
        this.es.au();
        if (this.ij) {
            return;
        }
        switch (b.action) {
            case 0:
                if (b.newItems != null) {
                    for (var c = 0; c < b.newItems.count; c++) {
                        this.qi(c + b.newStartingIndex, b.newItems.item(c));
                    }
                }
                break;
            case 1:
                if (b.oldItems != null) {
                    for (var d = 0; d < b.oldItems.count; d++) {
                        this.qm(b.oldStartingIndex, b.oldItems.item(d));
                    }
                }
                break;
            case 2:
                if (b.oldItems != null) {
                    for (var e = 0; e < b.oldItems.count; e++) {
                        this.qm(b.oldStartingIndex, b.oldItems.item(e));
                    }
                }
                if (b.newItems != null) {
                    for (var f = 0; f < b.newItems.count; f++) {
                        this.qi(f + b.newStartingIndex, b.newItems.item(f));
                    }
                }
                break;
            case 4:
                this.qp();
                break;
        }
        this.rp();
        if (!this.gd) {
            this.gd = true;
            this.delayedExecutionManager.executeIn(function () {
                _this.gd = false;
                if (_this.actualColumnsChanged != null) {
                    _this.actualColumnsChanged(_this, ((function () {
                        var $ret = new GridColumnsChangedEventArgs();
                        $ret.columns = _this.actualColumns;
                        return $ret;
                    })()));
                }
            }, 0);
        }
    };
    Grid.prototype.qp = function () {
        this.ey.w(this.db, this.model);
    };
    Grid.prototype.qm = function (a, b) {
        b.grid = null;
        b.propertyChanged = delegateRemove(b.propertyChanged, runOn(this, this.o5));
        b.columnCellsPropertyUpdating = delegateRemove(b.columnCellsPropertyUpdating, runOn(this, this.o6));
        b.columnHeaderCellsPropertyUpdating = delegateRemove(b.columnHeaderCellsPropertyUpdating, runOn(this, this.o9));
        this.ey.v(this.db, a, b, this.model);
        this.rp();
        b.e8 = 0;
        this.es.ac(a, b);
    };
    Grid.prototype.qi = function (a, b) {
        b.grid = this;
        b.propertyChanged = delegateCombine(b.propertyChanged, runOn(this, this.o5));
        b.columnCellsPropertyUpdating = delegateCombine(b.columnCellsPropertyUpdating, runOn(this, this.o6));
        b.columnHeaderCellsPropertyUpdating = delegateCombine(b.columnHeaderCellsPropertyUpdating, runOn(this, this.o9));
        this.ey.t(a, b, this.model);
        if (b.gd) {
            b.e8 = 3;
        }
        if (this.g6(b) && !b.gd && b.e8 != 3) {
            var c = b.e8;
            b.e8 = 1;
            this.rp();
            this.ck.ao(this, this.cx, this.model.g(b.g2), true, c);
        }
        else {
            this.rp();
        }
        for (var d = 0; d < this.b4.i.count; d++) {
            if (b.hx == this.b4.i.item(d).f) {
                b.e6 = this.b5(this.b4.i.item(d).c);
                break;
            }
        }
        this.es.aa(a, b);
    };
    Grid.prototype.o6 = function (a, b, c, d, e) {
        if (b == "Pinned") {
            this.gz(false);
        }
        if (b == "Width" || b == "MinWidth" || b == "Pinned") {
            this.rp();
            this.o4();
            return;
        }
        if (c == 10) {
            return;
        }
        var f = this.model.g(a.g2);
        if (f == null) {
            return;
        }
        if (b != null && stringStartsWith(b, "Actual")) {
            b = b.substr(6);
        }
        if (b == "HeaderText") {
            this.o9(a, "TextValue", c, d, e);
            return;
        }
        if (b == "ColumnOptionsIconAlignment" || b == "ColumnOptionsIconColor" || b == "ColumnOptionsIconBehavior" || b == "IsColumnOptionsEnabled") {
            this.o9(a, b, c, d, e);
            return;
        }
        if (b == "FormatString") {
            if (typeCast(NumericColumn.$, a) !== null || typeCast(DateTimeColumn.$, a) !== null) {
                b = "FormatStringOverride";
            }
        }
        if (b == "SortDirection" && false == this.hl) {
            this.ew.f(a, a.e6);
        }
        this.ck.r(this, f, b, c, d, e, false, false, false, false);
    };
    Grid.prototype.rb = function (a, b, c, d, e) {
        if (c == 10) {
            return;
        }
        if (b != null && stringStartsWith(b, "Actual")) {
            b = b.substr(6);
        }
        this.ck.r(this, null, b, c, d, e, false, false, true, false);
    };
    Grid.prototype.o9 = function (a, b, c, d, e) {
        if (c == 10) {
            return;
        }
        var f = this.model.g(a.g2);
        if (f == null) {
            return;
        }
        if (b != null && stringStartsWith(b, "Actual")) {
            b = b.substr(6);
        }
        this.ck.r(this, f, b, c, d, e, true, false, false, false);
    };
    Grid.prototype.rh = function (a, b) {
        var c = this.columns.indexOf(a);
        if (c == -1) {
            return;
        }
        if (a.fk == b) {
            return;
        }
        this.gz(false);
        a.gv = this.ey.k(c, this, this.model);
        a.gw = this.model.br._inner[c].n;
        a.fj = a.fk;
        a.fk = b;
        this.ey.s(this.model);
        var d = a.e8;
        if (this.ha(a)) {
            a.e8 = 6;
            this.ck.ak(this, this.cx, this.model.g(a.g2), d);
        }
    };
    Grid.prototype.pr = function (a, b) {
        var _this = this;
        this.externalGrid.ensureColumnsAreManual();
        var c = this.columns._inner[a];
        b = Math.min(this.columns.count - 1, Math.max(0, b));
        this.ij = true;
        if (c != null && c.gc) {
            throw new InvalidOperationException(1, "Can't move a column that was created from markup");
        }
        if (b > a) {
            var d = this.columns._inner[b - 1];
            if (d.gc) {
                throw new InvalidOperationException(1, "Can't move a column to before columns created from markup");
            }
        }
        else {
            var e = this.columns._inner[b];
            if (e.gc) {
                throw new InvalidOperationException(1, "Can't move a column to before columns created from markup");
            }
        }
        this.externalGrid.removeExternalColumn(c.externalObject);
        this.externalGrid.insertExternalColumnAtIndex(b, c.externalObject);
        this.ij = false;
        this.gz(false);
        this.qj(a, b, c);
        if (this.actualColumnsChanged != null) {
            this.actualColumnsChanged(this, ((function () {
                var $ret = new GridColumnsChangedEventArgs();
                $ret.columns = _this.actualColumns;
                return $ret;
            })()));
        }
    };
    Grid.prototype.ps = function (a) {
        this.hs(a, true, true);
    };
    Grid.prototype.pt = function (a) {
        this.hs(a, false, true);
    };
    Grid.prototype.gv = function (a) {
        return this.hs(a, true, false);
    };
    Grid.prototype.gw = function (a) {
        return this.hs(a, false, false);
    };
    Grid.prototype.hs = function (a, b, c) {
        var d = this.actualColumns;
        var e = d.count - 1;
        var f = d._inner[a];
        var g = f.fk;
        var h = -1;
        var i = a;
        do {
            i += b ? -1 : 1;
            if (i < 0 || i > e) {
                break;
            }
            var j = d._inner[i];
            if (!j.gd && j.fk == g) {
                h = i;
            }
        } while (h == -1);
        if (h != -1) {
            if (c) {
                this.pr(a, h);
            }
            return true;
        }
        switch (f.fk) {
            case 0:
                var k = this.ay(b);
                if (null == k) {
                    return false;
                }
                if (c) {
                    h = d.indexOf(k);
                    this.pr(a, h + (b ? 1 : -1));
                    f.fk = k.fk;
                }
                break;
            case 1:
                if (b) {
                    return false;
                }
                if (c) {
                    var l = this.ax(true);
                    if (l == null) {
                        this.rh(d._inner[a], 0);
                    }
                    else {
                        h = d.indexOf(l);
                        this.pr(a, h - 1);
                        f.fk = 0;
                    }
                }
                break;
            case 2:
                if (!b) {
                    return false;
                }
                if (c) {
                    var m = this.ax(false);
                    if (m == null) {
                        this.rh(d._inner[a], 0);
                    }
                    else {
                        h = d.indexOf(m);
                        this.pr(a, h + 1);
                        f.fk = 0;
                    }
                }
                break;
        }
        return true;
    };
    Grid.prototype.ay = function (a) {
        var b = a ? 1 : 2;
        var c = this.actualColumns;
        var d = this.model.bx;
        var e = d.count - 1;
        var f = a ? 0 : e;
        var g = d._inner[f];
        var h = c._inner[g];
        var i = null;
        while (h.fk == b) {
            i = h;
            f += a ? 1 : -1;
            if (f < 0 || f > e) {
                break;
            }
            g = d._inner[f];
            h = c._inner[g];
        }
        return i;
    };
    Grid.prototype.ax = function (a) {
        var b = this.actualColumns;
        var c = this.model.bx;
        var d = c.count - 1;
        var e = a ? 0 : d;
        var f = c._inner[e];
        var g = b._inner[f];
        while (g.fk != 0) {
            e += a ? 1 : -1;
            if (e < 0 || e > d) {
                break;
            }
            f = c._inner[e];
            g = b._inner[f];
        }
        if (g.fk == 0) {
            return g;
        }
        else {
            return null;
        }
    };
    Grid.prototype.qj = function (a, b, c) {
        c.gv = this.ey.k(a, this, this.model);
        c.gu = a;
        c.gw = this.model.br._inner[a].n;
        var d = c.e8;
        this.ey.u(this.db, this.model, a, b, c.g2);
        if (!this.ha(c) && d != 3) {
            c.e8 = 5;
        }
        this.rp();
        if (this.ha(c)) {
            c.e8 = 6;
            this.ck.ak(this, this.cx, this.model.g(c.g2), d);
        }
        this.es.ab(a, b, c);
    };
    Grid.prototype.o5 = function (a, b) {
        var c = a;
        switch (b.propertyName) {
            case "Filter":
                this.sl();
                break;
            case "IsHidden":
                if (c.gd) {
                    if (this.g9(c)) {
                        var d = c.e8;
                        c.e8 = 2;
                        this.rp();
                        this.ck.aj(this, this.cx, this.model.g(c.g2), false, d);
                    }
                    else {
                        c.e8 = 3;
                        if (c.f4) {
                            this.externalGrid.ensureColumnsAreManual();
                            this.externalGrid.removeExternalColumn(c.externalObject);
                        }
                        this.rp();
                    }
                }
                else {
                    if (this.he(c)) {
                        var e = c.e8;
                        c.e8 = 1;
                        this.rp();
                        this.ck.ao(this, this.cx, this.model.g(c.g2), false, e);
                    }
                    else {
                        c.e8 = 5;
                        this.ck.ah(this, this.model.g(c.g2));
                        this.c6.ab();
                        this.rp();
                    }
                }
                if (this.columnHiddenChanged != null) {
                    this.columnHiddenChanged(this, ((function () {
                        var $ret = new ColumnHiddenChangedEventArgs();
                        $ret.a = c;
                        $ret.b = c.gd;
                        return $ret;
                    })()));
                }
                break;
            case "Pinned":
                if (this.columnPinnedChanged != null) {
                    this.columnPinnedChanged(this, ((function () {
                        var $ret = new ColumnPinnedChangedEventArgs();
                        $ret.a = c;
                        $ret.b = c.fk;
                        return $ret;
                    })()));
                }
                break;
        }
    };
    Grid.prototype.sl = function () {
        if (this.actualDataSource == null) {
            return;
        }
        var a = this.z(null);
        if (a != null) {
            a.markAutoGenerated();
            var b = false;
            if (this.v != null) {
                for (var c = 0; c < this.v.j.count; c++) {
                    if (this.v.j.item(c).isAutoGenerated) {
                        this.v.j.item(c, a);
                        b = true;
                        break;
                    }
                }
            }
            if (!b) {
                this.v.add(a);
            }
        }
        else {
            for (var d = this.v.j.count - 1; d >= 0; d--) {
                if (this.v.j.item(d).isAutoGenerated) {
                    this.v.removeAt(d);
                }
            }
        }
    };
    Grid.prototype.ca = function (a) {
        var b = this.d2.getRowType(a.w);
        if (b != 0 && b != 3) {
            if (a.aq) {
                if (a.g) {
                    return this.dx;
                }
                return this.em;
            }
            switch (b) {
                case 1: if (this.dt != 1) {
                    return this.eq;
                }
                else {
                    return this.a0(a);
                }
                case 2: return this.eo;
                case 4: return this.e0;
                case 5: return this.e2;
                default: throw new NotSupportedException(0);
            }
        }
        else {
            if (a.aq) {
                if (a.g) {
                    return this.dx;
                }
                return this.em;
            }
            else {
                if (a.an) {
                    if (this.dragger.dragType == 1) {
                        return this.bw;
                    }
                    else if (this.dragger.dragType == 2) {
                        return this.bi;
                    }
                }
                if (a.aj || a.al || a.ai || a.ak) {
                    return this.ec;
                }
                var c = this.a0(a);
                if (a.g) {
                    if (a.h) {
                        return this.dz;
                    }
                    else {
                        return c.header;
                    }
                }
                else {
                    return c;
                }
            }
        }
    };
    Grid.prototype.ms = function (a, b, c, d) {
        return this.ca(a).cl(a, b, c, d);
    };
    Grid.prototype.ao = function (a, b) {
        var c = this.ca(a);
        var d = c.k(a, b);
        d.o = this;
        return d;
    };
    Grid.prototype.k7 = function () {
        return this.model.b();
    };
    Grid.prototype.mr = function () {
        var a = this.model.b();
        return a.av();
    };
    Grid.prototype.ei = function (a) {
        return this.d3.getRowPathForRow(a);
    };
    Grid.prototype.r6 = function (a) {
        var e_16, _a;
        var b = truncate(this.model.actualVisibleRegion.left);
        if (this.jq != -1) {
            b = this.jq;
        }
        var c = 0;
        var d = 0;
        if (a < 0) {
            a = 0;
        }
        if (a >= this.d3.getRowCount()) {
            a = this.d3.getRowCount() - 1;
        }
        var e = 0;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.model.bv)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                if (d + f.m > a) {
                    e = truncate(Math.floor(a - d));
                    var g = f.e(e);
                    c = f.f(e);
                    c += truncate(Math.round(g * ((a - d) - e)));
                }
                else {
                    d += f.m;
                    continue;
                }
            }
        }
        catch (e_16_1) {
            e_16 = { error: e_16_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_16)
                    throw e_16.error;
            }
        }
        var h = this.e4.i(this, this.model, new Rect(0, b, c, this.model.b9, this.model.by));
        var i = -1;
        var j = -1;
        for (var k = 0; k < h.count; k++) {
            if (h._inner[k].m == e) {
                i = k;
                j = h._inner[k].n;
                break;
            }
            if (h._inner[k].m > e) {
                i = k - 1;
                break;
            }
        }
        if (i == -1) {
            i = h.count - 1;
        }
        var l = 0;
        for (var m = i; m >= 0; m--) {
            if (h._inner[m].n > j) {
                if (h._inner[m].a != 3) {
                    j = h._inner[m].n;
                }
                l += h._inner[m].k + this.ky + this.kz;
            }
        }
        c -= truncate(l);
        c = Math.max(c, 0);
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0 && c + this.model.actualVisibleRegion.height > this.model.absoluteHeight) {
            c = truncate(Math.round(this.model.absoluteHeight - this.model.actualVisibleRegion.height));
        }
        if (c < 0) {
            c = 0;
        }
        this.jr = c;
        this.jq = b;
        this.viewportManager.moveViewportTo(b, c);
    };
    Grid.prototype.r5 = function (a) {
        var e_17, _a;
        var b = truncate(this.model.actualVisibleRegion.left);
        if (this.jq != -1) {
            b = this.jq;
        }
        var c = 0;
        var d = 0;
        if (a < 0) {
            a = 0;
        }
        if (a >= this.d3.getRowCount()) {
            a = this.d3.getRowCount() - 1;
        }
        var e = 0;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.model.bv)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var f = _c.value;
                if (d + f.m > a) {
                    var g = truncate(Math.floor(a - d));
                    var h = f.e(g);
                    e = h;
                    c = f.i + f.f(g);
                    c += truncate(Math.round(h * ((a - d) - g)));
                }
                else {
                    d += f.m;
                    continue;
                }
            }
        }
        catch (e_17_1) {
            e_17 = { error: e_17_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_17)
                    throw e_17.error;
            }
        }
        c -= this.model.ci;
        c = Math.max(c, 0);
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0) {
            c -= truncate(Math.round(this.model.actualVisibleRegion.height - this.model.cu - (e + this.model.ci)));
        }
        if (this.model.absoluteHeight > 0 && this.model.actualVisibleRegion.height > 0 && c + this.model.actualVisibleRegion.height > this.model.absoluteHeight) {
            c = truncate(Math.round(this.model.absoluteHeight - this.model.actualVisibleRegion.height));
        }
        if (c < 0) {
            c = 0;
        }
        this.jr = c;
        this.jq = b;
        this.viewportManager.moveViewportTo(b, c);
    };
    Grid.prototype.id = function (a) {
        var b = this.ka(a);
        if (b == -1) {
            return false;
        }
        this.r6(b);
        return true;
    };
    Grid.prototype.ie = function (a) {
        var b = this.kb(a);
        if (b == -1) {
            return false;
        }
        this.r6(b);
        return true;
    };
    Grid.prototype.r3 = function (a) {
        var b = truncate(a);
        if (b < 0) {
            b = 0;
            a = 0;
        }
        if (a > this.model.br.count) {
            b = this.model.br.count - 1;
            a = this.model.br.count - 1;
        }
        var c = this.columns._inner[b];
        if (c.fk != 0) {
            return;
        }
        var d = this.ey.k(b, this, this.model);
        var e = truncate(this.model.actualVisibleRegion.top);
        if (this.jr != -1) {
            e = this.jr;
        }
        var f = d + truncate((this.model.br._inner[b].k * (a - b)));
        f -= this.model.cf;
        if (this.model.absoluteWidth > 0 && this.model.actualVisibleRegion.width > 0 && f + this.model.actualVisibleRegion.width > this.model.absoluteWidth) {
            f = truncate(Math.round(this.model.absoluteWidth - this.model.actualVisibleRegion.width));
        }
        if (f < 0) {
            f = 0;
        }
        this.jr = e;
        this.jq = f;
        this.viewportManager.moveViewportTo(f, e);
    };
    Grid.prototype.r4 = function (a) {
        var b = truncate(a);
        if (b < 0) {
            b = 0;
            a = 0;
        }
        if (a > this.model.br.count) {
            b = this.model.br.count - 1;
            a = this.model.br.count - 1;
        }
        var c = this.columns._inner[b];
        var d = this.ey.k(b, this, this.model);
        var e = truncate(this.model.actualVisibleRegion.top);
        if (this.jr != -1) {
            e = this.jr;
        }
        var f = d + truncate((this.model.br._inner[b].k * (a - b)));
        var g = this.model.actualVisibleRegion.width - this.model.cg;
        if (this.model.absoluteWidth > 0 && g > 0) {
            f -= truncate(Math.round(g - this.model.br._inner[b].k));
        }
        if (this.model.absoluteWidth > 0 && this.model.actualVisibleRegion.width > 0 && f + this.model.actualVisibleRegion.width > this.model.absoluteWidth) {
            f = truncate(Math.round(this.model.absoluteWidth - this.model.actualVisibleRegion.width));
        }
        if (f < 0) {
            f = 0;
        }
        this.jr = e;
        this.jq = f;
        this.viewportManager.moveViewportTo(f, e);
    };
    Grid.prototype.ih = function (a) {
        return this.g6(a);
    };
    Grid.prototype.qq = function (a, b) {
        if (this.ch == 1 && this.cu != null) {
            if (this.cu.b >= a && this.cu.b <= b) {
                if (this.activeCellChanged != null) {
                    var c = new GridActiveCellChangedEventArgs();
                    c.newActiveCell = this.cu;
                    c.oldActiveCell = this.cu;
                    this.activeCellChanged(this, c);
                }
            }
        }
        var d = this.kh();
        var e = this.kl();
        if (b < d || a > e) {
            return;
        }
        if (a < d) {
            a = d;
        }
        if (b > e) {
            b = e;
        }
        if (!this.ic()) {
            return;
        }
        this.ck.y(this, a, b, false);
        if (this.d3.getRowCount() != this.model.ck()) {
            this.rp();
        }
        else {
            this.rq();
        }
        this.o4();
    };
    Grid.prototype.o4 = function () {
        if (this.model.actualVisibleRegion.isEmpty) {
            return;
        }
        if (this.model.actualVisibleRegion.bottom > this.model.absoluteHeight || this.model.actualVisibleRegion.top > this.model.absoluteHeight) {
            var a = this.d3.getRowCount() - 1;
            if (a < 0) {
                a = 0;
            }
            this.r6(a);
        }
        if (this.model.actualVisibleRegion.right > this.model.absoluteWidth || this.model.actualVisibleRegion.left > this.model.absoluteWidth) {
            var b = this.a2.j.count - 1;
            if (b < 0) {
                b = 0;
            }
            this.r4(b);
        }
    };
    Grid.prototype.kd = function (a) {
        return this.ey.i(this.model, a.k);
    };
    Grid.prototype.ic = function () {
        return this.model.be != null && this.model.bf != null && this.model.bf.w >= 0 && this.model.be.w >= 0;
    };
    Grid.prototype.kl = function () {
        return this.ey.i(this.model, this.model.be);
    };
    Grid.prototype.kh = function () {
        return this.ey.i(this.model, this.model.bf);
    };
    Grid.prototype.kf = function () {
        var a = this.ey.b(this.model.actualVisibleRegion.top + this.model.cl + this.model.cm + this.model.cv, this.model);
        return this.ey.i(this.model, a);
    };
    Grid.prototype.kj = function () {
        var a = this.ey.b(this.model.actualVisibleRegion.bottom - this.model.cu, this.model);
        return this.ey.i(this.model, a);
    };
    Grid.prototype.rf = function () {
        var a = this.kh();
        var b = this.kl();
        this.d3.firstVisibleIndexRequested = a;
        this.d3.lastVisibleIndexRequested = b;
    };
    Object.defineProperty(Grid.prototype, "hp", {
        get: function () {
            return this.cellPreviewPointerDown != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hq", {
        get: function () {
            return this.cellPreviewPointerUp != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "hn", {
        get: function () {
            return this.cellPointerDown != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "ho", {
        get: function () {
            return this.cellPointerUp != null;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.ia = function () {
        return this.dn != 0 || this.cellClicked != null || this.ch != 0 || this.bu != 2 || this.bg != 1;
    };
    Grid.prototype.ib = function () {
        return (this.bu != 2 && this.hj) || this.bg != 1;
    };
    Grid.prototype.q9 = function (a, b) {
        this.g1 = true;
        this.o0(a, b);
        this.g1 = false;
    };
    Grid.prototype.ra = function (a, b) {
        this.g1 = true;
        this.rx(a, b);
        this.g1 = false;
    };
    Grid.prototype.rc = function (a, b, c) {
        this.g1 = true;
        this.sp(a, b, c);
        this.g1 = false;
    };
    Grid.prototype.p0 = function (a, b) {
        if (!this.gp) {
            var c = new GridCellPosition();
            c.d = b;
            c.b = a;
            this.cu = c;
        }
        if (this.activeCellChanged != null) {
            var d = new GridActiveCellChangedEventArgs();
            d.newActiveCell = this.cu;
            d.oldActiveCell = this.ct;
            this.activeCellChanged(this, d);
        }
    };
    Grid.prototype.p2 = function (a, b) {
        if (b == null) {
            return;
        }
        var c = this.cu;
        if (!this.gp) {
            var d = new GridCellPosition();
            d.d = b;
            d.b = a;
            this.cu = d;
        }
        if (this.activeCellChanged != null) {
            var e = new GridActiveCellChangedEventArgs();
            e.newActiveCell = this.cu;
            e.oldActiveCell = c;
            this.activeCellChanged(this, e);
        }
    };
    Grid.prototype.hu = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.cs.b;
        var d = this.cs.d;
        if (c > this.d3.getRowCount() - 1) {
            return false;
        }
        var e = c + 1;
        if (b) {
            e = this.d3.getRowCount() - 1;
        }
        if (e > this.d3.getRowCount() - 1) {
            e = this.d3.getRowCount() - 1;
        }
        if (e == c) {
            return false;
        }
        var f = Math.min(this.aj.r(), this.actualColumns.count - 1);
        f = this.kc(f);
        var g = this.actualColumns._inner[f];
        if (d != g.hz()) {
            d = g.hz();
        }
        if (this.dt != 1) {
            var h = this.d3.getRowType(e);
            if (h == 1 || h == 2) {
                d = null;
            }
        }
        this.cu = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = d;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            var i = this.aj.r();
            this.o1(e, this.model.br._inner[i].n, false);
        }
        return true;
    };
    Grid.prototype.hv = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        if (!b || this.cb.g) {
            return false;
        }
        var c = this.ki();
        var d = this.actualColumns._inner[c];
        var e = this.cs.b;
        var f = this.cs.d;
        if (e >= this.d3.getRowCount() - 1 && f == d.hz()) {
            return false;
        }
        e = this.d3.getRowCount() - 1;
        f = d.hz();
        var g = this.d3.getRowType(e);
        if (g == 1 || g == 2) {
            f = null;
        }
        this.cu = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = f;
            return $ret;
        })());
        this.ft = true;
        this.r5(e);
        this.ft = false;
        this.r3(c);
        return true;
    };
    Grid.prototype.ki = function () {
        var a = this.actualColumns.count - 1;
        var b = this.ey.j(a, this.model);
        while (a > 0 && this.actualColumns._inner[b].gd) {
            a--;
            b = this.ey.j(a, this.model);
        }
        return b;
    };
    Grid.prototype.ke = function () {
        var a = 0;
        var b = this.ey.j(a, this.model);
        while (a < this.actualColumns.count - 1 && this.actualColumns._inner[b].gd) {
            a++;
            b = this.ey.j(a, this.model);
        }
        return b;
    };
    Grid.prototype.kn = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = Math.max(0, a - 1);
        if (!b) {
            c = this.ey.j(c, this.model);
        }
        if (this.actualColumns._inner[c].gd) {
            var d = c;
            var e = this.model.br._inner[c].n;
            while (e > 0 && this.actualColumns._inner[d].gd) {
                e--;
                d = this.ey.j(e, this.model);
            }
            if (this.actualColumns._inner[d].gd) {
                d = c;
                e = this.model.br._inner[c].n;
                while (e < this.actualColumns.count - 1 && this.actualColumns._inner[d].gd) {
                    e++;
                    d = this.ey.j(e, this.model);
                }
                if (!this.actualColumns._inner[d].gd) {
                    c = d;
                }
            }
            else {
                c = d;
            }
        }
        return c;
    };
    Grid.prototype.km = function (a, b) {
        if (b === void 0) {
            b = true;
        }
        var c = Math.min(this.actualColumns.count - 1, a + 1);
        if (!b) {
            c = this.ey.j(c, this.model);
        }
        return this.kc(c);
    };
    Grid.prototype.kc = function (a) {
        a = Math.min(a, this.actualColumns.count - 1);
        if (this.actualColumns._inner[a].gd) {
            var b = a;
            var c = this.model.br._inner[b].n;
            while (c < this.actualColumns.count - 1 && this.actualColumns._inner[b].gd) {
                c++;
                b = this.ey.j(c, this.model);
            }
            if (this.actualColumns._inner[b].gd) {
                b = a;
                c = this.model.br._inner[b].n;
                while (c > 0 && this.actualColumns._inner[b].gd) {
                    c--;
                    b = this.ey.j(c, this.model);
                }
                if (!this.actualColumns._inner[b].gd) {
                    a = b;
                }
            }
            else {
                a = b;
            }
        }
        return a;
    };
    Grid.prototype.o1 = function (a, b, c) {
        if (b <= this.kg()) {
            b = this.ey.j(b, this.model);
            this.r3(b);
        }
        else if (b >= this.kk()) {
            b = this.ey.j(b, this.model);
            this.r4(b);
        }
        if (a <= this.kf()) {
            this.r6(a);
        }
        else if (a >= this.kj()) {
            if (c) {
                this.r6(a);
            }
            else {
                this.r5(a);
            }
        }
    };
    Grid.prototype.hz = function (a, b) {
        if (!b || this.cb.g) {
            return false;
        }
        var c = this.ke();
        var d = this.actualColumns._inner[c];
        var e = this.cs.b;
        var f = this.cs.d;
        if (e <= 0 && f == d.hz()) {
            return false;
        }
        e = 0;
        f = d.hz();
        if (this.dt != 1) {
            var g = this.d3.getRowType(e);
            if (g == 1 || g == 2) {
                f = null;
            }
        }
        this.cu = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = f;
            return $ret;
        })());
        this.ft = true;
        this.r5(e);
        this.ft = false;
        this.r3(c);
        return true;
    };
    Grid.prototype.h0 = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.aj.r();
        var d = this.model.br._inner[c].n;
        var e = this.cs.b;
        var f = this.cs.d;
        if (f == null) {
            return false;
        }
        var g = this.kn(d, false);
        if (b) {
            g = this.ke();
        }
        var h = this.actualColumns._inner[g];
        if (f == h.hz()) {
            return false;
        }
        f = h.hz();
        this.cu = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = f;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            if (h.fk == 0) {
                this.o1(e, this.model.br._inner[g].n, false);
            }
        }
        return true;
    };
    Grid.prototype.h1 = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.cs.d;
        var d = this.aj.r();
        var e = this.kh();
        var f = this.kl();
        var g = f - e;
        var h = Math.min(f + 1, this.d3.getRowCount() - 1);
        if (!this.cb.g) {
            var i = this.d3.getRowType(h);
            if (i == 1 || i == 2) {
                c = null;
            }
            this.cu = ((function () {
                var $ret = new GridCellPosition();
                $ret.b = h;
                $ret.d = c;
                return $ret;
            })());
        }
        this.o1(h, this.model.br._inner[d].n, true);
        return true;
    };
    Grid.prototype.h2 = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.cs.d;
        var d = this.aj.r();
        var e = this.kh();
        var f = this.kl();
        var g = f - e;
        var h = Math.max(e - g - 1, 0);
        if (!this.cb.g) {
            var i = this.d3.getRowType(h);
            if (i == 1 || i == 2) {
                c = null;
            }
            this.cu = ((function () {
                var $ret = new GridCellPosition();
                $ret.b = h;
                $ret.d = c;
                return $ret;
            })());
        }
        this.o1(h, this.model.br._inner[d].n, false);
        return true;
    };
    Grid.prototype.h3 = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.aj.r();
        var d = this.model.br._inner[c].n;
        var e = this.cs.b;
        var f = this.cs.d;
        if (f == null) {
            return false;
        }
        var g = this.km(d, false);
        if (b) {
            g = this.ki();
        }
        var h = this.actualColumns._inner[g];
        if (f == h.hz()) {
            return false;
        }
        f = h.hz();
        this.cu = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = f;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            if (h.fk == 0) {
                this.o1(e, this.model.br._inner[g].n, false);
            }
        }
        return true;
    };
    Grid.prototype.h4 = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.aj.r();
        var d = this.model.br._inner[c].n;
        var e = this.cs.b;
        var f = this.cs.d;
        var g = e;
        var h = f;
        var i = c;
        var j = 0;
        if (g >= 0 && g < this.d3.getRowCount()) {
            j = this.d3.getRowType(g);
        }
        var k = this.dt != 1 && j == 1;
        var l = j != 1 && j != 2 && j != 4 && j != 5;
        if (a) {
            var m = void 0;
            var n = null;
            do {
                m = this.kn(d, false);
                n = this.actualColumns._inner[m];
                if (h == n.hz() || k) {
                    if (g > 0) {
                        g--;
                        j = this.d3.getRowType(g);
                        k = j == 1;
                        l = j != 1 && j != 2 && j != 4 && j != 5;
                        if (this.dt != 1 && j == 1) {
                            m = this.ke();
                        }
                        else {
                            m = this.ki();
                        }
                        n = this.actualColumns._inner[m];
                    }
                    else {
                        return false;
                    }
                }
                d = m;
                h = n.hz();
            } while (this.cb.g && g >= 0 && (!l || !n.ga));
            if (this.dt != 1) {
                if (j == 1 || j == 2) {
                    h = null;
                }
            }
            i = m;
        }
        else {
            var o = void 0;
            var p = null;
            do {
                o = this.km(d, false);
                p = this.actualColumns._inner[o];
                if (h == p.hz() || k) {
                    if (g < this.d3.getRowCount() - 1) {
                        o = this.ke();
                        p = this.actualColumns._inner[o];
                        g++;
                        j = this.d3.getRowType(g);
                        k = j == 1;
                        l = j != 1 && j != 2 && j != 4 && j != 5;
                    }
                    else {
                        return false;
                    }
                }
                d = o;
                h = p.hz();
            } while (this.cb.g && g < this.d3.getRowCount() - 1 && (!l || !p.ga));
            if (this.dt != 1) {
                if (j == 1 || j == 2) {
                    h = null;
                }
            }
            i = o;
        }
        if (this.cb.g && (f != h || e != g)) {
            this.gz(true);
            if (!this.cb.g) {
                this.cu = ((function () {
                    var $ret = new GridCellPosition();
                    $ret.b = g;
                    $ret.d = h;
                    return $ret;
                })());
                this.o1(g, this.model.br._inner[i].n, false);
                this.il();
            }
        }
        else {
            this.cu = ((function () {
                var $ret = new GridCellPosition();
                $ret.b = g;
                $ret.d = h;
                return $ret;
            })());
            this.o1(g, this.model.br._inner[i].n, false);
        }
        return true;
    };
    Grid.prototype.rg = function () {
    };
    Grid.prototype.h5 = function (a, b) {
        if (this.ch == 0 || this.cu == null) {
            return false;
        }
        var c = this.cs.b;
        var d = this.cs.d;
        if (c < 0) {
            return false;
        }
        var e = c - 1;
        if (b) {
            e = 0;
        }
        if (e < 0) {
            e = 0;
        }
        if (e == c) {
            return false;
        }
        var f = Math.min(this.aj.r(), this.actualColumns.count - 1);
        f = this.kc(f);
        var g = this.actualColumns._inner[f];
        if (d != g.hz()) {
            d = g.hz();
        }
        if (this.dt != 1) {
            var h = this.d3.getRowType(e);
            if (h == 1 || h == 2) {
                d = null;
            }
        }
        this.cu = ((function () {
            var $ret = new GridCellPosition();
            $ret.b = e;
            $ret.d = d;
            return $ret;
        })());
        if (this.model.br.count > 0) {
            var i = this.aj.r();
            this.o1(e, this.model.br._inner[i].n, false);
        }
        return true;
    };
    Grid.prototype.hw = function (a, b) {
        if (this.cb.g) {
            this.gz(true);
        }
        else {
            if (this.ch != 0 && this.cu != null) {
                var c = this.d3.getRowType(this.cu.b);
                if (c == 1) {
                    this.sn(this.cu.b);
                }
                else if (this.hf() && c == 0) {
                    var d = this.aj.r();
                    var e = this.actualColumns._inner[d];
                    if (e != null && e.ga) {
                        var f = this.model.d(d, this.cu.b);
                        return this.ii(f);
                    }
                }
            }
        }
        return false;
    };
    Grid.prototype.hx = function () {
        if (this.hf()) {
            if (this.cb.h != -1) {
                this.y.rejectPendingTransaction(this.cb.h);
            }
            this.gz(false);
        }
        return false;
    };
    Grid.prototype.hy = function () {
        return this.il();
    };
    Grid.prototype.il = function () {
        if (this.cb.g) {
            this.gz(true);
            return true;
        }
        if (this.ch != 0 && this.cu != null) {
            var a = this.d3.getRowType(this.cu.b);
            if (this.hf() && a == 0) {
                var b = this.aj.r();
                var c = this.actualColumns._inner[b];
                if (c != null && c.ga) {
                    var d = this.model.d(b, this.cu.b);
                    if (d == null) {
                        this.ar = new CellPath(1, b, 0, this.cu.b);
                    }
                    else {
                        this.ii(d);
                    }
                    return true;
                }
            }
        }
        return false;
    };
    Grid.prototype.ii = function (a) {
        if (!this.hf() || a == null || a.k.ax < 0 || a.k.w < 0) {
            return false;
        }
        this.ar = null;
        this.cb.f(true);
        var b = this.a0(a.k);
        if (!b.ga) {
            return false;
        }
        this.cb.n(a);
        this.o1(a.k.w, a.k.ax, false);
        return true;
    };
    Grid.prototype.gz = function (a) {
        if (this.cb.f(a)) {
            this.externalGrid.focusScroller();
            return true;
        }
        return false;
    };
    Grid.prototype.qb = function (a, b) {
        this.g1 = true;
        if (!this.gq) {
            var c = this.dh.af(a, this.a2.f(b).hz());
        }
        if (this.selectedCellsChanged != null) {
            var d = new GridSelectedCellsChangedEventArgs();
            d.addedCells = new GridSelectedCellsCollection();
            d.addedCells.add(this.dh.ai(a, b));
            d.removedCells = new GridSelectedCellsCollection();
            d.currentCells = this.dh;
            this.selectedCellsChanged(this, d);
        }
        this.g1 = false;
    };
    Grid.prototype.qc = function (a, b) {
        this.g1 = true;
        var c = this.dh.ai(a, b);
        if (c != null) {
            if (!this.gq) {
                this.dh.remove(c);
            }
            if (this.selectedCellsChanged != null) {
                var d = new GridSelectedCellsChangedEventArgs();
                d.addedCells = new GridSelectedCellsCollection();
                d.removedCells = new GridSelectedCellsCollection();
                d.removedCells.add(c);
                d.currentCells = this.dh;
                this.selectedCellsChanged(this, d);
            }
        }
        this.g1 = false;
    };
    Grid.prototype.o0 = function (a, b) {
        var c = this.ht;
        this.ht = false;
        if (!this.go) {
            this.ad.add1(a);
            this.ah.add(b);
        }
        this.ht = c;
        var d = new GridSelectedItemsChangedEventArgs();
        var e = new GridSelectedItemsCollection();
        e.add1(a);
        d.addedItems = e;
        d.currentItems = this.ad;
        if (this.selectedItemsChanged != null) {
            this.selectedItemsChanged(this, d);
        }
        var f = new GridSelectedKeysChangedEventArgs();
        var g = new GridSelectedKeysCollection();
        g.add(b);
        f.addedKeys = g;
        f.currentKeys = this.ah;
        if (this.selectedKeysChanged != null) {
            this.selectedKeysChanged(this, f);
        }
    };
    Grid.prototype.sp = function (a, b, c) {
        var d = this.ht;
        this.ht = false;
        var e = this.ad.ae._inner[a];
        if (!this.go) {
            this.ad.ae._inner[a] = b;
        }
        this.ht = d;
        var f = new GridSelectedItemsChangedEventArgs();
        var g = new GridSelectedItemsCollection();
        g.add1(b);
        f.addedItems = g;
        var h = new GridSelectedItemsCollection();
        h.add1(b);
        f.removedItems = h;
        f.currentItems = this.ad;
        if (this.selectedItemsChanged != null) {
            this.selectedItemsChanged(this, f);
        }
    };
    Grid.prototype.rx = function (a, b) {
        var c = this.ht;
        this.ht = false;
        if (!this.go) {
            this.ad.remove1(a);
            this.ah.remove(b);
        }
        this.ht = c;
        var d = new GridSelectedItemsChangedEventArgs();
        var e = new GridSelectedItemsCollection();
        e.add1(a);
        d.removedItems = e;
        d.currentItems = this.ad;
        if (this.selectedItemsChanged != null) {
            this.selectedItemsChanged(this, d);
        }
        var f = new GridSelectedKeysChangedEventArgs();
        var g = new GridSelectedKeysCollection();
        g.add(b);
        f.removedKeys = g;
        f.currentKeys = this.ah;
        if (this.selectedKeysChanged != null) {
            this.selectedKeysChanged(this, f);
        }
    };
    Grid.prototype.oz = function (a, b, c, d) {
        var e = new CellRange();
        e.k = a;
        e.i = b;
        e.l = c;
        e.j = d;
        this.oy(e);
    };
    Grid.prototype.oy = function (a) {
        this.de.add(a);
        this.at = a;
        if (this.selectedCellRangesChanged != null) {
            var b = new GridSelectedCellRangesChangedEventArgs();
            b.addedRanges = ((function () {
                var $ret = new GridSelectedCellRangesCollection();
                $ret.add(a);
                return $ret;
            })());
            b.currentRanges = this.de;
            this.selectedCellRangesChanged(this, b);
        }
    };
    Grid.prototype.ru = function (a) {
        if (this.de.contains(a)) {
            this.de.remove(a);
            if (this.selectedCellRangesChanged != null) {
                var b = new GridSelectedCellRangesChangedEventArgs();
                b.removedRanges = ((function () {
                    var $ret = new GridSelectedCellRangesCollection();
                    $ret.add(a);
                    return $ret;
                })());
                b.currentRanges = this.de;
                this.selectedCellRangesChanged(this, b);
            }
        }
    };
    Grid.prototype.rt = function () {
        if (this.de.count > 0) {
            var a = new GridSelectedCellRangesCollection();
            for (var b = 0; b < this.de.count; b++) {
                a.add(this.de._inner[b]);
            }
            this.de.clear();
            if (this.selectedCellRangesChanged != null) {
                var c = new GridSelectedCellRangesChangedEventArgs();
                c.removedRanges = a;
                c.currentRanges = this.de;
                this.selectedCellRangesChanged(this, c);
            }
        }
    };
    Grid.prototype.pu = function (a) {
        if (this.de.contains(a)) {
            if (this.selectedCellRangesChanged != null) {
                var b = new GridSelectedCellRangesChangedEventArgs();
                b.updatedRanges = ((function () {
                    var $ret = new GridSelectedCellRangesCollection();
                    $ret.add(a);
                    return $ret;
                })());
                b.currentRanges = this.de;
                this.selectedCellRangesChanged(this, b);
            }
        }
    };
    Grid.prototype.rd = function (a, b, c) {
        this.pn(a);
        if (b != c) {
            this.es.af(a);
            this.aj.ah(a);
        }
    };
    Grid.prototype.pn = function (a) {
        this.ck.al(this, a, a);
    };
    Grid.prototype.qd = function () {
        if (this.cb.g) {
            this.gz(false);
        }
        this.es.z();
        this.rp();
        this.pq();
    };
    Grid.prototype.pq = function () {
        if (!this.ic()) {
            return;
        }
        var a = this.kh();
        var b = this.kl();
        this.po(a, b);
    };
    Grid.prototype.po = function (a, b) {
        var c = this.kh();
        var d = this.kl();
        if (b < c || a > d) {
            return;
        }
        if (a < c) {
            a = c;
        }
        if (b > d) {
            b = d;
        }
        this.ck.y(this, a, b, true);
        this.model.bn = true;
        this.rq();
    };
    Grid.prototype.kg = function () {
        return this.ey.o(this.model.actualVisibleRegion.left + this.model.cf, this, this.model);
    };
    Grid.prototype.kk = function () {
        return this.ey.o(this.model.actualVisibleRegion.right - this.model.cg, this, this.model);
    };
    Grid.prototype.pp = function (a, b) {
        var c = this.ey.i(this.model, a);
        var d = this.ey.i(this.model, b);
        this.po(c, d);
    };
    Grid.prototype.rl = function () {
        var _this = this;
        if (!this.f0) {
            this.f0 = true;
            this.e4.v();
            this.renderingEngine.invalidateVisibility(function () { return _this.e4.l(_this); });
            this.renderingEngine.refresh(this.model, false);
        }
    };
    Grid.prototype.q1 = function (a, b) {
        var c = this.d3.getRowPathForRow(a);
        this.c6.ae(c);
        this.es.ad(this.ey.i(this.model, c));
        this.aj.af(this.ey.i(this.model, c));
        this.rl();
    };
    Grid.prototype.q6 = function (a, b) {
        var c = this.d3.getRowPathForRow(a);
        this.c6.af(c);
        this.es.ae(this.ey.i(this.model, c));
        this.aj.ag(this.ey.i(this.model, c));
        this.rl();
    };
    Grid.prototype.sb = function (a) {
        for (var b = 0; b < this.ee.g.count; b++) {
            if (this.ee.g._inner[b].n == a) {
                this.sc(this.ee.g._inner[b]);
            }
        }
    };
    Grid.prototype.sc = function (a) {
        this.ee.x(a);
    };
    Grid.prototype.pz = function (a, b, c) {
        if (this.w != null) {
            this.w.notifySetItem(a, b, c);
        }
    };
    Grid.prototype.pv = function () {
        if (this.w != null) {
            this.w.notifyClearItems();
        }
    };
    Grid.prototype.px = function (a, b) {
        if (this.w != null) {
            this.w.notifyInsertItem(a, b);
        }
        ;
    };
    Grid.prototype.py = function (a, b) {
        if (this.w != null) {
            this.w.notifyRemoveItem(a, b);
        }
        ;
    };
    Grid.prototype.ka = function (a) {
        if (this.w == null) {
            return -1;
        }
        return this.w.indexOfItem(a);
    };
    Grid.prototype.kb = function (a) {
        if (this.w == null) {
            return -1;
        }
        return this.w.indexOfKey(a);
    };
    Grid.prototype.i = function () {
        if (this.actualDataSource != null) {
            return this.actualDataSource.actualPrimaryKey;
        }
        return this.e;
    };
    Grid.prototype.la = function (a) {
        var b = a.b != null ? a.b : this.a2.g(a.j);
        var c = null;
        if (a.h != null) {
            c = a.h;
        }
        else if (a.primaryKey != null) {
            if (this.i() == null && a.primaryKey.key == null && a.primaryKey.value.length == 1) {
                c = a.primaryKey.value[0];
            }
            else {
                c = this.d3.getItemForKey(a.primaryKey);
            }
        }
        if (b != null && c != null) {
            return this.actualDataSource.getItemProperty(c, b.hx);
        }
        return null;
    };
    Grid.prototype.lb = function (a, b) {
        if (b < 0 || b > this.a2.j.count) {
            return null;
        }
        if (a < 0 || a > this.d3.getRowCount() - 1) {
            return null;
        }
        var c = this.actualDataSource.getItemAtIndex(a);
        if (c == null) {
            return null;
        }
        else {
            var d = this.d3.getRowType(a);
            if (d != 0 && d != 3) {
                return null;
            }
        }
        var e = this.ey.j(b, this.model);
        var f = this.a2.j._inner[e];
        return this.actualDataSource.getItemProperty(c, f.hx);
    };
    Grid.prototype.az = function (a) {
        var b = this.ey.j(a, this.model);
        if (b >= 0 && b < this.a2.j.count) {
            return this.a2.j._inner[b];
        }
        return null;
    };
    Grid.prototype.j = function () {
        if (this.actualDataSource != null) {
            return this.actualDataSource.getRootSummaryResults();
        }
        return null;
    };
    Grid.prototype.k = function (a) {
        if (this.actualDataSource != null) {
            return this.actualDataSource.getSectionSummaryResults(a);
        }
        return null;
    };
    Object.defineProperty(Grid.prototype, "h8", {
        get: function () {
            return this.gi;
        },
        set: function (a) {
            var b = this.gi;
            this.gi = a;
            if (b != this.gi) {
                this.q5("ReactsToSortChanges", b, this.gi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h7", {
        get: function () {
            return this.gh;
        },
        set: function (a) {
            var b = this.gh;
            this.gh = a;
            if (b != this.gh) {
                this.q5("ReactsToGroupChanges", b, this.gh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "h6", {
        get: function () {
            return this.gg;
        },
        set: function (a) {
            var b = this.gg;
            this.gg = a;
            if (b != this.gg) {
                this.q5("ReactsToFilterChanges", b, this.gg);
            }
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.z = function (a) {
        var b = null;
        for (var c = 0; c < this.a2.j.count; c++) {
            var d = this.a2.j._inner[c];
            if (d != a && d.eo != null) {
                var e = this.actualDataSource.resolveSchemaPropertyType(d.hx);
                var f = d.eo.a(d.hx, e);
                if (b != null) {
                    b = FilterFactory.instance.and(b, f);
                }
                else {
                    b = f;
                }
            }
        }
        return b;
    };
    Grid.prototype.im = function (a, b) {
        if (this.actualDataSource != null && a.k.ax >= 0 && a.k.ax < this.actualColumns.count) {
            var c_1 = this.actualColumns._inner[a.k.ax];
            var d = this.actualDataSource.resolveSchemaPropertyType(c_1.hx);
            var e_18 = null;
            try {
                e_18 = this.k6(d, b);
            }
            catch (f) {
                this.cb.l(f.message);
                return false;
            }
            if (e_18 == null && a.gh != null || e_18 != null && a.gh == null || !Base.equalsStatic(e_18, a.gh)) {
                if (this.cb.h != -1) {
                    this.y.rejectPendingTransaction(this.cb.h);
                }
                this.cb.l(null);
                var g = this.d3.getItemKey(this.e, a.gi);
                var h_1 = this.y.updatePropertyAtKey(g.value, c_1.hx, e_18, true);
                this.gf = true;
                if (this.cellValueChanging != null) {
                    var i = ((function () {
                        var $ret = new GridCellValueChangingEventArgs();
                        $ret.c = h_1;
                        $ret.cellInfo = a;
                        $ret.b = c_1;
                        $ret.e = a.gh;
                        $ret.d = e_18;
                        return $ret;
                    })());
                    this.cellValueChanging(this, i);
                    var j = this.y.getTransactionErrorByID(h_1);
                    if (j != null) {
                        this.cb.l(j);
                        a.ei = h_1;
                        return false;
                    }
                    var k = this.y.isPendingTransaction(h_1);
                    if (k && this.gr) {
                        this.ow(h_1);
                    }
                }
                else {
                    this.ow(h_1);
                }
                this.gf = false;
            }
            else {
                if (this.cb.h != -1) {
                    var l = this.y.getTransactionErrorByID(this.cb.h);
                    if (l != null) {
                        this.cb.l(l);
                        return false;
                    }
                }
            }
        }
        return true;
    };
    Grid.prototype.k6 = function (a, b) {
        if (b == null) {
            return null;
        }
        switch (a) {
            case 2: return Convert.toBoolean(b);
            case 10: return Convert.toByte1(b);
            case 8: return Convert.toDateTime(b);
            case 6: return Convert.toDecimal2(b);
            case 5: return Convert.toDouble3(b);
            case 1: return Convert.toInt321(b);
            case 3: return Convert.toInt64(b);
            case 11: return b;
            case 0: return b.toString();
        }
        return b;
    };
    Grid.prototype.hf = function () {
        return this.y != null && !this.y.isReadOnly && this.cf != 0;
    };
    Object.defineProperty(Grid.prototype, "gy", {
        get: function () {
            if (this.y != null) {
                return this.y.canUndo;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "gx", {
        get: function () {
            if (this.y != null) {
                return this.y.canRedo;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "gu", {
        get: function () {
            if (this.y != null) {
                return this.y.canCommit;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Grid.prototype.pa = function () {
        if (this.hf() && this.gu) {
            var a = this.y.commitEdits(true);
            if (a != -1) {
                var b = this.y.getAggregatedChanges(a);
                if (this.dataCommitting != null) {
                    var c = new GridDataCommittingEventArgs(a, b);
                    this.dataCommitting(this, c);
                    if (this.y.isPendingCommit(a) && this.gr) {
                        this.ov(a);
                    }
                }
                else {
                    this.ov(a);
                }
            }
        }
    };
    Grid.prototype.o2 = function () {
        if (this.hf()) {
            this.y.cancelEdits();
        }
    };
    Grid.prototype.ov = function (a) {
        if (this.hf()) {
            this.y.acceptPendingCommit(a);
        }
    };
    Grid.prototype.rr = function (a) {
        if (this.hf()) {
            this.y.rejectPendingCommit(a);
        }
    };
    Grid.prototype.sj = function () {
        if (this.hf()) {
            this.y.undo();
        }
    };
    Grid.prototype.rn = function () {
        if (this.hf()) {
            this.y.redo();
        }
    };
    Grid.prototype.so = function (a, b, c) {
        if (this.hf()) {
            this.y.updatePropertyAtKey(a, b, c, false);
            if (this.cf == 1) {
                this.pa();
            }
        }
    };
    Grid.prototype.rw = function (a) {
        if (this.hf()) {
            this.y.removeItemByKey(a);
            if (this.cf == 1) {
                this.pa();
            }
        }
    };
    Grid.prototype.rv = function (a) {
        if (this.hf()) {
            this.y.removeItem(a);
            if (this.cf == 1) {
                this.pa();
            }
        }
    };
    Grid.prototype.ow = function (a) {
        if (this.hf()) {
            this.y.acceptPendingTransaction(a);
            if (!this.y.isBatchingEnabled) {
                this.pa();
            }
        }
    };
    Grid.prototype.rs = function (a) {
        if (this.hf()) {
            this.y.rejectPendingTransaction(a);
        }
    };
    Grid.prototype.sd = function (a, b) {
        if (this.hf()) {
            this.y.setTransactionError(a, b);
        }
    };
    Grid.$t = markType(Grid, 'Grid', Base.$, [INotifyPropertyChanged_$type]);
    return Grid;
}(Base));
export { Grid };
/**
 * @hidden
 */
var GridColumnsAutoGeneratedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnsAutoGeneratedEventArgs, _super);
    function GridColumnsAutoGeneratedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = null;
        return _this;
    }
    Object.defineProperty(GridColumnsAutoGeneratedEventArgs.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (a) {
            this._columns = a;
        },
        enumerable: true,
        configurable: true
    });
    GridColumnsAutoGeneratedEventArgs.$t = markType(GridColumnsAutoGeneratedEventArgs, 'GridColumnsAutoGeneratedEventArgs', EventArgs.$);
    return GridColumnsAutoGeneratedEventArgs;
}(EventArgs));
export { GridColumnsAutoGeneratedEventArgs };
/**
 * @hidden
 */
var GridColumnsChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnsChangedEventArgs, _super);
    function GridColumnsChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._columns = null;
        return _this;
    }
    Object.defineProperty(GridColumnsChangedEventArgs.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (a) {
            this._columns = a;
        },
        enumerable: true,
        configurable: true
    });
    GridColumnsChangedEventArgs.$t = markType(GridColumnsChangedEventArgs, 'GridColumnsChangedEventArgs', EventArgs.$);
    return GridColumnsChangedEventArgs;
}(EventArgs));
export { GridColumnsChangedEventArgs };
/**
 * @hidden
 */
var GridSelectedCellsChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedCellsChangedEventArgs, _super);
    function GridSelectedCellsChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentCells = null;
        _this._addedCells = null;
        _this._removedCells = null;
        return _this;
    }
    Object.defineProperty(GridSelectedCellsChangedEventArgs.prototype, "currentCells", {
        get: function () {
            return this._currentCells;
        },
        set: function (a) {
            this._currentCells = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridSelectedCellsChangedEventArgs.prototype, "addedCells", {
        get: function () {
            return this._addedCells;
        },
        set: function (a) {
            this._addedCells = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridSelectedCellsChangedEventArgs.prototype, "removedCells", {
        get: function () {
            return this._removedCells;
        },
        set: function (a) {
            this._removedCells = a;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedCellsChangedEventArgs.$t = markType(GridSelectedCellsChangedEventArgs, 'GridSelectedCellsChangedEventArgs', EventArgs.$);
    return GridSelectedCellsChangedEventArgs;
}(EventArgs));
export { GridSelectedCellsChangedEventArgs };
/**
 * @hidden
 */
var GridCellEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellEventArgs, _super);
    function GridCellEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cellInfo = null;
        _this._grid = null;
        return _this;
    }
    Object.defineProperty(GridCellEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridCellEventArgs.prototype, "grid", {
        get: function () {
            return this._grid;
        },
        set: function (a) {
            this._grid = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellEventArgs.$t = markType(GridCellEventArgs, 'GridCellEventArgs', EventArgs.$);
    return GridCellEventArgs;
}(EventArgs));
export { GridCellEventArgs };
/**
 * @hidden
 */
var ColumnHiddenChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnHiddenChangedEventArgs, _super);
    function ColumnHiddenChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = false;
        return _this;
    }
    ColumnHiddenChangedEventArgs.$t = markType(ColumnHiddenChangedEventArgs, 'ColumnHiddenChangedEventArgs');
    return ColumnHiddenChangedEventArgs;
}(Base));
export { ColumnHiddenChangedEventArgs };
/**
 * @hidden
 */
var ColumnPinnedChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnPinnedChangedEventArgs, _super);
    function ColumnPinnedChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.b = 0;
        return _this;
    }
    ColumnPinnedChangedEventArgs.$t = markType(ColumnPinnedChangedEventArgs, 'ColumnPinnedChangedEventArgs');
    return ColumnPinnedChangedEventArgs;
}(Base));
export { ColumnPinnedChangedEventArgs };
/**
 * @hidden
 */
var GridCellValueChangingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridCellValueChangingEventArgs, _super);
    function GridCellValueChangingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.c = 0;
        _this._cellInfo = null;
        _this.b = null;
        _this.e = null;
        _this.d = null;
        return _this;
    }
    Object.defineProperty(GridCellValueChangingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    GridCellValueChangingEventArgs.$t = markType(GridCellValueChangingEventArgs, 'GridCellValueChangingEventArgs');
    return GridCellValueChangingEventArgs;
}(Base));
export { GridCellValueChangingEventArgs };
/**
 * @hidden
 */
var GridAnimationManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridAnimationManager, _super);
    function GridAnimationManager() {
        var _this = _super.call(this) || this;
        _this.l = new List$1(Number_$type, 0);
        _this.i = false;
        _this.animationCreated = null;
        _this.animationCompleted = null;
        _this.animationCanceled = null;
        _this.g = new GridColumnAnimationSettings();
        _this.f = new GridAnimationSettings();
        _this.k = new Dictionary$2(Number_$type, List$1.$.specialize(Delegate_$type), 0);
        _this.e = null;
        _this.d = null;
        _this.e = new GridAnimationPhaseSettings();
        _this.e.l = 0;
        _this.e.e = true;
        _this.e.n = 0;
        _this.d = new GridAnimationPhaseSettings();
        _this.d.l = 0;
        _this.d.e = true;
        _this.d.n = 0;
        return _this;
    }
    Object.defineProperty(GridAnimationManager.prototype, "h", {
        get: function () {
            return this.g;
        },
        enumerable: true,
        configurable: true
    });
    GridAnimationManager.prototype.p = function () {
        var a = GridAnimationManager.o;
        GridAnimationManager.o++;
        return a;
    };
    GridAnimationManager.prototype.ap = function () {
        this.i = true;
        this.l = new List$1(Number_$type, 0);
    };
    GridAnimationManager.prototype.m = function () {
        this.i = false;
        return this.l;
    };
    GridAnimationManager.prototype.w = function (a) {
        if (this.i) {
            this.l.add(a);
        }
        if (this.animationCreated != null) {
            this.animationCreated(this, ((function () {
                var $ret = new GridAnimationManagerAnimationCreatedEventArgs();
                $ret.a = a;
                return $ret;
            })()));
        }
    };
    GridAnimationManager.prototype.u = function (a) {
        if (this.i) {
            this.l.remove(a);
        }
        if (this.animationCanceled != null) {
            this.animationCanceled(this, ((function () {
                var $ret = new GridAnimationManagerAnimationCanceledEventArgs();
                $ret.a = a;
                return $ret;
            })()));
        }
    };
    GridAnimationManager.prototype.v = function (a) {
        if (this.i) {
            this.l.remove(a);
        }
        if (this.animationCompleted != null) {
            this.animationCompleted(this, ((function () {
                var $ret = new GridAnimationManagerAnimationCompletedEventArgs();
                $ret.a = a;
                return $ret;
            })()));
        }
    };
    GridAnimationManager.prototype.ao = function (a, b, c, d, e) {
        var _this = this;
        if (c == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        var g;
        var h;
        var i = a.a2.f(c.o);
        if (i == null) {
            return;
        }
        var j = new GridEffectGroup(1);
        j.effectsFinished = delegateCombine(j.effectsFinished, function (k, l) {
            i.e8 = 5;
            c.a = 5;
            a.model.bk = false;
            a.rp();
            a.qo(i);
            _this.v(f);
        });
        j.effectsCanceled = delegateCombine(j.effectsCanceled, function (k, l) {
            a.model.bk = false;
            a.qn(i);
            _this.u(f);
        });
        if (d) {
            if (i.fe != null && i.fe.n != null) {
                g = i.fe.n;
            }
            else if (b != null && b.n != null) {
                g = b.n;
            }
            else {
                g = this.g.n;
            }
            if (i.fe != null && i.fe.m != null) {
                h = i.fe.m;
            }
            else if (b != null && b.m != null) {
                h = b.m;
            }
            else {
                h = this.g.m;
            }
        }
        else {
            if (i.fe != null && i.fe.x != null) {
                g = i.fe.x;
            }
            else if (b != null && b.x != null) {
                g = b.x;
            }
            else {
                g = this.g.x;
            }
            if (i.fe != null && i.fe.w != null) {
                h = i.fe.w;
            }
            else if (b != null && b.w != null) {
                h = b.w;
            }
            else {
                h = this.g.w;
            }
        }
        var k = a.bz;
        if (!d) {
            k = a.b0;
        }
        if (k == 0) {
            k = i.e4();
        }
        if (e == 3 || e == 0) {
            switch (k) {
                case 2:
                case 4:
                case 5:
                case 7:
                case 9:
                case 10:
                case 6:
                    c.h = -1;
                    break;
                case 3:
                case 8:
                    c.h = 1;
                    break;
            }
        }
        a.model.bk = true;
        var l = new ColumnEffect();
        l.bx(g);
        l.al = true;
        l.bq = 0;
        l.x = function (m, n, o, p, q) {
            var r = o;
            var s = n;
            var t = p;
            t.h = s + (r - s) * m;
        };
        l.o = function (m, n) { return c.h; };
        j.g(l);
        a.c6.u(c, l);
        var m = new ColumnCellsEffect();
        m.t = 1;
        m.bx(h);
        m.al = true;
        m.bq = 0;
        m.x = function (n, o, p, q, r) {
            var s = p;
            var t = o;
            var u = q;
            switch (k) {
                case 6:
                case 2:
                case 3:
                case 7:
                case 8:
                    u.b0 = t + (s - t) * n;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    u.b4 = t + (s - t) * n;
                    break;
            }
        };
        m.o = function (n, o) {
            var p = n;
            var q = p.b0;
            if (k == 4 || k == 5 || k == 9 || k == 10) {
                q = p.b4;
            }
            if (e == 0 || e == 3) {
                switch (k) {
                    case 6:
                        q = 0;
                        p.b0 = q;
                        p.b5 = q;
                        p.bz = 0;
                        p.b4 = 0;
                        break;
                    case 2:
                    case 7:
                        q = -1;
                        p.b0 = q;
                        p.bz = 0;
                        p.b5 = 0;
                        p.b4 = 0;
                        break;
                    case 3:
                    case 8:
                        q = 1;
                        p.b0 = q;
                        p.bz = 0;
                        p.b5 = 0;
                        p.b4 = 0;
                        break;
                    case 4:
                    case 9:
                        q = (a.i6 + a.model.ci) * -1;
                        p.b4 = q;
                        p.bz = 0;
                        p.b0 = 0;
                        p.b5 = 0;
                        break;
                    case 5:
                    case 10:
                        q = (a.i6 + a.model.ci) * 1;
                        p.b4 = q;
                        p.bz = 0;
                        p.b0 = 0;
                        p.b5 = 0;
                        break;
                }
            }
            return q;
        };
        if (a.model.bm()) {
            m.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            m.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        j.g(m);
        if (k == 4 || k == 9) {
            m.ao = true;
        }
        a.c6.t(c, m);
        var n = new ColumnCellsEffect();
        n.t = 2;
        n.bx(h);
        n.al = true;
        n.bq = 1;
        n.x = function (o, p, q, r, s) {
            var t = q;
            var u = p;
            var v = r;
            var w = u + (t - u) * o;
            if (w < 0) {
                w = 0;
            }
            v.bx = w;
        };
        n.o = function (o, p) {
            var q = o;
            if (e == 0 || e == 3) {
                switch (k) {
                    case 10:
                    case 7:
                    case 8:
                    case 9:
                        q.bx = -1;
                        break;
                    case 6:
                        q.bx = 0;
                        break;
                }
            }
            return q.bx;
        };
        if (a.model.bm()) {
            n.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            n.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        j.g(n);
        if (k == 4 || k == 9) {
            n.ao = true;
        }
        a.c6.t(c, n);
    };
    GridAnimationManager.prototype.ai = function (a, b, c, d, e) {
        var _this = this;
        if (c == null || d == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        c.a = 2;
        d.a = 1;
        var g;
        var h;
        var i = a.a2.f(d.o);
        var j = a.a2.f(c.o);
        if (i == null || j == null) {
            return;
        }
        if (i.fe != null && i.fe.o != null) {
            g = i.fe.o;
        }
        else if (j.fe != null && j.fe.o != null) {
            g = j.fe.o;
        }
        else if (b != null && b.x != null) {
            g = b.o;
        }
        else {
            g = this.g.o;
        }
        if (i.fe != null && i.fe.p != null) {
            h = i.fe.p;
        }
        else if (j.fe != null && j.fe.p != null) {
            h = j.fe.p;
        }
        else if (b != null && b.p != null) {
            h = b.p;
        }
        else {
            h = this.g.p;
        }
        var k = a.a4;
        if (k == 0) {
            k = i.et();
        }
        var l = false;
        if (k == 2 || k == 7) {
            l = true;
        }
        if (l) {
            d.h = 1;
        }
        else {
            d.h = -1;
        }
        if (this.k.containsKey(c.o)) {
            this.k.addItem(d.o, new List$1(Delegate_$type, 0));
            this.k.item(c.o).add(function () {
                c = a.model.g(c.o);
                d = a.model.g(d.o);
                if (c == null || d == null) {
                    return;
                }
                j.e8 = 2;
                c.a = 2;
                i.e8 = 1;
                d.a = 1;
                _this.x(a, c, d, g, h, i, j, k, l, f);
            });
        }
        else {
            this.k.addItem(d.o, new List$1(Delegate_$type, 0));
            this.x(a, c, d, g, h, i, j, k, l, f);
        }
    };
    GridAnimationManager.prototype.x = function (a, b, c, d, e, f, g, h, i, j) {
        var _this = this;
        if (b == null || c == null) {
            return;
        }
        var k = new GridEffectGroup(1);
        k.effectsFinished = delegateCombine(k.effectsFinished, function (l, m) {
            var n = a.model.g(b.o);
            var o = a.model.g(c.o);
            var p = new GridEffectGroup(1);
            p.effectsFinished = delegateCombine(p.effectsFinished, function (q, r) {
                g.e8 = 3;
                b.a = 3;
                a.columns.remove(g);
                f.e8 = 5;
                c.a = 5;
                a.model.bk = false;
                a.rp();
                if (_this.k.containsKey(c.o)) {
                    var s = _this.k.item(c.o);
                    if (s.count == 0) {
                        _this.k.removeItem(c.o);
                    }
                    else {
                        var t = s._inner[0];
                        s.removeAt(0);
                        t();
                    }
                }
                a.qf(f);
                _this.v(j);
            });
            p.effectsCanceled = delegateCombine(p.effectsCanceled, function (q, r) {
                a.model.bk = false;
                a.qe(f);
                _this.u(j);
            });
            _this.t(a, n, o, d, g, i, p);
            _this.s(a, n, o, d, f, g, i, p);
        });
        k.effectsCanceled = delegateCombine(k.effectsCanceled, function (l, m) {
            a.qe(f);
            var n = new GridEffectGroup(1);
            n.effectsFinished = delegateCombine(n.effectsFinished, function (o, p) {
                g.e8 = 3;
                b.a = 3;
                a.columns.remove(g);
                a.model.bk = false;
                a.rp();
            });
            n.effectsCanceled = delegateCombine(n.effectsCanceled, function (o, p) { return a.model.bk = false; });
            var o = a.model.g(b.o);
            var p = a.model.g(c.o);
            _this.t(a, o, p, d, g, i, n);
        });
        var l = new ColumnCellsEffect();
        l.t = 1;
        l.bx(e);
        l.al = true;
        k.g(l);
        if (c.d != 0) {
            a.model.bk = true;
        }
        if (i) {
            l.bq = -1 - b.h;
        }
        else {
            l.bq = 1 + b.h;
        }
        var m = false;
        switch (h) {
            case 4:
            case 9:
                l.bq = (a.i6 + a.model.ci) * -1;
                m = true;
                break;
            case 5:
            case 10:
                l.bq = (a.i6 + a.model.ci) * 1;
                m = true;
                break;
        }
        if (m) {
            l.bi = 0;
        }
        l.x = function (n, o, p, q, r) {
            var s = p;
            var t = o;
            var u = q;
            switch (h) {
                case 2:
                case 3:
                case 7:
                case 8:
                    u.b0 = t + (s - t) * n;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    u.b4 = t + (s - t) * n;
                    break;
            }
        };
        l.o = function (n, o) {
            var p = n;
            var q = p.b0;
            if (h == 4 || h == 5 || h == 9 || h == 10) {
                q = p.b4;
            }
            if (h == 6) {
                q = 0;
            }
            switch (h) {
                case 2:
                case 7:
                case 6:
                    p.b0 = q;
                    p.bz = 0;
                    p.b5 = 0;
                    p.b4 = 0;
                    break;
                case 3:
                case 8:
                    p.b0 = q;
                    p.bz = 0;
                    p.b5 = 0;
                    p.b4 = 0;
                    break;
                case 4:
                case 9:
                    q = p.b4;
                    p.b4 = q;
                    p.bz = 0;
                    p.b0 = 0;
                    p.b5 = 0;
                    break;
                case 5:
                case 10:
                    q = p.b4;
                    p.b4 = q;
                    p.bz = 0;
                    p.b0 = 0;
                    p.b5 = 0;
                    break;
            }
            return q;
        };
        if (a.model.bm()) {
            l.g = new CellPath(0, 0, b.m, a.model.bf.x, a.model.bf.w);
            l.e = new CellPath(0, 0, b.m, a.model.be.x, a.model.be.w);
        }
        l.onFinished = delegateCombine(l.onFinished, function (n) {
        });
        if (h == 4 || h == 9) {
            l.ao = true;
        }
        a.c6.t(b, l);
        var n = new ColumnCellsEffect();
        n.t = 1;
        n.bx(e);
        n.al = true;
        k.g(n);
        if (i) {
            n.bq = -1;
        }
        else {
            n.bq = 1;
        }
        if (m) {
            n.bq = 0;
        }
        if (m) {
            n.bi = 0;
        }
        n.x = function (o, p, q, r, s) {
            var t = q;
            var u = p;
            var v = r;
            switch (h) {
                case 2:
                case 3:
                case 7:
                case 8:
                    v.b0 = u + (t - u) * o;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    v.b4 = u + (t - u) * o;
                    break;
            }
        };
        n.o = function (o, p) {
            var q = o;
            var r = q.b0;
            if (h == 4 || h == 5 || h == 9 || h == 10) {
                r = q.b4;
            }
            if (h == 6) {
                r = n.bq;
            }
            else {
                r = 0;
            }
            switch (h) {
                case 2:
                case 7:
                case 6:
                    q.b0 = r;
                    q.bz = 0;
                    q.b5 = 0;
                    q.b4 = 0;
                    break;
                case 3:
                case 8:
                    q.b0 = r;
                    q.bz = 0;
                    q.b5 = 0;
                    q.b4 = 0;
                    break;
                case 4:
                case 9:
                    r = (a.i6 + a.model.ci) * 1;
                    q.b4 = r;
                    q.bz = 0;
                    q.b0 = 1;
                    q.b5 = 0;
                    break;
                case 5:
                case 10:
                    r = (a.i6 + a.model.ci) * -1;
                    q.b4 = r;
                    q.bz = 0;
                    q.b0 = 1;
                    q.b5 = 0;
                    break;
            }
            return r;
        };
        if (a.model.bm()) {
            n.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            n.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        if (h == 5 || h == 10) {
            n.ao = true;
        }
        a.c6.t(c, n);
        var o = new ColumnCellsEffect();
        o.t = 2;
        o.bx(e);
        o.al = true;
        o.bq = 0;
        k.g(o);
        if (h != 6 && h != 10 && h != 7 && h != 9) {
            o.bq = 1;
        }
        o.x = function (p, q, r, s, t) {
            var u = r;
            var v = q;
            var w = s;
            w.b1 = v + (u - v) * p;
        };
        o.o = function (p, q) {
            var r = p;
            var s = r.b1;
            return s;
        };
        if (a.model.bm()) {
            o.g = new CellPath(0, 0, b.m, a.model.bf.x, a.model.bf.w);
            o.e = new CellPath(0, 0, b.m, a.model.be.x, a.model.be.w);
        }
        o.onFinished = delegateCombine(o.onFinished, function (p) {
        });
        if (h == 5 || h == 10) {
            o.ao = true;
        }
        a.c6.t(b, o);
        var p = new ColumnCellsEffect();
        p.t = 2;
        p.bx(e);
        p.al = true;
        p.bq = 1;
        k.g(p);
        p.x = function (q, r, s, t, u) {
            var v = s;
            var w = r;
            var x = t;
            x.b1 = w + (v - w) * q;
        };
        p.o = function (q, r) {
            var s = q;
            var t = s.b1;
            if (h == 6 || h == 10 || h == 8 || h == 7 || h == 9) {
                t = 0;
            }
            s.b1 = t;
            return t;
        };
        if (a.model.bm()) {
            p.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            p.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        if (h == 5 || h == 10) {
            p.ao = true;
        }
        a.c6.t(c, p);
    };
    GridAnimationManager.prototype.t = function (a, b, c, d, e, f, g) {
        var _this = this;
        if (b == null) {
            return;
        }
        var h = new ColumnEffect();
        h.bx(d);
        h.al = true;
        g.g(h);
        if (f) {
            h.bq = -1;
        }
        else {
            h.bq = 1;
        }
        h.x = function (i, j, k, l, m) {
            var n = k;
            var o = j;
            var p = l;
            p.h = o + (n - o) * i;
        };
        h.o = function (i, j) {
            if (_this.j(b, c)) {
                b.h = h.bq;
                return h.bq;
            }
            return b.h;
        };
        a.c6.u(b, h);
    };
    GridAnimationManager.prototype.s = function (a, b, c, d, e, f, g, h) {
        var _this = this;
        if (c == null) {
            return;
        }
        var i = new ColumnEffect();
        i.bx(d);
        i.al = true;
        i.bq = 0;
        h.g(i);
        i.x = function (j, k, l, m, n) {
            var o = l;
            var p = k;
            var q = m;
            q.h = p + (o - p) * j;
        };
        i.o = function (j, k) {
            if (_this.j(b, c)) {
                c.h = i.bq;
                return c.h;
            }
            return c.h;
        };
        a.c6.u(c, i);
        var j = new ColumnCellsEffect();
        j.bx(d);
        j.al = true;
        j.bq = 0;
        h.g(j);
        j.x = function (k, l, m, n, o) {
            var p = m;
            var q = l;
            var r = n;
            r.b0 = q + (p - q) * k;
        };
        j.o = function (k, l) {
            var m = k;
            if (_this.j(b, c)) {
                m.b0 = j.bq;
                return m.b0;
            }
            return m.b0;
        };
        a.c6.t(c, j);
    };
    GridAnimationManager.prototype.j = function (a, b) {
        if (a == null) {
            return true;
        }
        if (b == null) {
            return true;
        }
        if (a.b == null && b.b == null) {
            return true;
        }
        if (a.b == null && (b.b.c && b.b.f == 1)) {
            return true;
        }
        if ((a.b.c && a.b.f == 1) && b.b == null) {
            return true;
        }
        if (a.b.c && b.b.c && a.b.f == b.b.f) {
            return true;
        }
        if (!a.b.c && !b.b.c && a.b.f == b.b.f) {
            return true;
        }
        return false;
    };
    GridAnimationManager.prototype.ag = function (a, b, c, d) {
        var _this = this;
        if (c == null) {
            return;
        }
        var e = a.a2.f(c.o);
        if (e == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        var g;
        if (e.fe != null && e.fe.v != null) {
            g = e.fe.v;
        }
        else if (b != null && b.v != null) {
            g = b.v;
        }
        else {
            g = this.g.v;
        }
        var h = new ColumnEffect();
        h.bx(g);
        h.al = true;
        h.bq = d;
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(f); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(f); });
        h.x = function (i, j, k, l, m) {
            var n = k;
            var o = j;
            var p = l;
            var q = o + (n - o) * i;
            var r = ((function () {
                var $ret = new ColumnWidth();
                $ret.f = q;
                $ret.c = false;
                return $ret;
            })());
            if (!isNaN_(e.gm)) {
                r.e = e.gm;
            }
            e.width = r;
        };
        h.o = function (i, j) { return c.k; };
        if (!a.hd(e)) {
            h.ba = 0;
        }
        a.c6.u(c, h);
    };
    GridAnimationManager.prototype.ak = function (a, b, c, d) {
        var _this = this;
        if (c == null) {
            return;
        }
        var e = this.p();
        this.w(e);
        var f;
        var g;
        var h = a.a2.f(c.o);
        if (h == null) {
            return;
        }
        if (h.fe != null && h.fe.t != null) {
            f = h.fe.t;
        }
        else if (b != null && b.t != null) {
            f = b.t;
        }
        else {
            f = this.g.t;
        }
        if (h.fe != null && h.fe.s != null) {
            g = h.fe.s;
        }
        else if (b != null && b.w != null) {
            g = b.s;
        }
        else {
            g = this.g.s;
        }
        var i = a.bd;
        var j = new GridEffectGroup(1);
        j.effectsFinished = delegateCombine(j.effectsFinished, function (k, l) {
            var m = a.model.g(c.o);
            var n = a.model.bt(m);
            for (var o_1 = 0; o_1 < n.count; o_1++) {
                a.model.cz(n._inner[o_1]);
            }
            h.e8 = 5;
            a.rp();
            a.ql(h);
            _this.v(e);
        });
        j.effectsCanceled = delegateCombine(j.effectsCanceled, function (k, l) {
            a.qk(h);
            _this.u(e);
        });
        if (i == 0) {
            i = 2;
        }
        var k = 0;
        var l = c.h;
        c.h = 0;
        k = a.ey.k(c.m, a, a.model);
        c.h = l;
        var m = a.ey.j(h.gw, a.model);
        var n = m;
        var o = false;
        if (c.n < h.gw) {
            o = true;
        }
        var p = null;
        if (d != 6) {
            p = a.model.h(n, c, (c.k + a.model.cc) - c.f(a.model), c.b == null || c.b.c, o);
        }
        var q = a.model.bt(c);
        for (var r = 0; r < q.count; r++) {
            q._inner[r].e = true;
        }
        var s = c.m;
        var t = null;
        var u = a.model.bw;
        if (u._inner[s].count > 0) {
            for (var v = 0; v < u._inner[s].count; v++) {
                if (u._inner[s]._inner[v].n == c.o) {
                    t = u._inner[s]._inner[v];
                    break;
                }
            }
        }
        var w;
        if (t != null) {
            w = t;
            w.e = false;
        }
        else {
            w = a.model.h(s, c, 0, c.b == null || c.b.c, !o);
            w.e = false;
        }
        var x = h.gv;
        var y = GridAnimationManager.aq(a.model, c, h, k, x);
        k = y.p3;
        x = y.p4;
        var z = k - x;
        var aa = -1 * z;
        c.h = aa / c.k;
        c.a = 6;
        var ab = new ColumnEffect();
        ab.bx(f);
        ab.al = true;
        ab.bq = 0;
        var ac = c.k;
        var ad = false;
        var ae = 0;
        var af = c.m;
        var ag = a.ey.k(c.m, a, a.model);
        var ah = this.n(a, c, c.m);
        ag = this.q(a, c, ag, a.model.bt(c), ah);
        j.g(ab);
        ab.x = function (ai, aj, ak, al, am) {
            var an = ak;
            var ao = aj;
            var ap = al;
            ap.h = ao + (an - ao) * ai;
            if (ap.k > 0) {
                var aq = a.ey.l(ap.m, am, true);
                x = h.gv;
                var ar = GridAnimationManager.aq(a.model, c, h, aq, x);
                aq = ar.p3;
                x = ar.p4;
                if (aq - x != z) {
                    var as = aq - x;
                    var at = z - as;
                    var au = ae + (at / ap.k);
                    var av = au / (1 - ai);
                    ab.by(av, am, ap.o);
                    ap.h = au;
                    ae = au;
                    z = as;
                    ap.h = av + (an - av) * ai;
                }
                if (!ad) {
                    var aw = a.model.bs(ap);
                    for (var ax = 0; ax < aw.count; ax++) {
                        var ay = aw._inner[ax];
                        ay.b0 += (ae - ap.h);
                    }
                }
                ae = ap.h;
                af = ap.m;
                var az = a.model.bt(ap);
                ah = _this.n(a, ap, ap.m);
                ag = _this.q(a, ap, ag, az, ah);
            }
        };
        ab.o = function (ai, aj) {
            ae = c.h;
            return c.h;
        };
        a.c6.u(c, ab);
        var ai = new ColumnCellsEffect();
        ai.ar = true;
        ai.bx(g);
        ai.al = true;
        ai.bq = 0;
        j.g(ai);
        ai.x = function (aj, ak, al, am, an) {
            if (aj > 0) {
                ad = true;
            }
            if (ad) {
                var ao = al;
                var ap = ak;
                var aq = am;
                var ar = ap + (ao - ap) * aj;
                aq.b0 = ar;
            }
        };
        ai.o = function (aj, ak) {
            var al = aj;
            return al.b0;
        };
        if (a.model.bm()) {
            ai.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            ai.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        a.c6.t(c, ai);
    };
    GridAnimationManager.aq = function (a, b, c, d, e) {
        if (a.b3 > a.b0) {
            if (b.d == 1) {
                e += truncate(a.b0);
                d += truncate(a.b3);
            }
            else if (b.d == 0 && c.fj == 1) {
                e += truncate(a.b3);
                d += truncate(a.b0);
            }
        }
        if (a.b6 < a.absoluteWidth - a.b1) {
            var f = a.absoluteWidth - a.b1 - a.b6;
            if (b.d == 2) {
                d -= truncate(f);
            }
            else if (b.d == 0 && c.fj == 2) {
                e -= truncate(f);
            }
        }
        return {
            p3: d,
            p4: e
        };
    };
    GridAnimationManager.prototype.q = function (a, b, c, d, e) {
        if (e > 0) {
            var f = 0;
            for (var g = 0; g < d.count; g++) {
                if (!d._inner[g].e) {
                    if (e > d._inner[g].i) {
                        f = Math.abs(d._inner[g].i - e);
                        d._inner[g].i = e;
                    }
                }
            }
            var h = 0;
            for (var i = 0; i < d.count; i++) {
                if (d._inner[i].e) {
                    h += d._inner[i].i;
                }
            }
            var j = h - f;
            if (j < 0) {
                j = 0;
            }
            var k = 1;
            if (h == 0) {
                k = 0;
            }
            else {
                k = j / h;
            }
            for (var l = 0; l < d.count; l++) {
                if (d._inner[l].e) {
                    d._inner[l].i = d._inner[l].i * k;
                }
            }
        }
        if (b.o == 0) {
            c = a.ey.k(b.m, a, a.model);
        }
        return c;
    };
    GridAnimationManager.prototype.n = function (a, b, c) {
        var d = a.ey.l(c, a.model, true);
        var e = d + b.k;
        var f = a.ey.l(b.m, a.model, false);
        if (d > f) {
            return Math.max(0, (f + b.k) - d);
        }
        else {
            return Math.max(0, (d + b.k) - f);
        }
    };
    GridAnimationManager.prototype.aj = function (a, b, c, d, e) {
        var _this = this;
        if (c == null) {
            return;
        }
        var f = this.p();
        this.w(f);
        var g;
        var h;
        var i = a.a2.f(c.o);
        if (i == null) {
            return;
        }
        if (i.fe != null && i.fe.q != null) {
            g = i.fe.q;
        }
        else if (b != null && b.q != null) {
            g = b.q;
        }
        else {
            g = this.g.q;
        }
        if (i.fe != null && i.fe.r != null) {
            h = i.fe.r;
        }
        else if (b != null && b.r != null) {
            h = b.r;
        }
        else {
            h = this.g.r;
        }
        var j = a.ba;
        var k = new GridEffectGroup(1);
        k.effectsFinished = delegateCombine(k.effectsFinished, function (l, m) {
            i.e8 = 3;
            c.a = 3;
            if (i.f4) {
                a.externalGrid.ensureColumnsAreManual();
                a.externalGrid.removeExternalColumn(i.externalObject);
            }
            a.model.bk = false;
            a.rp();
            a.qh(i);
            _this.v(f);
        });
        k.effectsCanceled = delegateCombine(k.effectsCanceled, function (l, m) {
            a.model.bk = false;
            a.qg(i);
            _this.u(f);
        });
        if (j == 0) {
            j = i.eu();
        }
        var l = 0;
        switch (j) {
            case 2:
            case 7:
                l = -1;
                break;
            case 3:
            case 8:
                l = 1;
                break;
            case 4:
            case 9:
                l = (a.i6 + a.model.ci) * -1;
                break;
            case 5:
            case 10:
                l = (a.i6 + a.model.ci) * 1;
                break;
        }
        a.model.bk = true;
        var m = new ColumnCellsEffect();
        m.bx(g);
        m.t = 1;
        m.al = true;
        m.bq = l;
        k.g(m);
        m.x = function (n, o, p, q, r) {
            var s = p;
            var t = o;
            var u = q;
            switch (j) {
                case 2:
                case 3:
                case 7:
                case 8:
                    u.b0 = t + (s - t) * n;
                    break;
                case 4:
                case 5:
                case 9:
                case 10:
                    u.b4 = t + (s - t) * n;
                    break;
            }
        };
        m.o = function (n, o) {
            var p = n;
            var q = p.b0;
            if (j == 4 || j == 5) {
                q = p.b4;
            }
            return q;
        };
        if (a.model.bm()) {
            m.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            m.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        if (j == 5 || j == 10) {
            m.ao = true;
        }
        a.c6.t(c, m);
        var n = 0;
        switch (j) {
            case 2:
            case 4:
            case 5:
            case 7:
            case 9:
            case 10:
            case 6:
                n = -1;
                break;
            case 3:
            case 8:
                n = 1;
                break;
        }
        var o = new ColumnEffect();
        o.bx(h);
        o.al = true;
        o.bq = n;
        k.g(o);
        o.x = function (p, q, r, s, t) {
            var u = r;
            var v = q;
            var w = s;
            w.h = v + (u - v) * p;
        };
        o.o = function (p, q) { return c.h; };
        a.c6.u(c, o);
        var p = new ColumnCellsEffect();
        p.t = 2;
        p.bx(g);
        p.al = true;
        if (j == 6 || j == 10 || j == 7 || j == 8 || j == 9) {
            p.bq = 0;
        }
        else {
            p.bq = 1;
        }
        p.x = function (q, r, s, t, u) {
            var v = s;
            var w = r;
            var x = t;
            var y = w + (v - w) * q;
            if (y < 0) {
                y = 0;
            }
            x.bx = y;
        };
        p.o = function (q, r) {
            var s = q;
            if (e == 0 || e == 3) {
                switch (j) {
                    case 10:
                    case 7:
                    case 8:
                    case 9:
                        s.bx = 1;
                        break;
                    case 6:
                        s.bx = 1;
                        break;
                }
            }
            return s.bx;
        };
        if (a.model.bm()) {
            p.g = new CellPath(0, 0, c.m, a.model.bf.x, a.model.bf.w);
            p.e = new CellPath(0, 0, c.m, a.model.be.x, a.model.be.w);
        }
        k.g(p);
        if (j == 5 || j == 10) {
            p.ao = true;
        }
        a.c6.t(c, p);
    };
    GridAnimationManager.prototype.r = function (a, b, c, d, e, f, g, h, i, j) {
        var _this = this;
        if (!a.model.bm()) {
            return;
        }
        var k = this.p();
        this.w(k);
        var l = this.g.u;
        if (a.cx != null && a.cx.u != null) {
            l = a.cx.u;
        }
        var m = a.columnPropertyUpdatingAnimationMode;
        var n = new ColumnCellsEffect();
        n.bx(l);
        n.t = 7;
        n.as = true;
        if (g) {
            n.v = 5;
        }
        if (j) {
            n.v = 6;
        }
        n.bs = c;
        n.al = true;
        n.bq = f;
        n.onFinished = delegateCombine(n.onFinished, function (o) { return _this.v(k); });
        n.onCanceled = delegateCombine(n.onCanceled, function (o, p) { return _this.u(k); });
        if (m == 0) {
            m = 2;
        }
        if (d == 11) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                t.jl(c, q);
            };
        }
        if (d == 5 || d == 4 || d == 9 || d == 8 || (m != 3 && (d == 7 || d == 1 || d == 3))) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                if (o > 0.5) {
                    t.jl(c, q);
                }
                else {
                    t.jl(c, p);
                }
            };
        }
        if (m == 3 && d == 1) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                var w = u + (v - u) * o;
                t.jl(c, w);
            };
        }
        if (d == 0) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                var w = u + (v - u) * o;
                t.jl(c, w);
            };
        }
        if (d == 2) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                var w = BrushUtil.k(u, o, v, 0);
                t.jl(c, w);
            };
        }
        if (d == 3) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = p;
                var v = q;
                if (u != null) {
                    u.t(a.externalGrid.renderer);
                }
                if (v != null) {
                    v.t(a.externalGrid.renderer);
                }
                var w = new FontInfo();
                FontUtil.interpolateFont(w, o, u, v);
                t.jl(c, w);
            };
        }
        if (d == 6) {
            n.x = function (o, p, q, r, s) {
                var t = r;
                if (g != t.k.g) {
                    return;
                }
                if ((h && !t.k.aq) || (!h && t.k.aq)) {
                    return;
                }
                if ((j && !t.k.h) || (!j && t.k.h)) {
                    return;
                }
                var u = typeGetValue(p);
                var v = typeGetValue(q);
                var w = truncate((Math.round(u + (v - u) * o)));
                t.jl(c, w);
            };
        }
        n.o = function (o, p) {
            var q = o;
            return q.gg(c);
        };
        if (a.model.bm()) {
            if (h) {
                n.g = new CellPath(0, 0, -300, a.model.bf.x, a.model.bf.w);
                n.e = new CellPath(0, 0, -300, a.model.be.x, a.model.be.w);
            }
            else if (i) {
                n.g = new CellPath(0, 0, -400, a.model.bf.x, a.model.bf.w);
                n.e = new CellPath(0, 0, -400, a.model.be.x, a.model.be.w);
            }
            else {
                n.g = new CellPath(0, 0, b.m, a.model.bf.x, a.model.bf.w);
                n.e = new CellPath(0, 0, b.m, a.model.be.x, a.model.be.w);
            }
        }
        if (!a.hc || d == 11) {
            n.ba = 0;
        }
        if (h) {
            a.c6.x(n);
        }
        else if (i) {
            a.c6.y(n);
        }
        else {
            a.c6.t(b, n);
        }
    };
    GridAnimationManager.prototype.al = function (a, b, c) {
        var _this = this;
        var d = this.p();
        this.w(d);
        var e = this.e;
        var f = a.model;
        var g = new GridEffectGroup(1);
        g.effectsCanceled = delegateCombine(g.effectsCanceled, function (h, i) { return _this.u(d); });
        g.effectsFinished = delegateCombine(g.effectsFinished, function (h, i) { return _this.v(d); });
        for (var h = b; h <= c; h++) {
            var i = new RowCellsEffect();
            g.g(i);
            i.t = 6;
            i.bx(e);
            i.al = true;
            i.bq = 1;
            i.x = function (j, k, l, m, n) {
            };
            i.o = function (j, k) {
                var l = j;
                if (l.k.ag) {
                    var m = a.d3.getDataRow(l.k);
                    l.ee = m;
                    if (m == -1) {
                        return l.ie;
                    }
                    var n = a.d3.getRowType(m);
                    if (l.a5(n)) {
                        var o = a.d3.resolveValueForPath(a, l.k);
                        var p = a.ms(l.k, a, o, m);
                        a.q2(l, o, a.d3.resolveRow(m), p);
                    }
                }
                return l.ie;
            };
            var j = a.ei(h);
            if (a.model.bm()) {
                i.g = new CellPath(0, 0, a.model.cn, j.x, j.w);
                i.e = new CellPath(0, 0, a.model.cq, j.x, j.w);
            }
            if (!a.hr) {
                i.ba = 0;
            }
            a.c6.v(j, i);
        }
    };
    GridAnimationManager.prototype.ah = function (a, b) {
        var _this = this;
        if (b == null) {
            return;
        }
        var c = this.p();
        this.w(c);
        var d = this.d;
        var e = a.model;
        var f = new GridEffectGroup(1);
        f.effectsFinished = delegateCombine(f.effectsFinished, function (g, h) { return _this.v(c); });
        f.effectsCanceled = delegateCombine(f.effectsCanceled, function (g, h) { return _this.u(c); });
        var g = a.a2.f(b.o);
        if (g == null) {
            return;
        }
        var h = new ColumnEffect();
        f.g(h);
        h.bx(d);
        h.al = true;
        h.bq = 1;
        h.x = function (i, j, k, l, m) {
        };
        h.o = function (i, j) {
            var k = i;
            k.g = 0;
            k.h = 0;
            k.j = 0;
            a.rp();
            return k.g;
        };
        a.c6.u(b, h);
        var i = new ColumnCellsEffect();
        f.g(i);
        i.t = 1;
        i.bx(d);
        i.al = true;
        i.bq = 1;
        i.x = function (j, k, l, m, n) {
        };
        i.o = function (j, k) {
            var l = j;
            l.bz = 0;
            l.b0 = 0;
            l.b4 = 0;
            l.b5 = 0;
            l.bx = 1;
            return l.bz;
        };
        a.c6.t(b, i);
    };
    GridAnimationManager.prototype.y = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.e;
        if (a.cm != null && a.cm.e != null) {
            f = a.cm.e;
        }
        var g = a.al;
        var h = a.model;
        var i = new GridEffectGroup(1);
        i.effectsFinished = delegateCombine(i.effectsFinished, function (j, k) { return _this.v(e); });
        i.effectsCanceled = delegateCombine(i.effectsCanceled, function (j, k) { return _this.u(e); });
        for (var j = 0; j < h.br.count; j++) {
            var k = h.br._inner[j];
            var l = a.a2.f(k.o);
            if (l == null) {
                continue;
            }
            var m = new ColumnCellsEffect();
            i.g(m);
            m.t = 3;
            m.bx(f);
            m.al = true;
            m.bq = 0;
            if (g == 0) {
                g = 2;
            }
            m.x = function (n, o, p, q, r) {
                var s = q;
                var t = o;
                var u = p;
                if (s.k.ag) {
                    var v = a.a0(s.k);
                    if (a.d3.isPlaceholderValue(s.k)) {
                        n = 0;
                    }
                }
                s.b6 = t + (u - t) * n;
            };
            m.o = function (n, o) {
                var p = n;
                if (p.k.ag) {
                    var q = a.d3.getDataRow(p.k);
                    p.ee = q;
                    if (q == -1) {
                        return p.b6;
                    }
                    var r = a.d3.resolveValueForPath(a, p.k);
                    var s = false;
                    if (r == null && a.d3.isPlaceholderValue(p.k)) {
                        s = true;
                    }
                    if (p.a5(a.d3.getRowType(p.k.w))) {
                        var t = a.ms(p.k, a, r, q);
                        a.q2(p, r, a.d3.resolveRow(q), t);
                    }
                    if (s) {
                        p.b6 = 1;
                    }
                }
                return p.b6;
            };
            if (a.model.bm()) {
                m.g = new CellPath(0, 0, k.m, a.model.bf.x, a.model.bf.w);
                m.e = new CellPath(0, 0, k.m, a.model.be.x, a.model.be.w);
            }
            if (!a.g3 || d) {
                m.ba = 0;
            }
            a.c6.t(k, m);
        }
    };
    GridAnimationManager.prototype.af = function (a, b, c, d, e) {
        var _this = this;
        var f = this.p();
        this.w(f);
        var g = this.f.e;
        if (a.cm != null && a.cm.e != null) {
            g = a.cm.e;
        }
        var h = a.al;
        var i = a.model;
        if (d < 0 || d >= i.br.count) {
            return;
        }
        var j = i.br._inner[d];
        var k = a.a2.f(j.o);
        if (k == null) {
            return;
        }
        var l = new ColumnCellsEffect();
        l.onFinished = delegateCombine(l.onFinished, function (m) { return _this.v(f); });
        l.onCanceled = delegateCombine(l.onCanceled, function (m, n) { return _this.u(f); });
        l.t = 3;
        l.bx(g);
        l.al = true;
        l.bq = 0;
        if (h == 0) {
            h = 2;
        }
        l.x = function (m, n, o, p, q) {
            var r = p;
            var s = n;
            var t = o;
            if (r.k.ag) {
                var u = a.a0(r.k);
                if (a.d3.isPlaceholderValue(r.k)) {
                    m = 0;
                }
            }
            r.b6 = s + (t - s) * m;
        };
        l.o = function (m, n) {
            var o = m;
            if (o.k.ag) {
                var p = a.d3.getDataRow(o.k);
                o.ee = p;
                if (p == -1) {
                    return o.b6;
                }
                var q = a.d3.resolveValueForPath(a, o.k);
                var r = false;
                if (q == null && a.d3.isPlaceholderValue(o.k)) {
                    r = true;
                }
                if (o.a5(a.d3.getRowType(o.k.w))) {
                    var s = a.ms(o.k, a, q, p);
                    a.q2(o, q, a.d3.resolveRow(p), s);
                }
                if (r) {
                    o.b6 = 1;
                }
            }
            return o.b6;
        };
        if (a.model.bm()) {
            l.g = new CellPath(0, 0, j.m, a.model.bf.x, a.model.bf.w);
            l.e = new CellPath(0, 0, j.m, a.model.be.x, a.model.be.w);
        }
        if (!a.g3 || e) {
            l.ba = 0;
        }
        a.c6.t(j, l);
    };
    GridAnimationManager.prototype.am = function (a, b) {
        var _this = this;
        var c = this.p();
        this.w(c);
        var d = this.f.f;
        if (a.cx != null && a.cm.f != null) {
            d = a.cm.f;
        }
        var e = a.ek;
        var f = a.model;
        var g = new RowCellsEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(c); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(c); });
        g.t = 5;
        g.bx(d);
        g.al = true;
        g.bq = 1;
        if (e == 0) {
            e = 2;
        }
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b3 = n + (o - n) * h;
            }
            else {
                m.b3 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b3;
        };
        var h = a.ei(b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.g.d = a.model.br._inner[a.model.cn].d;
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
            g.e.d = a.model.br._inner[a.model.cq].d;
        }
        if (!a.hr || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.c6.v(h, g);
    };
    GridAnimationManager.prototype.an = function (a, b) {
        var _this = this;
        var c = this.p();
        this.w(c);
        var d = this.f.f;
        if (a.cx != null && a.cm.f != null) {
            d = a.cm.f;
        }
        var e = a.ek;
        var f = a.model;
        var g = new RowCellsEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(c); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(c); });
        g.t = 5;
        g.bx(d);
        g.al = true;
        g.bq = 0;
        if (e == 0) {
            e = 2;
        }
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b3 = n + (o - n) * h;
            }
            else {
                m.b3 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b3;
        };
        var h = a.ei(b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.g.d = a.model.br._inner[a.model.cn].d;
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
            g.e.d = a.model.br._inner[a.model.cq].d;
        }
        if (!a.hr || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.c6.v(h, g);
    };
    GridAnimationManager.prototype.ad = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.f;
        if (a.cm != null && a.cm.f != null) {
            f = a.cm.f;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 5;
        h.bx(f);
        h.al = true;
        h.bq = 1;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.b3 = o + (p - o) * i;
            }
            else {
                n.b3 = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.b3;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, a.model.cn, i.x, i.w);
            h.e = new CellPath(0, 0, a.model.cq, i.x, i.w);
        }
        if (!a.g4 || a.dragger.isDragActive) {
            h.ba = 0;
        }
        a.c6.r(i, h, d);
    };
    GridAnimationManager.prototype.z = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.d;
        if (a.cm != null && a.cm.d != null) {
            f = a.cm.d;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 8;
        h.bx(f);
        h.al = true;
        h.bq = 1;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.bu = o + (p - o) * i;
            }
            else {
                n.bu = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.bu;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, c, i.x, i.w);
            h.e = new CellPath(0, 0, c, i.x, i.w);
        }
        a.c6.r(i, h, d);
    };
    GridAnimationManager.prototype.ae = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.f;
        if (a.cm != null && a.cm.f != null) {
            f = a.cm.f;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 5;
        h.bx(f);
        h.al = true;
        h.bq = 0;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.b3 = o + (p - o) * i;
            }
            else {
                n.b3 = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.b3;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, a.model.cn, i.x, i.w);
            h.e = new CellPath(0, 0, a.model.cq, i.x, i.w);
        }
        if (!a.g4 || a.dragger.isDragActive) {
            h.ba = 0;
        }
        a.c6.r(i, h, d);
    };
    GridAnimationManager.prototype.aa = function (a, b, c, d) {
        var _this = this;
        var e = this.p();
        this.w(e);
        var f = this.f.d;
        if (a.cm != null && a.cm.d != null) {
            f = a.cm.d;
        }
        var g = a.model;
        var h = new CellEffect();
        h.onFinished = delegateCombine(h.onFinished, function (i) { return _this.v(e); });
        h.onCanceled = delegateCombine(h.onCanceled, function (i, j) { return _this.u(e); });
        h.t = 8;
        h.bx(f);
        h.al = true;
        h.bq = 0;
        h.x = function (i, j, k, l, m) {
            var n = l;
            var o = j;
            var p = k;
            if (n.k.ag) {
                n.bu = o + (p - o) * i;
            }
            else {
                n.bu = 0;
            }
        };
        h.o = function (i, j) {
            var k = i;
            return k.bu;
        };
        var i = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            h.g = new CellPath(0, 0, c, i.x, i.w);
            h.e = new CellPath(0, 0, c, i.x, i.w);
        }
        a.c6.r(i, h, d);
    };
    GridAnimationManager.prototype.ab = function (a, b, c) {
        var _this = this;
        var d = this.p();
        this.w(d);
        var e = this.f.f;
        if (a.cm != null && a.cm.f != null) {
            e = a.cm.f;
        }
        var f = a.model;
        var g = new CellPositionEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(d); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(d); });
        g.t = 5;
        g.bx(e);
        g.al = true;
        g.bq = 1;
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b3 = n + (o - n) * h;
            }
            else {
                m.b3 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b3;
        };
        var h = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
        }
        if (!a.g4 || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.c6.s(h, g);
    };
    GridAnimationManager.prototype.ac = function (a, b, c) {
        var _this = this;
        var d = this.p();
        this.w(d);
        var e = this.f.f;
        if (a.cm != null && a.cm.f != null) {
            e = a.cm.f;
        }
        var f = a.model;
        var g = new CellPositionEffect();
        g.onFinished = delegateCombine(g.onFinished, function (h) { return _this.v(d); });
        g.onCanceled = delegateCombine(g.onCanceled, function (h, i) { return _this.u(d); });
        g.t = 5;
        g.bx(e);
        g.al = true;
        g.bq = 0;
        g.x = function (h, i, j, k, l) {
            var m = k;
            var n = i;
            var o = j;
            if (m.k.ag) {
                m.b3 = n + (o - n) * h;
            }
            else {
                m.b3 = 0;
            }
        };
        g.o = function (h, i) {
            var j = h;
            return j.b3;
        };
        var h = new CellPath(1, c, 0, b);
        if (a.model.bm()) {
            g.g = new CellPath(0, 0, a.model.cn, h.x, h.w);
            g.e = new CellPath(0, 0, a.model.cq, h.x, h.w);
        }
        if (!a.g4 || a.dragger.isDragActive) {
            g.ba = 0;
        }
        a.c6.s(h, g);
    };
    GridAnimationManager.$t = markType(GridAnimationManager, 'GridAnimationManager');
    GridAnimationManager.o = 0;
    return GridAnimationManager;
}(Base));
export { GridAnimationManager };
/**
 * @hidden
 */
var CellKey = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellKey, _super);
    function CellKey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.e = null;
        _this.g = null;
        _this.i = null;
        _this.a = null;
        _this.c = null;
        return _this;
    }
    Object.defineProperty(CellKey.prototype, "primaryKey", {
        get: function () {
            if (this.e == null && this.g != null && this.d != null) {
                this.e = this.d.d3.getItemKey(this.d.i(), this.g);
            }
            return this.e;
        },
        set: function (a) {
            this.e = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "h", {
        get: function () {
            if (this.g == null && this.e != null && this.d != null) {
                this.g = this.d.d3.getItemForKey(this.primaryKey);
            }
            return this.g;
        },
        set: function (a) {
            this.g = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "j", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            this.i = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "b", {
        get: function () {
            if ((this.a == null || this.a.grid != this.d) && this.d != null) {
                this.a = this.d.a2.g(this.j);
            }
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellKey.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    CellKey.$t = markType(CellKey, 'CellKey');
    return CellKey;
}(Base));
export { CellKey };
/**
 * @hidden
 */
var GridSelectedCellsCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedCellsCollection, _super);
    function GridSelectedCellsCollection() {
        return _super.call(this, CellKey.$, 0) || this;
    }
    GridSelectedCellsCollection.prototype.an = function (a) {
        this.collectionChanged = delegateCombine(this.collectionChanged, a);
    };
    GridSelectedCellsCollection.prototype.ao = function (a) {
        this.collectionChanged = delegateRemove(this.collectionChanged, a);
    };
    Object.defineProperty(GridSelectedCellsCollection.prototype, "am", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedCellsCollection.prototype.ai = function (a, b) {
        for (var c = 0; c < this.count; c++) {
            if (this._inner[c].primaryKey != null && this._inner[c].primaryKey.equals(a) && this._inner[c].b != null && this._inner[c].b.g2 == b) {
                return this._inner[c];
            }
        }
        return null;
    };
    GridSelectedCellsCollection.prototype.aj = function (a, b) {
        for (var c = 0; c < this.count; c++) {
            if (this._inner[c].primaryKey.equals(a) && this._inner[c].j == b) {
                return this._inner[c];
            }
        }
        return null;
    };
    GridSelectedCellsCollection.prototype.ak = function (a, b) {
        for (var c = 0; c < this.count; c++) {
            if (this._inner[c].h == a && this._inner[c].j == b) {
                return this._inner[c];
            }
        }
        return null;
    };
    GridSelectedCellsCollection.prototype.ae = function (a, b) {
        return this.af(a, b.hz());
    };
    GridSelectedCellsCollection.prototype.af = function (a, b) {
        if (this.aj(a, b) != null) {
            return null;
        }
        var c = new CellKey();
        c.primaryKey = a;
        c.j = b;
        this.add(c);
        return c;
    };
    GridSelectedCellsCollection.prototype.ag = function (a, b) {
        return this.ah(a, b.hz());
    };
    GridSelectedCellsCollection.prototype.ah = function (a, b) {
        if (this.ak(a, b) != null) {
            return null;
        }
        var c = new CellKey();
        c.h = a;
        c.j = b;
        this.add(c);
        return c;
    };
    GridSelectedCellsCollection.prototype.al = function (a, b) {
        var c = this.ai(a, b);
        if (c != null) {
            this.remove(c);
        }
        return c;
    };
    GridSelectedCellsCollection.$t = markType(GridSelectedCellsCollection, 'GridSelectedCellsCollection', ObservableCollection$1.$.specialize(CellKey.$));
    return GridSelectedCellsCollection;
}(ObservableCollection$1));
export { GridSelectedCellsCollection };
/**
 * @hidden
 */
var DefinitionBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DefinitionBase, _super);
    function DefinitionBase() {
        var _this = _super.call(this) || this;
        _this.bl = null;
        _this.t = null;
        _this.dr = null;
        _this.ds = null;
        _this.dh = null;
        _this.dt = null;
        _this.dk = null;
        _this.a2 = truncate(DeviceUtils.g(0));
        _this.a4 = truncate(DeviceUtils.g(0));
        _this.a3 = truncate(DeviceUtils.g(0));
        _this.a1 = truncate(DeviceUtils.g(0));
        _this.ay = truncate(DeviceUtils.g(1));
        _this.a0 = truncate(DeviceUtils.g(1));
        _this.az = truncate(DeviceUtils.g(1));
        _this.ax = truncate(DeviceUtils.g(1));
        _this.a6 = truncate(DeviceUtils.g(2));
        _this.a8 = truncate(DeviceUtils.g(2));
        _this.a7 = truncate(DeviceUtils.g(2));
        _this.a5 = truncate(DeviceUtils.g(2));
        _this.r = null;
        _this.dj = null;
        _this.di = null;
        _this.dl = null;
        _this.dw = null;
        _this.dp = null;
        _this.dv = null;
        _this.dn = null;
        _this.du = null;
        _this.dm = null;
        _this.ar = 1;
        _this.b = 4;
        _this.g = 4;
        _this.a = 0;
        _this.f = 1;
        _this.w = 0;
        _this.v = 0;
        _this.dx = null;
        _this.dq = null;
        _this.as = NaN;
        _this.aq = 0;
        _this.ac = null;
        _this.ab = null;
        _this.dataBinding = null;
        _this.dataBound = null;
        _this.propertyChanged = null;
        _this.ag = false;
        _this.am = new HashSet$1(String_$type, 0);
        _this.ao = new List$1(String_$type, 0);
        _this.al = new Dictionary$2(String_$type, CellPropertyAnimationType_$type, 0);
        _this.definitionPropertyUpdated = null;
        _this.z = null;
        _this.cellStyleKeyRequested = null;
        _this.d0 = _this.eb();
        _this.d5 = _this.ef();
        _this.d4 = _this.ed();
        _this.d3 = _this.ec();
        _this.at = _this.av();
        _this.d6 = _this.eg();
        _this.ad = _this.af();
        _this.d2 = GridStyleRepository.bc;
        return _this;
    }
    Object.defineProperty(DefinitionBase.prototype, "externalObject", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            this.t = typeCast(IExternalDefinitionBase_$type, this.bl);
            if (this.bl != b) {
                this.c2("ExternalObject", 10, b, this.bl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d7", {
        get: function () {
            return this.dr;
        },
        set: function (a) {
            var b = this.dr;
            this.dr = a;
            if (this.dr != b) {
                this.c2("Background", 10, b, this.dr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d8", {
        get: function () {
            return this.ds;
        },
        set: function (a) {
            var b = this.ds;
            this.ds = a;
            if (this.ds != b) {
                this.c2("Border", 10, b, this.ds);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "dy", {
        get: function () {
            return this.dh;
        },
        set: function (a) {
            var b = this.dh;
            this.dh = a;
            if (this.dh != b) {
                this.c2("ActivationBorder", 10, b, this.dh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d9", {
        get: function () {
            return this.dt;
        },
        set: function (a) {
            var b = this.dt;
            this.dt = a;
            if (this.dt != b) {
                this.c2("ErrorBorder", 10, b, this.dt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d1", {
        get: function () {
            return this.dk;
        },
        set: function (a) {
            var b = this.dk;
            this.dk = a;
            if (this.dk != b) {
                this.c2("ActualBorder", 2, b, this.dk);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "be", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            var b = this.a2;
            this.a2 = a;
            if (this.a2 != b) {
                this.c2("BorderLeftWidth", 6, b, this.a2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bg", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (this.a4 != b) {
                this.c2("BorderTopWidth", 6, b, this.a4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bf", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (this.a3 != b) {
                this.c2("BorderRightWidth", 6, b, this.a3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bd", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (this.a1 != b) {
                this.c2("BorderBottomWidth", 6, b, this.a1);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ba", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (this.ay != b) {
                this.c2("ActivationBorderLeftWidth", 6, b, this.ay);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bc", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            if (this.a0 != b) {
                this.c2("ActivationBorderTopWidth", 6, b, this.a0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bb", {
        get: function () {
            return this.az;
        },
        set: function (a) {
            var b = this.az;
            this.az = a;
            if (this.az != b) {
                this.c2("ActivationBorderRightWidth", 6, b, this.az);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "a9", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.ax = a;
            if (this.ax != b) {
                this.c2("ActivationBorderBottomWidth", 6, b, this.ax);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bi", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (this.a6 != b) {
                this.c2("ErrorBorderLeftWidth", 6, b, this.a6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bk", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (this.a8 != b) {
                this.c2("ErrorBorderTopWidth", 6, b, this.a8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bj", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (this.a7 != b) {
                this.c2("ErrorBorderRightWidth", 6, b, this.a7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "bh", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (this.a5 != b) {
                this.c2("ErrorBorderBottomWidth", 6, b, this.a5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "grid", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            this.c0(b, a);
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.c0 = function (a, b) {
        if (a != null) {
            a.propertyChanged = delegateRemove(a.propertyChanged, runOn(this, this.c1));
        }
        if (b != null) {
            b.propertyChanged = delegateCombine(b.propertyChanged, runOn(this, this.c1));
        }
        this.c7();
        this.cz(a, b);
    };
    DefinitionBase.prototype.cz = function (a, b) {
    };
    DefinitionBase.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "IsActiveCellStyleEnabled":
                this.c7();
                break;
        }
    };
    Object.defineProperty(DefinitionBase.prototype, "d0", {
        get: function () {
            return this.dj;
        },
        set: function (a) {
            var b = this.dj;
            this.dj = a;
            if (this.dj != b) {
                this.c2("ActualBackground", 2, b, this.dj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "dz", {
        get: function () {
            return this.di;
        },
        set: function (a) {
            var b = this.di;
            this.di = a;
            if (this.di != b) {
                this.c2("ActualActivationBorder", 2, b, this.di);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d2", {
        get: function () {
            return this.dl;
        },
        set: function (a) {
            var b = this.dl;
            this.dl = a;
            if (this.dl != b) {
                this.c2("ActualErrorBorder", 2, b, this.dl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ej", {
        get: function () {
            return this.dw;
        },
        set: function (a) {
            var b = this.dw;
            this.dw = a;
            if (this.dw != b) {
                this.c2("PinnedBackground", 10, b, this.dw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d5", {
        get: function () {
            return this.dp;
        },
        set: function (a) {
            var b = this.dp;
            this.dp = a;
            if (this.dp != b) {
                this.c2("ActualStickyRowBackground", 2, b, this.dp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ei", {
        get: function () {
            return this.dv;
        },
        set: function (a) {
            var b = this.dv;
            this.dv = a;
            if (this.dv != b) {
                this.c2("PinnedRowBackground", 10, b, this.dv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d4", {
        get: function () {
            return this.dn;
        },
        set: function (a) {
            var b = this.dn;
            this.dn = a;
            if (this.dn != b) {
                this.c2("ActualPinnedRowBackground", 2, b, this.dn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "eh", {
        get: function () {
            return this.du;
        },
        set: function (a) {
            var b = this.du;
            this.du = a;
            if (this.du != b) {
                this.c2("LastStickyRowBackground", 10, b, this.du);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d3", {
        get: function () {
            return this.dm;
        },
        set: function (a) {
            var b = this.dm;
            this.dm = a;
            if (this.dm != b) {
                this.c2("ActualLastStickyRowBackground", 2, b, this.dm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "au", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (this.ar != b) {
                this.c2("ContentOpacity", 0, b, this.ar);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "e", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (this.b != b) {
                this.c2("HorizontalAlignment", 10, enumGetBox(CellContentHorizontalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.b));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "j", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            var b = this.g;
            this.g = a;
            if (this.g != b) {
                this.c2("VerticalAlignment", 10, enumGetBox(CellContentVerticalAlignment_$type, b), enumGetBox(CellContentVerticalAlignment_$type, this.g));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "c", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (this.a != b) {
                this.c2("ActualHorizontalAlignment", 4, enumGetBox(CellContentHorizontalAlignment_$type, b), enumGetBox(CellContentHorizontalAlignment_$type, this.a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "h", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            var b = this.f;
            this.f = a;
            if (this.f != b) {
                this.c2("VerticalAlignment", 4, enumGetBox(CellContentVerticalAlignment_$type, b), enumGetBox(CellContentVerticalAlignment_$type, this.f));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "y", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            var b = this.w;
            this.w = a;
            if (this.w != b) {
                this.c2("LineBreakMode", 10, enumGetBox(TextCellLineBreakMode_$type, b), enumGetBox(TextCellLineBreakMode_$type, this.w));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "x", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            var b = this.v;
            this.v = a;
            if (this.v != b) {
                this.c2("ActualLineBreakMode", 4, enumGetBox(TextCellLineBreakMode_$type, b), enumGetBox(TextCellLineBreakMode_$type, this.v));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ek", {
        get: function () {
            return this.dx;
        },
        set: function (a) {
            var b = this.dx;
            this.dx = a;
            if (this.dx != b) {
                this.c2("TextColor", 10, b, this.dx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "d6", {
        get: function () {
            return this.dq;
        },
        set: function (a) {
            var b = this.dq;
            this.dq = a;
            if (this.dq != b) {
                this.c2("ActualTextColor", 2, b, this.dq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "aw", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (this.as != b) {
                this.c2("PinnedRowOpacity", 10, b, this.as);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "at", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (this.aq != b) {
                this.c2("ActualPinnedRowOpacity", 0, b, this.aq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "textStyle", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            var b = this.ac;
            this.ac = a;
            if (this.ac != b) {
                this.c2("FontInfo", 10, b, this.ac);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ad", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (this.ab != b) {
                this.c2("ActualFontInfo", 3, b, this.ab);
            }
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.k = function (a, b) {
        var c = this.l(a);
        c.ir = b;
        return c;
    };
    DefinitionBase.prototype.cl = function (a, b, c, d) {
        var e = this.cm(a, b, c);
        if (this.cellStyleKeyRequested == null) {
            return e;
        }
        var f = new CellStyleRequestedEventArgs();
        f.resolvedValue = c;
        f.rowNumber = d;
        f.styleKey = e;
        this.cellStyleKeyRequested(this, f);
        return f.styleKey;
    };
    DefinitionBase.prototype.cw = function (a, b, c, d) {
        a.a1 = b.model.bl;
        a.f = this.c;
        a.h = this.h;
        a.bz = 0;
        a.b4 = 0;
        a.b0 = 0;
        a.b5 = 0;
        a.bx = 1;
        a.b6 = 0;
        a.b1 = 1;
        a.bx = this.au;
        a.ke = this.d6;
        a.j4 = this.d0;
        a.j0 = this.dz;
        a.c8 = this.ba;
        a.dd = this.bc;
        a.db = this.bb;
        a.c6 = this.a9;
        a.j7 = this.d2;
        a.em = this.bi;
        a.er = this.bk;
        a.ep = this.bj;
        a.ek = this.bh;
        if (this.ag) {
            a.j5 = this.d1;
            a.d6 = this.be;
            a.d9 = this.bf;
            a.eb = this.bg;
            a.d4 = this.bd;
        }
        else {
            if (a.j5 != null) {
                a.j5 = null;
                a.d6 = 0;
                a.eb = 0;
                a.d9 = 0;
                a.d4 = 0;
            }
        }
        if (this.grid != null) {
            if (this.ad != null) {
                this.ad.t(this.grid.externalGrid.renderer);
            }
        }
        a.af = this.ad;
        a.z = this.x;
        a.kd = this.d5;
        a.ka = this.d4;
        a.j9 = this.d3;
        a.b2 = this.at;
        if (a.c == null) {
            a.c = new DefaultCellActionManager(b, a);
        }
        if (a.d == null) {
            a.d = new DefaultGridInfoRequestor(b, a);
        }
    };
    DefinitionBase.prototype.cx = function (a, b, c, d) {
        if (this.dataBinding != null) {
            var e = this.n(a, b, c, d);
            this.dataBinding(this, e);
            c = e.resolvedValue;
            d = e.rowObject;
        }
        this.cy(a, b, c, d);
        if (this.dataBound != null) {
            this.dataBound(this, this.n(a, b, c, d));
        }
    };
    DefinitionBase.prototype.n = function (a, b, c, d) {
        var e = new DataBindingEventArgs();
        e.cellInfo = a;
        e.resolvedValue = c;
        e.rowObject = d;
        return e;
    };
    DefinitionBase.prototype.cy = function (a, b, c, d) {
        a.gi = d;
        if (!a.k.g && this.ai()) {
            var e = this.aa;
            var f = e.o;
            var g = f.count;
            var h = e.p;
            var i = e.q;
            for (var j = 0; j < g; j++) {
                if (h._inner[j]) {
                    continue;
                }
                a.jk(f._inner[j], i._inner[j]);
            }
        }
    };
    DefinitionBase.prototype.c5 = function () {
        for (var a = 0; a < this.ao.count; a++) {
            if (!this.ak(this.ao._inner[a])) {
                this.aj(this.ao._inner[a]);
            }
        }
    };
    DefinitionBase.prototype.aj = function (a) {
        if (this.ah(a)) {
            var b = 11;
            if (this.al.containsKey(a)) {
                b = this.al.item(a);
            }
            this.c3(a, b, this.bn(a), this.bn(a));
            return true;
        }
        return false;
    };
    DefinitionBase.prototype.ak = function (a) {
        if (stringStartsWith(a, "Actual")) {
            return false;
        }
        switch (a) {
            case "Background":
                this.c2("ActualBackground", 2, this.d0, this.d0);
                return true;
            case "ContentOpacity":
                this.c2("ContentOpacity", 0, this.au, this.au);
                return true;
            case "FontInfo":
                this.c2("ActualFontInfo", 3, this.ad, this.ad);
                return true;
            case "HorizontalAlignment":
                this.c2("ActualHorizontalAlignment", 4, enumGetBox(CellContentHorizontalAlignment_$type, this.c), enumGetBox(CellContentHorizontalAlignment_$type, this.c));
                return true;
            case "TextColor":
                this.c2("ActualTextColor", 2, this.d6, this.d6);
                return true;
            case "VerticalAlignment":
                this.c2("VerticalAlignment", 4, enumGetBox(CellContentVerticalAlignment_$type, this.h), enumGetBox(CellContentVerticalAlignment_$type, this.h));
                return true;
            case "Border":
                this.c2("ActualBorder", 2, this.d1, this.d1);
                return true;
            case "ActivationBorder":
                this.c2("ActualActivationBorder", 2, this.dz, this.dz);
                return true;
            case "BorderLeftWidth":
                this.c2("BorderLeftWidth", 0, this.be, this.be);
                return true;
            case "BorderTopWidth":
                this.c2("BorderTopWidth", 0, this.bg, this.bg);
                return true;
            case "BorderRightWidth":
                this.c2("BorderRightWidth", 0, this.bf, this.bf);
                return true;
            case "BorderBottomWidth":
                this.c2("BorderBottomWidth", 0, this.bd, this.bd);
                return true;
            case "ActivationBorderLeftWidth":
                this.c2("ActivationBorderLeftWidth", 0, this.ba, this.ba);
                return true;
            case "ActivationBorderTopWidth":
                this.c2("ActivationBorderTopWidth", 0, this.bc, this.bc);
                return true;
            case "ActivationBorderRightWidth":
                this.c2("ActivationBorderRightWidth", 0, this.bb, this.bb);
                return true;
            case "ActivationBorderBottomWidth":
                this.c2("ActivationBorderBottomWidth", 0, this.a9, this.a9);
                return true;
        }
        return false;
    };
    DefinitionBase.prototype.c2 = function (a, b, c, d) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.c3(a, b, c, d);
        if (this.definitionPropertyUpdated != null) {
            this.definitionPropertyUpdated(this, ((function () {
                var $ret = new DefinitionPropertyUpdatedEventArgs();
                $ret.propertyName = a;
                $ret.animationType = b;
                $ret.newValue = d;
                $ret.oldValue = c;
                return $ret;
            })()));
        }
    };
    DefinitionBase.prototype.c8 = function () {
        if (this.d7 != null) {
            this.d0 = this.d7;
        }
        else {
            this.d0 = this.eb();
        }
    };
    DefinitionBase.prototype.df = function () {
        if (this.ek != null) {
            this.d6 = this.ek;
        }
        else {
            this.d6 = this.eg();
        }
    };
    DefinitionBase.prototype.dg = function () {
        this.ad = this.textStyle;
    };
    DefinitionBase.prototype.dd = function () {
        if (!isNaN_(this.aw)) {
            this.at = this.aw;
        }
        else {
            this.at = this.av();
        }
    };
    DefinitionBase.prototype.dc = function () {
        if (this.ei != null) {
            this.d4 = this.ei;
        }
        else {
            this.d4 = this.ed();
        }
    };
    DefinitionBase.prototype.de = function () {
        if (this.ej != null) {
            this.d5 = this.ej;
        }
        else {
            this.d5 = this.ef();
        }
    };
    DefinitionBase.prototype.db = function () {
        if (this.eh != null) {
            this.d3 = this.eh;
        }
        else {
            this.d3 = this.ec();
        }
    };
    DefinitionBase.prototype.c3 = function (a, b, c, d) {
        this.cv(a, b);
        switch (a) {
            case "TextColor":
                this.df();
                break;
            case "Background":
                this.c8();
                break;
            case "PinnedBackground":
                this.de();
                break;
            case "PinnedRowBackground":
                this.dc();
                break;
            case "LastStickyRowBackground":
                this.db();
                break;
            case "PinnedRowOpacity":
                this.dd();
                break;
            case "VerticalAlignment":
                if (this.j == 4) {
                    this.h = this.i();
                }
                else {
                    this.h = this.j;
                }
                break;
            case "HorizontalAlignment":
                if (this.e == 4) {
                    this.c = this.d();
                }
                else {
                    this.c = this.e;
                }
                break;
            case "LineBreakMode":
                this.x = this.y;
                break;
            case "FontInfo":
                this.dg();
                break;
            case "Border":
            case "BorderLeftWidth":
            case "BorderTopWidth":
            case "BorderRightWidth":
            case "BorderBottomWidth":
                this.c9();
                break;
            case "ActivationBorder":
                this.c7();
                break;
            case "ErrorBorder":
                this.da();
                break;
        }
    };
    DefinitionBase.prototype.c9 = function () {
        if (this.be != 0 || this.bg != 0 || this.bf != 0 || this.bd != 0) {
            if (this.d8 != null) {
                this.ag = true;
                this.d1 = this.d8;
            }
            else if (this.d1 != null) {
                this.ag = true;
            }
        }
    };
    DefinitionBase.prototype.c7 = function () {
        if (this.grid != null && this.grid.g2) {
            if (this.dy == null) {
                this.dz = this.ea();
            }
            else {
                this.dz = this.dy;
            }
        }
        else {
            this.dy = null;
        }
    };
    DefinitionBase.prototype.da = function () {
        if (this.d9 != null) {
            this.d2 = this.d9;
        }
        else {
            this.d2 = GridStyleRepository.bc;
        }
    };
    Object.defineProperty(DefinitionBase.prototype, "an", {
        get: function () {
            return this.am;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefinitionBase.prototype, "ap", {
        get: function () {
            return this.ao;
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.cv = function (a, b) {
        if (this.am.contains(a)) {
            return;
        }
        this.am.add_1(a);
        this.ao.add(a);
        this.al.addItem(a, b);
    };
    DefinitionBase.prototype.d = function () {
        if (this.e != 4) {
            return this.e;
        }
        return 0;
    };
    DefinitionBase.prototype.i = function () {
        if (this.j != 4) {
            return this.j;
        }
        return 1;
    };
    DefinitionBase.prototype.eg = function () {
        return GridStyleRepository.bj;
    };
    DefinitionBase.prototype.ea = function () {
        return GridStyleRepository.at;
    };
    DefinitionBase.prototype.af = function () {
        return GridStyleRepository.l;
    };
    DefinitionBase.prototype.eb = function () {
        return GridStyleRepository.au;
    };
    DefinitionBase.prototype.ef = function () {
        return null;
    };
    DefinitionBase.prototype.ed = function () {
        return null;
    };
    DefinitionBase.prototype.ec = function () {
        return null;
    };
    DefinitionBase.prototype.ee = function () {
        return GridStyleRepository.a7;
    };
    DefinitionBase.prototype.av = function () {
        return 0.3;
    };
    DefinitionBase.prototype.c6 = function (a, b, c) {
        if (this.z == null) {
            this.z = new FastIterationDictionary$2(String_$type, Base.$, 0);
        }
        var d = null;
        if (this.z.d(a)) {
            d = this.z.item(a);
        }
        this.z.item(a, c);
        var e = false;
        if (d == null && c != null) {
            e = true;
        }
        if (d != null) {
            if (!Base.equalsStatic(d, c)) {
                e = true;
            }
        }
        if (e) {
            this.c2(a, b, d, c);
        }
    };
    DefinitionBase.prototype.ai = function () {
        if (this.z == null) {
            return false;
        }
        return this.z.r > 0;
    };
    Object.defineProperty(DefinitionBase.prototype, "aa", {
        get: function () {
            return this.z;
        },
        enumerable: true,
        configurable: true
    });
    DefinitionBase.prototype.ah = function (a) {
        if (this.z == null) {
            return false;
        }
        return this.z.d(a);
    };
    DefinitionBase.prototype.c4 = function (a) {
        if (this.z == null) {
            return;
        }
        if (this.z.d(a)) {
            this.z.f(a);
        }
    };
    DefinitionBase.prototype.bn = function (a) {
        if (this.z == null) {
            return null;
        }
        if (this.z.d(a)) {
            return this.z.item(a);
        }
        return null;
    };
    DefinitionBase.prototype.ck = function (a, b, c) {
        var d = stringEmpty();
        switch (b) {
            case 10:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = (typeGetValue(a)).toString();
                }
                break;
            case 8:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 5:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 1:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = (typeGetValue(a)).toString();
                }
                break;
            case 3:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = typeGetValue(a).toString();
                }
                break;
            case 4:
                if (c != null) {
                    var override_ = c;
                    var val_ = typeGetValue(a);
                    d = (override_.format(val_));
                }
                else {
                    d = typeGetValue(a).toString();
                }
                break;
            case 7:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 6:
                if (c != null) {
                    var override_ = c;
                    var val_ = a;
                    d = (override_.format(val_));
                }
                else {
                    d = a.toString();
                }
                break;
            case 0:
            case 2:
            case 11:
                d = a.toString();
                break;
        }
        return d;
    };
    DefinitionBase.prototype.u = function (a, b) {
        var c = b != null ? b.value.toString() : stringEmpty();
        var d = a.a;
        if (a.h == 4) {
            d = 1;
        }
        var e = b.value;
        switch (d) {
            case 10:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = (typeGetValue(e)).toString();
                }
                break;
            case 8:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    c = e.toString();
                }
                break;
            case 5:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    var summaryValue_ = e;
                    var maxFractionDigits_ = a.o;
                    c = (parseFloat(summaryValue_.toFixed(maxFractionDigits_)).toString());
                }
                break;
            case 1:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = (typeGetValue(e)).toString();
                }
                break;
            case 3:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = typeGetValue(e).toString();
                }
                break;
            case 4:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = typeGetValue(e);
                    c = (override_.format(val_));
                }
                else {
                    c = typeGetValue(e).toString();
                }
                break;
            case 7:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    var summaryValue_ = e;
                    var maxFractionDigits_ = a.o;
                    c = (parseFloat(summaryValue_.toFixed(maxFractionDigits_)).toString());
                }
                break;
            case 6:
                if (a.q != null) {
                    var override_ = a.q;
                    var val_ = e;
                    c = (override_.format(val_));
                }
                else {
                    var summaryValue_ = e;
                    var maxFractionDigits_ = a.o;
                    c = (parseFloat(summaryValue_.toFixed(maxFractionDigits_)).toString());
                }
                break;
            case 0:
            case 2:
            case 11:
                c = e.toString();
                break;
        }
        var f = a.u != null ? a.u : a.d != null ? a.d.displayName : stringEmpty();
        var g = stringIsNullOrWhiteSpace(a.v) ? a.w : a.v;
        var h = g + " " + f + " = " + c;
        var i = a.i(b, c, h);
        h = i.e;
        c = i.d;
        return ((function () {
            var $ret = new SummaryData();
            $ret.e = g;
            $ret.b = e;
            $ret.a = a.h;
            $ret.c = i.e;
            $ret.d = i.d;
            return $ret;
        })());
    };
    DefinitionBase.$t = markType(DefinitionBase, 'DefinitionBase', Base.$, [INotifyPropertyChanged_$type]);
    return DefinitionBase;
}(Base));
export { DefinitionBase };
/**
 * @hidden
 */
var Column = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Column, _super);
    function Column() {
        var _this = _super.call(this) || this;
        _this.g2 = 0;
        _this.e7 = 0;
        _this.gr = truncate(DeviceUtils.g(12));
        _this.gt = truncate(DeviceUtils.g(1));
        _this.gs = truncate(DeviceUtils.g(12));
        _this.gq = truncate(DeviceUtils.g(1));
        _this.ha = stringEmpty();
        _this.go = 0;
        _this.gn = 0;
        _this.gp = 0;
        _this.fh = 0;
        _this.g8 = null;
        _this.g9 = null;
        _this.g6 = null;
        _this.i8 = null;
        _this.i5 = null;
        _this.fd = null;
        _this.e9 = null;
        _this.gj = NaN;
        _this.fy = false;
        _this.fu = false;
        _this.f1 = false;
        _this.en = null;
        _this.ff = null;
        _this.fx = true;
        _this.f0 = true;
        _this.fz = false;
        _this.f2 = false;
        _this.e5 = 0;
        _this.fi = 0;
        _this.ft = false;
        _this.ev = 0;
        _this.ew = 0;
        _this.i3 = null;
        _this.i6 = null;
        _this.e0 = 0;
        _this.ez = 0;
        _this.fr = true;
        _this.fv = true;
        _this.fw = true;
        _this.i7 = null;
        _this.i4 = null;
        _this.gi = NaN;
        _this.gh = 0;
        _this.fo = null;
        _this.fn = null;
        _this.fb = 0;
        _this.g3 = null;
        _this.g7 = null;
        _this.el = null;
        _this.columnCellsPropertyUpdating = null;
        _this.columnHeaderCellsPropertyUpdating = null;
        _this.fl = null;
        _this.fs = false;
        _this.fs = true;
        _this.header = new TextHeader();
        _this.fs = false;
        _this.c = _this.d();
        _this.h = _this.i();
        _this.jb = _this.je();
        _this.g2 = Column.g1++;
        return _this;
    }
    Column.prototype.je = function () {
        return GridStyleRepository.a7;
    };
    Object.defineProperty(Column.prototype, "e8", {
        get: function () {
            return this.e7;
        },
        set: function (a) {
            var b = this.e7;
            this.e7 = a;
            if (this.e7 != b) {
                this.c2("State", 10, enumGetBox(ColumnStates_$type, b), enumGetBox(ColumnStates_$type, this.e7));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gy", {
        get: function () {
            return this.gr;
        },
        set: function (a) {
            var b = this.gr;
            this.gr = a;
            if (this.gr != b) {
                this.c2("PaddingLeft", 6, b, this.gr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g0", {
        get: function () {
            return this.gt;
        },
        set: function (a) {
            var b = this.gt;
            this.gt = a;
            if (this.gt != b) {
                this.c2("PaddingTop", 6, b, this.gt);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gz", {
        get: function () {
            return this.gs;
        },
        set: function (a) {
            var b = this.gs;
            this.gs = a;
            if (this.gs != b) {
                this.c2("PaddingRight", 6, b, this.gs);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gx", {
        get: function () {
            return this.gq;
        },
        set: function (a) {
            var b = this.gq;
            this.gq = a;
            if (this.gq != b) {
                this.c2("PaddingBottom", 6, b, this.gq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ic", {
        get: function () {
            return this.ha;
        },
        set: function (a) {
            var b = this.ha;
            this.ha = a;
            if (this.ha != b) {
                this.c2("Name", 10, b, this.ha);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gv", {
        get: function () {
            return this.go;
        },
        set: function (a) {
            this.go = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gu", {
        get: function () {
            return this.gn;
        },
        set: function (a) {
            this.gn = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gw", {
        get: function () {
            return this.gp;
        },
        set: function (a) {
            this.gp = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fj", {
        get: function () {
            return this.fh;
        },
        set: function (a) {
            this.fh = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "hx", {
        get: function () {
            return this.g8;
        },
        set: function (a) {
            this.g8 = a;
            if (this.h1 == null) {
                this.hh = this.hx;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "h1", {
        get: function () {
            return this.g9;
        },
        set: function (a) {
            var b = this.g9;
            this.g9 = a;
            if (this.g9 != b) {
                this.c2("HeaderText", 8, b, this.g9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "hh", {
        get: function () {
            return this.g6;
        },
        set: function (a) {
            var b = this.g6;
            this.g6 = a;
            if (this.g6 != b) {
                this.c2("ActualHeaderText", 8, b, this.g6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jf", {
        get: function () {
            return this.i8;
        },
        set: function (a) {
            var b = this.i8;
            this.i8 = a;
            if (this.i8 != b) {
                this.c2("SelectedBackground", 10, b, this.i8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jb", {
        get: function () {
            return this.i5;
        },
        set: function (a) {
            var b = this.i5;
            this.i5 = a;
            if (this.i5 != b) {
                this.c2("ActualSelectedBackground", 2, b, this.i5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fe", {
        get: function () {
            return this.fd;
        },
        set: function (a) {
            var b = this.fd;
            this.fd = a;
            if (this.fd != b) {
                this.c2("AnimationSettings", 10, b, "AnimationSettings");
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "width", {
        get: function () {
            return this.e9;
        },
        set: function (a) {
            var b = this.e9;
            this.e9 = a;
            if (this.e9 != b) {
                this.c2("Width", 10, b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gm", {
        get: function () {
            return this.gj;
        },
        set: function (a) {
            var b = this.gj;
            this.gj = a;
            if (this.gj != b) {
                this.c2("MinWidth", 10, b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gc", {
        get: function () {
            return this.fy;
        },
        set: function (a) {
            var b = this.fy;
            this.fy = a;
            if (this.fy != b) {
                this.c2("IsFromMarkup", 10, b, this.fy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f8", {
        get: function () {
            return this.fu;
        },
        set: function (a) {
            var b = this.fu;
            if (a) {
                this.gf = true;
            }
            this.fu = a;
            if (this.fu != b) {
                this.c2("IsAutoGenerated", 10, b, this.fu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gf", {
        get: function () {
            return this.f1;
        },
        set: function (a) {
            var self_ = this;
            var value_ = a;
            this.f1 = value_;
            self_.___mustPassByValue = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "eo", {
        get: function () {
            return this.en;
        },
        set: function (a) {
            var b = this.en;
            this.en = a;
            if (this.en != b) {
                this.c2("Filter", 10, b, this.en);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "header", {
        get: function () {
            return this.ff;
        },
        set: function (a) {
            var b = this.ff;
            this.ff = a;
            if (this.ff != b) {
                this.c2("Header", 10, b, this.ff);
            }
            this.ff.grid = this.grid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gb", {
        get: function () {
            return this.fx;
        },
        set: function (a) {
            var b = this.fx;
            this.fx = a;
            if (this.fx != b) {
                this.c2("IsFilteringEnabled", 10, b, this.fx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ge", {
        get: function () {
            return this.f0;
        },
        set: function (a) {
            var b = this.f0;
            this.f0 = a;
            if (this.f0 != b) {
                this.c2("IsResizingEnabled", 10, b, this.f0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gd", {
        get: function () {
            return this.fz;
        },
        set: function (a) {
            var b = this.fz;
            this.fz = a;
            if (this.fz != b) {
                this.c2("IsHidden", 10, b, this.fz);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gg", {
        get: function () {
            return this.f2;
        },
        set: function (a) {
            var b = this.f2;
            this.f2 = a;
            if (this.f2 != b) {
                this.c2("ShouldRemoveWhenHidden", 10, b, this.f2);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "e6", {
        get: function () {
            return this.e5;
        },
        set: function (a) {
            var b = this.e5;
            this.e5 = a;
            if (this.e5 != b) {
                this.c2("SortDirection", 11, enumGetBox(ColumnSortDirection_$type, b), enumGetBox(ColumnSortDirection_$type, this.e5));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fk", {
        get: function () {
            return this.fi;
        },
        set: function (a) {
            var b = this.fi;
            this.fi = a;
            if (this.fi != b) {
                this.c2("Pinned", 11, enumGetBox(PinnedPositions_$type, b), enumGetBox(PinnedPositions_$type, this.fi));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f7", {
        get: function () {
            return this.ft;
        },
        set: function (a) {
            var b = this.ft;
            this.ft = a;
            if (this.ft != b) {
                this.c2("InternalShouldRemoveWhenHidden", 10, b, this.ft);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f4", {
        get: function () {
            if (this.ft) {
                return true;
            }
            return this.f2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ex", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            var b = this.ev;
            this.ev = a;
            if (this.ev != b) {
                this.c2("ActualColumnOptionsIconAlignment", 4, enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.ev));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ey", {
        get: function () {
            return this.ew;
        },
        set: function (a) {
            var b = this.ew;
            this.ew = a;
            if (this.ew != b) {
                this.c2("ColumnOptionsIconAlignment", 10, enumGetBox(ColumnOptionsIconAlignment_$type, b), enumGetBox(ColumnOptionsIconAlignment_$type, this.ew));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "i9", {
        get: function () {
            return this.i3;
        },
        set: function (a) {
            var b = this.i3;
            this.i3 = a;
            if (this.i3 != b) {
                this.c2("ActualColumnOptionsIconColor", 2, b, this.i3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jc", {
        get: function () {
            return this.i6;
        },
        set: function (a) {
            var b = this.i6;
            this.i6 = a;
            if (this.i6 != b) {
                this.c2("ColumnOptionsIconColor", 10, b, this.i6);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "e2", {
        get: function () {
            return this.e0;
        },
        set: function (a) {
            var b = this.e0;
            this.e0 = a;
            if (this.e0 != b) {
                this.c2("ColumnOptionsIconBehavior", 10, enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.e0));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "e1", {
        get: function () {
            return this.ez;
        },
        set: function (a) {
            var b = this.ez;
            this.ez = a;
            if (this.ez != b) {
                this.c2("ActualColumnOptionsIconBehavior", 4, enumGetBox(ColumnOptionsIconBehavior_$type, b), enumGetBox(ColumnOptionsIconBehavior_$type, this.ez));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f3", {
        get: function () {
            return this.fr;
        },
        set: function (a) {
            var b = this.fr;
            this.fr = a;
            if (this.fr != b) {
                this.c2("ActualIsColumnOptionsEnabled", 5, b, this.fr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "f9", {
        get: function () {
            return this.fv;
        },
        set: function (a) {
            var b = this.fv;
            this.fv = a;
            if (this.fv != b) {
                this.c2("IsColumnOptionsEnabled", 10, b, this.fv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ga", {
        get: function () {
            return this.fw;
        },
        set: function (a) {
            var b = this.fw;
            this.fw = a;
            if (this.fw != b) {
                this.c2("IsEditable", 10, b, this.fw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "jd", {
        get: function () {
            return this.i7;
        },
        set: function (a) {
            var b = this.i7;
            this.i7 = a;
            if (this.i7 != b) {
                this.c2("DeletedTextColor", 10, b, this.i7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ja", {
        get: function () {
            return this.i4;
        },
        set: function (a) {
            var b = this.i4;
            this.i4 = a;
            if (this.i4 != b) {
                this.c2("ActualDeletedTextColor", 2, b, this.i4);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gl", {
        get: function () {
            return this.gi;
        },
        set: function (a) {
            var b = this.gi;
            this.gi = a;
            if (this.gi != b) {
                this.c2("EditOpacity", 10, b, this.gi);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "gk", {
        get: function () {
            return this.gh;
        },
        set: function (a) {
            var b = this.gh;
            this.gh = a;
            if (this.gh != b) {
                this.c2("ActualEditOpacity", 0, b, this.gh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "textEditStyle", {
        get: function () {
            return this.fo;
        },
        set: function (a) {
            var b = this.fo;
            this.fo = a;
            if (this.fo != b) {
                this.c2("EditFontInfo", 10, b, this.fo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fp", {
        get: function () {
            return this.fn;
        },
        set: function (a) {
            var b = this.fn;
            this.fn = a;
            if (this.fn != b) {
                this.c2("ActualEditFontInfo", 3, b, this.fn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "fc", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (b != this.fb) {
                this.c2("EditorTypeInternal", 4, enumGetBox(EditorType_$type, b), enumGetBox(EditorType_$type, this.fb));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "g4", {
        get: function () {
            return this.g3;
        },
        set: function (a) {
            var b = this.g3;
            this.g3 = a;
            if (b != this.g3) {
                this.c2("EditorItemsSourceInternal", 9, b, this.g3);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "ht", {
        get: function () {
            return this.g7;
        },
        set: function (a) {
            var b = this.g7;
            this.g7 = a;
            if (b != this.g7) {
                this.c2("EditorTextFieldInternal", 8, b, this.g7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "em", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (b != this.el) {
                this.c2("EditorValueFieldInternal", 8, b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    Column.prototype.ed = function () {
        return GridStyleRepository.a1;
    };
    Column.prototype.ef = function () {
        return GridStyleRepository.a8;
    };
    Column.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        a.gh = c;
        a.ax = b.d3.isEditedValue(d, this.hx);
        a.au = b.d3.isDeletedRow(d);
        a.ei = b.d3.getPendingEditID(d, this.hx);
        a.he = b.d3.getError(a.ei);
        if (b.es.o(a)) {
            a.b3 = 1;
        }
        else {
            a.b3 = 0;
        }
        if (b.aj.m(a)) {
            a.bu = 1;
        }
        else {
            a.bu = 0;
        }
    };
    Column.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.kb = this.jb;
        a.fh = this.gy;
        a.fl = this.g0;
        a.fj = this.gz;
        a.ff = this.gx;
        if (this.grid != null) {
            if (this.fp != null) {
                this.fp.t(this.grid.externalGrid.renderer);
            }
        }
        a.ae = this.fp;
        a.by = this.gk;
        a.j6 = this.ja;
    };
    Column.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "Header":
                var e = c;
                var f = d;
                if (e != null) {
                    e.definitionPropertyUpdated = delegateRemove(e.definitionPropertyUpdated, runOn(this, this.iq));
                }
                if (f != null) {
                    f.definitionPropertyUpdated = delegateCombine(f.definitionPropertyUpdated, runOn(this, this.iq));
                    if (f.e == 4) {
                        f.c = this.ep();
                    }
                    if (f.j == 4) {
                        f.h = this.eq();
                    }
                    if (!this.fs) {
                        f.c5();
                    }
                }
                break;
            case "HeaderText":
                this.hh = d;
                break;
            case "SelectedBackground":
                this.i2();
                break;
            case "ActualHorizontalAlignment":
                if (this.header != null) {
                    if (this.header.e == 4) {
                        this.header.c = this.ep();
                    }
                }
                break;
            case "VerticalAlignment":
                if (this.header != null) {
                    if (this.header.j == 4) {
                        this.header.h = this.eq();
                    }
                }
                break;
            case "SortDirection":
                this.i1(this, "SortDirection", 11, c, d);
                break;
            case "ActualLastStickyRowBackground":
                if (c != null && this.d3 == null) {
                    d = this.d5;
                }
                break;
            case "ColumnOptionsIconAlignment":
                this.iu();
                break;
            case "ColumnOptionsIconColor":
                this.ix();
                break;
            case "ColumnOptionsIconBehavior":
                this.iw();
                break;
            case "IsColumnOptionsEnabled":
                this.iv();
                break;
            case "DeletedTextColor":
                this.iy();
                break;
            case "EditOpacity":
                this.i0();
                break;
            case "EditFontInfo":
                this.iz();
                break;
        }
        this.it(a, b, c, d);
    };
    Column.prototype.eq = function () {
        return this.h;
    };
    Column.prototype.ep = function () {
        return this.c;
    };
    Column.prototype.i1 = function (a, b, c, d, e) {
        if (this.columnHeaderCellsPropertyUpdating != null) {
            this.columnHeaderCellsPropertyUpdating(this, b, c, d, e);
        }
    };
    Column.prototype.iq = function (a, b) {
        this.i1(this, b.propertyName, b.animationType, b.oldValue, b.newValue);
    };
    Column.prototype.cz = function (a, b) {
        if (this.header != null) {
            this.header.grid = b;
        }
        this.i2();
        this.i2();
        this.c8();
        this.df();
        this.dg();
        this.de();
        this.db();
        this.dc();
        this.dd();
        this.i0();
        this.iz();
        this.iy();
        this.iu();
        this.ix();
        this.iw();
        this.iv();
    };
    Column.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "CellSelectedBackground":
                this.i2();
                break;
            case "CellBackground":
                this.c8();
                break;
            case "CellTextColor":
                this.df();
                break;
            case "CellTextStyle":
                this.dg();
                break;
            case "StickyRowBackground":
                this.de();
                break;
            case "LastStickyRowBackground":
                this.db();
                break;
            case "PinnedRowBackground":
                this.dc();
                break;
            case "PinnedRowOpacity":
                this.dd();
                break;
            case "ColumnOptionsIconAlignment":
                this.iu();
                break;
            case "ColumnOptionsIconColor":
                this.ix();
                break;
            case "ColumnOptionsIconBehavior":
                this.iw();
                break;
            case "IsColumnOptionsEnabled":
                this.iv();
                break;
            case "DeletedTextColor":
                this.iy();
                break;
            case "EditOpacity":
                this.i0();
                break;
            case "EditTextStyle":
                this.iz();
                break;
        }
    };
    Column.prototype.i2 = function () {
        if (this.jf == null) {
            if (this.grid != null && this.grid.tv != null) {
                this.jb = this.grid.tv;
                return;
            }
            this.jb = this.je();
        }
        else {
            this.jb = this.jf;
        }
    };
    Column.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.tu != null) {
                this.d0 = this.grid.tu;
            }
            else {
                this.d0 = this.eb();
            }
        }
        else {
            this.d0 = this.d7;
        }
    };
    Column.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.tw != null) {
                this.d6 = this.grid.tw;
                return;
            }
            this.d6 = this.eg();
        }
        else {
            this.d6 = this.ek;
        }
    };
    Column.prototype.dg = function () {
        if (this.textStyle == null) {
            if (this.grid != null && this.grid.fh != null) {
                this.ad = this.grid.fh;
                return;
            }
            this.ad = this.af();
        }
        else {
            this.ad = this.textStyle;
        }
    };
    Column.prototype.dd = function () {
        if (isNaN_(this.aw)) {
            if (this.grid != null && !isNaN_(this.grid.ja)) {
                this.at = this.grid.ja;
                return;
            }
            this.at = this.av();
        }
        else {
            this.at = this.aw;
        }
    };
    Column.prototype.iy = function () {
        if (this.jd == null) {
            if (this.grid != null && this.grid.t0 != null) {
                this.ja = this.grid.t0;
                return;
            }
            this.ja = GridStyleRepository.bi;
        }
        else {
            this.ja = this.jd;
        }
    };
    Column.prototype.i0 = function () {
        if (isNaN_(this.gl)) {
            if (this.grid != null && !isNaN_(this.grid.i9)) {
                this.gk = this.grid.i9;
                return;
            }
            this.gk = GridStyleRepository.m;
        }
        else {
            this.gk = this.gl;
        }
    };
    Column.prototype.iz = function () {
        if (this.textEditStyle == null) {
            if (this.grid != null && this.grid.fi != null) {
                this.fp = this.grid.fi;
                return;
            }
            this.fp = GridStyleRepository.k;
        }
        else {
            this.fp = this.textEditStyle;
        }
    };
    Column.prototype.dc = function () {
        if (this.ei == null) {
            if (this.grid != null && this.grid.t7 != null) {
                this.d4 = this.grid.t7;
                return;
            }
            this.d4 = this.ed();
        }
        else {
            this.d4 = this.ei;
        }
    };
    Column.prototype.de = function () {
        if (this.ej == null) {
            if (this.grid != null && this.grid.uf != null) {
                this.d5 = this.grid.uf;
                return;
            }
            this.d5 = this.ef();
        }
        else {
            this.d5 = this.ej;
        }
    };
    Column.prototype.db = function () {
        if (this.eh == null) {
            if (this.grid != null && this.grid.t6 != null) {
                this.d3 = this.grid.t6;
                return;
            }
            this.d3 = this.ec();
        }
        else {
            this.d3 = this.eh;
        }
    };
    Column.prototype.iu = function () {
        if (this.ey == 0) {
            if (this.grid != null && this.grid.bk != 0) {
                this.ex = this.grid.bk;
                return;
            }
            this.ex = GridStyleRepository.a;
        }
        else {
            this.ex = this.ey;
        }
    };
    Column.prototype.ix = function () {
        if (this.jc == null) {
            if (this.grid != null && this.grid.ty != null) {
                this.i9 = this.grid.ty;
                return;
            }
            this.i9 = GridStyleRepository.ax;
        }
        else {
            this.i9 = this.jc;
        }
    };
    Column.prototype.iw = function () {
        if (this.e2 == 0) {
            if (this.grid != null && this.grid.bm != 0) {
                this.e1 = this.grid.bm;
                return;
            }
            this.e1 = GridStyleRepository.b;
        }
        else {
            this.e1 = this.e2;
        }
    };
    Column.prototype.iv = function () {
        if (this.grid != null) {
            this.f3 = this.grid.hb && this.f9;
        }
        else {
            this.f3 = false;
        }
    };
    Column.prototype.it = function (a, b, c, d) {
        if (this.columnCellsPropertyUpdating != null) {
            this.columnCellsPropertyUpdating(this, a, b, c, d);
        }
    };
    Column.prototype.eu = function () {
        if (this.c == 0) {
            return 3;
        }
        return 2;
    };
    Column.prototype.e4 = function () {
        if (this.c == 0) {
            return 3;
        }
        return 2;
    };
    Column.prototype.et = function () {
        return 2;
    };
    Column.prototype.e3 = function () {
        return 2;
    };
    Column.prototype.hz = function () {
        return this.ic != null && this.ic != "" ? this.ic : this.hx;
    };
    Column.prototype.is = function (a, b, c) {
        if (this.fl == null) {
            this.fl = new FastIterationDictionary$2(String_$type, Base.$, 0);
        }
        var d = null;
        if (this.fl.d(a)) {
            d = this.fl.item(a);
        }
        this.fl.item(a, c);
        var e = false;
        if (d == null && c != null) {
            e = true;
        }
        if (d != null) {
            if (!Base.equalsStatic(d, c)) {
                e = true;
            }
        }
        if (e) {
            this.i1(this, a, b, d, c);
        }
    };
    Column.prototype.f6 = function () {
        if (this.fl == null) {
            return false;
        }
        return this.fl.r > 0;
    };
    Object.defineProperty(Column.prototype, "fm", {
        get: function () {
            return this.fl;
        },
        enumerable: true,
        configurable: true
    });
    Column.prototype.f5 = function (a) {
        if (this.fl == null) {
            return false;
        }
        return this.fl.d(a);
    };
    Column.prototype.ir = function (a) {
        if (this.fl == null) {
            return;
        }
        if (this.fl.d(a)) {
            this.fl.f(a);
        }
    };
    Column.prototype.g5 = function (a) {
        if (this.fl == null) {
            return null;
        }
        if (this.fl.d(a)) {
            return this.fl.item(a);
        }
        return null;
    };
    Column.$t = markType(Column, 'Column', DefinitionBase.$);
    Column.g1 = 0;
    return Column;
}(DefinitionBase));
export { Column };
/**
 * @hidden
 */
var GridColumnCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnCollection, _super);
    function GridColumnCollection() {
        return _super.call(this, Column.$, 0) || this;
    }
    GridColumnCollection.$t = markType(GridColumnCollection, 'GridColumnCollection', ObservableCollection$1.$.specialize(Column.$));
    return GridColumnCollection;
}(ObservableCollection$1));
export { GridColumnCollection };
/**
 * @hidden
 */
var GridEffectGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridEffectGroup, _super);
    function GridEffectGroup(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.f = 0;
        _this.a = false;
        _this.b = false;
        _this.effectsFinished = null;
        _this.effectsCanceled = null;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0:
                {
                    var c = _rest[0];
                    _this.a = c;
                    _this.c = new List$1(GridEffect.$, 0);
                    _this.b = false;
                }
                break;
            case 1:
                {
                    var c = [true];
                    {
                        var e = c[0];
                        _this.a = e;
                        _this.c = new List$1(GridEffect.$, 0);
                        _this.b = false;
                    }
                }
                break;
        }
        return _this;
    }
    GridEffectGroup.prototype.k = function () {
        this.b = false;
        for (var a = 0; a < this.c.count; a++) {
            var b = this.c._inner[a];
            b.onFinished = delegateRemove(b.onFinished, runOn(this, this.i));
            var c = this.c._inner[a];
            c.onCanceled = delegateRemove(c.onCanceled, runOn(this, this.h));
        }
        this.f = 0;
        this.c.clear();
    };
    GridEffectGroup.prototype.g = function (a) {
        this.c.add(a);
        a.onFinished = delegateCombine(a.onFinished, runOn(this, this.i));
        a.onCanceled = delegateCombine(a.onCanceled, runOn(this, this.h));
    };
    GridEffectGroup.prototype.h = function (a, b) {
        this.b = true;
        this.f++;
        if (this.f == this.c.count) {
            this.j();
        }
    };
    GridEffectGroup.prototype.i = function (a) {
        this.f++;
        if (this.f == this.c.count) {
            this.j();
        }
    };
    GridEffectGroup.prototype.j = function () {
        if (this.b) {
            if (this.effectsCanceled != null) {
                this.effectsCanceled(this, new EventArgs());
            }
        }
        else {
            if (this.effectsFinished != null) {
                this.effectsFinished(this, new EventArgs());
            }
        }
        if (this.a) {
            this.k();
        }
    };
    GridEffectGroup.$t = markType(GridEffectGroup, 'GridEffectGroup');
    return GridEffectGroup;
}(Base));
export { GridEffectGroup };
/**
 * @hidden
 */
var RecyclingManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RecyclingManager, _super);
    function RecyclingManager() {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.b = new Dictionary$2(String_$type, Stack$1.$.specialize(CellModel.$), 0);
        return _this;
    }
    RecyclingManager.prototype.a = function (a) {
        if (!this.b.containsKey(a)) {
            this.b.addItem(a, new Stack$1(CellModel.$));
            return null;
        }
        var b = this.b.item(a);
        if (b.f > 0) {
            var c = b.e();
            if (c.t == 2) {
                c.t = 1;
            }
            return c;
        }
        return null;
    };
    RecyclingManager.prototype.c = function (a) {
        a.t = 1;
        if (!this.b.containsKey(a.ir)) {
            this.b.addItem(a.ir, new Stack$1(CellModel.$));
        }
        this.b.item(a.ir).h(a);
    };
    RecyclingManager.$t = markType(RecyclingManager, 'RecyclingManager');
    return RecyclingManager;
}(Base));
export { RecyclingManager };
/**
 * @hidden
 */
var ActivationManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ActivationManager, _super);
    function ActivationManager(a, b) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = null;
        _this.c = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.e = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.d = new FastIterationDictionary$2(Number_$type, String_$type, 0);
        _this.f = new FastIterationDictionary$2(String_$type, Number_$type, 0);
        _this.k = false;
        _this.l = false;
        _this.q = -1;
        _this.s = -1;
        _this.p = -1;
        _this.a = a;
        _this.b = b;
        return _this;
    }
    Object.defineProperty(ActivationManager.prototype, "g", {
        get: function () {
            if (this.k) {
                this.z();
                this.k = false;
            }
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivationManager.prototype, "i", {
        get: function () {
            if (this.k) {
                this.z();
                this.k = false;
            }
            return this.e;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivationManager.prototype, "h", {
        get: function () {
            if (this.k) {
                this.z();
                this.k = false;
            }
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivationManager.prototype, "j", {
        get: function () {
            if (this.k) {
                this.z();
                this.k = false;
            }
            return this.f;
        },
        enumerable: true,
        configurable: true
    });
    ActivationManager.prototype.ai = function (a) {
        if (!a.k.ag) {
            return;
        }
        if (this.m(a)) {
            this.ac(a);
        }
        else {
            this.x(a);
        }
    };
    ActivationManager.prototype.m = function (a) {
        var b = false;
        var c = this.a.d3.getDataRow(a.k);
        if (c == -1) {
            return false;
        }
        if (this.q < 0) {
            return false;
        }
        if (c != this.q) {
            return false;
        }
        if (typeCast(SectionHeaderCellModel.$, a) !== null) {
            return true;
        }
        if (this.i.d(a.k.ax)) {
            var d = this.i.item(a.k.ax);
            if (d >= 0) {
                b = this.n(c, d);
            }
        }
        return b;
    };
    ActivationManager.prototype.n = function (a, b) {
        return this.q == a && b == this.s;
    };
    ActivationManager.prototype.o = function () {
        return this.a.ch == 1;
    };
    ActivationManager.prototype.aa = function () {
        if (this.q >= 0 && this.s >= 0) {
            this.ab(this.q, this.s, true);
        }
    };
    ActivationManager.prototype.ac = function (a) {
        var b = this.a.d3.getDataRow(a.k);
        if (b == -1) {
            return;
        }
        if (this.i.d(a.k.ax)) {
            var c = this.i.item(a.k.ax);
            if (this.n(b, c)) {
                this.ab(b, c, true);
            }
        }
    };
    ActivationManager.prototype.x = function (a) {
        this.w(a.k);
    };
    ActivationManager.prototype.w = function (a) {
        if (!a.ag) {
            return;
        }
        if (!this.o()) {
            return;
        }
        if (this.q >= 0 && this.s != null) {
            this.ab(this.q, this.s, false);
        }
        var b = this.a.d3.getDataRow(a);
        if (b == -1) {
            return;
        }
        if (a.ax == -400) {
            if (this.q != b) {
                this.v(b, 0);
            }
        }
        if (this.i.d(a.ax)) {
            var c = this.i.item(a.ax);
            if (!this.n(b, c)) {
                this.u(b, c);
            }
        }
    };
    ActivationManager.prototype.y = function (a, b) {
        var c = this.s;
        if (b == null) {
            if (this.a.dt != 1) {
                var d = this.a.d3.getRowType(a);
                if (this.a.d3.isRowSpanning(d) && this.s == -1) {
                    c = this.i.item(0);
                }
            }
        }
        else if (this.j.d(b)) {
            c = this.j.item(b);
        }
        if (c != -1) {
            if (this.q >= 0 && this.s >= 0) {
                if (a != this.q || c != this.s) {
                    this.ab(this.q, this.s, false);
                    this.u(a, c);
                }
            }
            else if (this.q == -1 && this.s == -1) {
                this.u(a, c);
            }
        }
    };
    ActivationManager.prototype.v = function (a, b) {
        if (!this.i.d(b)) {
            return;
        }
        var c = this.i.item(b);
        if (a != this.q || c != this.s) {
            this.q = a;
            this.s = c;
            this.p = b;
            if (a >= 0 && b >= 0) {
                if (a >= 0 && a < this.a.d3.getRowCount()) {
                    if (this.a.dt != 1) {
                        var d = this.a.d3.getRowType(a);
                        if (this.a.d3.isRowSpanning(d)) {
                            b = -400;
                            c = -400;
                        }
                    }
                }
                this.b.z(this.a, a, b, c);
            }
            this.a.p0(a, this.t(c));
        }
    };
    ActivationManager.prototype.u = function (a, b) {
        if (!this.g.d(b)) {
            return;
        }
        var c = this.g.item(b);
        if (a != this.q || b != this.s) {
            this.q = a;
            this.s = b;
            this.p = c;
            if (a >= 0 && c >= 0) {
                if (a >= 0 && a < this.a.d3.getRowCount()) {
                    if (this.a.dt != 1) {
                        var d = this.a.d3.getRowType(a);
                        if (this.a.d3.isRowSpanning(d)) {
                            c = -400;
                            b = -400;
                        }
                    }
                }
                this.b.z(this.a, a, c, b);
            }
            this.a.p0(a, this.t(b));
        }
    };
    ActivationManager.prototype.ab = function (a, b, c) {
        if (this.n(a, b)) {
            this.s = -1;
            this.q = -1;
            this.p = -1;
            if (a >= 0) {
                if (this.g.d(b)) {
                    var d = this.g.item(b);
                    if (d >= 0) {
                        if (a >= 0 && a < this.a.d3.getRowCount()) {
                            if (this.a.dt != 1) {
                                var e = this.a.d3.getRowType(a);
                                if (this.a.d3.isRowSpanning(e)) {
                                    d = -400;
                                    b = -400;
                                }
                            }
                        }
                        this.b.aa(this.a, a, d, b);
                    }
                }
            }
            if (c) {
                this.a.p2(a, this.t(b));
            }
        }
    };
    ActivationManager.prototype.ae = function () {
        this.q = -1;
        this.s = -1;
        this.p = -1;
    };
    ActivationManager.prototype.af = function (a) {
    };
    ActivationManager.prototype.ag = function (a) {
    };
    ActivationManager.prototype.t = function (a) {
        if (!this.h.d(a)) {
            return null;
        }
        return this.h.item(a);
    };
    ActivationManager.prototype.ah = function (a) {
    };
    ActivationManager.prototype.ad = function () {
        this.k = true;
    };
    ActivationManager.prototype.z = function () {
        this.c.u();
        this.e.u();
        this.d.u();
        this.f.u();
        for (var a = 0; a < this.a.actualColumns.count; a++) {
            this.c.s(this.a.actualColumns._inner[a].g2, a);
            this.e.s(a, this.a.actualColumns._inner[a].g2);
            this.d.s(this.a.actualColumns._inner[a].g2, this.a.actualColumns._inner[a].hz());
            this.f.s(this.a.actualColumns._inner[a].hz(), this.a.actualColumns._inner[a].g2);
        }
    };
    ActivationManager.prototype.r = function () {
        if (this.g.d(this.s)) {
            return this.g.item(this.s);
        }
        if (this.p != -1) {
            return this.p;
        }
        return 0;
    };
    ActivationManager.$t = markType(ActivationManager, 'ActivationManager');
    return ActivationManager;
}(Base));
export { ActivationManager };
/**
 * @hidden
 */
var SelectionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SelectionManager, _super);
    function SelectionManager(a, b) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = null;
        _this.f = new FastIterationDictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        _this.e = new FastIterationDictionary$2(PrimaryKeyValue.$, FastIterationDictionary$2.$.specialize(Number_$type, Number_$type), 0);
        _this.c = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.d = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
        _this.i = false;
        _this.r = new List$1(CellRange.$, 0);
        _this.q = new List$1(CellRange.$, 0);
        _this.j = false;
        _this.a = a;
        _this.b = b;
        return _this;
    }
    Object.defineProperty(SelectionManager.prototype, "g", {
        get: function () {
            if (this.i) {
                this.v();
                this.i = false;
            }
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectionManager.prototype, "h", {
        get: function () {
            if (this.i) {
                this.v();
                this.i = false;
            }
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    SelectionManager.prototype.an = function (a) {
        if (!a.k.ag) {
            return;
        }
        if (this.o(a)) {
            this.aq(a);
        }
        else {
            this.aj(a);
        }
    };
    SelectionManager.prototype.am = function (a) {
        if (!a.k.ag) {
            return;
        }
        this.j = true;
        this.aj(a);
        this.j = false;
    };
    SelectionManager.prototype.o = function (a) {
        var b = this.a.d3.getDataRow(a.k);
        if (b == -1) {
            return false;
        }
        if (this.a.d3.isPlaceholderItem(b)) {
            return false;
        }
        var c = this.a.d3.getRowKey(this.a.i(), b);
        if (c == null) {
            return false;
        }
        var d = this.f.d(c);
        if (d) {
            var e = this.f.item(c);
            if (e == -1) {
                this.f.item(c, b);
            }
            var f = this.a.d3.resolveValueForRow(a.k);
            var g = this.a.ah.indexOf(c);
            if (g >= 0) {
                if (this.a.ad.ae._inner[g] == null) {
                    this.a.rc(g, f, c);
                }
            }
        }
        if (!d) {
            if (this.h.d(a.k.ax)) {
                var h = this.h.item(a.k.ax);
                if (h >= 0) {
                    d = this.k(c, h);
                    if (d && this.e.item(c).item(h) == -1) {
                        this.e.item(c).item(h, b);
                    }
                }
            }
        }
        if (!d) {
            if (a.k.ax >= 0) {
                var i = this.a.model.br._inner[a.k.ax];
                for (var j = 0; j < this.q.count; j++) {
                    if (this.q._inner[j].b(a.k.w, i.n)) {
                        d = true;
                        break;
                    }
                }
            }
        }
        if (!d) {
            if (this.a.d3.isRowPinned(b)) {
                var k = typeCast(DataSourceSpecialRow.$, c.value[0]);
                if (k != null) {
                    var l = this.a.d3.getItemKey(this.a.i(), k.targetRow);
                    d = this.f.d(l);
                    if (!d) {
                        if (this.h.d(a.k.ax)) {
                            var m = this.h.item(a.k.ax);
                            if (m >= 0) {
                                d = this.k(l, m);
                            }
                        }
                    }
                }
            }
        }
        return d;
    };
    SelectionManager.prototype.m = function (a) {
        return this.f.d(a);
    };
    SelectionManager.prototype.k = function (a, b) {
        return this.e.d(a) && this.e.item(a).d(b);
    };
    SelectionManager.prototype.n = function () {
        return this.a.dn == 1 || this.a.dn == 2;
    };
    SelectionManager.prototype.l = function () {
        return this.a.dn == 3 || this.a.dn == 4;
    };
    SelectionManager.prototype.aq = function (a) {
        var b = this.a.d3.getDataRow(a.k);
        if (b == -1) {
            return;
        }
        if (this.a.d3.isPlaceholderItem(b)) {
            return;
        }
        var c = this.a.d3.getRowKey(this.a.i(), b);
        if (this.m(c)) {
            this.ar(c, b, false);
        }
        if (this.h.d(a.k.ax)) {
            var d = this.h.item(a.k.ax);
            if (this.k(c, d)) {
                this.ao(c, b, d);
            }
        }
    };
    SelectionManager.prototype.aj = function (a) {
        if (this.a.dn == 0) {
            return;
        }
        if (this.a.dn == 1 || this.j) {
            var b = this.f.o;
            var c = this.f.p;
            var d = new List$1(PrimaryKeyValue.$, 0);
            var e = new List$1(Number_$type, 0);
            for (var f = 0; f < b.count; f++) {
                if (c._inner[f]) {
                    continue;
                }
                d.add(b._inner[f]);
                e.add(this.f.q._inner[f]);
            }
            for (var g = 0; g < d.count; g++) {
                this.ar(d._inner[g], e._inner[g], false);
            }
        }
        if (this.a.dn == 3 || this.j) {
            var h = this.e.o;
            var i = this.e.p;
            var j = new List$1(PrimaryKeyValue.$, 0);
            var k = new List$1(Number_$type, 0);
            var l = new List$1(Number_$type, 0);
            for (var m = 0; m < h.count; m++) {
                if (i._inner[m]) {
                    continue;
                }
                var n = h._inner[m];
                var o = this.e.item(n).o;
                var p = this.e.item(n).q;
                var q = this.e.item(n).p;
                for (var r = 0; r < o.count; r++) {
                    if (q._inner[r]) {
                        continue;
                    }
                    var s = o._inner[r];
                    var t = p._inner[r];
                    if (this.h.d(a.k.ax) && this.h.item(a.k.ax) == s && a.k.w == t) {
                        continue;
                    }
                    j.add(n);
                    k.add(s);
                    l.add(t);
                }
            }
            for (var u = 0; u < j.count; u++) {
                this.ao(j._inner[u], l._inner[u], k._inner[u]);
            }
        }
        var v = this.a.d3.getDataRow(a.k);
        if (v == -1) {
            return;
        }
        if (this.a.d3.isPlaceholderItem(v)) {
            return;
        }
        var w = this.a.d3.getRowKey(this.a.i(), v);
        if (w == null) {
            return;
        }
        if (this.n()) {
            this.ak(w, v, false);
        }
        else if (this.l()) {
            this.ai(w, v, a.k.ax);
        }
    };
    SelectionManager.prototype.ak = function (a, b, c) {
        var d = true;
        var e = false;
        if (!c) {
            if (this.a.d3.getRowType(b) == 3) {
                var f = typeCast(DataSourceSpecialRow.$, a.value[0]);
                if (f.targetRow != null) {
                    var g = this.a.d3.getItemKey(this.a.i(), f.targetRow);
                    var h = this.a.d3.indexOfVisibleItemByKey(this.a.i(), g, this.a.kh(), this.a.kl());
                    this.al(g, h, f.targetRow, true);
                }
                e = true;
                d = false;
            }
        }
        var i = null;
        if (!e) {
            i = this.a.d3.resolveValueForDataRow(b);
            if (this.a.ag.contains(a)) {
                var j = this.s(a);
                if (j >= 0) {
                    var k = this.a.d3.getRowKey(this.a.i(), j);
                    if (!this.m(k)) {
                        this.al(k, j, null, false);
                    }
                }
            }
        }
        this.al(a, b, i, d);
    };
    SelectionManager.prototype.al = function (a, b, c, d) {
        if (!this.f.d(a)) {
            this.f.s(a, b);
            if (b >= 0) {
                this.b.am(this.a, b);
            }
        }
        if (d && c != null) {
            this.a.q9(c, a);
        }
    };
    SelectionManager.prototype.as = function (a, b, c, d) {
        if (this.f.d(a)) {
            this.f.f(a);
            if (b >= 0) {
                var e = this.a.d3.getRowKey(this.a.i(), b);
                if (e != null && e.equals(a) && b >= 0) {
                    this.b.an(this.a, b);
                }
            }
        }
        if (d && c != null) {
            this.a.ra(c, a);
        }
    };
    SelectionManager.prototype.ar = function (a, b, c) {
        var d = true;
        var e = false;
        if (!c) {
            if (this.a.d3.getRowType(b) == 3) {
                var f = typeCast(DataSourceSpecialRow.$, a.value[0]);
                if (f.targetRow != null) {
                    var g = this.a.d3.getItemKey(this.a.i(), f.targetRow);
                    var h = this.a.d3.indexOfVisibleItemByKey(this.a.i(), g, this.a.kh(), this.a.kl());
                    this.as(g, h, f.targetRow, true);
                }
                e = true;
                d = false;
            }
        }
        var i = null;
        if (!e) {
            i = this.a.d3.resolveValueForDataRow(b);
            if (this.a.ag.contains(a)) {
                var j = this.s(a);
                if (j >= 0) {
                    var k = this.a.d3.getRowKey(this.a.i(), j);
                    if (this.m(k)) {
                        this.as(k, j, null, false);
                    }
                }
            }
        }
        this.as(a, b, i, d);
    };
    SelectionManager.prototype.ai = function (a, b, c) {
        if (!this.h.d(c)) {
            return;
        }
        var d = this.h.item(c);
        var e = true;
        if (this.a.d3.getRowType(b) == 3) {
            var f = typeCast(DataSourceSpecialRow.$, a.value[0]);
            if (f.targetRow != null) {
                var g = this.a.d3.getItemKey(this.a.i(), f.targetRow);
                var h = this.a.d3.indexOfVisibleItemByKey(this.a.i(), g, this.a.kh(), this.a.kl());
                this.ag(g, d, c, h, true);
            }
            e = false;
        }
        else {
            if (this.a.ag.contains(a)) {
                var i = this.s(a);
                if (i >= 0) {
                    var j = this.a.d3.getRowKey(this.a.i(), i);
                    if (!this.k(j, d)) {
                        this.ag(j, d, c, i, false);
                    }
                }
            }
        }
        this.ag(a, d, c, b, e);
    };
    SelectionManager.prototype.ah = function (a, b, c) {
        if (!this.g.d(c)) {
            return;
        }
        var d = this.g.item(c);
        if (!this.e.d(a)) {
            var e = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
            e.s(c, b);
            this.e.s(a, e);
            if (b >= 0 && d >= 0) {
                this.b.ad(this.a, b, d, c);
            }
            this.a.qb(a, c);
        }
        else {
            if (!this.e.item(a).d(c)) {
                this.e.item(a).s(c, b);
                if (b >= 0) {
                    this.b.ad(this.a, b, d, c);
                }
                this.a.qb(a, c);
            }
        }
    };
    SelectionManager.prototype.ag = function (a, b, c, d, e) {
        if (!this.e.d(a)) {
            if (b >= 0) {
                var f = new FastIterationDictionary$2(Number_$type, Number_$type, 0);
                f.s(b, d);
                this.e.s(a, f);
                if (d >= 0) {
                    this.b.ad(this.a, d, c, b);
                }
                if (e) {
                    this.a.qb(a, b);
                }
            }
        }
        else {
            if (!this.e.item(a).d(b)) {
                this.e.item(a).s(b, d);
                if (d >= 0) {
                    this.b.ad(this.a, d, c, b);
                }
                if (e) {
                    this.a.qb(a, b);
                }
            }
        }
    };
    SelectionManager.prototype.ap = function (a, b, c, d) {
        if (this.k(a, c)) {
            this.e.item(a).f(c);
            if (this.e.item(a).r == 0) {
                this.e.f(a);
            }
            if (b >= 0) {
                var e = this.a.d3.getRowKey(this.a.i(), b);
                if (e != null && e.equals(a) && b >= 0) {
                    if (this.g.d(c)) {
                        var f = this.g.item(c);
                        if (f >= 0) {
                            this.b.ae(this.a, b, f, c);
                        }
                    }
                }
            }
            if (d) {
                this.a.qc(a, c);
            }
        }
    };
    SelectionManager.prototype.ao = function (a, b, c) {
        var d = true;
        if (this.a.d3.getRowType(b) == 3) {
            var e = typeCast(DataSourceSpecialRow.$, a.value[0]);
            if (e.targetRow != null) {
                var f = this.a.d3.getItemKey(this.a.i(), e.targetRow);
                var g = this.a.d3.indexOfVisibleItemByKey(this.a.i(), f, this.a.kh(), this.a.kl());
                this.ap(f, g, c, true);
            }
            d = false;
        }
        else {
            if (this.a.ag.contains(a)) {
                var h = this.s(a);
                if (h >= 0) {
                    var i = this.a.d3.getRowKey(this.a.i(), h);
                    if (this.k(i, c)) {
                        this.ap(i, h, c, false);
                    }
                }
            }
        }
        this.ap(a, b, c, d);
    };
    SelectionManager.prototype.s = function (a) {
        var b = -1;
        var c = this.a.d3.getStickyRows();
        if (c != null) {
            for (var d = 0; d < c.length; d++) {
                var e = typeCast(DataSourceSpecialRow.$, this.a.actualDataSource.getItemAtIndex(c[d]));
                if (e != null && e.rowType == 3) {
                    var f = this.a.d3.getItemKey(this.a.i(), e.targetRow);
                    if (f != null && f.equals(a)) {
                        b = c[d];
                        break;
                    }
                }
            }
        }
        return b;
    };
    SelectionManager.prototype.av = function () {
        var a = this.p();
        var b = new Dictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        for (var c = 0; c < a.count; c++) {
            var d = a.item(c);
            var e = -1;
            if (this.f.d(d)) {
                e = this.f.item(d);
            }
            if (e == -1) {
                e = this.a.d3.indexOfVisibleItemByKey(this.a.i(), d, this.a.kh(), this.a.kl());
            }
            if (this.a.ag.contains(d)) {
                var f = this.s(d);
                if (f >= 0) {
                    var g = this.a.d3.getRowKey(this.a.i(), f);
                    if (!b.containsKey(g)) {
                        b.addItem(g, f);
                    }
                    if (!this.m(g)) {
                        this.ak(g, f, true);
                    }
                }
            }
            if (!b.containsKey(d)) {
                b.addItem(d, e);
            }
            if (!this.m(d)) {
                this.ak(d, e, true);
            }
        }
        var h = this.f.o;
        var i = this.f.p;
        var j = new List$1(PrimaryKeyValue.$, 0);
        var k = new List$1(Number_$type, 0);
        for (var l = 0; l < h.count; l++) {
            if (i._inner[l]) {
                continue;
            }
            var m = h._inner[l];
            if (!b.containsKey(m)) {
                j.add(m);
                k.add(this.f.q._inner[l]);
            }
        }
        for (var n = 0; n < k.count; n++) {
            this.ar(j._inner[n], k._inner[n], false);
        }
        for (var o = 0; o < this.a.ad.ae.count; o++) {
            var p = this.a.d3.getItemKey(this.a.i(), this.a.ad.ae._inner[o]);
            if (p != null && !b.containsKey(p)) {
                var q = -1;
                if (this.f.d(p)) {
                    q = this.f.item(p);
                }
                if (q == -1) {
                    q = this.a.d3.fastGetItemIndexForKey(this.a.i(), p, this.a.kh(), this.a.kl());
                }
                this.ar(p, q, false);
            }
        }
    };
    SelectionManager.prototype.au = function () {
        var a = this.a.dh.am;
        var b = new Dictionary$2(PrimaryKeyValue.$, IList$1_$type.specialize(Number_$type), 0);
        var _loop_1 = function (c) {
            var d = a.item(c).primaryKey;
            if (d == null) {
                return "continue";
            }
            if (a.item(c).b == null) {
                return "continue";
            }
            var e = a.item(c).b.g2;
            var f = -1;
            if (this_1.k(d, e)) {
                f = this_1.e.item(d).item(e);
            }
            if (f == -1) {
                var g = this_1.a.kh();
                var h = this_1.a.kl();
                if (g != -1 && h != -1) {
                    f = this_1.a.d3.indexOfVisibleItemByKey(this_1.a.i(), d, g, h);
                }
            }
            if (this_1.a.ag.contains(d)) {
                var i = this_1.s(d);
                if (i >= 0) {
                    var j = this_1.a.d3.getRowKey(this_1.a.i(), i);
                    if (!b.containsKey(j)) {
                        b.addItem(j, ((function () {
                            var $ret = new List$1(Number_$type, 0);
                            $ret.add(e);
                            return $ret;
                        })()));
                    }
                    else if (!b.item(j).contains(e)) {
                        b.item(j).add(e);
                    }
                    if (!this_1.k(j, e)) {
                        this_1.ah(j, f, e);
                    }
                }
            }
            if (!b.containsKey(d)) {
                b.addItem(d, ((function () {
                    var $ret = new List$1(Number_$type, 0);
                    $ret.add(e);
                    return $ret;
                })()));
            }
            else if (!b.item(d).contains(e)) {
                b.item(d).add(e);
            }
            if (!this_1.k(d, e)) {
                this_1.ah(d, f, e);
            }
        };
        var this_1 = this;
        for (var c = 0; c < a.count; c++) {
            _loop_1(c);
        }
        var k = this.e.o;
        var l = this.e.p;
        var m = new List$1(PrimaryKeyValue.$, 0);
        var n = new List$1(Number_$type, 0);
        var o = new List$1(Number_$type, 0);
        for (var p = 0; p < k.count; p++) {
            if (l._inner[p]) {
                continue;
            }
            var q = k._inner[p];
            for (var r = 0; r < this.e.item(q).r; r++) {
                var s = this.e.item(q).o._inner[r];
                var t = this.e.item(q).q._inner[r];
                if (!b.containsKey(q) || !b.item(q).contains(s)) {
                    m.add(q);
                    n.add(s);
                    o.add(t);
                }
            }
        }
        for (var u = 0; u < m.count; u++) {
            this.ao(m._inner[u], o._inner[u], n._inner[u]);
        }
    };
    SelectionManager.prototype.at = function () {
        var a = this.a.de.ae;
        this.r.clear();
        this.r = this.q;
        this.q = new List$1(CellRange.$, 0);
        for (var b = 0; b < a.count; b++) {
            this.q.add(a.item(b).a());
        }
        var c = this.a.d3.getStickyRows();
        if (c != null) {
            for (var d = 0; d < c.length; d++) {
                var e = this.a.d3.getRowType(c[d]);
                if (e == 3) {
                    for (var f = 0; f < this.a.model.bx.count; f++) {
                        var g = this.a.model.bx._inner[f];
                        var h = this.a.model.br._inner[g].n;
                        this.u(c[d], h);
                    }
                }
            }
        }
        var i = this.a.kh();
        var j = this.a.kl();
        for (var k = i; k <= j; k++) {
            for (var l = 0; l < this.a.model.bx.count; l++) {
                var m = this.a.model.bx._inner[l];
                var n = this.a.model.br._inner[m].n;
                this.u(k, n);
            }
        }
    };
    SelectionManager.prototype.u = function (a, b) {
        var c = false;
        var d = false;
        for (var e = 0; e < this.r.count; e++) {
            var f = this.r._inner[e];
            if (f.b(a, b)) {
                c = true;
            }
        }
        for (var g = 0; g < this.q.count; g++) {
            var h = this.q._inner[g];
            if (h.b(a, b)) {
                d = true;
            }
        }
        if (c && !d) {
            var i = this.a.ey.j(b, this.a.model);
            this.a.ck.ac(this.a, a, i);
        }
        else if (!c && d) {
            var j = this.a.ey.j(b, this.a.model);
            this.a.ck.ab(this.a, a, j);
        }
    };
    SelectionManager.prototype.p = function () {
        return this.a.ah.ae;
    };
    SelectionManager.prototype.z = function () {
        this.y();
        this.x();
    };
    SelectionManager.prototype.ad = function (a) {
        for (var b = 0; b < this.f.o.count; b++) {
            if (this.f.p._inner[b]) {
                continue;
            }
            var c = this.f.o._inner[b];
            var d = this.f.q._inner[b];
            if (d >= a) {
                this.f.item(c, d + 1);
            }
        }
        for (var e = 0; e < this.e.o.count; e++) {
            if (this.e.p._inner[e]) {
                continue;
            }
            var f = this.e.o._inner[e];
            var g = this.e.q._inner[e];
            for (var h = 0; h < g.o.count; h++) {
                if (this.e.item(f).p._inner[h]) {
                    continue;
                }
                var i = g.o._inner[h];
                var j = this.e.item(f).item(i);
                if (j >= a) {
                    this.e.item(f).item(i, j + 1);
                }
            }
        }
    };
    SelectionManager.prototype.ae = function (a) {
        var b = new List$1(PrimaryKeyValue.$, 0);
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < this.f.o.count; d++) {
            if (this.f.p._inner[d]) {
                continue;
            }
            var e = this.f.o._inner[d];
            var f = this.f.q._inner[d];
            if (f == a) {
                b.add(e);
                c.add(f);
            }
            if (f > a) {
                this.f.item(e, f - 1);
            }
        }
        for (var g = 0; g < b.count; g++) {
            this.ar(b._inner[g], c._inner[g], true);
        }
        for (var h = 0; h < this.e.o.count; h++) {
            if (this.e.p._inner[h]) {
                continue;
            }
            var i = this.e.o._inner[h];
            var j = this.e.q._inner[h];
            for (var k = 0; k < j.o.count; k++) {
                if (this.e.item(i).p._inner[k]) {
                    continue;
                }
                var l = j.o._inner[k];
                var m = this.e.item(i).item(l);
                if (m == a) {
                    this.e.item(i).item(l, -1);
                }
                if (m > a) {
                    this.e.item(i).item(l, m - 1);
                }
            }
        }
    };
    SelectionManager.prototype.ac = function (a, b) {
        var c = this.a.kh();
        var d = this.a.kl();
        var e = new List$1(Number_$type, 0);
        for (var f = 0; f < this.q.count; f++) {
            var g = this.q._inner[f];
            if (g.l > d || g.j < c) {
                continue;
            }
            if (a < g.k) {
                this.t(e, g.k - 1);
            }
            if (a <= g.i) {
                this.t(e, g.i);
            }
        }
        for (var h = 0; h < e.count; h++) {
            if (e._inner[h] >= 0 && e._inner[h] <= this.a.actualColumns.count) {
                this.a.ck.af(this.a, c, d, e._inner[h], true);
            }
        }
    };
    SelectionManager.prototype.aa = function (a, b) {
        var c = this.a.kh();
        var d = this.a.kl();
        var e = new List$1(Number_$type, 0);
        for (var f = 0; f < this.q.count; f++) {
            var g = this.q._inner[f];
            if (g.l > d || g.j < c) {
                continue;
            }
            if (a < g.k) {
                this.t(e, g.k);
            }
            if (a <= g.i) {
                this.t(e, g.i + 1);
            }
        }
        for (var h = 0; h < e.count; h++) {
            if (e._inner[h] >= 0 && e._inner[h] <= this.a.actualColumns.count) {
                this.a.ck.af(this.a, c, d, e._inner[h], true);
            }
        }
    };
    SelectionManager.prototype.ab = function (a, b, c) {
        var d = this.a.kh();
        var e = this.a.kl();
        var f = new List$1(Number_$type, 0);
        for (var g = 0; g < this.q.count; g++) {
            var h = this.q._inner[g];
            if (h.l > e || h.j < d) {
                continue;
            }
            if (h.c(a) && !h.c(b)) {
                this.t(f, b);
                if (b > h.i) {
                    this.t(f, h.i);
                }
                else if (b < h.k) {
                    this.t(f, h.k);
                }
            }
            else if (!h.c(a) && h.c(b)) {
                this.t(f, b);
                if (a > h.i) {
                    this.t(f, h.i + 1);
                }
                else if (a < h.k) {
                    this.t(f, h.k - 1);
                }
            }
            else if (!h.c(a) && !h.c(b)) {
                if (a < h.k && b > h.i) {
                    this.t(f, h.k - 1);
                    this.t(f, h.i);
                }
                if (a > h.i && b < h.k) {
                    this.t(f, h.k);
                    this.t(f, h.i + 1);
                }
            }
        }
        for (var i = 0; i < f.count; i++) {
            this.a.ck.af(this.a, d, e, f._inner[i], true);
        }
    };
    SelectionManager.prototype.t = function (a, b) {
        if (b < 0 || b >= this.a.actualColumns.count) {
            return;
        }
        if (!a.contains(b)) {
            a.add(b);
        }
    };
    SelectionManager.prototype.af = function (a) {
        var b = new List$1(PrimaryKeyValue.$, 0);
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < this.f.o.count; d++) {
            if (this.f.p._inner[d]) {
                continue;
            }
            var e = this.f.o._inner[d];
            var f = this.f.q._inner[d];
            if (f == a) {
                b.add(e);
                c.add(f);
            }
        }
        for (var g = 0; g < b.count; g++) {
            this.ar(b._inner[g], c._inner[g], true);
        }
    };
    SelectionManager.prototype.w = function () {
        this.i = true;
    };
    SelectionManager.prototype.v = function () {
        this.c.u();
        this.d.u();
        for (var a = 0; a < this.a.actualColumns.count; a++) {
            this.c.s(this.a.actualColumns._inner[a].g2, a);
            this.d.s(a, this.a.actualColumns._inner[a].g2);
        }
    };
    SelectionManager.prototype.y = function () {
        var a = new List$1(Number_$type, 0);
        var b = new HashSet$1(Number_$type, 0);
        for (var c = 0; c < this.f.o.count; c++) {
            if (this.f.p._inner[c]) {
                continue;
            }
            var d = this.f.o._inner[c];
            a.add(this.f.item(d));
            var e = this.a.d3.indexOfVisibleItemByKey(this.a.i(), d, this.a.kh(), this.a.kl());
            b.add_1(e);
            this.f.item(d, -1);
        }
        for (var f = 0; f < a.count; f++) {
            if (!b.contains(a._inner[f])) {
                this.a.ck.an(this.a, a._inner[f]);
            }
        }
    };
    SelectionManager.prototype.x = function () {
        var a = new FastIterationDictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        var b = new FastIterationDictionary$2(PrimaryKeyValue.$, Number_$type, 0);
        var c = new List$1(Number_$type, 0);
        for (var d = 0; d < this.e.q.count; d++) {
            var e = this.e.o._inner[d];
            var f = this.a.d3.indexOfVisibleItemByKey(this.a.i(), e, this.a.kh(), this.a.kl());
            var g = this.e.q._inner[d];
            for (var h = 0; h < g.q.count; h++) {
                var i = g.o._inner[h];
                if (!a.d(e)) {
                    a.s(e, this.e.item(e).item(i));
                    b.s(e, f);
                }
                c.add(i);
                this.e.item(e).item(i, -1);
            }
        }
        for (var j = 0; j < a.q.count; j++) {
            var k = a.o._inner[j];
            var l = a.q._inner[j];
            var m = b.q._inner[j];
            if (l > -1 && l < this.a.d3.getRowCount()) {
                var n = this.a.actualDataSource.getItemAtIndex(l);
                var o = typeCast(DataSourceSpecialRow.$, n);
                if (o != null && o.rowType == 3) {
                    var p = this.a.d3.getItemKey(this.a.i(), o.targetRow);
                    if (p.equals(k)) {
                        continue;
                    }
                }
            }
            if (!b.q.contains(l)) {
                this.a.ck.ae(this.a, l, this.c.item(c._inner[j]), c._inner[j]);
            }
        }
    };
    SelectionManager.$t = markType(SelectionManager, 'SelectionManager');
    return SelectionManager;
}(Base));
export { SelectionManager };
/**
 * @hidden
 */
var SortManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SortManager, _super);
    function SortManager(a) {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.e = false;
        _this.c = a;
        return _this;
    }
    SortManager.prototype.d = function (a) {
        if (null == a) {
            return false;
        }
        var b = a.hx;
        var c = this.c.b4;
        var d = this.a(b, c);
        var e = null == d ? 0 : d.c == 0 ? 1 : 2;
        var f = (this.c.dv == 3 || this.c.dv == 2);
        var g = this.b(e, f);
        this.f(a, g);
        return true;
    };
    SortManager.prototype.f = function (a, b) {
        if (null == a) {
            return false;
        }
        var c = a.hx;
        var d = this.c.b4;
        var e = this.a(c, d);
        return this.g(c, b, e);
    };
    SortManager.prototype.g = function (a, b, c) {
        if (this.e) {
            return false;
        }
        this.e = true;
        try {
            var d = this.c.b4;
            var e = d.j(c);
            var f = (this.c.dv == 1 || this.c.dv == 3);
            if (null != c) {
                d.h(c);
            }
            if (false == f) {
                d.m();
            }
            switch (b) {
                case 0: break;
                case 2:
                case 1:
                    {
                        var g = b == 1 ? 0 : 1;
                        var h = new ColumnSortDescription(2, a, g);
                        if (f && e >= 0) {
                            d.i.insert(e, h);
                        }
                        else {
                            d.g(h);
                        }
                    }
                    break;
            }
            return true;
        }
        finally {
            this.e = false;
        }
    };
    SortManager.prototype.h = function () {
        var a = this.c.b4;
        var b = a.i.count;
        if (b > 1) {
            for (var c = b - 1; c > 0; c--) {
                a.i.removeAt(c);
            }
        }
    };
    SortManager.prototype.a = function (a, b) {
        if (null == b || b.i.count < 1) {
            return null;
        }
        for (var c = 0; c < b.i.count; c++) {
            var d = b.i.item(c);
            if (d.f == a) {
                return d;
            }
        }
        return null;
    };
    SortManager.prototype.b = function (a, b) {
        if (b) {
            switch (a) {
                case 0: return 1;
                case 1: return 2;
                case 2: return 0;
            }
        }
        else {
            switch (a) {
                case 0:
                case 2: return 1;
                default: return 2;
            }
        }
        return 0;
    };
    SortManager.$t = markType(SortManager, 'SortManager');
    return SortManager;
}(Base));
export { SortManager };
/**
 * @hidden
 */
export var IDataAdapter_$type = /*@__PURE__*/ new Type(null, 'IDataAdapter');
/**
 * @hidden
 */
var DataAdapter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataAdapter, _super);
    function DataAdapter(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.h = new Dictionary$2(Base.$, Number_$type, 0);
        _this.i = new List$1(PrimaryKeyValue.$, 0);
        _this.g = null;
        _this.b = null;
        _this.d = null;
        _this.propertyChanged = null;
        _this.j = 0;
        _this.k = 0;
        _this.g = a;
        return _this;
    }
    Object.defineProperty(DataAdapter.prototype, "c", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (this.b != b) {
                this.n("DataSource", b, this.b);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataAdapter.prototype, "e", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            var b = this.d;
            this.d = a;
            if (this.d != b) {
                this.n("EditableDataSource", b, this.d);
            }
        },
        enumerable: true,
        configurable: true
    });
    DataAdapter.prototype.setDataSource = function (a) {
        this.c = a;
        this.e = typeCast(IEditableDataSource_$type, this.c);
    };
    DataAdapter.prototype.getItemForKey = function (a) {
        var b = this.indexOfKey(a);
        if (b == -1) {
            if (a.value != null && a.value.length == 1) {
                return a.value[0];
            }
            return null;
        }
        return this.c.getItemAtIndex(b);
    };
    DataAdapter.prototype.getItemKey = function (a, item_) {
        var b = (item_ != null && item_.$$isSpecialRow !== undefined);
        if (a == null) {
            if (item_ == null) {
                return null;
            }
            return PrimaryKeyValue.createIdentityKey(item_);
        }
        if (b) {
            var c = item_;
            if (this.c.isSectionContentVisible || !this.c.isSectionHeaderNormalRow || c.rowType != 1) {
                return PrimaryKeyValue.createIdentityKey(item_);
            }
            else if (c.rowType == 1) {
                var d = c.getSectionKeys();
                for (var e = 0; e < d.length; e++) {
                    for (var f = 0; f < a.length; f++) {
                        if (a[f] != d[e]) {
                            return PrimaryKeyValue.createIdentityKey(item_);
                        }
                    }
                }
            }
        }
        var g = new Array(a.length);
        for (var h = 0; h < a.length; h++) {
            g[h] = this.c.getItemProperty(item_, a[h]);
        }
        return new PrimaryKeyValue(a, g);
    };
    DataAdapter.prototype.getRowKey = function (a, b) {
        if (this.c == null) {
            return null;
        }
        if (b < 0 || b > this.c.actualCount - 1) {
            return null;
        }
        var c = this.c.getItemAtIndex(b);
        if (c == null) {
            return null;
        }
        return this.getItemKey(a, c);
    };
    DataAdapter.prototype.n = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.o(a, b, c);
    };
    DataAdapter.prototype.o = function (a, b, c) {
        switch (a) {
            case "DataSource":
                this.a = null;
                this.h.clear();
                if (this.c != null) {
                    if (this.a == null) {
                        this.a = new Array(1);
                        this.a[0] = new DefaultSectionInformation(0, this.b.actualCount, null, null, null);
                    }
                    for (var d = 0; d < this.a.length; d++) {
                        if (this.a[d].groupKeyValues != null) {
                            this.h.addItem(this.a[d].groupKeyValues, d);
                        }
                    }
                    for (var e = 0; e < this.i.count; e++) {
                        this.b.pinRow(this.i._inner[e].value);
                    }
                    this.i.clear();
                }
                break;
        }
    };
    DataAdapter.prototype.getRowCount = function () {
        return this.l(0);
    };
    DataAdapter.prototype.m = function (a, b) {
        if (this.b == null) {
            return -1;
        }
        if (this.b.actualPrimaryKey != null && this.b.isKeyIndexLookupSupported) {
            return this.indexOfKey(a);
        }
        if (this.b.isItemIndexLookupSupported) {
            return this.b.indexOfItem(b);
        }
        return -1;
    };
    DataAdapter.prototype.indexOfKey = function (a) {
        if (this.b == null) {
            return -1;
        }
        if (this.b.actualPrimaryKey != null && this.b.isKeyIndexLookupSupported) {
            return this.b.indexOfKey(a.value);
        }
        return -1;
    };
    DataAdapter.prototype.fastGetItemIndexForKey = function (a, b, c, d) {
        var e = this.indexOfVisibleItemByKey(a, b, c, d);
        if (e >= 0) {
            return e;
        }
        return this.indexOfKey(b);
    };
    DataAdapter.prototype.indexOfVisibleItemByKey = function (a, b, c, d) {
        if (this.b == null) {
            return -1;
        }
        for (var e = c; e <= d; e++) {
            if (e > this.b.actualCount - 1) {
                break;
            }
            var f = this.b.getItemAtIndex(e);
            if (f == null) {
                continue;
            }
            var g = this.getItemKey(a, f);
            if (g == null) {
                continue;
            }
            if (g.value != null && g.value.length == 1 && getInstanceType(g.value[0]) == DataSourceSpecialRow.$ && b.value != null && b.value.length == 1 && getInstanceType(b.value[0]) == DataSourceSpecialRow.$) {
                var h = typeCast(DataSourceSpecialRow.$, g.value[0]);
                var i = typeCast(DataSourceSpecialRow.$, b.value[0]);
                if (h.rowType == i.rowType && h.targetRow == i.targetRow) {
                    return e;
                }
            }
            if (g.equals(b)) {
                return e;
            }
        }
        return -1;
    };
    DataAdapter.prototype.l = function (a) {
        if (this.b == null) {
            return 0;
        }
        return this.b.actualCount;
    };
    DataAdapter.prototype.getSectionCount = function () {
        if (this.a == null) {
            return 0;
        }
        return this.a.length;
    };
    DataAdapter.prototype.f = function (a) {
        return a;
    };
    DataAdapter.prototype.getDataRow = function (a) {
        if (a == null) {
            return -1;
        }
        a = this.f(a);
        if (this.a == null || this.a.length < 1) {
            if (this.b.actualCount > a.w) {
                return a.w;
            }
        }
        else {
            var b = this.a[a.x].startIndex;
            var c = b + a.w;
            if (c < 0 || c >= this.b.actualCount) {
                return -1;
            }
            return c;
        }
        return -1;
    };
    DataAdapter.prototype.resolveValue = function (a, b) {
        if (a < 0 || a > this.b.actualCount - 1) {
            return null;
        }
        if (b != null && b.length == 1 && b.charAt(0) == '.') {
            return this.b.getItemAtIndex(a);
        }
        return this.b.getItemPropertyAtIndex(a, b);
    };
    DataAdapter.prototype.resolveValueForPath = function (a, b) {
        var c = null;
        if (b.ax == -400) {
            var d = this.b.getRowType(b.w);
            var e = this.b.getMainValuePath(d);
            c = e;
        }
        else {
            var f = a.a0(b);
            c = f.hx;
        }
        return this.resolveValue(b.w, c);
    };
    DataAdapter.prototype.resolveRow = function (a) {
        if (a < 0 || a > this.b.actualCount - 1) {
            return null;
        }
        return this.b.getItemAtIndex(a);
    };
    DataAdapter.prototype.resolveValueForDataRow = function (a) {
        if (a < 0 || a > this.b.actualCount - 1) {
            return null;
        }
        return this.b.getItemAtIndex(a);
    };
    DataAdapter.prototype.resolveValueForRow = function (a) {
        a = this.f(a);
        if (a == null) {
            return null;
        }
        var b = this.getDataRow(a);
        if (b < 0 || b > this.b.actualCount - 1) {
            return null;
        }
        return this.b.getItemAtIndex(b);
    };
    DataAdapter.prototype.getSectionForRow = function (a) {
        if (this.a == null || this.a.length < 2) {
            return 0;
        }
        for (var b = 0; b < this.a.length; b++) {
            if (b < this.a.length - 1) {
                if (a > this.a[b + 1].startIndex) {
                    continue;
                }
            }
            return b;
        }
        return this.a.length - 1;
    };
    DataAdapter.prototype.getRowPathForRow = function (a) {
        var b = this.getSectionForRow(a);
        return new RowPath(b, a - this.a[b].startIndex);
    };
    Object.defineProperty(DataAdapter.prototype, "firstVisibleIndexRequested", {
        get: function () {
            return this.j = 0;
        },
        set: function (a) {
            this.j = a;
            if (this.b != null) {
                this.b.firstVisibleIndexRequested = this.j;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataAdapter.prototype, "lastVisibleIndexRequested", {
        get: function () {
            return this.k = 0;
        },
        set: function (a) {
            this.k = a;
            if (this.b != null) {
                this.b.lastVisibleIndexRequested = this.k;
            }
        },
        enumerable: true,
        configurable: true
    });
    DataAdapter.prototype.isPlaceholderValue = function (a) {
        if (this.b == null) {
            return false;
        }
        var b = this.getDataRow(a);
        if (b < 0 || b > this.b.actualCount - 1) {
            return false;
        }
        return this.b.isPlaceholderItem(b);
    };
    DataAdapter.prototype.isPlaceholderItem = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isPlaceholderItem(a);
    };
    DataAdapter.prototype.getRowType = function (a) {
        if (this.b == null) {
            return 0;
        }
        return this.b.getRowType(a);
    };
    DataAdapter.prototype.getStickyRows = function () {
        if (this.b == null) {
            return null;
        }
        return this.b.getStickyRows();
    };
    DataAdapter.prototype.getStickyRowsInRange = function (a, b) {
        if (this.b == null) {
            return null;
        }
        return this.b.getStickyRowsInRange(a, b);
    };
    DataAdapter.prototype.getStickRowPriority = function (a) {
        if (this.b == null) {
            return -1;
        }
        return this.b.getStickyRowPriority(a);
    };
    DataAdapter.prototype.isExclusivelySticky = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isExclusivelySticky(a);
    };
    DataAdapter.prototype.isRowSpanning = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isRowSpanning(a);
    };
    DataAdapter.prototype.pinRow = function (a) {
        if (this.b == null) {
            this.i.add(a);
            return;
        }
        this.b.pinRow(a.value);
    };
    DataAdapter.prototype.unpinRow = function (a) {
        if (this.b == null) {
            for (var b = 0; b < this.i.count; b++) {
                if (this.i._inner[b].equals(a)) {
                    this.i.remove(this.i._inner[b]);
                    break;
                }
            }
            return;
        }
        this.b.unpinRow(a.value);
    };
    DataAdapter.prototype.clearPinnedRows = function () {
        if (this.b == null) {
            return;
        }
        this.b.clearPinnedRows();
    };
    DataAdapter.prototype.isRowPinned = function (a) {
        if (this.b == null) {
            return false;
        }
        return this.b.isRowPinned(a);
    };
    DataAdapter.prototype.getRowIndent = function (a) {
        if (this.b == null) {
            return 0;
        }
        return this.b.getRowLevel(a);
    };
    DataAdapter.prototype.getRootSummaryRowCount = function () {
        if (this.b == null) {
            return 0;
        }
        return this.b.getRootSummaryRowCount();
    };
    DataAdapter.prototype.isEditedValue = function (a, b) {
        if (this.e == null || a == null) {
            return false;
        }
        var c = this.getItemKey(this.b.actualPrimaryKey, a);
        return this.e.hasEdit(c.value, b) || this.e.hasAdd(c.value);
    };
    DataAdapter.prototype.isDeletedRow = function (a) {
        if (this.e == null || a == null) {
            return false;
        }
        var b = this.getItemKey(this.b.actualPrimaryKey, a);
        return this.e.hasDelete(b.value);
    };
    DataAdapter.prototype.getPendingEditID = function (a, b) {
        if (this.e == null || a == null) {
            return -1;
        }
        var c = this.getItemKey(this.b.actualPrimaryKey, a);
        return this.e.getTransactionID(c.value, b);
    };
    DataAdapter.prototype.getError = function (a) {
        if (this.e == null || a == -1) {
            return null;
        }
        return this.e.getTransactionErrorByID(a);
    };
    DataAdapter.$t = markType(DataAdapter, 'DataAdapter', Base.$, [INotifyPropertyChanged_$type, IDataAdapter_$type]);
    return DataAdapter;
}(Base));
export { DataAdapter };
/**
 * @hidden
 */
var ColumnMovingSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnMovingSeparator, _super);
    function ColumnMovingSeparator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.el = truncate(DeviceUtils.g(2));
        return _this;
    }
    ColumnMovingSeparator.prototype.cm = function (a, b, c) {
        return "columnMovingSeparator";
    };
    ColumnMovingSeparator.prototype.l = function (a) {
        return new VerticalSeparatorCellModel();
    };
    ColumnMovingSeparator.prototype.eb = function () {
        return GridStyleRepository.aw;
    };
    Object.defineProperty(ColumnMovingSeparator.prototype, "em", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (this.el != b) {
                this.c2("SeparatorWidth", 6, b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    ColumnMovingSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    ColumnMovingSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.tx != null) {
                this.d0 = this.grid.tx;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    ColumnMovingSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "ColumnMovingSeparatorBackground":
                this.c8();
                break;
        }
    };
    ColumnMovingSeparator.$t = markType(ColumnMovingSeparator, 'ColumnMovingSeparator', DefinitionBase.$);
    return ColumnMovingSeparator;
}(DefinitionBase));
export { ColumnMovingSeparator };
/**
 * @hidden
 */
var ComboBoxColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ComboBoxColumn, _super);
    function ComboBoxColumn() {
        var _this = _super.call(this) || this;
        _this.jh = null;
        _this.fc = 1;
        return _this;
    }
    Object.defineProperty(ComboBoxColumn.prototype, "ji", {
        get: function () {
            return this.jh;
        },
        set: function (a) {
            var b = this.jh;
            this.jh = a;
            if (this.jh != b) {
                this.c2("ActualDataSource", 10, b, this.jh);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxColumn.prototype, "jj", {
        get: function () {
            return this.g4;
        },
        set: function (a) {
            this.g4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxColumn.prototype, "jn", {
        get: function () {
            return this.ht;
        },
        set: function (a) {
            this.ht = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboBoxColumn.prototype, "jg", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    ComboBoxColumn.prototype.l = function (a) {
        return new TextCellModel();
    };
    ComboBoxColumn.prototype.cm = function (a, b, c) {
        return "combobox";
    };
    ComboBoxColumn.prototype.cz = function (a, b) {
        _super.prototype.cz.call(this, a, b);
        if (this.ji == null && this.jj != null) {
            if (b != null) {
                this.ji = b.externalGrid.createLocalDataSource(this.jj);
            }
        }
    };
    ComboBoxColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        e.kh = this.jm(c);
    };
    ComboBoxColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    ComboBoxColumn.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "EditorItemsSourceInternal":
                if (typeCast(IDataSource_$type, this.jj) !== null) {
                    this.ji = this.jj;
                }
                else if (this.grid != null) {
                    this.ji = this.grid.externalGrid.createLocalDataSource(this.jj);
                }
                break;
            case "ActualDataSource":
                if (c != null) {
                    var e = c;
                    e.schemaChanged = delegateRemove(e.schemaChanged, runOn(this, this.jo));
                }
                if (this.ji != null) {
                    var f = this.ji;
                    f.schemaChanged = delegateCombine(f.schemaChanged, runOn(this, this.jo));
                }
                this.jp();
                break;
            case "EditorTextFieldInternal":
            case "EditorValueFieldInternal":
                this.jp();
                break;
        }
    };
    ComboBoxColumn.prototype.jo = function (a, b) {
        this.jp();
    };
    ComboBoxColumn.prototype.jp = function () {
        if (this.ji != null) {
            if (this.jg != null) {
                this.ji.primaryKey = this.jg;
            }
            else if (this.jn != null) {
                this.ji.primaryKey = [this.jn];
            }
            else {
                var a = this.ji.actualSchema;
                if (a != null && a.propertyNames.length > 0) {
                    this.ji.primaryKey = [a.propertyNames[0]];
                }
            }
        }
    };
    ComboBoxColumn.prototype.jl = function (a) {
        if (typeof a === 'string') {
            return a;
        }
        return null;
    };
    ComboBoxColumn.prototype.jm = function (a) {
        var b = null;
        if (this.ji != null && this.jn != null) {
            var c = this.ji.indexOfKey([a]);
            if (c > -1) {
                var d = this.ji.getItemPropertyAtIndex(c, this.jn);
                if (d != null) {
                    b = this.jl(d);
                }
            }
        }
        if (b == null && a != null) {
            b = this.jl(a);
        }
        return b;
    };
    ComboBoxColumn.$t = markType(ComboBoxColumn, 'ComboBoxColumn', Column.$);
    return ComboBoxColumn;
}(Column));
export { ComboBoxColumn };
/**
 * @hidden
 */
var DateTimeColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeColumn, _super);
    function DateTimeColumn() {
        var _this = _super.call(this) || this;
        _this.jh = new DateTimeColumnValueFormatter();
        _this.ji = 0;
        _this.jp = null;
        _this.jm = null;
        return _this;
    }
    Object.defineProperty(DateTimeColumn.prototype, "jj", {
        get: function () {
            return this.ji;
        },
        set: function (a) {
            var b = this.ji;
            this.ji = a;
            if (this.ji != b) {
                this.c2("DateTimeFormat", 4, enumGetBox(DateTimeFormats_$type, b), enumGetBox(DateTimeFormats_$type, this.ji));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "jt", {
        get: function () {
            return this.jp;
        },
        set: function (a) {
            var b = this.jp;
            this.jp = a;
            if (this.jp != b) {
                this.c2("FormatString", 8, b, this.jp);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "jo", {
        get: function () {
            return this.jm;
        },
        set: function (a) {
            var b = this.jm;
            this.jm = a;
            if (this.jm != b) {
                this.c2("FormatOverride", 9, b, this.jm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "jk", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "jn", {
        get: function () {
            return this.g4;
        },
        set: function (a) {
            this.g4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "jr", {
        get: function () {
            return this.ht;
        },
        set: function (a) {
            this.ht = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateTimeColumn.prototype, "jg", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    DateTimeColumn.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "DateTimeFormat":
                this.jh.k();
                break;
        }
    };
    DateTimeColumn.prototype.l = function (a) {
        return new DateTimeCellModel();
    };
    DateTimeColumn.prototype.cm = function (a, b, c) {
        return "datetime";
    };
    DateTimeColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        e.km = this.jl(c);
        e.kg = this.jh;
        this.jh.j(e);
    };
    DateTimeColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
        e.ki = this.jj;
        e.ku = this.jo;
    };
    DateTimeColumn.prototype.jl = function (a) {
        if (a == null) {
            return dateMinValue();
        }
        if (typeCast(Date_$type, a) !== null) {
            return a;
        }
        return dateMinValue();
    };
    DateTimeColumn.$t = markType(DateTimeColumn, 'DateTimeColumn', Column.$);
    return DateTimeColumn;
}(Column));
export { DateTimeColumn };
/**
 * @hidden
 */
export var IExternalDefinitionBase_$type = /*@__PURE__*/ new Type(null, 'IExternalDefinitionBase');
/**
 * @hidden
 */
var DataBindingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataBindingEventArgs, _super);
    function DataBindingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._resolvedValue = null;
        _this._rowObject = null;
        _this._cellInfo = null;
        return _this;
    }
    Object.defineProperty(DataBindingEventArgs.prototype, "resolvedValue", {
        get: function () {
            return this._resolvedValue;
        },
        set: function (a) {
            this._resolvedValue = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataBindingEventArgs.prototype, "rowObject", {
        get: function () {
            return this._rowObject;
        },
        set: function (a) {
            this._rowObject = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataBindingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    DataBindingEventArgs.$t = markType(DataBindingEventArgs, 'DataBindingEventArgs', EventArgs.$);
    return DataBindingEventArgs;
}(EventArgs));
export { DataBindingEventArgs };
/**
 * @hidden
 */
var Header = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header() {
        var _this = _super.call(this) || this;
        _this.e8 = null;
        _this.e7 = null;
        _this.em = 3;
        _this.el = 3;
        _this.eq = truncate(DeviceUtils.g(12));
        _this.es = truncate(DeviceUtils.g(0));
        _this.er = truncate(DeviceUtils.g(12));
        _this.ep = truncate(DeviceUtils.g(0));
        _this.e9 = _this.fa();
        return _this;
    }
    Header.prototype.eg = function () {
        return GridStyleRepository.bf;
    };
    Header.prototype.eb = function () {
        return GridStyleRepository.bd;
    };
    Header.prototype.fa = function () {
        return GridStyleRepository.bh;
    };
    Header.prototype.af = function () {
        return GridStyleRepository.h;
    };
    Header.prototype.cz = function (a, b) {
        this.c8();
        this.df();
        this.dg();
        this.e5();
        this.e6();
    };
    Header.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.t1 != null) {
                this.d0 = this.grid.t1;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    Header.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.t5 != null) {
                this.d6 = this.grid.t5;
                return;
            }
            this.d6 = this.eg();
        }
        else {
            this.d6 = this.ek;
        }
    };
    Header.prototype.dg = function () {
        if (this.textStyle == null) {
            if (this.grid != null && this.grid.fj != null) {
                this.ad = this.grid.fj;
                return;
            }
            this.ad = this.af();
        }
        else {
            this.ad = this.textStyle;
        }
    };
    Header.prototype.e5 = function () {
        if (this.fb == null) {
            if (this.grid != null && this.grid.t4 != null) {
                this.e9 = this.grid.t4;
                return;
            }
            this.e9 = this.fa();
        }
        else {
            this.e9 = this.fb;
        }
    };
    Header.prototype.e6 = function () {
        if (this.eo == 3) {
            if (this.grid != null) {
                this.en = this.grid.eu;
                return;
            }
            this.en = 0;
        }
        else {
            this.en = this.eo;
        }
    };
    Header.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "HeaderBackground":
                this.c8();
                break;
            case "HeaderTextColor":
                this.df();
                break;
            case "HeaderTextStyle":
                this.dg();
                break;
            case "HeaderSortIndicatorColor":
                this.e5();
                break;
            case "HeaderSortIndicatorStyle":
                this.e6();
                break;
        }
    };
    Object.defineProperty(Header.prototype, "fb", {
        get: function () {
            return this.e8;
        },
        set: function (a) {
            var b = this.e8;
            this.e8 = a;
            if (this.e8 != b) {
                this.c2("SortIndicatorColor", 10, b, this.e8);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "e9", {
        get: function () {
            return this.e7;
        },
        set: function (a) {
            var b = this.e7;
            this.e7 = a;
            if (this.e7 != b) {
                this.c2("ActualSortIndicatorColor", 2, b, this.e7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "eo", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (this.em != b) {
                this.c2("SortIndicatorStyle", 11, enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.em));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "en", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (this.el != b) {
                this.c2("ActualSortIndicatorStyle", 11, enumGetBox(SortIndicatorStyle_$type, b), enumGetBox(SortIndicatorStyle_$type, this.el));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "eu", {
        get: function () {
            return this.eq;
        },
        set: function (a) {
            var b = this.eq;
            this.eq = a;
            if (this.eq != b) {
                this.c2("PaddingLeft", 6, b, this.eq);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "ew", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (this.es != b) {
                this.c2("PaddingTop", 6, b, this.es);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "ev", {
        get: function () {
            return this.er;
        },
        set: function (a) {
            var b = this.er;
            this.er = a;
            if (this.er != b) {
                this.c2("PaddingRight", 6, b, this.er);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "et", {
        get: function () {
            return this.ep;
        },
        set: function (a) {
            var b = this.ep;
            this.ep = a;
            if (this.ep != b) {
                this.c2("PaddingBottom", 6, b, this.ep);
            }
        },
        enumerable: true,
        configurable: true
    });
    Header.prototype.ak = function (a) {
        if (_super.prototype.ak.call(this, a)) {
            return true;
        }
        if (stringStartsWith(a, "Actual")) {
            return false;
        }
        switch (a) {
            case "PaddingBottom":
                this.c2("PaddingBottom", 0, this.et, this.et);
                return true;
            case "PaddingLeft":
                this.c2("PaddingLeft", 0, this.eu, this.eu);
                return true;
            case "PaddingRight":
                this.c2("PaddingRight", 0, this.ev, this.ev);
                return true;
            case "PaddingTop":
                this.c2("PaddingTop", 0, this.ew, this.ew);
                return true;
            case "SortIndicatorColor":
                this.c2("ActualSortIndicatorColor", 2, this.e9, this.e9);
                return true;
        }
        return false;
    };
    Header.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.fh = this.eu;
        a.fl = this.ew;
        a.fj = this.ev;
        a.ff = this.et;
        a.kc = this.e9;
    };
    Header.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = b.a0(a.k);
        if (e != null) {
            if (a.k.g && e.f6()) {
                var f = e.fm;
                var g = f.o;
                var h = g.count;
                var i = f.p;
                var j = f.q;
                for (var k = 0; k < h; k++) {
                    if (i._inner[k]) {
                        continue;
                    }
                    a.jk(g._inner[k], j._inner[k]);
                }
            }
        }
    };
    Header.$t = markType(Header, 'Header', DefinitionBase.$);
    return Header;
}(DefinitionBase));
export { Header };
/**
 * @hidden
 */
var ColumnResizingSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnResizingSeparator, _super);
    function ColumnResizingSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnResizingSeparator.prototype.cm = function (a, b, c) {
        return "columnResizingSeparator";
    };
    ColumnResizingSeparator.prototype.l = function (a) {
        return new VerticalSeparatorCellModel();
    };
    ColumnResizingSeparator.prototype.eb = function () {
        return GridStyleRepository.a2;
    };
    ColumnResizingSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    ColumnResizingSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.tz != null) {
                this.d0 = this.grid.tz;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    ColumnResizingSeparator.prototype.el = function (a, b) {
        switch (b.propertyName) {
            case "ColumnResizingSeparatorBackground":
                this.c8();
                break;
        }
    };
    ColumnResizingSeparator.$t = markType(ColumnResizingSeparator, 'ColumnResizingSeparator', DefinitionBase.$);
    return ColumnResizingSeparator;
}(DefinitionBase));
export { ColumnResizingSeparator };
/**
 * @hidden
 */
var HeaderSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(HeaderSeparator, _super);
    function HeaderSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderSeparator.prototype.cm = function (a, b, c) {
        return "headerSeparator";
    };
    HeaderSeparator.prototype.l = function (a) {
        return new VerticalSeparatorCellModel();
    };
    HeaderSeparator.prototype.eb = function () {
        return GridStyleRepository.be;
    };
    HeaderSeparator.prototype.el = function () {
        return truncate(DeviceUtils.g(1));
    };
    HeaderSeparator.prototype.cz = function (a, b) {
        this.c8();
        this.em();
    };
    HeaderSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "HeaderSeparatorBackground":
                this.c8();
                break;
        }
    };
    HeaderSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.t3 != null) {
                this.d0 = this.grid.t3;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    HeaderSeparator.prototype.em = function () {
        if (this.grid != null) {
            this.d1 = ((function () {
                var $ret = new Brush();
                $ret.color = Color.u(0, 0, 0, 0);
                return $ret;
            })());
            var a = this.grid.j5(this.grid.kt);
            this.be = a;
            this.bf = a;
        }
    };
    HeaderSeparator.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.c.isLeaveActionDesired = true;
    };
    HeaderSeparator.$t = markType(HeaderSeparator, 'HeaderSeparator', DefinitionBase.$);
    return HeaderSeparator;
}(DefinitionBase));
export { HeaderSeparator };
/**
 * @hidden
 */
var ImageColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ImageColumn, _super);
    function ImageColumn() {
        var _this = _super.call(this) || this;
        _this.jk = 0;
        _this.ji = 0;
        _this.jl = 0;
        _this.h = _this.i();
        _this.c = _this.d();
        return _this;
    }
    Object.defineProperty(ImageColumn.prototype, "jl", {
        get: function () {
            return this.jk;
        },
        set: function (a) {
            var b = this.jk;
            this.jk = a;
            if (this.jk != b) {
                this.c2("ImageStretchOption", 4, enumGetBox(ImageStretchOptions_$type, b), enumGetBox(ImageStretchOptions_$type, this.jk));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "jj", {
        get: function () {
            return this.ji;
        },
        set: function (a) {
            var b = this.ji;
            this.ji = a;
            if (this.ji != b) {
                this.c2("ImageResourceType", 11, enumGetBox(ImageResourceType_$type, b), enumGetBox(ImageResourceType_$type, this.ji));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "jh", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "jm", {
        get: function () {
            return this.g4;
        },
        set: function (a) {
            this.g4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "jn", {
        get: function () {
            return this.ht;
        },
        set: function (a) {
            this.ht = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageColumn.prototype, "jg", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    ImageColumn.prototype.i = function () {
        if (this.j != 4) {
            return this.j;
        }
        return 3;
    };
    ImageColumn.prototype.ep = function () {
        if (this.c == 3) {
            return 1;
        }
        return _super.prototype.ep.call(this);
    };
    ImageColumn.prototype.eq = function () {
        if (this.h == 3) {
            return 1;
        }
        return _super.prototype.eq.call(this);
    };
    ImageColumn.prototype.d = function () {
        if (this.e != 4) {
            return this.e;
        }
        return 3;
    };
    ImageColumn.prototype.l = function (a) {
        return new ImageCellModel();
    };
    ImageColumn.prototype.cm = function (a, b, c) {
        return "image";
    };
    ImageColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        if (c != null) {
            e.ie = c.toString();
            e.ki = this.jl;
            e.kg = this.jj;
            e.kn = this.jo(c);
        }
    };
    ImageColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    ImageColumn.prototype.jo = function (a) {
        if (a == null) {
            return "";
        }
        if (typeof a === 'string') {
            return a;
        }
        return a.toString();
    };
    ImageColumn.$t = markType(ImageColumn, 'ImageColumn', Column.$);
    return ImageColumn;
}(Column));
export { ImageColumn };
/**
 * @hidden
 */
var NumericColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericColumn, _super);
    function NumericColumn() {
        var _this = _super.call(this) || this;
        _this.jv = null;
        _this.jx = null;
        _this.jw = null;
        _this.jy = "";
        _this.jl = 10;
        _this.jm = 0;
        _this.jn = -1;
        _this.ji = false;
        _this.ju = null;
        _this.jr = null;
        _this.c = _this.d();
        return _this;
    }
    NumericColumn.prototype.d = function () {
        if (this.e != 4) {
            return this.e;
        }
        return 2;
    };
    Object.defineProperty(NumericColumn.prototype, "j6", {
        get: function () {
            return this.jv;
        },
        set: function (a) {
            var b = this.jv;
            this.jv = a;
            if (this.jv != b) {
                this.c2("NegativePrefix", 8, b, this.jv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "ka", {
        get: function () {
            return this.jx;
        },
        set: function (a) {
            var b = this.jx;
            this.jx = a;
            if (this.jx != b) {
                this.c2("PositivePrefix", 8, b, this.jx);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "j8", {
        get: function () {
            return this.jw;
        },
        set: function (a) {
            var b = this.jw;
            this.jw = a;
            if (this.jw != b) {
                this.c2("NegativeSuffix", 8, b, this.jw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "kc", {
        get: function () {
            return this.jy;
        },
        set: function (a) {
            var b = this.jy;
            this.jy = a;
            if (this.jy != b) {
                this.c2("PositiveSuffix", 8, b, this.jy);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jo", {
        get: function () {
            return this.jl;
        },
        set: function (a) {
            var b = this.jl;
            this.jl = a;
            if (this.jl != b) {
                this.c2("MaxFractionDigits", 6, b, this.jl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jp", {
        get: function () {
            return this.jm;
        },
        set: function (a) {
            var b = this.jm;
            this.jm = a;
            if (this.jm != b) {
                this.c2("MinFractionDigits", 6, b, this.jm);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jq", {
        get: function () {
            return this.jn;
        },
        set: function (a) {
            var b = this.jn;
            this.jn = a;
            if (this.jn != b) {
                this.c2("MinIntegerDigits", 6, b, this.jn);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jj", {
        get: function () {
            return this.ji;
        },
        set: function (a) {
            var b = this.ji;
            this.ji = a;
            if (this.ji != b) {
                this.c2("ShowGroupingSeparator", 5, b, this.ji);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "j1", {
        get: function () {
            return this.ju;
        },
        set: function (a) {
            var b = this.ju;
            this.ju = a;
            if (this.ju != b) {
                this.c2("FormatString", 8, b, this.ju);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jt", {
        get: function () {
            return this.jr;
        },
        set: function (a) {
            var b = this.jr;
            this.jr = a;
            if (this.jr != b) {
                this.c2("FormatOverride", 9, b, this.jr);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jh", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "js", {
        get: function () {
            return this.g4;
        },
        set: function (a) {
            this.g4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jz", {
        get: function () {
            return this.ht;
        },
        set: function (a) {
            this.ht = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NumericColumn.prototype, "jg", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    NumericColumn.prototype.l = function (a) {
        return new NumericCellModel();
    };
    NumericColumn.prototype.cm = function (a, b, c) {
        return "numeric";
    };
    NumericColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        {
            e.kh = false;
            e.kl = this.jk(c);
        }
    };
    NumericColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
        e.kt = this.jp;
        e.kr = this.jo;
        e.kv = this.jq;
        e.lk = this.ka;
        e.lf = this.j6;
        e.lm = this.kc;
        e.lh = this.j8;
        e.k5 = this.jt;
        e.kj = this.jj;
    };
    NumericColumn.prototype.jk = function (a) {
        if (a == null) {
            return NaN;
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return a;
        }
        if (typeof a === 'number') {
            return a;
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'string') {
            var b_1;
            if (((function () { var c = tryParseNumber(a, b_1); b_1 = c.p1; return c.ret; })())) {
                return b_1;
            }
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        if (typeof a === 'number') {
            return typeGetValue(a);
        }
        return NaN;
    };
    NumericColumn.$t = markType(NumericColumn, 'NumericColumn', Column.$);
    return NumericColumn;
}(Column));
export { NumericColumn };
/**
 * @hidden
 */
var PinnedAreaSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PinnedAreaSeparator, _super);
    function PinnedAreaSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PinnedAreaSeparator.prototype.cm = function (a, b, c) {
        return "pinnedAreaSeparator";
    };
    PinnedAreaSeparator.prototype.l = function (a) {
        return ((function () {
            var $ret = new VerticalSeparatorCellModel();
            $ret.kg = false;
            return $ret;
        })());
    };
    PinnedAreaSeparator.prototype.eb = function () {
        return GridStyleRepository.a0;
    };
    PinnedAreaSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    PinnedAreaSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    PinnedAreaSeparator.prototype.c1 = function (a, b) {
    };
    PinnedAreaSeparator.$t = markType(PinnedAreaSeparator, 'PinnedAreaSeparator', DefinitionBase.$);
    return PinnedAreaSeparator;
}(DefinitionBase));
export { PinnedAreaSeparator };
/**
 * @hidden
 */
var SectionFooter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionFooter, _super);
    function SectionFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionFooter.prototype.l = function (a) {
        return new TextCellModel();
    };
    SectionFooter.prototype.cm = function (a, b, c) {
        return "sectionFooter";
    };
    SectionFooter.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
    };
    SectionFooter.prototype.cw = function (a, b, c, d) {
        this.d0 = GridStyleRepository.a4;
        _super.prototype.cw.call(this, a, b, c, d);
    };
    SectionFooter.$t = markType(SectionFooter, 'SectionFooter', DefinitionBase.$);
    return SectionFooter;
}(DefinitionBase));
export { SectionFooter };
/**
 * @hidden
 */
var SectionHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionHeader, _super);
    function SectionHeader() {
        var _this = _super.call(this) || this;
        _this.fc = null;
        _this.fb = null;
        _this.et = truncate(DeviceUtils.g(12));
        _this.ev = truncate(DeviceUtils.g(1));
        _this.eu = truncate(DeviceUtils.g(1));
        _this.es = truncate(DeviceUtils.g(1));
        _this.ep = false;
        _this.em = 4;
        _this.sectionHeaderPropertyUpdating = null;
        _this.er = new Dictionary$2(String_$type, ComboBoxColumn.$, 0);
        _this.fd = _this.ee();
        return _this;
    }
    Object.defineProperty(SectionHeader.prototype, "fe", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            var b = this.fc;
            this.fc = a;
            if (this.fc != b) {
                this.c2("SelectedBackground", 10, b, this.fc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "fd", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (this.fb != b) {
                this.c2("ActualSelectedBackground", 2, b, this.fb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ex", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (this.et != b) {
                this.c2("PaddingLeft", 6, b, this.et);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ez", {
        get: function () {
            return this.ev;
        },
        set: function (a) {
            var b = this.ev;
            this.ev = a;
            if (this.ev != b) {
                this.c2("PaddingTop", 6, b, this.ev);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ey", {
        get: function () {
            return this.eu;
        },
        set: function (a) {
            var b = this.eu;
            this.eu = a;
            if (this.eu != b) {
                this.c2("PaddingRight", 6, b, this.eu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "ew", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (this.es != b) {
                this.c2("PaddingBottom", 6, b, this.es);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "eq", {
        get: function () {
            return this.ep;
        },
        set: function (a) {
            var b = this.ep;
            this.ep = a;
            if (this.ep != b) {
                this.c2("IsCollapsable", 5, b, this.ep);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SectionHeader.prototype, "en", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (this.em != b) {
                this.c2("SummaryDisplayMode", 4, enumGetBox(GroupSummaryDisplayMode_$type, b), enumGetBox(GroupSummaryDisplayMode_$type, this.em));
            }
        },
        enumerable: true,
        configurable: true
    });
    SectionHeader.prototype.cm = function (a, b, c) {
        return "sectionHeader";
    };
    SectionHeader.prototype.l = function (a) {
        return new SectionHeaderCellModel();
    };
    SectionHeader.prototype.eb = function () {
        return GridStyleRepository.a5;
    };
    SectionHeader.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = new List$1(GroupData.$, 0);
        var f = new List$1(SummaryData.$, 0);
        var g = stringEmpty();
        var h = stringEmpty();
        var i = typeCast(FastIterationDictionary$2.$.specialize(String_$type, Base.$), c);
        if (i != null) {
            var j = b.actualDataSource.actualSchema;
            var k = 0;
            for (var l = 0; l < i.o.count; l++) {
                var m = i.o._inner[l];
                var n = i.q._inner[l];
                var o = null;
                for (var p = 0; p < b.a7.i.count; p++) {
                    if (b.a7.i.item(p).f == m) {
                        o = b.a7.i.item(p);
                        break;
                    }
                }
                if (!o.i) {
                    b.rz(o);
                }
                if (k > 0) {
                    g += ", ";
                }
                e.add(this.el(m, n, o, o.g));
                g += e._inner[k].b;
                k++;
            }
            if (this.en == 0 && b.b7.i.count > 0) {
                var q = typeCast(DataSourceSpecialRow.$, d);
                if (q != null && q.summaryResults != null) {
                    for (var r = 0; r < q.summaryResults.length; r++) {
                        if (q.summaryResults[r] != null) {
                            var s = q.summaryResults[r].summaryIndex;
                            var t = b.b7.i.item(s);
                            if (r > 0) {
                                h += ", ";
                            }
                            f.add(this.u(t, q.summaryResults[r]));
                            h += f._inner[r].c;
                        }
                    }
                }
            }
        }
        var u = typeCast(SectionHeaderCellModel.$, a);
        if (u != null) {
            u.kh = e.toArray();
            u.ki = f.toArray();
            u.kv = g;
            u.kt = h;
            u.kk = this.en;
            if (b.es.o(u)) {
                u.b3 = 1;
            }
            else {
                u.b3 = 0;
            }
            if (b.aj.m(u)) {
                u.bu = 1;
            }
            else {
                u.bu = 0;
            }
            u.aq = this.eq;
            u.ay = b.actualDataSource.getIsRowExpandedAtIndex(a.k.w);
            u.ey = b.d3.getRowIndent(a.k.w);
        }
    };
    SectionHeader.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        a.kb = this.fd;
        a.fh = this.ex;
        a.fl = this.ez;
        a.fj = this.ey;
        a.ff = this.ew;
    };
    SectionHeader.prototype.cz = function (a, b) {
        this.fa();
        this.c8();
        this.df();
        this.dg();
        this.e9();
        if (a != null) {
            a.actualColumnsChanged = delegateRemove(a.actualColumnsChanged, runOn(this, this.e8));
        }
        if (b != null) {
            b.actualColumnsChanged = delegateCombine(b.actualColumnsChanged, runOn(this, this.e8));
        }
    };
    SectionHeader.prototype.e8 = function (a, b) {
        this.er.clear();
        for (var c = 0; c < b.columns.count; c++) {
            var d = typeCast(ComboBoxColumn.$, b.columns._inner[c]);
            if (d != null && !this.er.containsKey(d.hx)) {
                this.er.addItem(d.hx, d);
            }
        }
    };
    SectionHeader.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "SectionHeaderSelectedBackground":
                this.fa();
                break;
            case "SectionHeaderBackground":
                this.c8();
                break;
            case "SectionHeaderTextColor":
                this.df();
                break;
            case "SectionHeaderTextStyle":
                this.dg();
                break;
            case "IsGroupCollapsable":
                this.e9();
                break;
        }
    };
    SectionHeader.prototype.fa = function () {
        if (this.fe == null) {
            if (this.grid != null && this.grid.ud != null) {
                this.fd = this.grid.ud;
            }
            else {
                this.fd = this.ee();
            }
        }
        else {
            this.fd = this.fe;
        }
    };
    SectionHeader.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.uc != null) {
                this.d0 = this.grid.uc;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    SectionHeader.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.ue != null) {
                this.d6 = this.grid.ue;
                return;
            }
            this.d6 = this.eg();
        }
        else {
            this.d6 = this.ek;
        }
    };
    SectionHeader.prototype.dg = function () {
        if (this.textStyle == null) {
            if (this.grid != null && this.grid.fk != null) {
                this.ad = this.grid.fk;
                return;
            }
            this.ad = this.af();
        }
        else {
            this.ad = this.textStyle;
        }
    };
    SectionHeader.prototype.e9 = function () {
        if (this.grid != null) {
            this.eq = this.grid.hg;
        }
    };
    SectionHeader.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "SelectedBackground":
                this.fa();
                break;
        }
        if (this.sectionHeaderPropertyUpdating != null) {
            this.sectionHeaderPropertyUpdating(this, a, b, c, d);
        }
    };
    SectionHeader.prototype.el = function (a, b, c, d) {
        var e = b != null ? b.toString() : stringEmpty();
        var f = a + ": " + e;
        var g = stringEmpty();
        if (c != null) {
            if (c.m == null) {
                g = a + ": ";
            }
            else if (c.m != stringEmpty()) {
                g = c.m + ": ";
            }
            if (b != null) {
                switch (d) {
                    case 10:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = (typeGetValue(b)).toString();
                        }
                        break;
                    case 8:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = b;
                            e = (override_.format(val_));
                        }
                        else {
                            e = b.toString();
                        }
                        break;
                    case 5:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = b;
                            e = (override_.format(val_));
                        }
                        else {
                            e = b.toString();
                        }
                        break;
                    case 1:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = (typeGetValue(b)).toString();
                        }
                        break;
                    case 3:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = typeGetValue(b).toString();
                        }
                        break;
                    case 4:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = typeGetValue(b);
                            e = (override_.format(val_));
                        }
                        else {
                            e = typeGetValue(b).toString();
                        }
                        break;
                    case 7:
                        if (c.k != null) {
                            var override_ = c.k;
                            var val_ = b;
                            e = (override_.format(val_));
                        }
                        else {
                            e = b.toString();
                        }
                        break;
                    case 0:
                    case 6:
                    case 2:
                    case 11:
                        e = b.toString();
                        break;
                }
                if (this.er.containsKey(c.f)) {
                    var h = this.er.item(c.f);
                    var i = h.jm(b);
                    if (i != null) {
                        e = i;
                    }
                }
            }
            f = g + e;
            f = c.n(b, e, f);
        }
        return ((function () {
            var $ret = new GroupData();
            $ret.c = a;
            $ret.a = b;
            $ret.b = f;
            return $ret;
        })());
    };
    SectionHeader.$t = markType(SectionHeader, 'SectionHeader', DefinitionBase.$);
    return SectionHeader;
}(DefinitionBase));
export { SectionHeader };
/**
 * @hidden
 */
var RowSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowSeparator, _super);
    function RowSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowSeparator.prototype.cm = function (a, b, c) {
        return "rowSeparator";
    };
    RowSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    RowSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.t8 != null) {
                this.d0 = this.grid.t8;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    RowSeparator.prototype.dc = function () {
        if (this.ei == null) {
            if (this.grid != null && this.grid.ua != null) {
                this.d4 = this.grid.ua;
                return;
            }
            this.d4 = this.ed();
        }
        else {
            this.d4 = this.ei;
        }
    };
    RowSeparator.prototype.de = function () {
        if (this.ej == null) {
            if (this.grid != null && this.grid.ub != null) {
                this.d5 = this.grid.ub;
                return;
            }
            this.d5 = this.ef();
        }
        else {
            this.d5 = this.ej;
        }
    };
    RowSeparator.prototype.db = function () {
        if (this.eh == null) {
            if (this.grid != null && this.grid.t9 != null) {
                this.d3 = this.grid.t9;
                return;
            }
            this.d3 = this.ec();
        }
        else {
            this.d3 = this.eh;
        }
    };
    RowSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "RowSeparatorBackground":
                this.c8();
                break;
            case "RowSeparatorLastStickyRowBackground":
                this.db();
                break;
            case "RowSeparatorPinnedRowBackground":
                this.dc();
                break;
            case "RowSeparatorStickyRowBackground":
                this.de();
                break;
        }
    };
    RowSeparator.prototype.l = function (a) {
        return new RowSeparatorModel();
    };
    RowSeparator.prototype.eb = function () {
        return GridStyleRepository.bg;
    };
    RowSeparator.prototype.ef = function () {
        return GridStyleRepository.a9;
    };
    RowSeparator.prototype.ec = function () {
        return GridStyleRepository.az;
    };
    RowSeparator.prototype.ed = function () {
        return this.eb();
    };
    RowSeparator.prototype.av = function () {
        return 1;
    };
    RowSeparator.$t = markType(RowSeparator, 'RowSeparator', DefinitionBase.$);
    return RowSeparator;
}(DefinitionBase));
export { RowSeparator };
/**
 * @hidden
 */
var HeaderRowSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(HeaderRowSeparator, _super);
    function HeaderRowSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderRowSeparator.prototype.cm = function (a, b, c) {
        return "headerRowSeparator";
    };
    HeaderRowSeparator.prototype.l = function (a) {
        return new RowSeparatorModel();
    };
    HeaderRowSeparator.prototype.eb = function () {
        return GridStyleRepository.ay;
    };
    HeaderRowSeparator.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.t2 != null) {
                this.d0 = this.grid.t2;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    HeaderRowSeparator.prototype.cz = function (a, b) {
        this.c8();
    };
    HeaderRowSeparator.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "HeaderRowSeparatorBackground":
                this.c8();
                break;
        }
    };
    HeaderRowSeparator.$t = markType(HeaderRowSeparator, 'HeaderRowSeparator', DefinitionBase.$);
    return HeaderRowSeparator;
}(DefinitionBase));
export { HeaderRowSeparator };
/**
 * @hidden
 */
var SummaryRow = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryRow, _super);
    function SummaryRow() {
        var _this = _super.call(this) || this;
        _this.fd = null;
        _this.fb = null;
        _this.fe = null;
        _this.fc = null;
        _this.em = null;
        _this.el = null;
        _this.er = truncate(DeviceUtils.g(12));
        _this.et = truncate(DeviceUtils.g(0));
        _this.es = truncate(DeviceUtils.g(12));
        _this.eq = truncate(DeviceUtils.g(0));
        _this.ff = _this.ee();
        _this.en = _this.eo();
        _this.fg = _this.fh();
        return _this;
    }
    Object.defineProperty(SummaryRow.prototype, "fi", {
        get: function () {
            return this.fd;
        },
        set: function (a) {
            var b = this.fd;
            this.fd = a;
            if (this.fd != b) {
                this.c2("SelectedBackground", 10, b, this.fd);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ff", {
        get: function () {
            return this.fb;
        },
        set: function (a) {
            var b = this.fb;
            this.fb = a;
            if (this.fb != b) {
                this.c2("ActualSelectedBackground", 2, b, this.fb);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "fj", {
        get: function () {
            return this.fe;
        },
        set: function (a) {
            var b = this.fe;
            this.fe = a;
            if (this.fe != b) {
                this.c2("SummaryLabelTextColor", 10, b, this.fe);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "fg", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            var b = this.fc;
            this.fc = a;
            if (this.fc != b) {
                this.c2("ActualSummaryLabelTextColor", 2, b, this.fc);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "summaryNameTextStyle", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            var b = this.em;
            this.em = a;
            if (this.em != b) {
                this.c2("SummaryNameFontInfo", 10, b, this.em);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "en", {
        get: function () {
            return this.el;
        },
        set: function (a) {
            var b = this.el;
            this.el = a;
            if (this.el != b) {
                this.c2("ActualSummaryLabelFontInfo", 3, b, this.el);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ev", {
        get: function () {
            return this.er;
        },
        set: function (a) {
            var b = this.er;
            this.er = a;
            if (this.er != b) {
                this.c2("PaddingLeft", 6, b, this.er);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ex", {
        get: function () {
            return this.et;
        },
        set: function (a) {
            var b = this.et;
            this.et = a;
            if (this.et != b) {
                this.c2("PaddingTop", 6, b, this.et);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "ew", {
        get: function () {
            return this.es;
        },
        set: function (a) {
            var b = this.es;
            this.es = a;
            if (this.es != b) {
                this.c2("PaddingRight", 6, b, this.es);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryRow.prototype, "eu", {
        get: function () {
            return this.eq;
        },
        set: function (a) {
            var b = this.eq;
            this.eq = a;
            if (this.eq != b) {
                this.c2("PaddingBottom", 6, b, this.eq);
            }
        },
        enumerable: true,
        configurable: true
    });
    SummaryRow.prototype.cm = function (a, b, c) {
        return "summary";
    };
    SummaryRow.prototype.l = function (a) {
        return new SummaryCellModel();
    };
    SummaryRow.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = typeCast(DataSourceSpecialRow.$, d);
        var f = stringEmpty();
        var g = stringEmpty();
        var h = b.a0(a.k);
        if (h != null) {
            var i = e.getSummaryResults(h.hx);
            if (i.length > 0 && b.b7.i.count > 0) {
                var j = b.b7.i.item(i[0].summaryIndex);
                if (j.d != null) {
                    var k = this.u(j, i[0]);
                    f = j.u != null ? j.u : j.d.displayName;
                    g = k.d;
                }
            }
        }
        var l = typeCast(SummaryCellModel.$, a);
        if (l != null) {
            l.kn = f;
            l.kp = g;
            l.ey = b.d3.getRowIndent(a.k.w);
            if (b.es.o(l)) {
                l.b3 = 1;
            }
            else {
                l.b3 = 0;
            }
            if (b.aj.m(l)) {
                l.bu = 1;
            }
            else {
                l.bu = 0;
            }
        }
    };
    SummaryRow.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = typeCast(SummaryCellModel.$, a);
        e.kb = this.ff;
        e.j4 = this.d0;
        e.ku = this.fg;
        e.kg = this.en;
        e.fh = this.ev;
        e.fl = this.ex;
        e.fj = this.ew;
        e.ff = this.eu;
    };
    SummaryRow.prototype.cz = function (a, b) {
        this.e8();
        this.e9();
        this.c8();
        this.df();
        this.dg();
        this.fa();
    };
    SummaryRow.prototype.fh = function () {
        return GridStyleRepository.ba;
    };
    SummaryRow.prototype.eg = function () {
        return GridStyleRepository.bb;
    };
    SummaryRow.prototype.c1 = function (a, b) {
        switch (b.propertyName) {
            case "SummaryRootSelectedBackground":
            case "SummarySectionSelectedBackground":
                this.e8();
                break;
            case "SummaryRootBackground":
            case "SummarySectionBackground":
                this.c8();
                break;
            case "SummaryRootValueTextColor":
            case "SummarySectionValueTextColor":
                this.df();
                break;
            case "SummaryRootLabelTextColor":
            case "SummarySectionLabelTextColor":
                this.e9();
                break;
            case "SummaryRootLabelTextStyle":
            case "SummarySectionLabelTextStyle":
                this.fa();
                break;
            case "SummaryRootValueTextStyle":
            case "SummarySectionValueTextStyle":
                this.dg();
                break;
        }
    };
    SummaryRow.prototype.e8 = function () {
        if (this.fi == null) {
            this.ff = this.ee();
        }
        else {
            this.ff = this.fi;
        }
    };
    SummaryRow.prototype.e9 = function () {
    };
    SummaryRow.prototype.dg = function () {
    };
    SummaryRow.prototype.fa = function () {
    };
    SummaryRow.prototype.c3 = function (a, b, c, d) {
        _super.prototype.c3.call(this, a, b, c, d);
        switch (a) {
            case "SelectedBackground":
                this.e8();
                break;
            case "SummaryLabelTextColor":
                this.e9();
                break;
            case "SummaryNameFontInfo":
                this.fa();
                break;
        }
    };
    SummaryRow.prototype.af = function () {
        return GridStyleRepository.j;
    };
    SummaryRow.prototype.eo = function () {
        return GridStyleRepository.i;
    };
    SummaryRow.$t = markType(SummaryRow, 'SummaryRow', DefinitionBase.$);
    return SummaryRow;
}(DefinitionBase));
export { SummaryRow };
/**
 * @hidden
 */
var SummaryRowRoot = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryRowRoot, _super);
    function SummaryRowRoot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryRowRoot.prototype.cm = function (a, b, c) {
        return "summaryRowRoot";
    };
    SummaryRowRoot.prototype.eb = function () {
        return GridStyleRepository.a3;
    };
    SummaryRowRoot.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.ug != null) {
                this.d0 = this.grid.ug;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    SummaryRowRoot.prototype.e8 = function () {
        if (this.fi == null) {
            if (this.grid != null && this.grid.ui != null) {
                this.ff = this.grid.ui;
            }
            else {
                this.ff = this.ee();
            }
        }
        else {
            this.ff = this.fi;
        }
    };
    SummaryRowRoot.prototype.e9 = function () {
        if (this.fj == null) {
            if (this.grid != null && this.grid.uh != null) {
                this.fg = this.grid.uh;
            }
            else {
                this.fg = this.fh();
            }
        }
        else {
            this.fg = this.fj;
        }
    };
    SummaryRowRoot.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.uj != null) {
                this.d6 = this.grid.uj;
            }
            else {
                this.d6 = this.eg();
            }
        }
        else {
            this.d6 = this.ek;
        }
    };
    SummaryRowRoot.prototype.fa = function () {
        if (this.summaryNameTextStyle == null) {
            if (this.grid != null && this.grid.fl != null) {
                this.en = this.grid.fl;
            }
            else {
                this.en = this.eo();
            }
        }
        else {
            this.en = this.summaryNameTextStyle;
        }
    };
    SummaryRowRoot.$t = markType(SummaryRowRoot, 'SummaryRowRoot', SummaryRow.$);
    return SummaryRowRoot;
}(SummaryRow));
export { SummaryRowRoot };
/**
 * @hidden
 */
var SummaryRowSection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryRowSection, _super);
    function SummaryRowSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryRowSection.prototype.cm = function (a, b, c) {
        return "summaryRowSection";
    };
    SummaryRowSection.prototype.eb = function () {
        return GridStyleRepository.a6;
    };
    SummaryRowSection.prototype.c8 = function () {
        if (this.d7 == null) {
            if (this.grid != null && this.grid.uk != null) {
                this.d0 = this.grid.uk;
                return;
            }
            this.d0 = this.eb();
        }
        else {
            this.d0 = this.d7;
        }
    };
    SummaryRowSection.prototype.e8 = function () {
        if (this.fi == null) {
            if (this.grid != null && this.grid.um != null) {
                this.ff = this.grid.um;
            }
            else {
                this.ff = this.ee();
            }
        }
        else {
            this.ff = this.fi;
        }
    };
    SummaryRowSection.prototype.e9 = function () {
        if (this.fj == null) {
            if (this.grid != null && this.grid.ul != null) {
                this.fg = this.grid.ul;
            }
            else {
                this.fg = this.fh();
            }
        }
        else {
            this.fg = this.fj;
        }
    };
    SummaryRowSection.prototype.df = function () {
        if (this.ek == null) {
            if (this.grid != null && this.grid.un != null) {
                this.d6 = this.grid.un;
            }
            else {
                this.d6 = this.eg();
            }
        }
        else {
            this.d6 = this.ek;
        }
    };
    SummaryRowSection.prototype.fa = function () {
        if (this.summaryNameTextStyle == null) {
            if (this.grid != null && this.grid.fn != null) {
                this.en = this.grid.fn;
            }
            else {
                this.en = this.eo();
            }
        }
        else {
            this.en = this.summaryNameTextStyle;
        }
    };
    SummaryRowSection.$t = markType(SummaryRowSection, 'SummaryRowSection', SummaryRow.$);
    return SummaryRowSection;
}(SummaryRow));
export { SummaryRowSection };
/**
 * @hidden
 */
var TemplateColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateColumn, _super);
    function TemplateColumn() {
        var _this = _super.call(this) || this;
        _this.cellUpdating = null;
        _this.ga = false;
        return _this;
    }
    TemplateColumn.prototype.l = function (a) {
        return new TemplateCellModel();
    };
    TemplateColumn.prototype.cm = function (a, b, c) {
        var d = "template-" + this.g2;
        return d;
    };
    TemplateColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        e.kh = c;
    };
    TemplateColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
    };
    TemplateColumn.prototype.jh = function (a, b) {
        if (this.cellUpdating != null) {
            this.cellUpdating(this, ((function () {
                var $ret = new TemplateCellUpdatingEventArgs();
                $ret.cellInfo = a;
                $ret.content = b;
                return $ret;
            })()));
        }
    };
    TemplateColumn.prototype.c3 = function (a, b, c, d) {
        switch (a) {
            case "IsEditable":
                this.ga = false;
                break;
        }
        _super.prototype.c3.call(this, a, b, c, d);
    };
    TemplateColumn.$t = markType(TemplateColumn, 'TemplateColumn', Column.$);
    return TemplateColumn;
}(Column));
export { TemplateColumn };
/**
 * @hidden
 */
var TemplateCellUpdatingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellUpdatingEventArgs, _super);
    function TemplateCellUpdatingEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cellInfo = null;
        _this._content = null;
        return _this;
    }
    Object.defineProperty(TemplateCellUpdatingEventArgs.prototype, "cellInfo", {
        get: function () {
            return this._cellInfo;
        },
        set: function (a) {
            this._cellInfo = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemplateCellUpdatingEventArgs.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (a) {
            this._content = a;
        },
        enumerable: true,
        configurable: true
    });
    TemplateCellUpdatingEventArgs.$t = markType(TemplateCellUpdatingEventArgs, 'TemplateCellUpdatingEventArgs', EventArgs.$);
    return TemplateCellUpdatingEventArgs;
}(EventArgs));
export { TemplateCellUpdatingEventArgs };
/**
 * @hidden
 */
var TextColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextColumn, _super);
    function TextColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.jj = null;
        return _this;
    }
    Object.defineProperty(TextColumn.prototype, "jm", {
        get: function () {
            return this.jj;
        },
        set: function (a) {
            var b = this.jj;
            this.jj = a;
            if (this.jj != b) {
                this.c2("FormatString", 8, b, this.jj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "jh", {
        get: function () {
            return this.fc;
        },
        set: function (a) {
            this.fc = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "ji", {
        get: function () {
            return this.g4;
        },
        set: function (a) {
            this.g4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "jk", {
        get: function () {
            return this.ht;
        },
        set: function (a) {
            this.ht = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextColumn.prototype, "jg", {
        get: function () {
            return this.em;
        },
        set: function (a) {
            this.em = a;
        },
        enumerable: true,
        configurable: true
    });
    TextColumn.prototype.l = function (a) {
        return new TextCellModel();
    };
    TextColumn.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        if (c != null) {
            e.kh = this.jl(c);
        }
        else {
            e.kh = null;
        }
    };
    TextColumn.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
    };
    TextColumn.prototype.jl = function (a) {
        if (typeof a === 'string') {
            return a;
        }
        return null;
    };
    TextColumn.prototype.cm = function (a, b, c) {
        return "text";
    };
    TextColumn.$t = markType(TextColumn, 'TextColumn', Column.$);
    return TextColumn;
}(Column));
export { TextColumn };
/**
 * @hidden
 */
var TextHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeader, _super);
    function TextHeader() {
        var _this = _super.call(this) || this;
        _this.c = 0;
        _this.h = 1;
        return _this;
    }
    TextHeader.prototype.l = function (a) {
        var b = new TextHeaderCellModel();
        return b;
    };
    TextHeader.prototype.cm = function (a, b, c) {
        return "textHeader";
    };
    TextHeader.prototype.cw = function (a, b, c, d) {
        _super.prototype.cw.call(this, a, b, c, d);
        var e = a;
        var f = b.a0(a.k);
        e.kk = f.ex;
        e.k2 = f.i9;
        e.km = f.e1;
    };
    TextHeader.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        var f = b.a0(a.k);
        e.kh = f.hh;
        e.ie = e.kh;
        e.m = f.e6;
        e.kq = f.f3;
        e.ko = this.en;
    };
    TextHeader.$t = markType(TextHeader, 'TextHeader', Header.$);
    return TextHeader;
}(Header));
export { TextHeader };
/**
 * @hidden
 */
var GridEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridEffect, _super);
    function GridEffect() {
        var _this = _super.call(this) || this;
        _this.s = 0;
        _this.u = 0;
        _this.br = "";
        _this.af = false;
        _this.ac = false;
        _this.onFinished = null;
        _this.onCanceled = null;
        _this.a3 = 0;
        _this.a1 = 0;
        _this.h = null;
        _this.a7 = -1;
        _this.a8 = -1;
        _this.a2 = 300;
        _this.j = null;
        _this.a4 = 0;
        _this.c = null;
        _this.a = null;
        _this.a6 = -1;
        _this.ad = false;
        _this.ab = false;
        _this.bk = -1;
        _this.bm = null;
        _this.bn = null;
        _this.w = null;
        _this.p = null;
        _this.aa = false;
        _this.n = null;
        _this.ae = false;
        _this.ay = null;
        _this.az = 1;
        _this.a5 = -1;
        _this.b = null;
        _this.ax = new Dictionary$2(CellPath.$, Number_$type, 0);
        return _this;
    }
    GridEffect.prototype.bu = function () {
        if (this.onFinished != null) {
            this.onFinished(this);
        }
    };
    GridEffect.prototype.bt = function (a) {
        if (this.onCanceled != null) {
            this.onCanceled(this, a);
        }
    };
    Object.defineProperty(GridEffect.prototype, "t", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            this.s = a;
        },
        enumerable: true,
        configurable: true
    });
    GridEffect.prototype.am = function (a) {
        if (a == null) {
            return false;
        }
        if (a.s != this.s) {
            return false;
        }
        if (!this.af) {
            return true;
        }
        if (a.u != this.u) {
            return false;
        }
        if (a.br != this.br) {
            return false;
        }
        return true;
    };
    Object.defineProperty(GridEffect.prototype, "v", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            this.u = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bs", {
        get: function () {
            return this.br;
        },
        set: function (a) {
            this.br = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "as", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            this.af = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ap", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            this.ac = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ba", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            this.a3 = a;
            this.a1 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            this.h = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bi", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            this.a7 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bj", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            this.a8 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "a9", {
        get: function () {
            return this.a2;
        },
        set: function (a) {
            this.a2 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bg", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            this.a4 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "g", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "e", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            this.a = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bh", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            this.a6 = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "aq", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            this.ad = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ao", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            this.ab = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bl", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            this.bk = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bo", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            this.bm = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "bq", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            this.bn = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "x", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            this.w = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "q", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            this.p = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "al", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            this.aa = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "o", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            this.n = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridEffect.prototype, "ar", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            this.ae = a;
        },
        enumerable: true,
        configurable: true
    });
    GridEffect.prototype.bx = function (a) {
        this.ba = a.l;
        this.bg = a.m;
        this.bi = a.n;
        this.bj = a.o;
        this.aq = a.e;
        this.q = this.r(a.c);
    };
    GridEffect.prototype.r = function (a) {
        switch (a) {
            case 0: return null;
            case 1: return EasingFunctions.cubicEase;
            case 3: return EasingFunctions.circleEase;
            case 2: return EasingFunctions.exponentialEase;
        }
        return null;
    };
    GridEffect.prototype.au = function (a, b, c, d) {
        if (this.ar && this.an(d)) {
            return false;
        }
        var e = this.a0(d);
        var f = 1;
        if (this.a3 > 0) {
            f = e / this.a3;
        }
        var g = false;
        if (this.w == null) {
            return true;
        }
        if (f >= 1) {
            f = 1;
            g = true;
        }
        if (this.p != null) {
            f = this.p(f);
        }
        var h = this.bp(this.bm, b, a, a.o);
        this.w(f, h, this.bn, a, b);
        return g;
    };
    GridEffect.prototype.av = function (a, b, c, d) {
        if (this.ar && this.an(d)) {
            return false;
        }
        var e = this.a0(d);
        var f = 1;
        if (this.a3 > 0) {
            f = e / this.a3;
        }
        var g = false;
        if (this.w == null) {
            return true;
        }
        if (f >= 1) {
            f = 1;
            g = true;
        }
        if (this.p != null) {
            f = this.p(f);
        }
        var h = this.bp(this.bm, b, a, a);
        this.w(f, h, this.bn, a, b);
        return g;
    };
    GridEffect.prototype.a0 = function (a) {
        var b = (a - this.bk);
        if (this.a4 > 0) {
            if (b < this.a4) {
                b = 0;
            }
            else {
                b -= this.a4;
            }
        }
        return b;
    };
    GridEffect.prototype.an = function (a) {
        var b = (a - this.bk);
        if (this.a4 > 0) {
            if (b < this.a4) {
                return true;
            }
        }
        return false;
    };
    GridEffect.prototype.bz = function (a, b, c, d) {
        var e = this.bb(b, a);
        if (this.f == null) {
            return;
        }
        var f = this.bb(b, this.f);
        var g = f / this.a6;
        if (g > 5) {
            g = 5;
        }
        if (g == this.az) {
            return;
        }
        var h = g / this.az;
        this.az = g;
        var i = truncate(Math.round(this.a1 * h));
        if (i <= 0) {
            var j = 0;
            j += 1;
        }
        {
            this.a1 = i;
        }
    };
    GridEffect.prototype.at = function (a, b, c, d) {
        var e = false;
        this.bz(a.k, b, c, d);
        if (this.ar && this.an(d)) {
            return false;
        }
        var f = this.a0(d);
        var g = this.bf(b, c, a.k, d);
        var h = this.bc(b, c, a.k, d);
        if (h < 300) {
            var i = 0;
            i += 1;
        }
        var j = f - g;
        if (j < 0) {
            j = 0;
        }
        var k = 1;
        if (h > 0) {
            k = j / h;
        }
        if (k >= 1) {
            k = 1;
            e = true;
        }
        if (this.p != null) {
            k = this.p(k);
        }
        var l = this.bp(this.bm, b, a, a.k);
        this.w(k, l, this.bn, a, b);
        return e;
    };
    GridEffect.prototype.by = function (a, b, c) {
        if (this.ay == null) {
            this.ay = new Dictionary$2(Base.$, Base.$, 0);
        }
        this.ay.item(c, a);
    };
    GridEffect.prototype.bp = function (a, b, c, d) {
        if (this.al) {
            if (this.ay == null) {
                this.ay = new Dictionary$2(Base.$, Base.$, 0);
            }
            if (this.ay.containsKey(d)) {
                return this.ay.item(d);
            }
            var e = this.o(c, b);
            this.ay.item(d, e);
            return e;
        }
        else {
            return this.bm;
        }
    };
    GridEffect.prototype.aw = function (a, b, c, d) {
        if (this.ar && this.an(d)) {
            return false;
        }
        var e = this.a0(d);
        var f = 1;
        if (this.a3 > 0) {
            f = e / this.a3;
        }
        var g = false;
        if (this.w == null) {
            return true;
        }
        if (f >= 1) {
            f = 1;
            g = true;
        }
        if (this.p != null) {
            f = this.p(f);
        }
        this.w(f, this.bm, this.bn, a, b);
        return g;
    };
    GridEffect.prototype.ag = function (a, b) {
        return false;
    };
    GridEffect.prototype.ah = function (a, b) {
        return false;
    };
    GridEffect.prototype.ai = function (a, b) {
        return false;
    };
    GridEffect.prototype.aj = function (a, b) {
        return false;
    };
    GridEffect.prototype.bv = function (a) {
    };
    GridEffect.prototype.bw = function (a) {
    };
    Object.defineProperty(GridEffect.prototype, "f", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    GridEffect.prototype.bf = function (a, b, c, d) {
        if (c == null) {
            return 0;
        }
        var e = this.bb(a, c);
        var f = this.bd(a, b, c, d);
        var g = this.a3;
        if (this.ad) {
            g = truncate(((f / this.a6) * g));
        }
        var h = this.a7;
        if (h == -1) {
            h = truncate((g / f));
            if ((g - truncate((f * h))) < this.a2) {
                h = truncate(((g - this.a2) / f));
            }
            if (h < 0) {
                h = 0;
            }
        }
        var i = h * e;
        if (this.h != null) {
            i = this.h(this.c, this.a6, c);
        }
        var j = this.a1;
        if (i < (j * -1)) {
            i = (j * -1);
        }
        if (i > (j)) {
            i = j - this.a2;
        }
        if (this.ad && this.a0(d) > i && c != null && !this.ax.containsKey(c)) {
            this.ax.addItem(c, f);
        }
        return i;
    };
    GridEffect.prototype.bd = function (a, b, c, d) {
        if (this.f == null || !this.ad) {
            return this.a6;
        }
        if (this.ax.containsKey(c)) {
            return this.ax.item(c);
        }
        var e = this.bb(a, this.f);
        return e;
    };
    GridEffect.prototype.bb = function (a, b) {
        if (b == null) {
            return 0;
        }
        var c = this.be(a, b);
        if (this.a6 == -1) {
            this.a6 = this.be(a, this.a) + 1;
        }
        if (this.ab) {
            c = ((this.a6 - 1) - c);
        }
        var d = c;
        if (d > this.a6 && d > this.a5) {
            this.a5 = d;
            this.b = b;
        }
        return d;
    };
    GridEffect.prototype.be = function (a, b) {
        return 0;
    };
    GridEffect.prototype.bc = function (a, b, c, d) {
        var e = this.a1;
        if (this.j != null) {
            if (this.a6 == -1) {
                this.a6 = this.be(a, this.a) + 1;
            }
            e = this.j(this.c, this.a6, c);
        }
        else {
            if (this.a8 == -1) {
                if (this.ad) {
                    var f = this.bd(a, b, c, d);
                    e = this.a3;
                    e = truncate(((f / this.a6) * e));
                    e = e - this.bf(a, b, c, d);
                }
                else {
                    if (this.ab) {
                        e = this.a3 - this.bf(a, b, this.d(a), d);
                    }
                    else {
                        e = this.a3 - this.bf(a, b, this.a, d);
                    }
                }
            }
            else {
                e = this.a8;
            }
        }
        return e;
    };
    GridEffect.prototype.d = function (a) {
        return this.c;
    };
    GridEffect.prototype.y = function (a, b) {
        if (b.x == a.x) {
            if (b.w <= a.w) {
                a = a.aa();
                a.w += 1;
            }
        }
        return a;
    };
    GridEffect.prototype.z = function (a, b) {
        if (b.x == a.x) {
            if (b.w < a.w) {
                a = a.aa();
                a.w -= 1;
            }
        }
        return a;
    };
    GridEffect.prototype.ak = function (a, b, c) {
        var d = this.a0(c);
        return d >= this.a1;
    };
    GridEffect.$t = markType(GridEffect, 'GridEffect');
    return GridEffect;
}(Base));
export { GridEffect };
/**
 * @hidden
 */
var ColumnEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnEffect, _super);
    function ColumnEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = 0;
        return _this;
    }
    ColumnEffect.prototype.ah = function (a, b) {
        if (this.b0 == a.o) {
            return true;
        }
        return false;
    };
    ColumnEffect.$t = markType(ColumnEffect, 'ColumnEffect', GridEffect.$);
    return ColumnEffect;
}(GridEffect));
export { ColumnEffect };
/**
 * @hidden
 */
var SpacerEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SpacerEffect, _super);
    function SpacerEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = 0;
        return _this;
    }
    SpacerEffect.prototype.aj = function (a, b) {
        return a.o == this.b0;
    };
    SpacerEffect.$t = markType(SpacerEffect, 'SpacerEffect', GridEffect.$);
    return SpacerEffect;
}(GridEffect));
export { SpacerEffect };
/**
 * @hidden
 */
var ColumnCellsEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnCellsEffect, _super);
    function ColumnCellsEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b2 = 0;
        _this.b1 = 0;
        _this.b0 = 0;
        return _this;
    }
    ColumnCellsEffect.prototype.ag = function (a, b) {
        if (this.b2 == -300) {
            if (a.aq) {
                return true;
            }
        }
        if (this.b2 == -400) {
            if (a.ax == -400) {
                return true;
            }
        }
        if (this.b1 >= 0) {
            if (this.b1 == a.ax && this.b0 == a.b) {
                return true;
            }
        }
        else {
            var c = b.g(this.b2);
            if (c == null) {
                return false;
            }
            if (a.ax == c.m && c.c == a.b) {
                return true;
            }
        }
        return false;
    };
    ColumnCellsEffect.prototype.d = function (a) {
        if (a.ci > 0) {
            var b = this.g;
            var c = new CellPath(0, b.b, b.ax, -100, -100);
            return c;
        }
        else {
            return this.g;
        }
    };
    ColumnCellsEffect.prototype.be = function (a, b) {
        var c = this.g;
        var d = this.e;
        var e = b;
        if (e == null) {
            return 0;
        }
        if (e.g) {
            return 0;
        }
        var f = 0;
        if (a.ci > 0) {
            f++;
        }
        if (c == null) {
            return 0;
        }
        if (e.at && e.i) {
            if (d == null) {
                return 0;
            }
            return (d.w - c.w) + f - e.o;
        }
        if (e.x == c.x) {
            return (e.w - c.w) + f;
        }
        var g = f;
        var h = c.x;
        if (e.x > c.x) {
            while (h <= e.x) {
                if (h == c.x) {
                    g += (a.bv._inner[h].m - 1) - c.w;
                    if (a.bv._inner[h].d > 0) {
                        g++;
                    }
                }
                else if (h == e.x) {
                    if (a.bv._inner[h].g > 0) {
                        g++;
                    }
                    g += (e.w + 1);
                }
                else {
                    if (a.bv._inner[h].g > 0) {
                        g++;
                    }
                    g += a.bv._inner[h].m;
                    if (a.bv._inner[h].d > 0) {
                        g++;
                    }
                }
                h++;
            }
        }
        else if (e.x < c.x) {
            while (h >= e.x) {
                if (h == c.x) {
                    g -= c.w;
                    if (a.bv._inner[h].d > 0) {
                        g++;
                    }
                }
                else if (h == e.x) {
                    if (a.bv._inner[h].d > 0) {
                        g--;
                    }
                    g -= (a.bv._inner[h].m - e.w);
                }
                else {
                    if (a.bv._inner[h].g > 0) {
                        g--;
                    }
                    g -= a.bv._inner[h].m;
                    if (a.bv._inner[h].d > 0) {
                        g--;
                    }
                }
                h--;
            }
        }
        return g;
    };
    ColumnCellsEffect.$t = markType(ColumnCellsEffect, 'ColumnCellsEffect', GridEffect.$);
    return ColumnCellsEffect;
}(GridEffect));
export { ColumnCellsEffect };
/**
 * @hidden
 */
var CellEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellEffect, _super);
    function CellEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b4 = 0;
        _this.b3 = 0;
        _this.b1 = 0;
        _this.b0 = null;
        _this.b2 = false;
        return _this;
    }
    CellEffect.prototype.ag = function (a, b) {
        if (this.b0.w == a.w) {
            if (this.b4 == -400) {
                if (a.ax == -400) {
                    return true;
                }
            }
            if (this.b3 >= 0) {
                if (this.b3 == a.ax && this.b1 == a.b) {
                    return true;
                }
            }
            else {
                var c = b.g(this.b4);
                if (c == null) {
                    return false;
                }
                if (a.ax == c.m && c.c == a.b) {
                    return true;
                }
            }
        }
        return false;
    };
    CellEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    CellEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    CellEffect.$t = markType(CellEffect, 'CellEffect', GridEffect.$);
    return CellEffect;
}(GridEffect));
export { CellEffect };
/**
 * @hidden
 */
var CellPositionEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellPositionEffect, _super);
    function CellPositionEffect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellPositionEffect.prototype.ag = function (a, b) {
        return this.b0.equals(a);
    };
    CellPositionEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    CellPositionEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    CellPositionEffect.$t = markType(CellPositionEffect, 'CellPositionEffect', CellEffect.$);
    return CellPositionEffect;
}(CellEffect));
export { CellPositionEffect };
/**
 * @hidden
 */
var RowEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowEffect, _super);
    function RowEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = null;
        return _this;
    }
    RowEffect.prototype.ai = function (a, b) {
        if (this.b0.equals(a)) {
            return true;
        }
        return false;
    };
    RowEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    RowEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    RowEffect.$t = markType(RowEffect, 'RowEffect', GridEffect.$);
    return RowEffect;
}(GridEffect));
export { RowEffect };
/**
 * @hidden
 */
var RowCellsEffect = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowCellsEffect, _super);
    function RowCellsEffect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b0 = null;
        return _this;
    }
    RowCellsEffect.prototype.ag = function (a, b) {
        if (this.b0.x == a.x && this.b0.w == a.w && this.b0.b == a.b) {
            return true;
        }
        return false;
    };
    RowCellsEffect.prototype.bv = function (a) {
        this.b0 = this.y(this.b0, a);
    };
    RowCellsEffect.prototype.bw = function (a) {
        this.b0 = this.z(this.b0, a);
    };
    RowCellsEffect.prototype.be = function (a, b) {
        if (this.g == null || b.as) {
            return 0;
        }
        if (b.aq) {
            return this.be(a, this.e);
        }
        var c = a.br._inner[this.g.ax].n;
        var d = a.br._inner[b.ax].n;
        if (b.d == 0) {
            d = a.br._inner[b.ax].n - a.co;
        }
        else if (b.d == 2) {
            d = a.br._inner[b.ax].n - (a.co + a.cr);
        }
        return d - c;
    };
    RowCellsEffect.$t = markType(RowCellsEffect, 'RowCellsEffect', GridEffect.$);
    return RowCellsEffect;
}(GridEffect));
export { RowCellsEffect };
/**
 * @hidden
 */
var GridEffectManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridEffectManager, _super);
    function GridEffectManager(a, b) {
        var _this = _super.call(this) || this;
        _this.b = null;
        _this.k = new List$1(ColumnEffect.$, 0);
        _this.j = new List$1(ColumnCellsEffect.$, 0);
        _this.m = new List$1(RowEffect.$, 0);
        _this.l = new List$1(RowCellsEffect.$, 0);
        _this.i = new List$1(CellEffect.$, 0);
        _this.n = new List$1(SpacerEffect.$, 0);
        _this.q = -30;
        _this.o = -1;
        _this.a = null;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    Object.defineProperty(GridEffectManager.prototype, "c", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    GridEffectManager.prototype.ae = function (a) {
        for (var b = 0; b < this.l.count; b++) {
            this.l._inner[b].bv(a);
        }
        for (var c = 0; c < this.m.count; c++) {
            this.m._inner[c].bv(a);
        }
        for (var d = 0; d < this.i.count; d++) {
            this.i._inner[d].bv(a);
        }
    };
    GridEffectManager.prototype.af = function (a) {
        for (var b = this.l.count - 1; b >= 0; b--) {
            if (a.equals(this.l._inner[b].b0)) {
                this.aj(this.l._inner[b].b0, false, this.l._inner[b]);
            }
            else {
                this.l._inner[b].bw(a);
            }
        }
        for (var c = this.m.count - 1; c >= 0; c--) {
            if (a.equals(this.m._inner[c].b0)) {
                this.ak(this.m._inner[c].b0, false, this.m._inner[c]);
            }
            else {
                this.m._inner[c].bw(a);
            }
        }
        for (var d = this.i.count - 1; d >= 0; d--) {
            if (a.equals(this.i._inner[d].b0)) {
                this.ag(this.i._inner[d].b0, false, this.i._inner[d]);
            }
            else {
                this.i._inner[d].bw(a);
            }
        }
    };
    GridEffectManager.prototype.ad = function () {
        var _this = this;
        var a = this.k.count > 0;
        this.a.h9 = true;
        this.an(false);
        if (a) {
            var b = this.a.model.absoluteWidth;
            this.a.ey.q(this.a, this.a.model, truncate(this.a.i7));
            this.d();
            if (b != this.a.model.absoluteWidth) {
                this.a.externalGrid.onContentSizeChanged();
            }
        }
        this.a.h9 = false;
        this.a.renderingEngine.invalidateVisibility(function () { return _this.a.e4.l(_this.a); });
        this.a.renderingEngine.refresh(this.a.model, true);
    };
    GridEffectManager.prototype.d = function () {
        var a = this.k.count > 0;
        var b = this.p();
        var c = this.a.model;
        var d = this.a.db;
        this.f(b, c, d);
        return a;
    };
    GridEffectManager.prototype.ac = function () {
        var a = this.p();
        var b = this.a.model;
        var c = this.a.db;
        this.g(a, b, c);
    };
    GridEffectManager.prototype.ab = function () {
        var a = this.p();
        var b = this.a.model;
        var c = this.a.db;
        this.e(a, b, c);
    };
    GridEffectManager.prototype.an = function (a) {
        var b = this.p();
        if ((b - this.q < 15) && !a) {
            this.b.requestFrame(this.o);
            return;
        }
        var c = this.a.model;
        var d = this.a.db;
        var e = true;
        if (!this.f(b, c, d)) {
            e = false;
        }
        if (!this.h(b, c, d)) {
            e = false;
        }
        if (!this.g(b, c, d)) {
            e = false;
        }
        if (!this.e(b, c, d)) {
            e = false;
        }
        if (e && this.k.count == 0 && this.j.count == 0 && this.i.count == 0 && this.m.count == 0 && this.l.count == 0 && this.n.count == 0) {
            this.am();
        }
        else {
            this.b.requestFrame(this.o);
        }
    };
    GridEffectManager.prototype.p = function () {
        var a = dateNow();
        return a.getTime();
    };
    GridEffectManager.prototype.am = function () {
        this.b.teardownTicking(this.o);
        this.o = -1;
    };
    GridEffectManager.prototype.aa = function () {
        if (this.o == -1) {
            this.o = this.b.setupTicking(runOn(this, this.ad));
            this.b.requestFrame(this.o);
        }
    };
    GridEffectManager.prototype.u = function (a, b) {
        b.b0 = a.o;
        b.bl = this.p();
        this.ai(a.o, true, b);
        this.k.add(b);
        this.aa();
    };
    GridEffectManager.prototype.ai = function (a, b, c) {
        for (var d = this.k.count - 1; d >= 0; d--) {
            if (this.k._inner[d].b0 == a && this.k._inner[d].am(c)) {
                if (b) {
                    this.k._inner[d].bt(c);
                }
                this.k.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.z = function (a, b) {
        b.b0 = a.o;
        b.bl = this.p();
        this.al(a, true, b);
        this.n.add(b);
        this.aa();
    };
    GridEffectManager.prototype.al = function (a, b, c) {
        for (var d = this.n.count - 1; d >= 0; d--) {
            if (this.n._inner[d].b0 == a.o && this.n._inner[d].am(c)) {
                if (b) {
                    this.n._inner[d].bt(c);
                }
                this.n.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.t = function (a, b) {
        b.b2 = a.o;
        b.bl = this.p();
        this.ah(a.o, true, b);
        this.j.add(b);
        this.aa();
    };
    GridEffectManager.prototype.x = function (a) {
        a.b2 = -300;
        a.bl = this.p();
        this.ah(-300, true, a);
        this.j.add(a);
        this.aa();
    };
    GridEffectManager.prototype.y = function (a) {
        a.b2 = -400;
        a.bl = this.p();
        this.ah(-400, true, a);
        this.j.add(a);
        this.aa();
    };
    GridEffectManager.prototype.ah = function (a, b, c) {
        for (var d = this.j.count - 1; d >= 0; d--) {
            if (this.j._inner[d].b2 == a && this.j._inner[d].am(c)) {
                if (b) {
                    this.j._inner[d].bt(c);
                }
                this.j.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.w = function (a, b) {
        b.b0 = a;
        b.bl = this.p();
        this.ak(a, true, b);
        this.m.add(b);
        this.aa();
    };
    GridEffectManager.prototype.ak = function (a, b, c) {
        for (var d = this.m.count - 1; d >= 0; d--) {
            if (this.m._inner[d].b0.equals(a) && this.m._inner[d].am(c)) {
                if (b) {
                    this.m._inner[d].bt(c);
                }
                this.m.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.v = function (a, b) {
        b.b0 = a;
        b.bl = this.p();
        this.aj(a, true, b);
        this.l.add(b);
        this.aa();
    };
    GridEffectManager.prototype.aj = function (a, b, c) {
        for (var d = this.l.count - 1; d >= 0; d--) {
            if (this.l._inner[d].b0.equals(a) && this.l._inner[d].am(c)) {
                if (b) {
                    this.l._inner[d].bt(c);
                }
                this.l.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.r = function (a, b, c) {
        b.b4 = c;
        b.b0 = a;
        b.bl = this.p();
        b.b2 = true;
        this.ag(a, true, b);
        this.i.add(b);
        this.aa();
    };
    GridEffectManager.prototype.s = function (a, b) {
        b.b0 = a;
        b.bl = this.p();
        b.b2 = false;
        this.ag(a, true, b);
        this.i.add(b);
        this.aa();
    };
    GridEffectManager.prototype.ag = function (a, b, c) {
        for (var d = this.i.count - 1; d >= 0; d--) {
            if (this.i._inner[d].b0.equals(a) && this.i._inner[d].am(c)) {
                if (b) {
                    this.i._inner[d].bt(c);
                }
                this.i.removeAt(d);
            }
        }
    };
    GridEffectManager.prototype.f = function (a, b, c) {
        var d = true;
        var e;
        var f;
        var g = new List$1(ColumnEffect.$, 0);
        for (var h = 0; h < this.k.count; h++) {
            if (b.g(this.k._inner[h].b0) == null) {
                this.ai(this.k._inner[h].b0, false, this.k._inner[h]);
            }
        }
        for (var i = 0; i < b.br.count; i++) {
            e = b.br._inner[i];
            for (var j = 0; j < this.k.count; j++) {
                f = this.k._inner[j];
                if (f.ah(e, b)) {
                    if (!f.au(e, b, c, a)) {
                        d = false;
                    }
                    else {
                        g.add(f);
                    }
                }
            }
        }
        for (var k = 0; k < g.count; k++) {
            this.ai(g._inner[k].b0, false, g._inner[k]);
            g._inner[k].bu();
        }
        return d;
    };
    GridEffectManager.prototype.h = function (a, b, c) {
        var d = true;
        var e = b.bw;
        var f = new List$1(GridColumnSpacer.$, 0);
        var g = new List$1(SpacerEffect.$, 0);
        for (var h = 0; h < e.count; h++) {
            var i = e._inner[h];
            for (var j = 0; j < i.count; j++) {
                var k = i._inner[j];
                for (var l = 0; l < this.n.count; l++) {
                    if (this.n._inner[l].aj(k, b)) {
                        if (!this.n._inner[l].av(k, b, c, a)) {
                            d = false;
                        }
                        else {
                            f.add(k);
                            g.add(this.n._inner[l]);
                        }
                    }
                }
            }
        }
        for (var m = 0; m < f.count; m++) {
            this.al(f._inner[m], false, g._inner[m]);
            g._inner[m].bu();
        }
        return d;
    };
    GridEffectManager.prototype.g = function (a, b, c) {
        var d = true;
        var e = new CellPath(1, 0, 0, 0);
        var f;
        for (var g = 0; g < this.m.count; g++) {
            f = this.m._inner[g];
            e.b = f.b0.b;
            e.w = f.b0.w;
            e.x = f.b0.x;
            if (!f.aw(b.bv._inner[e.x], b, c, a)) {
                d = false;
            }
        }
        return d;
    };
    GridEffectManager.prototype.e = function (a, b, c) {
        var d = true;
        if (this.j.count == 0 && this.l.count == 0 && this.i.count == 0) {
            return true;
        }
        for (var e = 0; e < this.j.count; e++) {
            this.j._inner[e].b1 = -1;
            var f = b.g(this.j._inner[e].b2);
            if (f != null) {
                this.j._inner[e].b1 = f.m;
                this.j._inner[e].b0 = f.c;
            }
            this.j._inner[e].ap = true;
        }
        for (var g = 0; g < this.l.count; g++) {
            this.l._inner[g].ap = true;
        }
        for (var h = 0; h < this.i.count; h++) {
            this.i._inner[h].b3 = -1;
            if (this.i._inner[h].b2) {
                var i = b.g(this.i._inner[h].b4);
                if (i != null) {
                    this.i._inner[h].b3 = i.m;
                    this.i._inner[h].b1 = i.c;
                }
            }
            this.i._inner[h].ap = true;
        }
        for (var j = 0; j < b.bu.count; j++) {
            var k = b.bu._inner[j];
            for (var l = 0; l < k.o.count; l++) {
                if (k.p._inner[l]) {
                    continue;
                }
                var m = k.o._inner[l];
                for (var n = 0; n < this.j.count; n++) {
                    var o = this.j._inner[n];
                    if (o.ag(m, b)) {
                        if (!o.at(k.q._inner[l], b, c, a)) {
                            o.ap = false;
                        }
                    }
                }
                for (var p = 0; p < this.l.count; p++) {
                    var q = this.l._inner[p];
                    if (q.ag(m, b)) {
                        if (!q.at(k.q._inner[l], b, c, a)) {
                            q.ap = false;
                        }
                    }
                }
                for (var r = 0; r < this.i.count; r++) {
                    var s = this.i._inner[r];
                    if (s.ag(m, b)) {
                        if (!s.at(k.q._inner[l], b, c, a)) {
                            s.ap = false;
                        }
                    }
                }
            }
        }
        var t = new List$1(ColumnCellsEffect.$, 0);
        for (var u = 0; u < this.j.count; u++) {
            if (this.j._inner[u].ak(b, c, a) && this.j._inner[u].ap) {
                t.add(this.j._inner[u]);
            }
            else {
                d = false;
            }
        }
        var v = new List$1(RowCellsEffect.$, 0);
        for (var w = 0; w < this.l.count; w++) {
            if (this.l._inner[w].ak(b, c, a) && this.l._inner[w].ap) {
                v.add(this.l._inner[w]);
            }
            else {
                d = false;
            }
        }
        var x = new List$1(CellEffect.$, 0);
        for (var y = 0; y < this.i.count; y++) {
            if (this.i._inner[y].ak(b, c, a) && this.i._inner[y].ap) {
                x.add(this.i._inner[y]);
            }
            else {
                d = false;
            }
        }
        for (var z = 0; z < t.count; z++) {
            this.ah(t._inner[z].b2, false, t._inner[z]);
            t._inner[z].bu();
        }
        for (var aa = 0; aa < v.count; aa++) {
            this.aj(v._inner[aa].b0, false, v._inner[aa]);
            v._inner[aa].bu();
        }
        for (var ab = 0; ab < x.count; ab++) {
            this.ag(x._inner[ab].b0, false, x._inner[ab]);
            x._inner[ab].bu();
        }
        return d;
    };
    GridEffectManager.$t = markType(GridEffectManager, 'GridEffectManager');
    return GridEffectManager;
}(Base));
export { GridEffectManager };
/**
 * @hidden
 */
var GridLayerController = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridLayerController, _super);
    function GridLayerController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.e = new RecyclingManager();
        return _this;
    }
    GridLayerController.prototype.a = function (a, b) {
        var c = b.bu;
        var d = c.count;
        for (var e = 0; e < d; e++) {
            var f = c._inner[e].b(a);
            if (f != undefined) {
                return f;
            }
        }
        return null;
    };
    GridLayerController.prototype.b = function (a, b, c, d, e, f, g, h) {
        var i = this.a(a, c);
        if (i == null) {
            var j = null;
            var k = null;
            var l = false;
            var m = -1;
            if (a.ag) {
                m = b.d3.getDataRow(a);
                k = b.d3.resolveValueForPath(b, a);
                if (k == null && b.d3.isPlaceholderValue(a)) {
                    l = true;
                }
            }
            var n = b.ms(a, b, k, m);
            j = this.e.a(n);
            if (j == null) {
                j = b.ao(a, n);
            }
            else {
                j.ji();
            }
            var o = a;
            if (j.k != null) {
                o = j.k;
            }
            if (c.bh.d(o)) {
                c.bh.item(o).remove(j);
                if (c.bh.item(o).count == 0) {
                    c.bh.f(o);
                }
            }
            d.s(a, j);
            j.q = d;
            j.k = a;
            j.v = e;
            j.ee = m;
            j.a3 = f;
            j.a4 = g;
            j.az = h;
            j.x = a.d;
            var p = false;
            var q = false;
            var r = 0;
            var s = j.k.ax;
            var t = (s >= 0 && c.br._inner[s].n == 0) || a.as;
            if (t) {
                r = b.d3.getRowIndent(j.k.w);
                var u = b.d3.getRowType(j.k.w);
                if (u == 1 && b.hg) {
                    if (b.ig) {
                        if (a.ax == -401 || (a.ax == -400 && c.cf == 0)) {
                            p = b.hg;
                            q = b.actualDataSource.getIsRowExpandedAtIndex(j.k.w);
                        }
                    }
                    else {
                        p = b.hg;
                        q = b.actualDataSource.getIsRowExpandedAtIndex(j.k.w);
                    }
                }
            }
            j.aq = p;
            j.ay = q;
            j.ey = r;
            b.q3(j, k, b.d3.resolveRow(m));
            if (l) {
                j.b6 = 1;
            }
            return j;
        }
        else {
            this.g(a, c, d);
            i.v = e;
            var v = i.k.a2;
            i.k = a;
            i.a3 = f;
            i.a4 = g;
            i.az = h;
            i.x = a.d;
            if (a.a2 != v && a.w >= 0 && a.ax >= 0) {
                i.a6 = b.es.o(i);
                if (i.a6) {
                    i.b3 = 1;
                }
                else {
                    i.b3 = 0;
                }
            }
            var w = false;
            var x = false;
            var y = 0;
            var z = i.k.ax;
            var aa = (z >= 0 && c.br._inner[z].n == 0) || a.as;
            if (aa) {
                y = b.d3.getRowIndent(i.k.w);
                var ab = b.d3.getRowType(i.k.w);
                if (ab == 1 && b.hg) {
                    if (b.ig) {
                        if (a.ax == -401 || (a.ax == -400 && c.cf == 0)) {
                            w = b.hg;
                            x = b.actualDataSource.getIsRowExpandedAtIndex(i.k.w);
                        }
                    }
                    else {
                        w = b.hg;
                        x = b.actualDataSource.getIsRowExpandedAtIndex(i.k.w);
                    }
                }
            }
            i.aq = w;
            i.ay = x;
            i.ey = y;
            return i;
        }
    };
    GridLayerController.prototype.d = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            if (b.bu._inner[c].d(a)) {
                return b.bu._inner[c];
            }
        }
        return null;
    };
    GridLayerController.prototype.g = function (a, b, c) {
        var d = this.d(a, b);
        if (d == null || d == c) {
            return;
        }
        var e = d.item(a);
        d.f(a);
        c.s(a, e);
        e.q = c;
    };
    GridLayerController.prototype.f = function (a, b, c) {
        if (c == null) {
            c = this.d(a, b);
        }
        if (c == null) {
            return;
        }
        var d = c.item(a);
        c.f(a);
        var e = null;
        if (b.bh.d(a)) {
            e = b.bh.item(a);
            if (e.count == 1) {
                var f = a.aa();
                b.bh.f(a);
                b.bh.s(f, e);
            }
        }
        else {
            e = new List$1(CellModel.$, 0);
            b.bh.s(a, e);
        }
        e.add(d);
    };
    GridLayerController.prototype.i = function (a, b) {
        var c = this.d(a, b);
        if (c == null) {
            return;
        }
        var d = this.c(a, b);
        this.f(a, b, c);
        this.e.c(d);
    };
    GridLayerController.prototype.j = function (a, b, c) {
        if (b == null) {
            return;
        }
        var d = b.item(a);
        this.f(a, c, b);
        this.e.c(d);
    };
    GridLayerController.prototype.c = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            if (b.bu._inner[c].d(a)) {
                return b.bu._inner[c].item(a);
            }
        }
        return null;
    };
    GridLayerController.prototype.h = function (a, b, c, d, e, f) {
        if (a.k.h) {
            a.b7 = c + a.bz + (a.b0 * b.br._inner[a.k.ax].k);
        }
        else {
            a.b7 = c + a.bz + (a.b0 * a.f8);
        }
        a.b8 = d + a.b4 + (a.b5 * a.ev);
        a.fv = truncate(Math.round(a.b7));
        a.fx = truncate(Math.round(a.b8));
        a.f8 = truncate(e);
        a.ev = truncate(f);
    };
    GridLayerController.$t = markType(GridLayerController, 'GridLayerController');
    return GridLayerController;
}(Base));
export { GridLayerController };
/**
 * @hidden
 */
var VisibilityEngine = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VisibilityEngine, _super);
    function VisibilityEngine() {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.c = null;
        _this.f = false;
        _this.j = 0;
        _this.e = false;
        return _this;
    }
    Object.defineProperty(VisibilityEngine.prototype, "k", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
        },
        enumerable: true,
        configurable: true
    });
    VisibilityEngine.prototype.v = function () {
        this.e = true;
    };
    VisibilityEngine.prototype.l = function (a) {
        var b = false;
        if (this.e) {
            this.e = false;
            b = true;
        }
        this.m(a, a.model, a.ey, b);
    };
    VisibilityEngine.prototype.m = function (a, b, c, d) {
        a.ph();
        var e = b.actualVisibleRegion;
        if (e.isEmpty) {
            return;
        }
        if (e.width == 0 || e.height == 0) {
            return;
        }
        if (b.br.count == 0) {
            return;
        }
        if (a.d3 == null) {
            return;
        }
        var f = this.a(a, b, c, e);
        for (var g = 0; g < b.bx.count; g++) {
            var h = b.bx._inner[g];
            var i = c.k(h, a, b);
            b.br._inner[h].l = i;
        }
        b.cp = 0;
        b.cv = 0;
        b.b7 = 0;
        b.bf = f.b;
        b.be = f.a;
        b.cn = f.k;
        b.cq = f.m;
        b.co = f.l;
        b.cr = f.n;
        a.rf();
        this.d = f.b;
        this.c = f.a;
        var j = a.db;
        a.h9 = true;
        this.u(a, b, f, j);
        if (b.bx.count == 0) {
            return;
        }
        this.n(a, b, f, j);
        f.j += b.ch;
        if (this.c.w == -1) {
            return;
        }
        this.h(a, b, b.actualVisibleRegion, f, false);
        this.o(a, b, f, j);
        a.c6.ab();
        a.h9 = false;
    };
    VisibilityEngine.prototype.a = function (a, b, c, d) {
        var e;
        e = new CalculationParameters();
        e.j = d.top;
        e.g = d.bottom;
        e.h = d.left;
        e.i = d.right;
        if (this.k > 0) {
            var f = this.k * a.j4;
            e.j = Math.max(e.j - f, 0);
            e.g = Math.min(e.g + f, b.absoluteHeight);
            e.h = Math.max(e.h - f, 0);
            e.i = Math.min(e.i + f, b.absoluteWidth);
        }
        e.o = a.inset;
        e.d = Math.max(e.h, a.inset.c);
        e.f = Math.min(e.i, b.absoluteWidth - a.inset.d);
        e.e = e.f - e.d;
        e.b = c.b(e.j + b.cl + b.cm, b);
        e.a = c.b(e.g, b);
        e.k = 0;
        e.m = 0;
        b.bx.clear();
        var g = b.cf + truncate(a.inset.c);
        var h = g;
        var i = 0;
        var j = 0;
        var k = b.cg;
        for (var l = 0; l < b.br.count; l++) {
            var m = b.br._inner[l];
            var n = b.bw._inner[l];
            var o = b.br._inner[l].d == 0;
            if (o) {
                g += truncate(Math.round(n.ad(-1)));
                if (m.a != 6) {
                    g += (m.k) + a.model.cc - truncate(Math.round(m.f(b)));
                }
            }
            if (m.a == 3) {
                continue;
            }
            if (b.br._inner[l].d == 1) {
                b.bx.insert(i, l);
                i++;
            }
            else if (b.br._inner[l].d == 2) {
                b.bx.insert(b.bx.count, l);
                j++;
                if (m.a == 6) {
                    k -= m.k;
                }
            }
            else {
                if (g >= e.d + b.cf && h <= e.f - k) {
                    b.bx.insert(b.bx.count - j, l);
                }
                else if (b.br._inner[l].a == 2 || b.br._inner[l].a == 1 || b.br._inner[l].a == 6) {
                    b.bx.insert(b.bx.count - j, l);
                }
                else if (g < e.d + b.cf) {
                    e.l++;
                }
                else if (h > e.f - b.cg) {
                    e.n++;
                }
            }
            if (o) {
                h = g;
                g += truncate(Math.round(n.af(-1)));
            }
        }
        if (b.bx.count > 0) {
            e.k = b.bx._inner[0];
            e.m = b.bx._inner[b.bx.count - 1];
        }
        return e;
    };
    VisibilityEngine.prototype.u = function (a, b, c, d) {
        var e = this.d.x;
        var f = this.c.x;
        var g = this.d.w;
        var h = this.c.w;
        var i = 0;
        var j = 0;
        var k = 0;
        var l = false;
        var m = false;
        var n = false;
        var o = false;
        var p = false;
        var q = false;
        var r = a.j3 == 0;
        var s = a.ky == 0;
        var t = null;
        var u = a.d3.getStickyRows();
        if (u != null) {
            for (var v = 0; v < u.length; v++) {
                if (t == null) {
                    t = new HashSet$1(Number_$type, 0);
                }
                t.add_1(u[v]);
            }
        }
        for (var w = 0; w < b.bu.count; w++) {
            var x = b.bu._inner[w];
            x.g = true;
            for (var y = 0; y < x.o.count; y++) {
                if (x.p._inner[y]) {
                    continue;
                }
                var z = x.o._inner[y];
                m = false;
                l = false;
                i = z.x;
                j = z.w;
                k = z.ax;
                m = z.aq || z.j || z.as || z.aj || z.al || z.ai || z.ak;
                p = z.an || z.aj || z.al;
                o = z.g;
                n = t != null && t.contains(j);
                q = z.d != 0;
                if (j == -1000 && k == -1000) {
                    continue;
                }
                if (b.bx.count == 0) {
                    l = true;
                }
                if (z.aq && s) {
                    l = true;
                }
                if (z.g && r) {
                    l = true;
                }
                if (z.an && !a.dragger.isDragActive) {
                    l = true;
                }
                if ((z.aj || z.ai) && b.cf == 0) {
                    l = true;
                }
                if ((z.al || z.ak) && b.cg == 0) {
                    l = true;
                }
                if (!m && !b.bx.contains(k)) {
                    l = true;
                }
                else if (!o && (i < e || i > f)) {
                    l = true;
                }
                else {
                    if (!n && !p && !z.aj && !z.al && !z.ai && !z.ak) {
                        if (i == e && j < g) {
                            l = true;
                        }
                        if (i == f && j > h) {
                            l = true;
                        }
                    }
                }
                if (!a.ig && (z.ax == -401 || z.ax == -402)) {
                    l = true;
                }
                if (!l) {
                    var aa = a.d3.getRowType(j);
                    var ab = a.d3.isRowSpanning(aa) && a.dt != 1;
                    if (!z.aq && !z.an && !z.aj && !z.al && !z.ai && !z.ak) {
                        if (b.bn && (aa == 1 || aa == 2)) {
                            l = true;
                        }
                        else if ((ab && !m) || (m && !ab)) {
                            l = true;
                        }
                        else if ((z.ar && aa != 5) || (z.ao && aa != 4) || (!z.ar && aa == 5) || (!z.ao && aa == 4)) {
                            l = true;
                        }
                    }
                    else if ((aa == 4 && !z.ap) || (aa != 4 && z.ap)) {
                        l = true;
                    }
                }
                if (l) {
                    a.db.j(z, x, b);
                }
            }
            x.g = false;
        }
        b.bn = false;
    };
    VisibilityEngine.prototype.t = function (a, b, c) {
        var d = c.b;
        var e = c.a;
        var f = e.x;
        var g = new CellPath(1, 0, 0, 0);
        for (var h = d.x; h <= f; h++) {
            this.q(h, a, b, c, g);
        }
    };
    VisibilityEngine.prototype.q = function (a, b, c, d, e) {
        var f = d.b;
        var g = d.a;
        var h = c.bv;
        var i = b.db;
        var j = g.x;
        var k = d.d;
        var l = d.f;
        var m = d.e;
        var n = h._inner[a];
        var o = a == j ? g.w : n.m - 1;
        if (o == -201) {
            o = n.m - 1;
        }
        var p = 0;
        if (f.x == a) {
            p = f.w == -200 ? 0 : f.w;
        }
        if (p == -201) {
            var q = new CellPath(1, 0, a, -200);
            this.ab(q, c, k, n.i + n.l() - n.d, m, a, false, b);
            e.x = a;
            e.w = -201;
            e.ax = 0;
            return;
        }
        if (n.g > 0) {
            this.s(a, b, c, d, e, f, n, p);
        }
        if (n.d > 0) {
            this.r(a, b, c, d, e, i, j, n);
        }
        e.x = a;
    };
    VisibilityEngine.prototype.i = function (a, b, c) {
        var d = this.a(a, b, a.ey, c);
        return this.h(a, b, c, d, true);
    };
    VisibilityEngine.prototype.h = function (a, b, c, d, e) {
        var f = d.a;
        var g = d.b;
        var h = d.a.x;
        var i = d.b.x;
        var j = new CellPath(1, 0, 0, 0);
        var k = b.bv._inner[0];
        var l = a.d3.getStickyRowsInRange(g.w, f.w);
        var m = -1;
        var n = -1;
        var o = -1;
        var p = -1;
        var q = false;
        var r = a.ky;
        var s = a.dt == 3;
        var t = new Dictionary$2(Number_$type, PinnedRowInfo.$, 0);
        var u = new List$1(PinnedRowInfo.$, 0);
        b.cu = 0;
        if (l != null && ((a.a7.i.count > 0 && a.hi) || a.a7.i.count == 0)) {
            var v = c.top + b.ci;
            var w = c.bottom;
            var _loop_2 = function (x) {
                var y = l[x];
                var z = a.d3.getRowType(y);
                var aa = y * k.k() + k.i;
                var ab = new PinnedRowInfo();
                ab.b = b;
                ab.a = z;
                ab.k = k.e(y);
                ab.i = k.j(y);
                ab.n = a.d3.getStickRowPriority(y);
                ab.m = y;
                ab.l = aa;
                ab.e = (x == l.length - 1) || l[x + 1] != y + 1;
                ab.f = z == 5 && (x == l.length - 1);
                t.addItem(y, ab);
                if (x == 0) {
                    if (ab.a != 4) {
                        if (ab.l <= v) {
                            ab.l += (v - ab.l);
                            p = x;
                        }
                        else if (ab.j > c.bottom) {
                            ab.l += (c.bottom - ab.j);
                            q = true;
                        }
                    }
                    else {
                        if (ab.j > c.bottom) {
                            ab.l += (c.bottom - ab.j);
                            ab.h = true;
                            q = true;
                        }
                    }
                    return "continue";
                }
                var ac = l[x - 1];
                var ad = a.d3.getStickRowPriority(ac);
                var ae = a.d3.getStickRowPriority(y);
                var af = t.item(ac);
                var ag = a.d3.isExclusivelySticky(y);
                var ah = x - 1 == p;
                af.f = (z != 5 && af.a == 5) || (z == 5 && x == l.length - 1);
                var ai = ((function () {
                    var $ret = new PushRowSettings();
                    $ret.a = l;
                    $ret.d = t;
                    $ret.c = true;
                    $ret.b = ag;
                    return $ret;
                })());
                if (ab.a != 4) {
                    if (ab.l <= af.j && ah) {
                        p = x;
                        var aj = this_2.b(x - 1, x, x, ai);
                        if (!aj.b) {
                            ab.l = aj.a.j;
                        }
                    }
                    if (ab.a == 2) {
                        var ak = a.d3.getRootSummaryRowCount();
                        var al = c.bottom - ak * k.k();
                        if (ab.j > al) {
                            ab.l -= ab.j - al;
                            ab.h = true;
                            q = true;
                            ai.c = false;
                            var am = this_2.b(x - 1, x, x, ai);
                            if (!am.b) {
                                ab.l = am.a.j;
                            }
                        }
                    }
                    else if (s && ab.a == 5) {
                        var an = a.d3.getRootSummaryRowCount();
                        var ao = c.bottom - an * k.k();
                        if (ab.j > ao) {
                            ab.l -= ab.j - ao;
                            ab.h = true;
                            q = true;
                            ai.c = false;
                            var ap = this_2.b(x - 1, x, x, ai);
                            if (!ap.b) {
                                ab.l = ap.a.j;
                            }
                        }
                    }
                }
                if (z == 4) {
                    ab.l += (c.bottom - ab.j);
                    ab.h = true;
                    b.b7++;
                    q = true;
                    this_2.y(a, x - 1, x, 4, l, t);
                }
            };
            var this_2 = this;
            for (var x = 0; x < l.length; x++) {
                _loop_2(x);
            }
            for (var aq = 0; aq < l.length; aq++) {
                for (var ar = aq + 1; ar < l.length; ar++) {
                    var as = t.item(l[aq]);
                    var at = t.item(l[ar]);
                    if (at.l < as.j) {
                        at.g = true;
                        at.d = Math.round(at.j) <= Math.round(as.j);
                    }
                    else {
                        break;
                    }
                }
            }
            for (var au = 0; au <= p; au++) {
                var av = l[au];
                var aw = t.item(av).l;
                var ax = t.item(av).j;
                var ay = t.item(av).k;
                var az = t.item(av).g;
                var a0 = t.item(av).d;
                m = av;
                var a1 = false;
                var a2 = false;
                var a3 = false;
                if (t.item(av).a == 3) {
                    a1 = true;
                    a2 = true;
                }
                if (t.item(av).a == 3 && t.item(av).e) {
                    a3 = true;
                }
                u.add(t.item(av));
                if (!e) {
                    this.p(a, b, d, j, a.db, av, aw, ay, true, a1, a2, a3, az, a0);
                }
            }
            if (q) {
                var a4 = 0;
                for (var a5 = 0; a5 < l.length; a5++) {
                    var a6 = l[a5];
                    if (!t.item(a6).h) {
                        continue;
                    }
                    if (o == -1) {
                        o = a6;
                    }
                    var a7 = t.item(a6).l;
                    var a8 = t.item(a6).j;
                    var a9 = t.item(a6).k;
                    var ba = t.item(a6).g;
                    var bb = t.item(a6).d;
                    n = a6;
                    var bc = t.item(a6).a == 3 && t.item(a6).e;
                    var bd = t.item(a6).a == 3;
                    if (!e) {
                        j.i = true;
                        j.o = (b.cp - 1) - a4;
                        this.p(a, b, d, j, a.db, a6, a7, a9, true, bd, bd, bc, ba, bb);
                        j.i = false;
                        j.o = -1;
                    }
                    a4++;
                }
            }
        }
        for (var be = Math.max(m + 1, g.w); be <= f.w; be++) {
            if (o != -1 && n != -1) {
                if (be >= o && be <= n) {
                    continue;
                }
            }
            var bf = k.f(be);
            bf += k.i;
            var bg = k.e(be);
            var bh = false;
            var bi = false;
            var bj = false;
            var bk = a.d3.getRowType(be);
            if (bk == 3) {
                bj = true;
                bi = true;
            }
            if (bk == 0 && a.d3.isRowPinned(be)) {
                bi = true;
            }
            if (bk == 3) {
                if (t.containsKey(be) && t.item(be).e) {
                    bh = true;
                }
            }
            if (!e) {
                this.p(a, b, d, j, a.db, be, bf, bg, false, bi, bj, bh, false, false);
            }
        }
        return u;
    };
    VisibilityEngine.prototype.y = function (a, b, c, d, e, f) {
        if (b < 0) {
            return;
        }
        var g = e[b];
        var h = e[c];
        if (f.item(g).a == d) {
            if (f.item(g).j > f.item(h).l) {
                f.item(g).l -= f.item(g).j - f.item(h).l;
                f.item(g).h = true;
                this.y(a, b - 1, b, d, e, f);
            }
        }
    };
    VisibilityEngine.prototype.b = function (a, b, c, d) {
        var _this = this;
        var e = d.a[a];
        var f = d.a[b];
        var g = d.a[c];
        var h = d.d;
        var i = h.item(e).n;
        var j = h.item(f).n;
        var k = h.item(g).n;
        var l = true;
        if (f == 12) {
            var m = 0;
        }
        d.e++;
        if (h.item(f).l < h.item(e).j) {
            if (j > i || (j == i && d.b)) {
                var n = h.item(f).l - h.item(e).j;
                var o_2 = this.g(n, a, c, d);
                var p = null;
                while (o_2 && a > 0) {
                    a = a - 1;
                    p = this.b(a, c, c, d);
                    o_2 = p.b;
                }
                if (p == null) {
                    p = ((function () {
                        var $ret = new PushRowResult();
                        $ret.b = o_2;
                        $ret.a = h.item(d.a[a]);
                        return $ret;
                    })());
                }
                return p;
            }
            else if (j == i && !d.b) {
                return ((function () {
                    var $ret = new PushRowResult();
                    $ret.b = false;
                    $ret.a = h.item(e);
                    return $ret;
                })());
            }
            else if (j < i) {
                if (k >= i) {
                    if (!l) {
                        var q_1 = h.item(f).l - h.item(e).j;
                        return ((function () {
                            var $ret = new PushRowResult();
                            $ret.b = _this.g(q_1, a, c, d);
                            $ret.a = h.item(e);
                            return $ret;
                        })());
                    }
                    else {
                        if (h.item(g).l < h.item(e).j) {
                            var r_1 = h.item(g).l - h.item(e).j;
                            return ((function () {
                                var $ret = new PushRowResult();
                                $ret.b = _this.g(r_1, a, c, d);
                                $ret.a = h.item(e);
                                return $ret;
                            })());
                        }
                    }
                    return ((function () {
                        var $ret = new PushRowResult();
                        $ret.b = true;
                        $ret.a = h.item(e);
                        return $ret;
                    })());
                }
                return ((function () {
                    var $ret = new PushRowResult();
                    $ret.b = false;
                    $ret.a = h.item(e);
                    return $ret;
                })());
            }
        }
        return ((function () {
            var $ret = new PushRowResult();
            $ret.b = true;
            $ret.a = h.item(e);
            return $ret;
        })());
    };
    VisibilityEngine.prototype.g = function (a, b, c, d) {
        var e = d.a[b];
        d.d.item(e).l += a;
        d.d.item(e).h = !d.c;
        if (b > 0) {
            var f = this.b(b - 1, b, c, d);
            if (!d.b || !d.c) {
                if (!f.b) {
                    var g = d.a[b - 1];
                    d.d.item(e).l = d.d.item(g).j;
                    return false;
                }
            }
        }
        return true;
    };
    VisibilityEngine.prototype.p = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
        d.w = f;
        d.d = 0;
        d.am = m;
        d.af = n;
        var o = b.br;
        var p = c.d;
        var q = c.f;
        var r = c.e;
        var s = a.ky;
        var t = a.d3.getRowType(f);
        d.ao = t == 4;
        d.ar = t == 5;
        var u = false;
        if (t != 0) {
            u = a.d3.isRowSpanning(t) && a.dt != 1;
        }
        if (u) {
            var v = a.ig ? b.cf : 0;
            var w = a.ig ? b.cg : 0;
            var x = p;
            var y = r;
            if (v > 0) {
                d.ax = -401;
                y = b.cf;
                this.z(x, y, g, h, d.aa(), b, p, q, a, i, j, k, l, t);
            }
            d.ax = -400;
            x = p + v;
            y = r - v - w;
            this.z(x, y, g, h, d.aa(), b, p, q, a, i, j, k, l, t);
            if (w > 0) {
                d.ax = -402;
                x = q - b.cg;
                y = b.cg;
                this.z(x, y, g, h, d.aa(), b, p, q, a, i, j, k, l, t);
            }
        }
        else {
            for (var z = 0; z < b.bx.count; z++) {
                var aa = b.bx._inner[z];
                var ab = o._inner[aa];
                d.ax = ab.m;
                d.a2 = ab.n;
                d.d = ab.d;
                var ac = d.aa();
                this.z(c.o.c + ab.l, ab.k, g, h, ac, b, p, q, a, i, j, k, l, t);
            }
        }
        var ad = t != 4 && t != 2 && (t != 5 || a.dt != 3);
        if (ad && i) {
            b.cv = truncate(Math.round((g + h + a.kz) - c.j));
        }
        var ae = t == 4 || (t == 5 && a.dt == 3);
        if (ae && i && g < c.g) {
            b.cu += truncate(h) + a.kz;
        }
        if (s > 0) {
            if (ad && i) {
                b.cv = truncate(Math.round((g + h + a.kz + s) - c.j));
            }
            if (ae && i && g < c.g) {
                b.cu += s;
            }
            d.d = 0;
            d.ax = -300;
            d.ap = t == 4;
            this.ad(c, d.aa(), b, p, r, g + h + a.kz, s, a, i, j, k, l, t);
        }
    };
    VisibilityEngine.prototype.r = function (a, b, c, d, e, f, g, h) {
        var i = d.d;
        var j = d.f;
        var k = d.e;
        e.x = a;
        e.w = -201;
        e.ax = 0;
        var l = new CellPath(1, e.ax, e.x, e.w);
        var m = h.i + h.l() - h.d;
        var n = m;
        if (a == g) {
            n = d.g - h.d;
            if (n < (h.i + h.g)) {
                n = (h.i + h.g);
            }
            this.ac(l, c, i, Math.min(m, n), k, a, false, true, b);
        }
        else {
            this.ab(l, c, i, Math.min(m, n), k, a, false, b);
        }
    };
    VisibilityEngine.prototype.s = function (a, b, c, d, e, f, g, h) {
        var i = d.d;
        var j = d.f;
        var k = d.e;
        e.x = a;
        e.w = -200;
        e.ax = 0;
        var l = new CellPath(1, e.ax, e.x, e.w);
        if (a == f.x) {
            if (h == g.m - 1) {
                var m = g.j(h);
                var n = g.f(h) + g.i;
                var o = (n + m) - g.g;
                this.ac(l, c, i, Math.min(o, d.j), k, a, true, true, b);
            }
            else {
                this.ac(l, c, i, Math.max(g.i, d.j - b.inset.e), k, a, true, true, b);
            }
        }
        else {
            this.ab(l, c, i, g.i, k, a, true, b);
        }
    };
    VisibilityEngine.prototype.n = function (a, b, c, d) {
        var e = b.br;
        var f = a.inset;
        var g = f.e;
        if (b.ci > 0) {
            var h = Math.max(c.j, g);
            b.bj = this.f;
            if (this.f) {
                h = g;
            }
            for (var i = 0; i < b.bx.count; i++) {
                var j = b.bx._inner[i];
                var k = e._inner[j];
                var l = new CellPath(1, k.m, -100, -100);
                l.d = k.d;
                this.aa(l, b, h, c.d, c.f, a);
                if (a.hj) {
                    var m = new CellPath(1, k.m, -100, -101);
                    m.d = k.d;
                    var n = a.j5(a.kt);
                    var o = a.kt + n * 2;
                    var p = c.o.c + b.br._inner[l.ax].l + b.br._inner[l.ax].k - a.kt - n;
                    this.ae(m, b, h, p, o, b.cl, c.d, c.f, a);
                }
            }
            if (b.cm > 0) {
                var q = new CellPath(1, -300, -100, -100);
                this.ad(c, q, b, c.d, c.e, 0, b.cm, a, false, false, false, false, 0);
            }
        }
        if (a.bu == 0 && a.dragger != null && a.dragger.isDragActive && a.dragger.dragType == 1) {
            var r = new CellPath(1, -400, 0, -102);
            this.ae(r, b, Math.max(c.j, g), a.kv, a.j8, b.by, c.h, c.i, a);
        }
        if (a.bg != 1 && a.dragger != null && a.dragger.isDragActive && a.dragger.dragType == 2) {
            var s = new CellPath(1, -400, 0, -102);
            this.ae(s, b, c.j, a.kv, a.j6, b.by, c.h, c.i, a);
        }
    };
    VisibilityEngine.prototype.o = function (a, b, c, d) {
        if (b.cd > -1) {
            b.b4 = c.d + a.ey.k(b.cd, a, b) - a.ku;
        }
        else {
            b.b4 = b.cf;
        }
        if (b.ce > -1) {
            var e = b.br._inner[b.ce].l - a.ku;
            if (c.i >= b.absoluteWidth) {
                b.b5 = e + a.inset.c;
            }
            else {
                b.b5 = e - (b.absoluteWidth - c.i - a.inset.c - a.inset.d);
            }
        }
        var f = Math.max(c.j - b.ci, a.inset.e);
        var g = c.j;
        var h = b.b7 * (a.j4 + a.ky + a.kz);
        var i = c.g - h;
        var j = Math.min(b.absoluteHeight - h, c.g - h);
        var k = Math.max(0, j - g);
        var l = new CellPath(1, 0, 0, 0);
        if (b.cf > 0) {
            l.ax = -500;
            if (b.ci > 0) {
                l.w = -100;
                this.ae(l.aa(), b, f, b.b4, a.ku, b.ci, c.d, c.i, a);
            }
            l.w = -103;
            this.ae(l.aa(), b, g, b.b4, a.ku, k, c.d, c.i, a);
            if (b.b7 > 0) {
                l.w = -104;
                this.ae(l.aa(), b, i, b.b4, a.ku, h, c.d, c.i, a);
            }
        }
        if (b.cg > 0) {
            l.ax = -501;
            if (b.ci > 0) {
                l.w = -100;
                this.ae(l.aa(), b, f, b.b5, a.ku, b.ci, c.d, c.i, a);
            }
            l.w = -103;
            this.ae(l.aa(), b, g, b.b5, a.ku, k, c.d, c.i, a);
            if (b.b7 > 0) {
                l.w = -104;
                this.ae(l.aa(), b, i, b.b5, a.ku, h, c.d, c.i, a);
            }
        }
    };
    VisibilityEngine.prototype.w = function (a, b, c, d, e, f, g, h, i) {
        this.x(a, b, c, d, e, f, g, h, i, false, false, false);
    };
    VisibilityEngine.prototype.x = function (a, b, c, d, e, f, g, h, i, j, k, l) {
        var m = a.db.b(c, a, b, d, e, j, k, l);
        a.db.h(m, b, f, g, h, i);
        if (a.cb.g) {
            if (a.cb.a == null && a.cb.j == m.k.w && a.cb.i == m.k.ax) {
                a.cb.m(m);
            }
        }
        else {
            if (a.ar != null && a.ar.ax == m.k.ax && a.ar.w == m.k.w) {
                a.ii(m);
            }
        }
    };
    VisibilityEngine.prototype.z = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
        var o = f.al;
        var p = e.d;
        var q = e.d != 0;
        var r = i.ey;
        var s = 1;
        if (n == 1) {
            s = 2;
        }
        if (n == 2) {
            s = 3;
        }
        if (e.ax == -400 || e.ax == -401 || e.ax == -402) {
            if (n == 1 || n == 2) {
                if (!e.af) {
                    o = j && !e.am ? f.a3 : f.a6;
                }
                else {
                    o = f.al;
                }
            }
        }
        else {
            if (f.br._inner[e.ax].a == 1 || f.br._inner[e.ax].a == 2 || f.br._inner[e.ax].a == 3) {
                if (j) {
                    o = n != 4 ? f.a1 : f.a9;
                }
                else {
                    o = q ? f.as : f.a7;
                }
            }
            else if (f.br._inner[e.ax].a == 6) {
                q = e.d != 0 || i.columns._inner[e.ax].fj != 0;
                if (j) {
                    o = n != 4 ? f.a2 : f.bc;
                }
                else {
                    o = q ? f.av : f.ba;
                }
            }
            else {
                if (j) {
                    o = n != 4 ? (q ? f.aq : f.a0) : (q ? f.ap : f.az);
                }
                else {
                    o = q ? f.an : f.al;
                }
            }
        }
        if (p == 1) {
            var t = f.br._inner[e.ax].l;
            a = g + t;
        }
        else if (p == 2) {
            var u = f.br._inner[e.ax].l;
            if (h >= f.absoluteWidth) {
                a = u + i.inset.c;
            }
            else {
                a = u - (f.absoluteWidth - h - i.inset.c - i.inset.d);
            }
        }
        this.x(i, f, e, o, s, a, c, b, d, k, l, m);
    };
    VisibilityEngine.prototype.aa = function (a, b, c, d, e, f) {
        var g = a.d == 0 ? b.az : b.ap;
        if (b.br._inner[a.ax].a == 1 || b.br._inner[a.ax].a == 2 || b.br._inner[a.ax].a == 3) {
            g = a.d == 0 ? b.a9 : b.au;
        }
        if (b.br._inner[a.ax].a == 6) {
            g = a.d == 0 && f.columns._inner[a.ax].fj == 0 ? b.bc : b.ax;
        }
        var h = b.br._inner[a.ax].l + f.inset.c;
        var i = b.br._inner[a.ax].k;
        if (a.d == 1) {
            h = d + b.br._inner[a.ax].l;
        }
        else if (a.d == 2) {
            var j = b.br._inner[a.ax].l;
            if (e >= b.absoluteWidth) {
                h = j + f.inset.c;
            }
            else {
                h = j - (b.absoluteWidth - e - f.inset.c - f.inset.d);
            }
        }
        this.w(f, b, a, g, 0, h, c, i, b.cl);
    };
    VisibilityEngine.prototype.ae = function (a, b, c, d, e, f, g, h, i) {
        var j = b.bd;
        if (a.h) {
            j = a.d == 0 ? b.ay : b.ao;
            if (b.br._inner[a.ax].a == 1 || b.br._inner[a.ax].a == 2 || b.br._inner[a.ax].a == 3) {
                j = a.d == 0 ? b.a8 : b.at;
            }
            if (b.br._inner[a.ax].a == 6) {
                j = a.d == 0 && i.columns._inner[a.ax].fj == 0 ? b.bb : b.aw;
            }
            if (a.d == 1) {
                d += g - i.inset.c;
            }
            else if (a.d == 2) {
                if (h < b.absoluteWidth) {
                    d -= b.absoluteWidth - h - i.inset.d;
                }
            }
        }
        if (!i.ig) {
            if ((a.aj || a.al) && a.w != -104) {
                j = b.ar;
            }
        }
        this.w(i, b, a, j, 5, d, c, e, f);
    };
    VisibilityEngine.prototype.ab = function (a, b, c, d, e, f, g, h) {
        this.ac(a, b, c, d, e, f, g, false, h);
    };
    VisibilityEngine.prototype.ac = function (a, b, c, d, e, f, g, h, i) {
        var j = g ? b.bv._inner[f].g : b.bv._inner[f].d;
        var k = 3;
        var l = b.a6;
        if (g) {
            k = 2;
        }
        if (h) {
            l = b.a6;
        }
        this.w(i, b, a, l, k, c, d, e, j);
    };
    VisibilityEngine.prototype.ad = function (a, b, c, d, e, f, g, h, i, j, k, l, m) {
        var n = 0;
        var o = c.al;
        if (i) {
            if (m == 1 || m == 2) {
                o = !b.am ? c.a3 : c.a6;
            }
            else if (m == 4) {
                o = c.a5;
            }
            else {
                o = c.aq;
            }
        }
        else {
            if (m == 1 || m == 2) {
                o = c.a6;
            }
        }
        if (b.g) {
            var p = h.inset;
            var q = p.e;
            var r = Math.max(a.j, q);
            n = r + c.cl;
            if (this.f) {
                n = a.o.e + c.cl;
            }
            o = c.ay;
        }
        else {
            var s = c.bv._inner[b.x];
            n = f;
        }
        this.x(h, c, b, o, 4, d, n, e, g, j, k, l);
    };
    VisibilityEngine.$t = markType(VisibilityEngine, 'VisibilityEngine');
    return VisibilityEngine;
}(Base));
export { VisibilityEngine };
/**
 * @hidden
 */
var PinnedRowInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PinnedRowInfo, _super);
    function PinnedRowInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.m = 0;
        _this.o = null;
        _this.l = 0;
        _this.k = 0;
        _this.i = 0;
        _this.e = false;
        _this.c = false;
        _this.a = 0;
        _this.f = false;
        _this.n = 0;
        _this.g = false;
        _this.d = false;
        _this.b = null;
        return _this;
    }
    Object.defineProperty(PinnedRowInfo.prototype, "j", {
        get: function () {
            return this.l + this.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PinnedRowInfo.prototype, "h", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (this.c != b) {
                if (this.b != null) {
                    this.b.cp = Math.min(0, this.c ? this.b.cp + 1 : this.b.cp - 1);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    PinnedRowInfo.prototype.toString = function () {
        return EnumUtil.getName(DataSourceRowType_$type, this.a) + "(" + this.n + ") " + this.j;
    };
    PinnedRowInfo.$t = markType(PinnedRowInfo, 'PinnedRowInfo');
    return PinnedRowInfo;
}(Base));
export { PinnedRowInfo };
/**
 * @hidden
 */
var PushRowSettings = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PushRowSettings, _super);
    function PushRowSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        _this.d = null;
        _this.b = false;
        _this.c = false;
        _this.e = 0;
        return _this;
    }
    PushRowSettings.$t = markType(PushRowSettings, 'PushRowSettings');
    return PushRowSettings;
}(Base));
export { PushRowSettings };
/**
 * @hidden
 */
var PushRowResult = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PushRowResult, _super);
    function PushRowResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b = false;
        _this.a = null;
        return _this;
    }
    PushRowResult.$t = markType(PushRowResult, 'PushRowResult');
    return PushRowResult;
}(Base));
export { PushRowResult };
/**
 * @hidden
 */
export var ICellRenderingEngine_$type = /*@__PURE__*/ new Type(null, 'ICellRenderingEngine');
/**
 * @hidden
 */
var SpatialEngine = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SpatialEngine, _super);
    function SpatialEngine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.f = new List$1(ColumnInfo.$, 0);
        _this.c = new Dictionary$2(Number_$type, ColumnInfo.$, 0);
        _this.d = new List$1(Number_$type, 0);
        _this.e = new List$1(Number_$type, 0);
        _this.a = new GridColumnSpacerCollection();
        return _this;
    }
    SpatialEngine.prototype.r = function (a, b, c) {
        b.absoluteHeight = 0;
        b.absoluteWidth = 0;
        b.absoluteHeight = truncate(a.inset.e);
        b.ch = truncate(a.inset.e);
        b.bv.clear();
        this.c.clear();
        for (var d = 0; d < a.model.br.count; d++) {
            this.c.addItem(a.model.br._inner[d].o, a.model.br._inner[d]);
        }
        b.c1();
        b.cf = 0;
        b.cg = 0;
        b.cd = -1;
        b.ce = -1;
        a.model.cc = a.j9;
        if (a.d3 == null) {
            return;
        }
        var e = a.d3.getSectionCount();
        e = Math.max(1, e);
        a.model.cm = a.j3 > 0 ? a.ky : 0;
        a.model.ci = a.j3 + a.model.cm;
        a.model.cl = a.j3;
        a.model.absoluteHeight += a.model.ci;
        a.model.ch += a.model.ci;
        a.model.b0 = a.inset.c;
        a.model.b1 = a.inset.d;
        a.model.b2 = a.inset.e;
        a.model.bz = a.inset.b;
        for (var f = 0; f < e; f++) {
            var g = new SectionInfo();
            g.h = f;
            g.i = b.absoluteHeight;
            g.m = a.d3.getRowCount();
            g.g = a.k2;
            g.d = a.k0;
            g.o = a.ky;
            g.p = a.kz;
            g.n = a.j4;
            g.q = g.m * g.n;
            a.model.absoluteHeight += g.l();
            a.model.bv.add(g);
        }
        var h = a.defaultColumnWidth;
        var i = 0;
        var j = a.defaultColumnWidth;
        var k = a.i8;
        this.f.clear();
        this.d.clear();
        this.e.clear();
        for (i = 0; i < a.actualColumns.count; i++) {
            var l = new ColumnInfo();
            if (this.c.containsKey(a.actualColumns._inner[i].g2)) {
                l = this.c.item(a.actualColumns._inner[i].g2);
            }
            l.m = i;
            var m = a.actualColumns._inner[i];
            l.p = m.hx;
            l.o = m.g2;
            if (m.e8 == 3) {
                l.h = -1;
            }
            if (m.e8 == 5) {
                l.h = 0;
            }
            l.a = m.e8;
            var n = null;
            h = m.width;
            if (n == null) {
                n = (h == null) ? j : h;
            }
            var o = 0;
            if (!isNaN_(k)) {
                o = k;
            }
            if (!isNaN_(n.e) && n.e > 0) {
                o = Math.max(o, n.e);
            }
            if (!isNaN_(m.gm)) {
                o = m.gm;
            }
            l.b = n;
            l.i = o;
            l.d = m.fk;
            l.n = i;
            if (l.d == 1) {
                this.d.add(i);
            }
            if (l.d == 2) {
                this.e.add(i);
            }
            if (m.e8 != 2 && m.e8 != 3) {
                if (m.fk == 0) {
                    if (b.cd == -1) {
                        b.cd = i;
                    }
                }
                if (b.ce == -1 && m.fk == 2) {
                    b.ce = i;
                }
            }
            a.model.cy(l);
        }
        this.s(b);
        this.c.clear();
        a.model.cf = 0;
        a.model.cg = 0;
        this.q(a, b, c);
        a.c6.ac();
        a.model.absoluteHeight += truncate(a.inset.b);
    };
    SpatialEngine.prototype.s = function (a) {
        if (this.d.count > 0 || this.e.count > 0) {
            for (var b = 0; b < a.br.count; b++) {
                a.br._inner[b].n = this.m(a.br._inner[b].d, b, a);
            }
        }
    };
    SpatialEngine.prototype.q = function (a, b, c) {
        var e_19, _a;
        b.absoluteWidth = 0;
        b.cj = 0;
        b.cf = 0;
        b.cg = 0;
        var d = a.model.cc;
        var e = a.model.cc;
        var f = 0;
        var g = new List$1(ColumnInfo.$, 0);
        var h = b.bw;
        try {
            for (var _b = tslib_1.__values(fromEnum(b.br)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var i = _c.value;
                if (i.b.c) {
                    f += i.b.f * this.g(i);
                    g.add(i);
                }
                else {
                    i.k = truncate((Math.max(DeviceUtils.g(i.b.f), i.i)));
                    if (i.a != 3) {
                        if (i.a == 6) {
                            e += i.k + a.model.cc;
                        }
                        else {
                            e += i.k + a.model.cc - truncate(Math.round(i.f(b)));
                        }
                        b.cj += i.k + a.model.cc;
                        if (i.d == 1) {
                            b.cf += i.k + b.cc - truncate(Math.round(i.f(b)));
                        }
                        if (i.d == 2) {
                            b.cg += i.k + b.cc - truncate(Math.round(i.f(b)));
                        }
                    }
                    if (i.a == 6) {
                        d += i.k + a.model.cc;
                    }
                    else {
                        d += i.k + a.model.cc - truncate(Math.round(i.f(b)));
                    }
                }
            }
        }
        catch (e_19_1) {
            e_19 = { error: e_19_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_19)
                    throw e_19.error;
            }
        }
        b.cf = Math.max(0, b.cf - b.cc);
        if (f > 0) {
            var j = e;
            e = SpatialEngine.p(a, b, c, d, e, f, g);
        }
        a.model.absoluteWidth = e;
        a.model.absoluteWidth += truncate((a.inset.c + a.inset.d));
        a.model.cj += truncate((a.inset.c + a.inset.d));
    };
    SpatialEngine.prototype.g = function (a) {
        if (a.a == 6) {
            return 1;
        }
        if (a.a == 3) {
            return 0;
        }
        var b = 1 - Math.max(0, Math.min(1, Math.abs(a.h)));
        return b;
    };
    SpatialEngine.p = function (a, b, c, d, e, f, g) {
        var e_20, _a, e_21, _b;
        c -= d;
        c -= truncate((a.inset.c + a.inset.d));
        c -= (g.count * a.model.cc);
        c -= a.model.cs + a.model.ct;
        var h = 0;
        var i = (c) / f;
        if (i < 0) {
            i = 0;
        }
        if (c < 0) {
            c = 0;
        }
        var j = false;
        var k = new HashSet$1(ColumnInfo.$, 0);
        while (f > 0 && !j) {
            j = true;
            try {
                for (var _c = (e_20 = void 0, tslib_1.__values(fromEnum(g))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var l = _d.value;
                    if (k.contains(l)) {
                        continue;
                    }
                    if (l.i > i * l.b.f) {
                        j = false;
                        if (l.a != 3) {
                            f--;
                        }
                        k.add_1(l);
                        l.k = truncate(l.i);
                        if (l.a != 6) {
                            if (l.a != 3) {
                                e += (l.k) + a.model.cc - truncate(Math.round(l.f(b)));
                                b.cj += l.k + a.model.cc;
                            }
                            if (l.a == 6) {
                                var m = (l.k) + a.model.cc;
                                d += m;
                                c -= m;
                            }
                            else {
                                var n = (l.k) + a.model.cc - truncate(Math.round(l.f(b)));
                                d += n;
                                c -= n;
                            }
                        }
                        else {
                            e += l.k;
                            b.cj += l.k + a.model.cc;
                        }
                    }
                }
            }
            catch (e_20_1) {
                e_20 = { error: e_20_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_20)
                        throw e_20.error;
                }
            }
            i = (c) / f;
        }
        if (c < 0) {
            c = 0;
        }
        var o = 0;
        try {
            for (var _e = tslib_1.__values(fromEnum(g)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var p = _f.value;
                if (k.contains(p)) {
                    if (p.a != 3) {
                        if (p.d == 1) {
                            a.model.cf += p.k + a.model.cc;
                        }
                        if (p.d == 2) {
                            a.model.cg += p.k + a.model.cc;
                        }
                    }
                    continue;
                }
                var q = Math.max(p.i, i * p.b.f);
                var r = o + q;
                o += q;
                if (Math.round(r) >= r) {
                    p.k = truncate(Math.ceil(q));
                }
                else {
                    p.k = truncate(Math.floor(q));
                }
                e += a.model.cc;
                d += a.model.cc;
                h += a.model.cc;
                o += a.model.cc;
                b.cj += a.model.cc;
                if (p.a != 3) {
                    if (p.a == 6) {
                        e += p.k;
                    }
                    else {
                        e += p.k - truncate(Math.round(p.f(b)));
                    }
                    if (p.d == 1) {
                        a.model.cf += p.k + a.model.cc;
                    }
                    if (p.d == 2) {
                        a.model.cg += p.k + a.model.cc;
                    }
                    b.cj += p.k;
                }
                if (p.a == 6) {
                    d += p.k;
                    h += p.k;
                }
                else {
                    d += p.k - truncate(Math.round(p.f(b)));
                    h += p.k - truncate(Math.round(p.f(b)));
                }
            }
        }
        catch (e_21_1) {
            e_21 = { error: e_21_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_21)
                    throw e_21.error;
            }
        }
        a.model.cf = Math.max(0, a.model.cf - a.model.cc);
        if (h < c) {
            var s = (c - h - a.model.cc);
            g._inner[g.count - 1].k += s;
            e += s;
            d += s;
            b.cj += s;
        }
        if (h > c) {
            var t = (c - h - a.model.cc);
            g._inner[g.count - 1].k += t;
            e += t;
            d += t;
            b.cj += t;
        }
        return e;
    };
    SpatialEngine.prototype.k = function (a, b, c) {
        return this.l(a, c, false);
    };
    SpatialEngine.prototype.l = function (a, b, c) {
        var d = 0;
        if (b.br._inner[a].d == 1) {
            d += this.h(a, b.br._inner[a].o, 1, b);
        }
        if (b.br._inner[a].d == 0) {
            d += this.h(b.br.count, b.br._inner[a].o, 1, b);
            d += this.h(a, b.br._inner[a].o, 0, b);
        }
        if (b.br._inner[a].d == 2) {
            d += this.h(b.br.count, b.br._inner[a].o, 1, b);
            d += this.h(b.br.count, b.br._inner[a].o, 0, b);
            d += this.h(a, b.br._inner[a].o, 2, b);
        }
        d += truncate(Math.round(b.bw._inner[a].ad(b.br._inner[a].o)));
        if (!c) {
            d = truncate((d + Math.round(b.br._inner[a].e(b))));
        }
        return d;
    };
    SpatialEngine.prototype.h = function (a, b, c, d) {
        var e = 0;
        for (var f = 0; f < a; f++) {
            if (d.br._inner[f].d == c) {
                e += truncate(Math.round(d.bw._inner[f].ad(b)));
                if (d.br._inner[f].a != 6) {
                    e += (d.br._inner[f].k) + d.cc - truncate(Math.round(d.br._inner[f].f(d)));
                }
                e += truncate(Math.round(d.bw._inner[f].af(b)));
            }
        }
        return e;
    };
    SpatialEngine.prototype.m = function (a, b, c) {
        var d = b;
        if (a == 0) {
            var e = 0;
            for (var f = 0; f < b; f++) {
                if (c.br._inner[f].d == 0) {
                    e++;
                }
            }
            d = this.d.count + e;
        }
        if (a == 1) {
            var g = 0;
            for (var h = 0; h < this.d.count; h++) {
                if (this.d._inner[h] < b) {
                    g++;
                }
            }
            d = g;
        }
        if (a == 2) {
            var i = 0;
            for (var j = 0; j < this.e.count; j++) {
                if (this.e._inner[j] > b) {
                    i++;
                }
            }
            d = c.br.count - 1 - i;
        }
        return d;
    };
    SpatialEngine.prototype.j = function (a, b) {
        for (var c = 0; c < b.br.count; c++) {
            if (b.br._inner[c].n == a) {
                return c;
            }
        }
        return -1;
    };
    SpatialEngine.prototype.n = function (a, b, c) {
        var d = c.br._inner[a].o;
        var e = truncate(b.inset.c) + c.cf + c.cc;
        var f = c.bw;
        var g = c.br;
        for (var h = 0; h < a; h++) {
            if (g._inner[h].d != 0) {
                continue;
            }
            e += truncate(Math.round(f._inner[h].ad(d)));
            if (g._inner[h].a != 6) {
                e += (g._inner[h].k) + b.model.cc - truncate(Math.round(g._inner[h].f(c)));
            }
            e += truncate(Math.round(f._inner[h].af(d)));
        }
        e += truncate(Math.round(f._inner[a].ad(d)));
        return (e);
    };
    SpatialEngine.prototype.o = function (a, b, c) {
        var d = 0;
        var e = 0;
        var f = truncate(b.inset.c);
        e += f;
        var g = c.bw;
        var h = c.br;
        var i = h.count;
        for (var j = 0; j < i; j++) {
            var k = h._inner[j];
            e += truncate(Math.round(g._inner[d].ad(-1)));
            if (k.a != 6) {
                e += (k.k) + b.model.cc - truncate(Math.round(k.f(c)));
            }
            if (a <= e) {
                return d;
            }
            e += truncate(Math.round(g._inner[d].af(-1)));
            d++;
        }
        var l = c.br.count - 1;
        if (d > l) {
            d = l;
        }
        return d;
    };
    SpatialEngine.prototype.b = function (a, b) {
        var c = b.bv.count;
        for (var d = 0; d < c; d++) {
            var e = b.bv._inner[d];
            var f = e.i;
            var g = f + e.l();
            if (a <= g) {
                if (a < f) {
                    a = f;
                }
                return e.a(a);
            }
        }
        return new RowPath(b.bv.count - 1, b.bv._inner[b.bv.count - 1].m - 1);
    };
    SpatialEngine.prototype.v = function (a, b, c, d) {
        this.ab(a, b, d, false);
        for (var e = b + 1; e < d.br.count; e++) {
            this.aa(e, d, false, b);
        }
    };
    SpatialEngine.prototype.t = function (a, b, c) {
        for (var d = c.br.count - 1; d >= a; d--) {
            this.aa(d, c, true, a);
        }
    };
    SpatialEngine.prototype.x = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            var d = new List$1(CellModel.$, 0);
            var e = b.bu._inner[c];
            for (var f = 0; f < e.o.count; f++) {
                if (e.p._inner[f]) {
                    continue;
                }
                var g = e.o._inner[f];
                if (g.x > a.x || (g.x == a.x && g.w >= a.w)) {
                    d.add(e.q._inner[f]);
                }
            }
            e.g = true;
            for (var h = 0; h < d.count; h++) {
                var i = d._inner[h];
                e.f(i.k);
                i.k.w = i.k.w + 1;
            }
            for (var j = 0; j < d.count; j++) {
                var k = d._inner[j];
                e.s(k.k, k);
            }
            e.g = false;
        }
    };
    SpatialEngine.prototype.y = function (a, b, c) {
        for (var d = 0; d < c.bu.count; d++) {
            var e = new List$1(CellModel.$, 0);
            var f = c.bu._inner[d];
            var g = new List$1(CellPath.$, 0);
            for (var h = 0; h < f.o.count; h++) {
                if (f.p._inner[h]) {
                    continue;
                }
                var i = f.o._inner[h];
                if (i.x > b.x || (i.x == b.x && i.w > b.w)) {
                    e.add(f.q._inner[h]);
                }
                if (i.x == b.x && i.w == b.w) {
                    g.add(i);
                }
            }
            f.g = true;
            for (var j = 0; j < g.count; j++) {
                var k = g._inner[j];
                a.j(k, f, c);
            }
            for (var l = 0; l < e.count; l++) {
                var m = e._inner[l];
                f.f(m.k);
                m.k.w = m.k.w - 1;
            }
            for (var n = 0; n < e.count; n++) {
                var o = e._inner[n];
                f.s(o.k, o);
            }
            f.g = false;
        }
    };
    SpatialEngine.prototype.aa = function (a, b, c, d) {
        for (var e = 0; e < b.bu.count; e++) {
            var f = new List$1(CellModel.$, 0);
            var g = b.bu._inner[e];
            for (var h = 0; h < g.o.count; h++) {
                if (g.p._inner[h]) {
                    continue;
                }
                var i = g.o._inner[h];
                if (i.ax == a && (i.ag || i.ah)) {
                    f.add(g.q._inner[h]);
                }
            }
            g.g = true;
            for (var j = 0; j < f.count; j++) {
                var k = f._inner[j];
                g.f(k.k);
                if (c) {
                    k.k.ax = k.k.ax + 1;
                }
                else {
                    k.k.ax = k.k.ax - 1;
                }
                g.s(k.k, k);
            }
            g.g = false;
        }
        var l = b.bw;
        if (c) {
            if (a == l.count - 1) {
                l.add(new GridColumnSpacerCollection());
            }
            for (var m = l._inner[a].count - 1; m >= 0; m--) {
                if (a != d || l._inner[a]._inner[m].d) {
                    l._inner[a + 1].add(l._inner[a]._inner[m]);
                    l._inner[a].removeAt(m);
                }
            }
        }
        else {
            for (var n = l._inner[a].count - 1; n >= 0; n--) {
                l._inner[a - 1].add(l._inner[a]._inner[n]);
                l._inner[a].removeAt(n);
            }
        }
    };
    SpatialEngine.prototype.ab = function (a, b, c, d) {
        for (var e = 0; e < c.bu.count; e++) {
            var f = new List$1(CellModel.$, 0);
            var g = c.bu._inner[e];
            for (var h = 0; h < g.o.count; h++) {
                if (g.p._inner[h]) {
                    continue;
                }
                var i = g.o._inner[h];
                if (i.ax == b && (i.ag || i.ah)) {
                    f.add(g.q._inner[h]);
                }
            }
            g.g = true;
            for (var j = 0; j < f.count; j++) {
                var k = f._inner[j];
                if (d) {
                    g.f(k.k);
                    k.k.ax = -800;
                    g.s(k.k, k);
                }
                else {
                    a.j(k.k, g, c);
                }
            }
            g.g = false;
        }
        var l = c.bw;
        if (b < l.count) {
            for (var m = l._inner[b].count - 1; m >= 0; m--) {
                this.a.add(l._inner[b]._inner[m]);
                l._inner[b].removeAt(m);
            }
        }
    };
    SpatialEngine.prototype.z = function (a, b) {
        for (var c = 0; c < b.bu.count; c++) {
            var d = new List$1(CellModel.$, 0);
            var e = b.bu._inner[c];
            for (var f = 0; f < e.o.count; f++) {
                if (e.p._inner[f]) {
                    continue;
                }
                var g = e.o._inner[f];
                if (g.ax == -800 && (g.ag || g.ah)) {
                    d.add(e.q._inner[f]);
                }
            }
            e.g = true;
            for (var h = 0; h < d.count; h++) {
                var i = d._inner[h];
                e.f(i.k);
                i.k.ax = a;
                e.s(i.k, i);
            }
            e.g = false;
        }
    };
    SpatialEngine.prototype.w = function (a, b) {
        for (var c = 0; c < b.br.count; c++) {
            this.ab(a, c, b, false);
        }
    };
    SpatialEngine.prototype.u = function (a, b, c, d, e) {
        this.ab(a, c, b, true);
        for (var f = c + 1; f < b.br.count; f++) {
            this.aa(f, b, false, c);
        }
        for (var g = b.br.count - 1; g >= d; g--) {
            this.aa(g, b, true, d);
        }
        this.z(d, b);
        var h = b.bw;
        for (var i = this.a.count - 1; i >= 0; i--) {
            h._inner[c].add(this.a._inner[i]);
            this.a.removeAt(i);
        }
    };
    SpatialEngine.prototype.i = function (a, b) {
        if (b == null) {
            return 0;
        }
        var c = 0;
        for (var d = 0; d < b.x; d++) {
            c += a.bv._inner[d].m;
        }
        c += b.w;
        return c;
    };
    SpatialEngine.$t = markType(SpatialEngine, 'SpatialEngine');
    return SpatialEngine;
}(Base));
export { SpatialEngine };
/**
 * @hidden
 */
var ColumnExchanger = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnExchanger, _super);
    function ColumnExchanger(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.a = null;
        _this.b = 0;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0: break;
            case 1:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    _this.a = c;
                    _this.b = d;
                }
                break;
        }
        return _this;
    }
    ColumnExchanger.$t = markType(ColumnExchanger, 'ColumnExchanger');
    return ColumnExchanger;
}(Base));
export { ColumnExchanger };
/**
 * @hidden
 */
var ColumnExchangersCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnExchangersCollection, _super);
    function ColumnExchangersCollection() {
        return _super.call(this, ColumnExchanger.$, 0) || this;
    }
    ColumnExchangersCollection.$t = markType(ColumnExchangersCollection, 'ColumnExchangersCollection', ObservableCollection$1.$.specialize(ColumnExchanger.$));
    return ColumnExchangersCollection;
}(ObservableCollection$1));
export { ColumnExchangersCollection };
/**
 * @hidden
 */
var ResponsiveEngine = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsiveEngine, _super);
    function ResponsiveEngine(a) {
        var _this = _super.call(this) || this;
        _this.c = null;
        _this.l = 500;
        _this.m = 200;
        _this.k = dateMinValue();
        _this.h = false;
        _this.i = false;
        _this.j = null;
        _this.a = null;
        _this.f = null;
        _this.b = null;
        _this.d = null;
        _this.a = a;
        _this.g = new ResponsiveStatesCollection();
        _this.j = new List$1(Number_$type, 0);
        _this.h = true;
        _this.d = null;
        return _this;
    }
    Object.defineProperty(ResponsiveEngine.prototype, "g", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            this.f = a;
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveEngine.prototype.x = function (a) {
        if (this.b == a) {
            return;
        }
        this.d = a;
        if (this.h) {
        }
        else {
            this.w();
        }
    };
    ResponsiveEngine.prototype.y = function (a, b) {
        this.k = dateNow();
        if (this.h) {
            this.q();
            this.h = false;
        }
        else {
            this.w();
        }
    };
    ResponsiveEngine.prototype.w = function () {
        var _this = this;
        if (this.i) {
            return;
        }
        var a = this.n();
        this.i = true;
        this.a.delayedExecutionManager.executeIn(function () {
            if (!_this.i) {
                return;
            }
            _this.i = false;
            if (_this.n() < 1) {
                _this.q();
            }
            else {
                _this.w();
            }
        }, a);
    };
    ResponsiveEngine.prototype.q = function () {
        if (this.b != null) {
            return;
        }
        var a = null;
        if (this.g.count > 0) {
            a = this.e(this.a.i7);
        }
        if (a == this.c) {
            return;
        }
        if (this.c != null && a != null) {
            this.c.q();
            this.c = null;
        }
        if (a != null) {
            if (this.d != null) {
                this.d = null;
            }
            this.b = a;
            this.c = a;
            this.c.l = 0;
            this.c.p();
            this.t(this.c);
            this.c.o();
        }
    };
    ResponsiveEngine.prototype.t = function (a) {
        var _this = this;
        if (a.c.count == a.l) {
            this.b = null;
            var b = this.e(this.a.i7);
            {
                if (b != this.c) {
                    this.w();
                }
            }
            return;
        }
        if (this.h) {
            this.u(a);
            this.c.l = this.c.l + 1;
            this.t(a);
        }
        else {
            this.a.delayedExecutionManager.executeIn(function () {
                var c = _this.a.ck;
                c.animationCompleted = delegateCombine(c.animationCompleted, runOn(_this, _this.p));
                var d = _this.a.ck;
                d.animationCanceled = delegateCombine(d.animationCanceled, runOn(_this, _this.o));
                _this.a.ck.ap();
                _this.u(a);
                _this.j = _this.a.ck.m();
                if (_this.j.count == 0) {
                    _this.r(-1);
                }
            }, a.c._inner[0].i);
        }
    };
    ResponsiveEngine.prototype.u = function (a) {
        var b = a.c._inner[a.l];
        this.v(b.e);
        this.s(b.b);
    };
    ResponsiveEngine.prototype.o = function (a, b) {
        this.r(b.a);
    };
    ResponsiveEngine.prototype.p = function (a, b) {
        this.r(b.a);
    };
    ResponsiveEngine.prototype.r = function (a) {
        if (this.j.contains(a)) {
            this.j.remove(a);
        }
        if (this.j.count == 0) {
            var b = this.a.ck;
            b.animationCompleted = delegateRemove(b.animationCompleted, runOn(this, this.p));
            var c = this.a.ck;
            c.animationCanceled = delegateRemove(c.animationCanceled, runOn(this, this.o));
            this.c.l = this.c.l + 1;
            this.t(this.c);
        }
    };
    ResponsiveEngine.prototype.v = function (a) {
        for (var b = 0; b < a.count; b++) {
            var c = a._inner[b];
            var d = null;
            for (var e = 0; e < this.a.actualColumns.count; e++) {
                if (this.a.actualColumns._inner[e].ic == c.c) {
                    d = this.a.actualColumns._inner[e];
                    break;
                }
            }
            if (d == null) {
                for (var f = 0; f < this.a.actualColumns.count; f++) {
                    if (this.a.actualColumns._inner[f].hx == c.c) {
                        d = this.a.actualColumns._inner[f];
                        break;
                    }
                }
            }
            if (d == null) {
                continue;
            }
            var g = d.externalObject;
            this.a.propertySetter.setProperty(g, c.d, c.b);
        }
    };
    ResponsiveEngine.prototype.s = function (a) {
        for (var b = 0; b < a.count; b++) {
            var c = a._inner[b];
            if (c.a == null) {
                continue;
            }
            if (c.b >= this.a.actualColumns.count) {
                continue;
            }
            var d = this.a.actualColumns._inner[c.b];
            this.a.pe(c.a, d);
        }
    };
    ResponsiveEngine.prototype.e = function (a) {
        if (this.d != null) {
            return this.d;
        }
        for (var b = 0; b < this.g.count; b++) {
            var c = this.g._inner[b];
            if (a >= c.k && a <= c.j && !c.i) {
                return c;
            }
        }
        return null;
    };
    ResponsiveEngine.prototype.n = function () {
        var a = timeSpanFromMilliseconds(this.m);
        var b = timeSpanFromMilliseconds(this.l);
        if (+(this.k) != +(dateMinValue())) {
            a = +(dateNow()) - +(this.k);
        }
        var c = truncate(timeSpanTotalMilliseconds(a));
        var d = (this.m - c);
        if (d < 1) {
            d = 0;
        }
        return d;
    };
    ResponsiveEngine.$t = markType(ResponsiveEngine, 'ResponsiveEngine');
    return ResponsiveEngine;
}(Base));
export { ResponsiveEngine };
/**
 * @hidden
 */
var ResponsivePhase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsivePhase, _super);
    function ResponsivePhase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.j = null;
        _this.k = null;
        _this.i = 0;
        _this.d = new ColumnPropertySettersCollection();
        _this.a = new ColumnExchangersCollection();
        return _this;
    }
    Object.defineProperty(ResponsivePhase.prototype, "e", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponsivePhase.prototype, "b", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    ResponsivePhase.prototype.g = function (a) {
        this.e.add(a);
        return this;
    };
    ResponsivePhase.prototype.c = function () {
        var a = new ColumnPropertySetter(0);
        this.e.add(a);
        return a;
    };
    ResponsivePhase.prototype.f = function (a) {
        this.b.add(a);
        return this;
    };
    ResponsivePhase.prototype.h = function () {
        var a = new ColumnExchanger(0);
        this.b.add(a);
        return this;
    };
    ResponsivePhase.$t = markType(ResponsivePhase, 'ResponsivePhase');
    return ResponsivePhase;
}(Base));
export { ResponsivePhase };
/**
 * @hidden
 */
var ResponsivePhasesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsivePhasesCollection, _super);
    function ResponsivePhasesCollection() {
        return _super.call(this, ResponsivePhase.$, 0) || this;
    }
    ResponsivePhasesCollection.$t = markType(ResponsivePhasesCollection, 'ResponsivePhasesCollection', ObservableCollection$1.$.specialize(ResponsivePhase.$));
    return ResponsivePhasesCollection;
}(ObservableCollection$1));
export { ResponsivePhasesCollection };
/**
 * @hidden
 */
var ResponsiveState = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsiveState, _super);
    function ResponsiveState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.m = null;
        _this.n = null;
        _this.k = 0;
        _this.j = 0;
        _this.stateEntering = null;
        _this.stateEntered = null;
        _this.stateExited = null;
        _this.h = false;
        _this.l = 0;
        _this.b = new ResponsivePhasesCollection();
        return _this;
    }
    Object.defineProperty(ResponsiveState.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            this.h = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponsiveState.prototype, "c", {
        get: function () {
            return this.b;
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveState.prototype.d = function (a) {
        this.c.add(a);
        return this;
    };
    ResponsiveState.prototype.a = function () {
        var a = new ResponsivePhase();
        this.c.add(a);
        return a;
    };
    ResponsiveState.prototype.p = function () {
        if (this.stateEntering != null) {
            this.stateEntering(this, new ResponsiveStateEnteringEventArgs());
        }
    };
    ResponsiveState.prototype.o = function () {
        if (this.stateEntered != null) {
            this.stateEntered(this, new ResponsiveStateEnteredEventArgs());
        }
    };
    ResponsiveState.prototype.q = function () {
        if (this.stateExited != null) {
            this.stateExited(this, new ResponsiveStateExitedEventArgs());
        }
    };
    ResponsiveState.$t = markType(ResponsiveState, 'ResponsiveState');
    return ResponsiveState;
}(Base));
export { ResponsiveState };
/**
 * @hidden
 */
var ResponsiveStatesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ResponsiveStatesCollection, _super);
    function ResponsiveStatesCollection() {
        return _super.call(this, ResponsiveState.$, 0) || this;
    }
    ResponsiveStatesCollection.$t = markType(ResponsiveStatesCollection, 'ResponsiveStatesCollection', ObservableCollection$1.$.specialize(ResponsiveState.$));
    return ResponsiveStatesCollection;
}(ObservableCollection$1));
export { ResponsiveStatesCollection };
/**
 * @hidden
 */
var GridLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridLayer, _super);
    function GridLayer(a) {
        var _this = _super.call(this, CellPath.$, CellModel.$, 0) || this;
        _this.v = null;
        _this.v = a;
        return _this;
    }
    GridLayer.$t = markType(GridLayer, 'GridLayer', FastIterationDictionary$2.$.specialize(CellPath.$, CellModel.$));
    return GridLayer;
}(FastIterationDictionary$2));
export { GridLayer };
/**
 * @hidden
 */
var ColumnInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnInfo, _super);
    function ColumnInfo() {
        var _this = _super.call(this) || this;
        _this.m = 0;
        _this.n = 0;
        _this.b = null;
        _this.i = 0;
        _this.k = 0;
        _this.l = 0;
        _this.p = null;
        _this.o = 0;
        _this.c = 0;
        _this.g = 0;
        _this.j = 0;
        _this.h = 0;
        _this.a = 0;
        _this.d = 0;
        _this.g = 0;
        _this.h = 0;
        _this.j = 0;
        _this.i = 0;
        return _this;
    }
    ColumnInfo.prototype.e = function (a) {
        var b = this.h;
        if (this.a != 6) {
            if (b > 0 && b < 1) {
                b = 0;
            }
            if (b >= 1) {
                b = b - 1;
            }
        }
        return this.g + b * (this.k + a.cc);
    };
    ColumnInfo.prototype.f = function (a) {
        var b = Math.abs(this.g + this.h * (this.k + a.cc));
        if (b < (-1 * (this.k + a.cc))) {
            b = (-1 * (this.k + a.cc));
        }
        if (b > (this.k + a.cc)) {
            b = (this.k + a.cc);
        }
        return b;
    };
    ColumnInfo.$t = markType(ColumnInfo, 'ColumnInfo');
    return ColumnInfo;
}(Base));
export { ColumnInfo };
/**
 * @hidden
 */
var SectionInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionInfo, _super);
    function SectionInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.h = 0;
        _this.m = 0;
        _this.q = 0;
        _this.o = 0;
        _this.g = 0;
        _this.d = 0;
        _this.n = 0;
        _this.p = 0;
        _this.i = 0;
        _this.b = null;
        _this.c = null;
        return _this;
    }
    SectionInfo.prototype.l = function () {
        return this.q + this.g + this.d + ((this.o + this.p) * this.m);
    };
    SectionInfo.prototype.e = function (a) {
        if (a == -200) {
            return this.g;
        }
        if (a == -201) {
            return this.d;
        }
        if (this.b == null) {
            return this.n;
        }
        else {
            return this.b._inner[a];
        }
    };
    SectionInfo.prototype.f = function (a) {
        if (this.c == null) {
            if (a == -200) {
                return 0;
            }
            else if (a == -201) {
                return this.l() - this.g;
            }
            return (a * this.k()) + this.g;
        }
        else {
            if (a == -200) {
                return 0;
            }
            else if (a == -201) {
                return this.l() - this.d;
            }
            return this.c._inner[a];
        }
    };
    SectionInfo.prototype.k = function () {
        return this.n + this.p + this.o;
    };
    SectionInfo.prototype.j = function (a) {
        if (this.c == null) {
            return this.n + this.p + this.o;
        }
        else {
            return this.b._inner[a] + this.o + this.p;
        }
    };
    SectionInfo.prototype.a = function (a) {
        a -= this.i;
        if (a < this.g) {
            return new RowPath(this.h, -200);
        }
        else if (a > this.l() - this.d) {
            return new RowPath(this.h, -201);
        }
        a -= this.g;
        if (this.b == null) {
            var b = this.k();
            var c = truncate((a / b));
            if (c >= this.m) {
                c = this.m - 1;
            }
            return new RowPath(this.h, c);
        }
        else {
            for (var d = 0; d < this.m; d++) {
                var e = this.c._inner[d];
                var f = this.j(d);
                if (a >= e && a <= e + f) {
                    return new RowPath(this.h, d);
                }
            }
        }
        return null;
    };
    SectionInfo.$t = markType(SectionInfo, 'SectionInfo');
    return SectionInfo;
}(Base));
export { SectionInfo };
/**
 * @hidden
 */
var VisualModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(VisualModel, _super);
    function VisualModel() {
        var _this = _super.call(this) || this;
        _this._actualVisibleRegion = null;
        _this._absoluteWidth = 0;
        _this._absoluteHeight = 0;
        _this.ci = 0;
        _this.cl = 0;
        _this.cm = 0;
        _this.ch = 0;
        _this.cf = 0;
        _this.cg = 0;
        _this.cc = 0;
        _this.cs = 0;
        _this.ct = 0;
        _this.b4 = 0;
        _this.b5 = 0;
        _this.cd = 0;
        _this.ce = 0;
        _this.cj = 0;
        _this.cp = 0;
        _this.b7 = 0;
        _this.b0 = 0;
        _this.b1 = 0;
        _this.b2 = 0;
        _this.bz = 0;
        _this.ae = null;
        _this.p = null;
        _this.i = null;
        _this.k = null;
        _this.ah = null;
        _this.s = null;
        _this.o = null;
        _this.j = null;
        _this.ag = null;
        _this.r = null;
        _this.q = null;
        _this.af = null;
        _this.w = null;
        _this.v = null;
        _this.l = null;
        _this.aj = null;
        _this.u = null;
        _this.t = null;
        _this.ai = null;
        _this.m = null;
        _this.x = null;
        _this.n = null;
        _this.y = null;
        _this.z = null;
        _this.aa = null;
        _this.ab = null;
        _this.ac = null;
        _this.ad = null;
        _this.ak = null;
        _this.c = null;
        _this.bg = null;
        _this.bv = null;
        _this.br = null;
        _this.bl = false;
        _this.bn = false;
        _this.bk = false;
        _this.bq = new List$1(GridColumnSpacerCollection.$, 0);
        _this.bo = null;
        _this.bf = null;
        _this.be = null;
        _this.cx = -1;
        _this.f = null;
        _this.bp = null;
        _this.bx = null;
        _this.cn = 0;
        _this.cq = 0;
        _this.co = 0;
        _this.cr = 0;
        _this.bj = false;
        _this.cv = 0;
        _this.cw = 0;
        _this.cu = 0;
        _this.actualVisibleRegion = Rect.empty;
        _this.ae = new GridLayer("SubContentLayer");
        _this.i = new GridLayer("ContentLayer");
        _this.ah = new GridLayer("SuperContentLayer");
        _this.j = new GridLayer("DecoratorLayer");
        _this.x = new GridLayer("PinnedRowsLayer");
        _this.y = new GridLayer("PinnedRowsSubLayer");
        _this.z = new GridLayer("PinnedRowsSuperLayer");
        _this.aa = new GridLayer("PinnedSectionLayer");
        _this.ab = new GridLayer("PinnedSectionSubLayer");
        _this.ac = new GridLayer("PinnedSectionSuperLayer");
        _this.ad = new GridLayer("SectionLayer");
        _this.ag = new GridLayer("SubHeaderLayer");
        _this.w = new GridLayer("HeaderLayer");
        _this.v = new GridLayer("HeaderDecoratorLayer");
        _this.aj = new GridLayer("SuperHeaderLayer");
        _this.ak = new GridLayer("VerticalSeparatorLayer");
        _this.af = new GridLayer("SubHeaderDecoratorLayer");
        _this.ai = new GridLayer("SuperHeaderDecoratorLayer");
        _this.k = new GridLayer("FixedContentLayer");
        _this.m = new GridLayer("FixedHeaderLayer");
        _this.n = new GridLayer("FixedPinnedRowsLayer");
        _this.o = new GridLayer("FixedSeparatorLayer");
        _this.p = new GridLayer("FixedSubContentLayer");
        _this.r = new GridLayer("FixedSubHeaderLayer");
        _this.s = new GridLayer("FixedSuperContentLayer");
        _this.u = new GridLayer("FixedSuperHeaderLayer");
        _this.q = new GridLayer("FixedSubHeaderDecoratorLayer");
        _this.u = new GridLayer("FixedSuperHeaderLayer");
        _this.t = new GridLayer("FixedSuperHeaderDecoratorLayer");
        _this.l = new GridLayer("FixedHeaderDecoratorLayer");
        _this.bg = new FastIterationDictionary$2(CellPath.$, List$1.$.specialize(CellModel.$), 0);
        _this.c2();
        _this.bv = new List$1(SectionInfo.$, 0);
        _this.br = new List$1(ColumnInfo.$, 0);
        _this.bo = new Dictionary$2(Number_$type, Number_$type, 0);
        _this.bx = new List$1(Number_$type, 0);
        return _this;
    }
    Object.defineProperty(VisualModel.prototype, "actualVisibleRegion", {
        get: function () {
            return this._actualVisibleRegion;
        },
        set: function (a) {
            this._actualVisibleRegion = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "absoluteWidth", {
        get: function () {
            return this._absoluteWidth;
        },
        set: function (a) {
            this._absoluteWidth = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "absoluteHeight", {
        get: function () {
            return this._absoluteHeight;
        },
        set: function (a) {
            this._absoluteHeight = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b8", {
        get: function () {
            return truncate(this.actualVisibleRegion.top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b3", {
        get: function () {
            return truncate(this.actualVisibleRegion.left);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b6", {
        get: function () {
            return truncate(this.actualVisibleRegion.right);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "by", {
        get: function () {
            return truncate(this.actualVisibleRegion.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "b9", {
        get: function () {
            return truncate(this.actualVisibleRegion.width);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a7", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            this.ae = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "as", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            this.p = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "al", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            this.i = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "an", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            this.k = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ba", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            this.ah = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "av", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            this.s = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ar", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            this.o = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "am", {
        get: function () {
            return this.j;
        },
        set: function (a) {
            this.j = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a9", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            this.ag = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "au", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            this.r = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "at", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            this.q = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a8", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            this.af = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "az", {
        get: function () {
            return this.w;
        },
        set: function (a) {
            this.w = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ay", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            this.v = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ao", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            this.l = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bc", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            this.aj = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ax", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            this.u = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "aw", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            this.t = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bb", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            this.ai = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "ap", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            this.m = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a0", {
        get: function () {
            return this.x;
        },
        set: function (a) {
            this.x = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "aq", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            this.n = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a1", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            this.y = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a2", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            this.z = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a3", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            this.aa = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a4", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            this.ab = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a5", {
        get: function () {
            return this.ac;
        },
        set: function (a) {
            this.ac = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "a6", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            this.ad = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bd", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            this.ak = a;
            this.c2();
        },
        enumerable: true,
        configurable: true
    });
    VisualModel.prototype.e = function (a, b) {
        a += this.actualVisibleRegion.left;
        b += this.actualVisibleRegion.top;
        var c = this.bu;
        var d = c.count;
        for (var e = d - 1; e >= 0; e--) {
            if (c._inner[e] == this.al) {
                break;
            }
            var f = c._inner[e].q;
            var g = c._inner[e].q.count;
            var h = c._inner[e].p;
            for (var i = 0; i < g; i++) {
                if (h._inner[i]) {
                    continue;
                }
                var j = f._inner[i];
                if (a >= j.b7 && a <= j.b7 + j.f8 && b >= j.b8 && b <= j.b8 + j.ev) {
                    this.c = j;
                    return j;
                }
            }
        }
        if (this.c != null) {
            var k = this.c;
            if (a >= k.b7 && a <= k.b7 + k.f8 && b >= k.b8 && b <= k.b8 + k.ev) {
                this.c = k;
                return k;
            }
        }
        c = this.bu;
        d = c.count;
        for (var l = d - 1; l >= 0; l--) {
            var m = c._inner[l].q;
            var n = c._inner[l].q.count;
            var o = c._inner[l].p;
            for (var p = 0; p < n; p++) {
                if (o._inner[p]) {
                    continue;
                }
                var q = m._inner[p];
                if (a >= q.b7 && a <= q.b7 + q.f8 && b >= q.b8 && b <= q.b8 + q.ev) {
                    this.c = q;
                    return q;
                }
            }
        }
        return null;
    };
    Object.defineProperty(VisualModel.prototype, "bh", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            this.bg = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualModel.prototype, "bw", {
        get: function () {
            while (this.bq.count < this.br.count) {
                this.bq.add(new GridColumnSpacerCollection());
            }
            return this.bq;
        },
        set: function (a) {
            this.bq = a;
        },
        enumerable: true,
        configurable: true
    });
    VisualModel.prototype.bm = function () {
        if (this.bf != null && this.be != null && this.bf.w >= 0 && this.be.w >= 0) {
            return true;
        }
        return false;
    };
    VisualModel.prototype.g = function (a) {
        if (a == this.cx) {
            return this.f;
        }
        var b = null;
        if (this.bo.containsKey(a)) {
            b = this.br._inner[this.bo.item(a)];
        }
        this.cx = a;
        this.f = b;
        return b;
    };
    VisualModel.prototype.cy = function (a) {
        this.br.add(a);
        this.bo.addItem(a.o, this.br.count - 1);
    };
    VisualModel.prototype.c2 = function () {
        this.bp = new List$1(GridLayer.$, 0);
        this.bp.add(this.a7);
        this.bp.add(this.al);
        this.bp.add(this.ba);
        this.bp.add(this.am);
        this.bp.add(this.a1);
        this.bp.add(this.a0);
        this.bp.add(this.a2);
        this.bp.add(this.as);
        this.bp.add(this.an);
        this.bp.add(this.av);
        this.bp.add(this.aq);
        this.bp.add(this.ar);
        this.bp.add(this.a6);
        this.bp.add(this.a4);
        this.bp.add(this.a3);
        this.bp.add(this.a5);
        this.bp.add(this.a9);
        this.bp.add(this.a8);
        this.bp.add(this.az);
        this.bp.add(this.ay);
        this.bp.add(this.bc);
        this.bp.add(this.bb);
        this.bp.add(this.au);
        this.bp.add(this.at);
        this.bp.add(this.ap);
        this.bp.add(this.ao);
        this.bp.add(this.ax);
        this.bp.add(this.aw);
        this.bp.add(this.bd);
    };
    Object.defineProperty(VisualModel.prototype, "bu", {
        get: function () {
            return this.bp;
        },
        enumerable: true,
        configurable: true
    });
    VisualModel.prototype.bi = function () {
        for (var a = 0; a < this.bp.count; a++) {
            for (var b = 0; b < this.bp._inner[a].o.count; b++) {
                if (this.bp._inner[a].p._inner[b]) {
                    continue;
                }
                var c = this.bp._inner[a].o._inner[b];
                var d = this.bp._inner[a].q._inner[b];
                if (c != d.k) {
                    return false;
                }
            }
        }
        return true;
    };
    VisualModel.prototype.c1 = function () {
        this.f = null;
        this.cx = -1;
        this.br.clear();
        this.bo.clear();
    };
    VisualModel.prototype.c0 = function () {
        this.c1();
        this.bv.clear();
        this.a7.u();
        this.al.u();
        this.ba.u();
        this.am.u();
        this.a1.u();
        this.a0.u();
        this.a2.u();
        this.as.u();
        this.an.u();
        this.av.u();
        this.aq.u();
        this.ar.u();
        this.a6.u();
        this.a4.u();
        this.a3.u();
        this.a5.u();
        this.a9.u();
        this.a8.u();
        this.az.u();
        this.ay.u();
        this.bc.u();
        this.bb.u();
        this.au.u();
        this.at.u();
        this.ap.u();
        this.ao.u();
        this.ax.u();
        this.aw.u();
        this.bd.u();
    };
    VisualModel.prototype.b = function () {
        var a = new VisualModelExport();
        a.ae = new RectData(this.actualVisibleRegion.x, this.actualVisibleRegion.y, this.actualVisibleRegion.width, this.actualVisibleRegion.height);
        a.ah = this.absoluteWidth;
        a.ag = this.absoluteHeight;
        a.au = this.cl;
        a.an = this.ci;
        a.am = this.ch;
        a.ak = this.cf;
        a.al = this.cg;
        a.ai = this.cc;
        a.aq = this.cs;
        a.ar = this.ct;
        a.as = this.b8;
        a.ap = this.b3;
        a.ao = this.by;
        a.at = this.b9;
        a.x = this.a(this.a7);
        a.a = this.a(this.al);
        a.aa = this.a(this.ba);
        a.b = this.a(this.am);
        a.r = this.a(this.a1);
        a.q = this.a(this.a0);
        a.s = this.a(this.a2);
        a.h = this.a(this.as);
        a.c = this.a(this.an);
        a.k = this.a(this.av);
        a.f = this.a(this.aq);
        a.g = this.a(this.ar);
        a.w = this.a(this.a6);
        a.u = this.a(this.a4);
        a.t = this.a(this.a3);
        a.v = this.a(this.a5);
        a.z = this.a(this.a9);
        a.y = this.a(this.a8);
        a.o = this.a(this.az);
        a.n = this.a(this.ay);
        a.ac = this.a(this.bc);
        a.ab = this.a(this.bb);
        a.j = this.a(this.au);
        a.i = this.a(this.at);
        a.e = this.a(this.ap);
        a.d = this.a(this.ao);
        a.m = this.a(this.ax);
        a.l = this.a(this.aw);
        a.ad = this.a(this.bd);
        a.ax();
        return a;
    };
    VisualModel.prototype.a = function (a) {
        var e_22, _a;
        var b = new GridLayerExport(a.v);
        var c = a == this.az;
        try {
            for (var _b = tslib_1.__values(fromEnum(a.n)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var d = _c.value;
                var e = d.b(null);
                if (this.bj && c) {
                    e.s += this.b8;
                }
                b.e(e);
            }
        }
        catch (e_22_1) {
            e_22 = { error: e_22_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_22)
                    throw e_22.error;
            }
        }
        return b;
    };
    VisualModel.prototype.h = function (a, b, c, d, e) {
        var f = new GridColumnSpacer();
        f.i = c;
        f.j = c;
        f.f = d;
        f.n = b.o;
        f.d = e;
        this.bw._inner[a].add(f);
        return f;
    };
    VisualModel.prototype.cz = function (a) {
        var b = this.bw;
        for (var c = 0; c < b.count; c++) {
            var d = b._inner[c];
            for (var e = d.count - 1; e >= 0; e--) {
                if (d._inner[e].o == a.o) {
                    d.removeAt(e);
                }
            }
        }
    };
    VisualModel.prototype.bt = function (a) {
        var b = new List$1(GridColumnSpacer.$, 0);
        var c = this.bw;
        for (var d = 0; d < c.count; d++) {
            var e = c._inner[d];
            for (var f = e.count - 1; f >= 0; f--) {
                if (e._inner[f].n == a.o) {
                    b.add(e._inner[f]);
                }
            }
        }
        return b;
    };
    VisualModel.prototype.bs = function (a) {
        var b = new List$1(CellModel.$, 0);
        for (var c = 0; c < this.bu.count; c++) {
            var d = new List$1(CellModel.$, 0);
            var e = this.bu._inner[c];
            for (var f = 0; f < e.o.count; f++) {
                if (e.p._inner[f]) {
                    continue;
                }
                var g = e.q._inner[f];
                if (g.k.ax == a.m && g.k.b == a.c) {
                    b.add(g);
                }
            }
        }
        return b;
    };
    VisualModel.prototype.d = function (a, b) {
        for (var c = 0; c < this.bu.count; c++) {
            var d = this.bu._inner[c];
            for (var e = 0; e < d.o.count; e++) {
                if (d.p._inner[e]) {
                    continue;
                }
                var f = d.q._inner[e];
                if (f.k.ax == a && f.k.w == b) {
                    return f;
                }
            }
        }
        return null;
    };
    VisualModel.prototype.ck = function () {
        var a = 0;
        for (var b = 0; b < this.bv.count; b++) {
            a += this.bv._inner[b].m;
        }
        return a;
    };
    VisualModel.$t = markType(VisualModel, 'VisualModel');
    return VisualModel;
}(Base));
export { VisualModel };
//# sourceMappingURL=IExternalGrid_combined.js.map
